//#region imports

import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React, { forwardRef, useImperativeHandle } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import './ChangeOfNameTable.scss';
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import DoneIcon from "@mui/icons-material/Done";
import InfoIcon from "@mui/icons-material/Info";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import InputAdornment from "@mui/material/InputAdornment";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import { useEffect, useLayoutEffect, useState } from "react";
import Error from "../../../components/error/error";
import { useLocation, useNavigate } from "react-router-dom";
import InfoImage from "../../../images/informationButton.png";
import ActionsCell from "../../../components/actionCell/ActionCell";
// import ErrorIcon from '@mui/icons-material/Error';
import "../../../style/common.scss";
// use scan detection
import useScanDetection from "use-scan-detection";
//jspdf
import { jsPDF } from "jspdf";
import "jspdf-autotable";
//fonts
import ErrorIcon from "@mui/icons-material/Error";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import PrintIcon from "@mui/icons-material/Print";
import { TextField } from "@mui/material";
import { Formik, useFormik } from "formik";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import CheckPermissions from "../../../authorization/authorization";
import Base64Image from "../../../components/Base64Image/Base64Image";
import StepProgressBar from "../../../components/StepProgressBar/StepProgressBar";
import BasicTable from "../../../components/basicTable/basicTable";
import ProcessingSummaryTable from "../../../components/processingSummaryTable/processingSummaryTable";
import {
  fetchPaginatedChangeOfAttributesNormal,
  filterDateFrom as filterDateFromNormal,
  filterDateTo as filterDateToNormal,
  filterObjectionStatus as filterObjectionStatusNormal,
  filterProgressId as filterProgressIdNormal,
  firstPage as firstPageNormal,
  lastPage as lastPageNormal,
  nextPage as nextPageNormal,
  previousPage as prePageNormal,
  resetDateFilter as resetDateFilterNormal,
  resetObjectionStatusFilter as resetObjectionStatusFilterNormal,
  resetProgressIdFilter as resetProgressIdFilterNormal,
} from "../../../features/generalServices/coaNormalSlice";
import {
  fetchPaginatedChangeOfAttributesOverdue,
  filterDateFrom as filterDateFromOverdue,
  filterDateTo as filterDateToOverdue,
  filterObjectionStatus as filterObjectionStatusOverdue,
  filterProgressId as filterProgressIdOverdue,
  firstPage as firstPageOverdue,
  lastPage as lastPageOverdue,
  nextPage as nextPageOverdue,
  previousPage as prePageOverdue,
  resetDateFilter as resetDateFilterOverdue,
  resetObjectionStatusFilter as resetObjectionStatusFilterOverdue,
  resetProgressIdFilter as resetProgressIdFilterOverdue,
} from "../../../features/generalServices/coaOverdueSlice";
import tickicon from "../../../images/Accept.png";
import FESCOWaterMark from "../../../images/DiscosWater/fesco-watermark.png";
import GEPCOWaterMark from "../../../images/DiscosWater/gepco-watermark.png";
import HAZECOWaterMark from "../../../images/DiscosWater/hazeco-watermark.png";
import HESCOWaterMark from "../../../images/DiscosWater/hesco-watermark.png";
import IESCOWaterMark from "../../../images/DiscosWater/iescowatermark.png";
import LESCOWaterMark from "../../../images/DiscosWater/lescowatermark.png";
import MEPCOWaterMark from "../../../images/DiscosWater/mepcco-watermark.png";
import PESCOWaterMark from "../../../images/DiscosWater/pesco-watermark.png";
import QESCOWaterMark from "../../../images/DiscosWater/qesco-watermark.png";
import SEPCOWaterMark from "../../../images/DiscosWater/sepco-watermark.png";
import TESCOWaterMark from "../../../images/DiscosWater/tesco-watermark.png";
import pdfIcon from "../../../images/pdfIcon.png";
import crossIcon from "../../../images/remove.png";
import pencilIcon from "../../../images/pencil.png";
import warning from "../../../images/warning.png";
import { SearchIndividualApplication } from "../../../network/APIs/APIs";
import { cfpBaseUrl } from "../../../network/urls";
import JsBarcode from "jsbarcode";
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from "../../../images/pitc.png";
import {
  companyName,
  convertDate,
  convertDatewithTime,
  dBillAPI,
  divisionName,
  documentValidation,
  downloadBill,
  getDocumentBackGroundColor,
  handleFileUpload,
  companyShortName,
  numberFormatting,
  printStamp,
  statusFunc,
  subdivisionName,
  isPdf,
  isImage,
  convertDatewithTimeWithoutSecond,
} from "../../../services/Functions";
import { openBase64Image } from "../../../services/OpenBase64Image";
import OpenBase64ImageInPopup from "../../../services/OpenBase64ImageInPopup";
import { tableStyle, tableStyleOverDue } from "../../../style/common";
import { documentExtensions, portalName } from "../../../utils/PortalName";
import "../NewConnection/NewConnectionForm.scss";
import ProcessingSummaryTableForCoa from "../../../components/processingSummaryTable/processingSummaryTableForCoa";
import IESCODDLOGO from "../../../images/discologos/iesco logo.png";
import FESCODDLOGO from "../../../images/discologos/fesco.jpg";
import GEPCODDLOGO from "../../../images/discologos/gepco.jpg";
import HAZECODDLOGO from "../../../images/discologos/hazeco_logo-removebg-preview.png";
import HESCODDLOGO from "../../../images/discologos/hesco logo.png";
import LESCODDLOGO from "../../../images/discologos/lesco.jpg";
import MEPCODDLOGO from "../../../images/discologos/mepco1.jpg";
import PESCODDLOGO from "../../../images/discologos/pesco1.jpg";
import PITCDDLOGO from "../../../images/discologos/pitc11-removebg-preview.png";
import QESCODDLOGO from "../../../images/discologos/qesco.png";
import SEPCODDLOGO from "../../../images/discologos/sepco.jpg";
import TESCODDLOGO from "../../../images/discologos/tesco.jpg";
import useFetchData from "../../../hooks/fetchData";
//#endregion

const ChangeAttributesTable = forwardRef((props, ref) => {
  const dispatch = useDispatch();

  const {
    currentPage: currentPageNormal,
    data: dataNormal,
    pageSize: pageSizeNormal,
    totalPages: totalPagesNormal,
    totalRecords: totalRecordsNormal,
    dateFrom: dateFromNormal,
    dateTo: dateToNormal,
    applicationProgressId: applicationProgressIdNormal,
    objectionStatus: objectionStatusNormal,
    error: coaNormalError,
    isLoading: isLoad,
  } = useSelector((state) => state.coaNormalPaginated);
  const {
    currentPage: currentPageOverdue,
    data: dataOverdue,
    pageSize: pageSizeOverdue,
    totalPages: totalPagesOverdue,
    totalRecords: totalRecordsOverdue,
    dateFrom: dateFromOverdue,
    dateTo: dateToOverdue,
    applicationProgressId: applicationProgressIdOverdue,
    objectionStatus: objectionStatusOverdue,
    error: coaOverdueError,
    isLoading: isLoadd,
  } = useSelector((state) => state.coaOverduePaginated);
  const handleNextPageNormal = () => {
    setViewBackdrop(true);
    dispatch(nextPageNormal());
  };

  const handleDateFromFilterNormal = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateFromNormal(value));
    }
  };

  const handleDateToFilterNormal = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateToNormal(value));
    }
  };

  const handleResetDateFilterNormal = () => {
    setViewBackdrop(true);
    dispatch(resetDateFilterNormal());
    dispatch(firstPageNormal());
  };

  const handleProgressIdFilterNormal = (value) => {
    if (value || value === 0) {
      setViewBackdrop(true);
      dispatch(filterProgressIdNormal(value));
    }
  };

  const handleResetProgressIdFilterNormal = () => {
    setViewBackdrop(true);
    dispatch(resetProgressIdFilterNormal());
    dispatch(firstPageNormal());
  };

  const handleObjectionStatusFilterNormal = (value) => {
    if (value || value === 0) {
      setViewBackdrop(true);
      dispatch(filterObjectionStatusNormal(value));
    }
  };

  const handleResetObjectionStatusFilterNormal = () => {
    setViewBackdrop(true);
    dispatch(resetObjectionStatusFilterNormal());
    dispatch(firstPageNormal());
  };

  const handlePreviousPageNormal = () => {
    setViewBackdrop(true);
    dispatch(prePageNormal());
  };

  const handleFirstPageNormal = () => {
    setViewBackdrop(true);
    dispatch(firstPageNormal());
  };

  const handleLastPageNormal = () => {
    setViewBackdrop(true);
    dispatch(lastPageNormal(totalPagesNormal)); // Replace '2' with actual value
  };

  useEffect(() => {
    if (dataNormal) {
      setChangeOfNameApplications(dataNormal);
      setViewBackdrop(false);
    }
  }, [dataNormal]);

  const scoHandleClose = () => {
    setScoPopUp(false);
  };

  const handleNextPageOverdue = () => {
    setViewBackdrop(true);
    dispatch(nextPageOverdue());
  };

  const handleDateFromFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateFromOverdue(value));
    }
  };

  const handleDateToFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateToOverdue(value));
    }
  };
  const handleResetDateFilterOverdue = () => {
    setViewBackdrop(true);
    dispatch(resetDateFilterOverdue());
    dispatch(firstPageOverdue());
  };
  const handleProgressIdFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterProgressIdOverdue(value));
    }
  };

  const handleResetProgressIdFilterOverdue = () => {
    setViewBackdrop(true);
    dispatch(resetProgressIdFilterOverdue());
    dispatch(firstPageOverdue());
  };

  const handleObjectionStatusFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterObjectionStatusOverdue(value));
    }
  };

  const handleResetObjectionStatusFilterOverdue = () => {
    setViewBackdrop(true);
    dispatch(resetObjectionStatusFilterOverdue());
    dispatch(firstPageOverdue());
  };

  const handlePreviousPageOverdue = () => {
    setViewBackdrop(true);
    dispatch(prePageOverdue());
  };

  const handleFirstPageOverdue = () => {
    setViewBackdrop(true);
    dispatch(firstPageOverdue());
  };

  const handleLastPageOverdue = () => {
    setViewBackdrop(true);
    dispatch(lastPageOverdue(totalPagesOverdue));
  };

  useEffect(() => {
    if (dataOverdue) {
      setChangeOfNameApplicationsOverDue(dataOverdue);
      setViewBackdrop(false);
    }
  }, [dataOverdue]);

  //#region initial values

  const initialValues = {
    iv_objection_Type: 1,
    iv_objection_Descripton: "",
    iv_distance: "",
    iv_sketch_diagram: "",
    iv_property_reference_no: "",
    iv_material_required: false,
    iv_meter_to_replace: false,
    iv_batch_change: false,
    iv_seasonal: 0,
    iv_area_type: "",
    iv_reference_to_allot: "",
    iv_batch: "",
    iv_sub_batch: "",
    iv_arear_paid_bill_document: "",
    iv_arear_paid_bill_date: "",
    iv_meter_type: 1,
    iv_signed_consent_image: "",
    iv_old_referenceNumber: "",
    iv_location_code: "P",
    iv_remarks_others: "",
    // Charge fields
    iv_grid_sharing_cost: 0,
    iv_feeder_rehab_charges: 0,
    iv_civil_work_charges: 0,
    iv_mnt_charges: 0,
    iv_labour_charges: 0,
    iv_design_vetting_fee: 0,
    iv_consultancy_charges: 0,
    iv_variation_charges: 0,
    iv_dismantlement_charges: 0,
    iv_earthing_charges: 0,
  };

  const {
    token,
    userId,
    hierarchy,
    roleId,
    roleName,
    permissions,
    code,
    roleTypeId,
  } = useSelector((state) => state.auth);
  const [installedMeterImageThumbnail, setInstalledMeterImageThumbnail] =
    useState("");

  const calculateMF = (ctNom, ctDenom, ptNom, ptDenom) => {
    let mf = (ctNom / ctDenom) * (ptNom / ptDenom);
    return mf;
  };

  const subDivisions = JSON.parse(window.localStorage.getItem("subDivisions"));
  let userCompany = code.slice(0, 2);

  const getWaterMarkLogo = (code) => {
    switch (code) {
      case "11":
        return LESCOWaterMark;
      case "12":
        return GEPCOWaterMark;
      case "13":
        return FESCOWaterMark;
      case "14":
        return IESCOWaterMark;
      case "15":
        return MEPCOWaterMark;
      case "26":
        return PESCOWaterMark;
      case "27":
        return HAZECOWaterMark;
      case "37":
        return HESCOWaterMark;
      case "38":
        return SEPCOWaterMark;
      case "48":
        return QESCOWaterMark;
      case "59":
        return TESCOWaterMark;
      default:
        return MEPCOWaterMark;
    }
  };

  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };

  const getLogo = (code) => {
    switch (code) {
      case "10":
        return pitcLogo;
      case "11":
        return LESCOLOGO;
      case "12":
        return GEPCOLOGO;
      case "13":
        return FESCOLOGO;
      case "14":
        return IESCOLOGO;
      case "15":
        return MEPCOLOGO;
      case "26":
        return PESCOLOGO;
      case "27":
        return HAZECOLOGO;
      case "37":
        return HESCOLOGO;
      case "38":
        return SEPCOLOGO;
      case "48":
        return QESCOLOGO;
      case "59":
        return TESCOLOGO;
      default:
        return MEPCOLOGO;
    }
  };

  //#endregion

  //#region states
  const [frontImg, setFrontImg] = useState(null);
  const [backImg, setBackImg] = useState(null);
  const [showMasterForm, setShowMasterForm] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [dialogRowData, setDialogRowData] = React.useState({});
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [editSections, setEditSections] = useState({
    name: false,
    load: false,
    tariff: false,
  });
  const [editLoadError, setEditLoadError] = useState("");
  const [editLoadChangeTypeError, setEditLoadChangeTypeError] = useState("");
  const [editNameErrors, setEditNameErrors] = useState({
    newName: "",
    guardianName: "",
    newCNIC: "",
    newPhone: "",
  });
  const [editTariffError, setEditTariffError] = useState("");
  const [editSaveError, setEditSaveError] = useState("");
  const [editFbrDocument, setEditFbrDocument] = useState("");
  const [editFbrDocumentThumbnail, setEditFbrDocumentThumbnail] = useState("");
  const [editFbrDocumentError, setEditFbrDocumentError] = useState("");
  const [editFbrDocumentCleared, setEditFbrDocumentCleared] = useState(false);
  const [editNtnError, setEditNtnError] = useState("");
  const [editFormData, setEditFormData] = useState({
    // Common fields
    referenceNo: "",
    address: "",
    connectionType: "",
    tariff: "",
    city: "",
    circle: "",
    division: "",
    subdivision: "",
    // Change of Name fields
    currentName: "",
    currentCNIC: "",
    currentPhone: "",
    newName: "",
    newCNIC: "",
    newPhone: "",
    relation: "",
    guardianName: "",
    telcoCode: "",
    // Change of Load fields
    loadChangeType: "",
    currentLoad: "",
    newLoad: "",
    // Change of Tariff fields
    currentTariff: "",
    newTariff: "",
    ntnNo: "",
    newEmail: "",
  });
  const [editCircleList, setEditCircleList] = useState([]);
  const [editDivisionList, setEditDivisionList] = useState([]);
  const [editSubDivisionList, setEditSubDivisionList] = useState([]);
  const [changeOfNameApplications, setChangeOfNameApplications] = useState([]);
  const [
    changeOfNameApplicationsToDataGrid,
    setChangeOfNameApplicationsToDataGrid,
  ] = useState([]);
  const [changeOfNameApplicationsOverDue, setChangeOfNameApplicationsOverDue] =
    useState([]);
  const [
    changeOfNameApplicationsOverDueToDataGrid,
    setChangeOfNameApplicationsOverDueToDataGrid,
  ] = useState([]);
  const [arrearFlag, setArearFlag] = useState(0);
  const [viewDropBackForEfile, setViewDropBackForEfile] = useState(false);
  const [arearPaidBillUpload, setArearPaidBillUpload] = useState(false);
  const [arearPaidBillDocument, setArearPaidBillDocument] = useState("");
  const [arearPaidBillDocumentError, setArearPaidBillDocumentError] =
    useState("");
  const [arearPaidBillDocumentThumbnail, setArearPaidBillDocumentThumbnail] =
    useState("");
  const [consentVerificationFlag, setConsentVerificationFlag] = useState(0);
  const [dnRejectModalOpen, setDnRejectModalOpen] = useState(false);
  const [dnPaymentRemarks, setDnPaymentRemarks] = useState("");
  const [showDNPayment, setShowDNPayment] = useState(true);
  const [paidDNImagePopUp, setPaidDNImagePopUp] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [responseMessageError, setResponseMessageError] = useState("");
  const [responseType, setResponseType] = useState(""); // "success" or "error"
  const [openResponseModal, setOpenResponseModal] = useState(false);
  const [dnApprovalPayload, setDnApprovalPayload] = useState(null);
  const [dnPaymentVerification, setDnPaymentVerification] = useState(null);
  const [dnNumber, setDnNumber] = useState();
  const [dnPaymentDate, setDnPaymentDate] = useState();
  const [dnApproveStep, setDnApproveStep] = useState([]);
  const [dnDets, setDnDets] = useState([]);
  const [dnImage, setDnImage] = useState();
  const [showSJOPart1Form, setShowSJOPart1Form] = useState(false);
  const [showSJOPart2Form, setShowSJOPart2Form] = useState(false);
  const [dnPaymentVerifyAlert, setDnPaymentVerifyAlert] = React.useState(false);
  const [dnPaymentRejectAlert, setDnPaymentRejectAlert] = React.useState(false);
  const [sjoApproveAlert, setSjoApproveAlert] = React.useState(false);
  const [noArrears, setNoArrears] = useState("");
  const [officeHierarchy, setOfficeHierarchy] = useState();
  const navigate = useNavigate();
  const [signedConsentFormImage, setSignedConsentFormImageImage] = useState();
  const [
    signedConsentFormImageThumbnail,
    setSignedConsentFormImageImageThumbnail,
  ] = useState();
  const [signedConsentFormImageError, setSignedConsentFormImageError] =
    useState();
  const [dnReceiptImage, setDnReceiptImage] = useState();
  const [arrearPaidReceiptImage, setArrearPaidReceiptImage] = useState();
  const [arrearPaidReceiptImageThumbnail, setArrearPaidReceiptImageThumbnail] =
    useState();
  const [dnReceiptImageThumbnail, setDnReceiptImageThumbnail] = useState();
  const [objectionPopUpOpen, setObjectionPopUpOpen] = React.useState(false);
  const [arrearsEntryPopUpOpen, setArrearsEntryPopUpOpen] =
    React.useState(false);
  const [docVerifyAlert, setDocVerifyAlert] = React.useState(false);
  const [fieldVerifyAlert, setFieldVerifyAlert] = React.useState(false);
  const [
    signedConsentRejectionRemovalAlert,
    setSignedConsentRejectionRemovalAlert,
  ] = React.useState(false);
  const [arrearRejectionRemovalAlert, setArrearRejectionRemovalAlert] =
    React.useState(false);
  const [arrearsVerifyPopUpOpen, setArrearsVerifyPopUpOpen] =
    React.useState(false);
  const [eFileData, setEFileData] = useState([]);
  const [error, setError] = useState("");
  const [previousSecurity, setPreviousSecurity] = useState();
  const [sanctionedLoad, setSanctionedLoad] = useState();
  const [connectionCategoryType, setConnectionCategoryType] = useState();
  const [bankName, setBankName] = useState();
  const [progressBarStepName, setProgressBarStepName] = useState();
  const [paidDnImageDetails, setPaidDnImageDetails] = useState({
    id: null,
    applicationId: "",
    demandNoticeNo: "",
    paidDNImage: "",
    uploadedBy: "",
    uploadedAt: "",
    paymentDate: "",
    painDNImageVerification: null,
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const [coaApplicationUpdatedPopUp, setCoaApplicationUpdatedPopUp] =
    useState(false);
  const [coaApplicationUpdatedHistoryData, setCoaApplicationUpdatedHistoryData] =
    useState(null);
  const [documentsVerifiedSubPopUp, setDocumentsVerifiedSubPopUp] =
    useState(false);
  const [applicationSubittedPopUp, setApplicationSubmittedPopUp] =
    useState(false);
  const [arrearVerifiedSubPopUp, setArrearVerifiedSubPopUp] = useState(false);
  const [fieldSurveyedSubPopUp, setFieldSurveyedSubPopUp] = useState(false);
  const [fieldSurveyedObjectionSubPopUp, setFieldSurveyedObjectionSubPopUp] =
    useState(false);

  const [dnApprovalSubPopUp, setDnApprovalSubPopUp] = useState(false);
  const [dnPaymentSubmittedSubPopUp, setDnPaymentSubmittedSubPopUp] =
    useState(false);
  const [dnPaymentVerifiedSubPopUp, setDnPaymentVerifiedSubPopUp] =
    useState(false);
  const [
    serviceConnectionOrderedSubPopUp,
    setServiceConnectionOrderedSubPopUp,
  ] = useState(false);
  const [meterInstalledSubPopUp, setMeterInstalledSubPopUp] = useState(false);

  const [paymentStatus, setPaymentStatus] = useState("");
  const [arrearAmount, setArrearAmount] = useState("");
  const [billMonth, setBillMonth] = useState("");

  const [lookUpDataOfCON, setLookUpDataOfCON] = useState(null);
  const [sketchDiagramThumbnail, setSketchDiagramThumbnail] = useState("");
  const [sketchDiagram, setSketchDiagram] = useState();
  const [sketchDiagramError, setSketchDiagramError] = useState();
  const [sketchDiagramUploaded, setSketchDiagramUploaded] = useState();
  const [partialValue, setPartialValue] = useState("");
  const [showBoq, setShowBoq] = React.useState(false);
  const [errormessageBoqEstimation, setErrormessageBoqEstimation] =
    useState("");
  const [grandTotalCharges, setGrandTotalCharges] = useState(0);
  const [itemsArray, setItemsArray] = useState([]);
  const [fixedChargesOfMetering, setFixedChargesOfMetering] = useState(0);
  const [boqItems, setBoqItems] = useState([]);
  const [costEstimationForNC, setCostEstimationForNC] = React.useState({});
  const [allMaterialList, setAllMaterialList] = useState([]);
  const [installRefNo, setInstallRefNo] = useState([]);
  const [meterTypeValue, setMeterTypeValue] = useState("");
  const [tariff, setTariff] = useState();
  const [gridSharingCost, setGridSharingCost] = useState(0);
  const [lessTheCost, setLessTheCost] = useState(0);
  const [totalCharges, setTotalCharges] = useState(0);
  const [miscellaneousCharges, setMiscellaneousCharges] = useState(0);
  const [civilWorkCharges, setCivilWorkCharges] = useState(0);
  const [feederRehabilitationCharges, setFeederRehabilitationCharges] =
    useState(0);
  const [mntCharges, setMntCharges] = useState(0);
  const [labourCharges, setLabourCharges] = useState(0);
  const [designVettingFee, setDesignVettingFee] = useState(0);
  const [consultancyCharges, setConsultancyCharges] = useState(0);
  const [variationCharges, setVariationCharges] = useState(0);
  const [dismantlementCharges, setDismantlementCharges] = useState(0);
  const [earthingCharges, setEarthingCharges] = useState(0);
  const [installationCharges, setInstallationCharges] = useState(null);
  const [errormessageCostEstimation, setErrormessageCostEstimation] =
    useState("");
  const [meterAlreadyInstalled, setMeterAlreadyInstalled] = useState("");
  const [itemsAmount, setItemsAmount] = useState(null);
  const [storeCharges, setStoreCharges] = useState(null);
  const [showCostEstimation, setShowCostEstimation] = React.useState(false);
  const [estimateDistance, setEstimateDistance] = useState("");
  const [installedMeterImage, setInstalledMeterImage] = useState("");
  const [installedMeterImageVerifyPopUp, setInstalledMeterImageVerifyPopUp] =
    useState(false);

  const [
    applicantCNICFrontObjectionRemarks,
    setApplicantCNICFrontObjectionRemarks,
  ] = useState("");
  const [
    applicantCNICBackObjectionRemarks,
    setApplicantCNICBackObjectionRemarks,
  ] = useState("");
  const [owenershipObjectionRemarks, setowenershipObjectionRemarks] =
    useState("");
  const [electricityBillObjectionRemarks, setElectricityBillObjectionRemarks] =
    useState("");
  const [fbrDocumentObjectionRemarks, setFbrDocumentObjectionRemarks] =
    useState("");

  const [
    preOwnerCNICFrontObjectionRemarks,
    setpreOwnerCNICFrontObjectionRemarks,
  ] = useState("");
  const [
    preOwnerCNICBackObjectionRemarks,
    setpreOwnerCNICBackObjectionRemarks,
  ] = useState("");
  const [perOwenerNOCObjectionRemarks, setperOwenerNOCObjectionRemarks] =
    useState("");
  const [
    newOwenerAffidaviteObjectionRemarks,
    setnewOwenerAffidaviteObjectionRemarks,
  ] = useState("");
  const [
    addDocCivicAuthorityObjectionRemarks,
    setaddDocCivicAuthorityObjectionRemarks,
  ] = useState("");
  const [addDocAnyOtherObjectionRemarks, setaddDocAnyOtherObjectionRemarks] =
    useState("");
  const [addCONConsentObjectionRemarks, setaddCONConsentObjectionRemarks] =
    useState("");

  const [additionalCivicDocument, setAdditionalCivicDocument] = useState("");
  const [
    additionalCivicDocumentThumbnail,
    setAdditionalCivicDocumentThumbnail,
  ] = useState("");
  const [additionalCivicDocumentError, setAdditionalCivicDocumentError] =
    useState("");
  const [inputValue, setInputValue] = useState("");

  const [debouncedInputValue, setDebouncedInputValue] = useState(inputValue);

  const [openObjectionPopup, setOpenObjectionPopup] = useState(false);
  const [allTariffList, setAllTariffList] = useState([]);

  const [receiptImage, setReceiptImage] = useState("");
  const [receiptImageThumbnail, setReceiptImageThumbnail] = useState("");
  const [receiptImageError, setReceiptImageError] = useState("");
  const [dnReceiptImageUploaded, setDnReceiptImageUploaded] = useState("");
  const [paymentDateError, setPaymentDateError] = useState("");
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [remarksError, setRemarksError] = useState(""); // new state
  const [phase, setPhase] = useState();
  const [installedMeterImageError, setInstalledMeterImageError] = useState("");
  const [scoPopUp, setScoPopUp] = useState(false);
  const [showDnExpiryPopup, setShowDnExpiryPopup] = useState(false);
  const [dnExpiryDialogData, setDnExpiryDialogData] = useState({
    applicationId: "",
    issueDate: "",
  });
  const [dialogDnExpiryFlag, setDialogDnExpiryFlag] = useState(null);

  const getCoaHistoryProgressId = (row) =>
    Number(row?.historyProgressId ?? row?.applicationProgressId);

  const COA_APPLICATION_UPDATED_PROGRESS_IDS = [2, 3, 4];

  const isCoaApplicationUpdatedAllowedProgress = (row) => {
    if (!row) return false;
    const applicationProgressId = Number(row.applicationProgressId);
    const historyProgressId = Number(row.historyProgressId);
    if (COA_APPLICATION_UPDATED_PROGRESS_IDS.includes(applicationProgressId)) {
      return true;
    }
    if (COA_APPLICATION_UPDATED_PROGRESS_IDS.includes(historyProgressId)) {
      return true;
    }
    return false;
  };

  const getCoaApplicationUpdatedStepProgressId = (row) => {
    const applicationProgressId = Number(row?.applicationProgressId);
    const historyProgressId = Number(row?.historyProgressId);
    if (COA_APPLICATION_UPDATED_PROGRESS_IDS.includes(applicationProgressId)) {
      return applicationProgressId;
    }
    if (COA_APPLICATION_UPDATED_PROGRESS_IDS.includes(historyProgressId)) {
      return historyProgressId;
    }
    return getCoaHistoryProgressId(row);
  };

  const getCoaHistoryId = (row) =>
    row?.historyId ?? row?.historyID ?? row?.id ?? null;

  const resolveActivityLogHistoryRow = (row) => {
    if (!row || typeof row !== "object") return row;
    return row._raw ?? row;
  };

  const isCoaApplicationUpdatedRemarks = (row) =>
    String(row?.remarks || "")
      .toLowerCase()
      .includes("application updated");

  const shouldOpenCoaApplicationUpdatedPopUp = (historyRow, tableRow) => {
    if (!historyRow || typeof historyRow !== "object") return false;
    if (!isCoaApplicationUpdatedRemarks(historyRow)) return false;
    if (!getCoaHistoryId(historyRow)) return false;

    if (isCoaApplicationUpdatedAllowedProgress(historyRow)) return true;

    const stepLabel = String(
      tableRow?.stepName || historyRow?.coaProgStatusName || ""
    ).toLowerCase();
    return (
      stepLabel.includes("arrear") ||
      stepLabel.includes("field survey") ||
      stepLabel.includes("dn approval")
    );
  };

  const tableColumnsProcessingSummary = [
    {
      header: "Step Name",
      accessorKey: "stepName",
    },
    {
      header: "Processed By",
      accessorKey: "processedBy",
    },
    {
      header: "Date",
      accessorKey: "date",
    },
    {
      header: "Remarks",
      accessorKey: "remarks",
    },
  ];
  let batchArray = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
  ];
  const [tableDataProcessingSummary, setTableDataProcessingSummary] = useState([
    {
      stepName: "Application Submission",
      processedBy: "Akram",
      date: "24-Dec-2023",
      time: "02:23:19 AM",
      remarks: "-",
    },
    {
      stepName: "Application Submission",
      processedBy: "Akram",
      date: "24-Dec-2023",
      time: "02:23:19 AM",
      remarks: "-",
    },
    {
      stepName: "Application Submission",
      processedBy: "Akram",
      date: "24-Dec-2023",
      time: "02:23:19 AM",
      remarks: "-",
    },
    {
      stepName: "Application Submission",
      processedBy: "Akram",
      date: "24-Dec-2023",
      time: "02:23:19 AM",
      remarks: "-",
    },
  ]);

  const [arrearsDetails, setArrearsDetails] = useState({
    arrearsAmount: "",
    meterStatus: "",
    tariffDesc: "",
    meterType: "",
    phase: "",
    consumerName: "",
    consumerNo: "",
    consumerAddress: "",
    consumerEmail: "",
  });

  const [arrearsDetailsToDisplay, setArrearsDetailsToDisplay] = useState({
    refNo: "",
    arrearsAmount: "",
    meterStatus: "",
    tariffDesc: "",
    meterType: "",
    phase: "",
    consumerName: "",
    consumerNo: "",
    consumerAddress: "",
    consumerEmail: "",
    paidArearImage: "",
    paidArearDate: "",
  });

  const [consentImageDetails, setConsentImageDetails] = useState({
    consentImageChnageofName: "",
    consentImageChnageofNameFlag: "",
  });
  const [consentImagePopUp, setConsentImagePopUp] = useState(false);

  const [dnDetails, setDnDetails] = useState({
    demandNoticeNo: "",
    issueDate: "",
    applicationId: "",
    dueDate: "",
    roOfficeAddress: "",
    consumerAccountNo: "",
    batchNo: "",
    tariff: "",
    bankName: "",
    industryFactoryType: null,
    connectionAccountNo: "",
    dnPaymentFlag: null,
    paymentMethod: null,
    dnPaymentVerificationFlag: null,
    previousSecurity: null,
    sanctionLoad: "",
    filledBy: null,
    filledDate: "",
    filledFlag: null,
    approvedBy: null,
    approvedDate: null,
    approvedFlag: null,
    connectionCatagoryType: null,
    dNamount: null,
  });

  const [sjoDetails, setSjoDetails] = useState({
    subDivisionCode: null,
    sCONo: "",
    scoCreationDate: "",
    applicationId: "",
    applicationSubmissionDate: null,
    accountNo: null,
    feederNo: null,
    batch: null,
    applicantNewName: null,
    applicantOldTariff: null,
    applicantOldLoad: null,
    applicantNewTariff: null,
    applicantNewLoad: null,
    applicationType: null,
    mobileNo: null,
    date: null,
    materNo: null,
    cNICNo: null,
    securityDepositDNNo: null,
    dNCreationDate: null,
    ammountOfSecurityDeposit: null,
    dNPaymentDate: null,
    ammountOfCapitalCost: 0,
    capitalCostPaymentDate: null,
    filledBy: null,
    filledDate: null,
    filledFlag: null,
    approvedBy: null,
    approvedDate: null,
    approvedFlag: null,
  });

  const [masterDataFormDetails, setMasterDataFormDetails] = useState({
    applicationId: "",
    electricityDuty: "",
    governmentDepartment: "",
    standardClassificationCode: "",
    incomeTax: "",
    reason: "",
    authority: "",
    filledBy: "",
    filledByDate: "",
    filledByFlag: "",
    approvedBy: "",
    approvalDate: "",
    approvalFlag: "",
  });

  const [scoDetails, setScoDetails] = useState({
    scoId: "",
    applicationId: "",
    scoCreationDate: "",
    urbanRural: "",
    fataPata: "",
    refNo: "",
    feederNo: "",
    batch: "",
    subBatch: "",
    fGovt: "",
    cantonmentBoard: "",
    pGovt: "",
    localBodies: "",
    scoP1FilledBy: "",
    scoP1FillingDate: "",
    scoP1FillFlag: "",
    authorizedByName: "",
    dateOfAuthorization: "",
    scoP1ApprovedFlag: "",
    storeRequisitionNo: "",
    storeRequisitionDate: "",
    seasonalFlag: "",
    senctionLoad: "",
    noOfACs: "",
    noOfMeters: "",
    noOfMeterSets: "",
    noOfSubSets: "",
    noOfSupplyPoints: "",
    installedTransformerCapacity: "",
    meterId: "",
    meterNo: "",
    locationCode: "",
    meterCode: "",
    manufacturerCode: "",
    multiplyingFactor: "",
    meterRange: "",
    meterReading: "",
    dateOfConnection: "",
    cp78ItemNo: "",
    tieUpNonTieUp: "",
    sealOnMeter: "",
    sealOnBox: "",
    securitySlipOrPriceBondNo: "",
    connectionInstallerName: "",
    scoP2FilledBy: "",
    scoP2FillingDate: "",
    scoP2FillFlag: "",
    scoP2ApprovedBy: "",
    scoP2ApprovalDate: "",
    scoP2ApprovalFlag: "",
    installedMeterImage: "",
    meterType: null,
    threePhasePeak: null,
    threePhaseOffPeak: null,
    mdi: null,
    noOfMDIreset: null,
    cT: "",
    pT: "",
    threePhasePeakKVARH: "",
    threePhaseOffPeakKVARH: "",
    threePhasePeakKWH: "",
    threePhaseOffPeakKWH: "",
  });

  const [viewBackdrop, setViewBackdrop] = useState(false);

  const documentObjections = [
    -"Applicant CNIC document doesn't matches the entered applicant CNIC number.",
    "Owner CNIC document doesn't matches the entered owner CNIC.",
    "Invalid applicant CNIC document attached.",
    "Invalid owner CNIC document attached.",
    "Invalid property document attached.",
    "Invalid owner NOC attached.",
    "Others",
  ];

  const fieldObjections = [
    "Unelectrified area / No Lt network.",
    "Meters already installed at applied premisies.",
    "Invalid address.",
    "Premises / Property is disputed or sub judice.",
    "Load at site exceeds than applied.",
    "No load / building at site.",
    "Transformer overloaded",
    "Others",
  ];
  let subBatchArray = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
  ];
  const [copyOfApplicantCNICVerifyPopUp, setCopyOfApplicantCNICVerifyPopUp] =
    useState(false);
  const [preOwnerCNICVerifyPopUp, setPreOwnerCNICVerifyPopUp] = useState(false);
  const [owenershipDocumentVerifyPopUp, setOwenershipDocumentVerifyPopUp] =
    useState(false);
  const [
    electricityBillDocumentVerifyPopUp,
    setElectricityBillDocumentVerifyPopUp,
  ] = useState(false);
  const [fbrDocumentVerifyPopUp, setFbrDocumentVerifyPopUp] = useState(false);
  const [paidBillPopUp, setPaidBillPopUp] = useState(false);

  const [perOwenerNOCVerifyPopUp, setPerOwenerNOCVerifyPopUp] = useState(false);
  const [newOwenerAffidaviteVerifyPopUp, setNewOwenerAffidaviteVerifyPopUp] =
    useState(false);
  const [addDocCivicAuthorityVerifyPopUp, setAddDocCivicAuthorityVerifyPopUp] =
    useState(false);
  const [addDocAnyOtherVerifyPopUp, setAddDocAnyOtherVerifyPopUp] =
    useState(false);
  const [addDocCONConsentVerifyPopUp, setAddDocCONConsentVerifyPopUp] =
    useState(false);

  const [flag_applicantCNICFront, setFlag_applicantCNICFront] = useState(null);
  const [flag_applicantCNICBack, setFlag_applicantCNICBack] = useState(null);
  const [flag_owenershipDocument, setFlag_owenershipDocument] = useState(null);
  const [flag_electricityBillDocument, setFlag_electricityBillDocument] =
    useState(null);
  const [flag_fbrDocument, setFlag_fbrDocument] = useState(null);

  const [flag_preOwnerCNICFront, setFlag_PreOwnerCNICFront] = useState(null);
  const [flag_preOwnerCNICBack, setFlag_PreOwnerCNICBack] = useState(null);
  const [flag_perOwenerNOC, setFlag_perOwenerNOC] = useState(null);
  const [flag_newOwenerAffidavite, setFlag_newOwenerAffidavite] =
    useState(null);
  const [flag_addDocCivicAuthority, setFlag_addDocCivicAuthority] =
    useState(null);
  const [flag_addDocAnyOther, setFlag_addDocAnyOther] = useState(null);
  const [flag_addCONConsent, setFlag_addDocCONConsent] = useState(null);
  const [manufacturerCode, setManufcaturerCode] = useState({
    code: null,
    name: "",
  });
  const manufacturesList = [
    { code: 1, name: "General Electric" },
    { code: 10, name: "Climax" },
    { code: 11, name: "Escorts" },
    { code: 12, name: "Schlumburger France" },
    { code: 13, name: "CHINA" },
    { code: 14, name: "TIP" },
    { code: 15, name: "RUSSIAN" },
    { code: 16, name: "BULGARIA" },
    { code: 17, name: "BRAZIL" },
    { code: 18, name: "GANZ" },
    { code: 19, name: "BELGIUM" },
    { code: 2, name: "Westinghouse" },
    { code: 20, name: "SWITZERLAND" },
    { code: 21, name: "KRIZIK" },
    { code: 22, name: "HITACHI" },
    { code: 23, name: "ISKARA" },
    { code: 24, name: "ELGMA(TOU)" },
    { code: 25, name: "USA(TOD)" },
    { code: 26, name: "SABEECO" },
    { code: 27, name: "MICRO TECH" },
    { code: 28, name: "ETHOPIA" },
    { code: 29, name: "LETHIANIA" },
    { code: 3, name: "Landis & Gyr" },
    { code: 30, name: "M.T.I Micro Tech" },
    { code: 31, name: "SBEEC" },
    { code: 32, name: "Hexing(China)" },
    { code: 33, name: "Creative Electronics" },
    { code: 34, name: "Elektromed" },
    { code: 35, name: "J n P" },
    { code: 36, name: "TRANSFAB" },
    { code: 37, name: "HAMEED" },
    { code: 38, name: "ELEMATIC" },
    { code: 39, name: "TRANSPAK" },
    { code: 4, name: "Aeg" },
    { code: 40, name: "NECOPE" },
    { code: 41, name: "TRANSFOPOWER" },
    { code: 42, name: "IRAN" },
    { code: 43, name: "ACE INDIGO" },
    { code: 44, name: "PAN POWER" },
    { code: 45, name: "AB AMPERRE" },
    { code: 46, name: "POWER TECH" },
    { code: 47, name: "J.F.INDUSTRIES" },
    { code: 48, name: "KBK" },
    { code: 49, name: "M / S HAMMAD" },
    { code: 5, name: "Siemens" },
    { code: 50, name: "M / S NATIONAL" },
    { code: 51, name: "M / S IMS" },
    { code: 52, name: "ACCURATE COMPANY" },
    { code: 53, name: "VERTEX STATIC" },
    { code: 54, name: "ELSTER" },
    { code: 55, name: "RECLAIMED" },
    { code: 56, name: "KAIFA" },
    { code: 57, name: "XJ" },
    { code: 58, name: "CHINT" },
    { code: 59, name: "PEL" },
    { code: 6, name: "GEC" },
    { code: 7, name: "Ferranti" },
    { code: 8, name: "Mitsubishi" },
    { code: 9, name: "Syed Bhais" },
  ];
  // Dropdown companies list
  const companies = [
    { code: "11", name: "LESCO", logo: LESCODDLOGO },
    { code: "12", name: "GEPCO", logo: GEPCODDLOGO },
    { code: "13", name: "FESCO", logo: FESCODDLOGO },
    { code: "14", name: "IESCO", logo: IESCODDLOGO },
    { code: "15", name: "MEPCO", logo: MEPCODDLOGO },
    { code: "26", name: "PESCO", logo: PESCODDLOGO },
    { code: "27", name: "HAZECO", logo: HAZECODDLOGO },
    { code: "37", name: "HESCO", logo: HESCODDLOGO },
    { code: "38", name: "SEPCO", logo: SEPCODDLOGO },
    { code: "48", name: "QESCO", logo: QESCODDLOGO },
    { code: "59", name: "TESCO", logo: TESCODDLOGO },
  ];

  // Selected officeCode state
  const [selectedOfficeCode, setSelectedOfficeCode] = useState("15");
  const [foundInCON, setFoundInCON] = useState();
  const { state } = useLocation();
  const { foundId } = state ? state : "";

  //#endregion
  useEffect(() => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      cfpBaseUrl + "changeOfAttributes/getChangeOfAttributesLookupData",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          setLookUpDataOfCON(result.data);
        }
      })
      .catch((error) => console.error(error));
  }, [token, cfpBaseUrl]);

  useEffect(() => {
    setPartialValue(dialogRowData.subDivisionCode);
  }, [dialogRowData]);

  useEffect(() => {
    if (props.showTable && currentPath == "/change-of-attributes-table") {
      dispatch(
        fetchPaginatedChangeOfAttributesOverdue({
          page: currentPageOverdue,
          pageSize: pageSizeOverdue,
          dateFrom: dateFromOverdue,
          dateTo: dateToOverdue,
          applicationProgressId: applicationProgressIdOverdue,
          objectionStatus: objectionStatusOverdue,
          officeCode: selectedOfficeCode || code,
        })
      );
    }
  }, [
    currentPageOverdue,
    pageSizeOverdue,
    dateFromOverdue,
    dateToOverdue,
    applicationProgressIdOverdue,
    objectionStatusOverdue,
    selectedOfficeCode,
  ]);

  useEffect(() => {
    if (props.showTable && currentPath == "/change-of-attributes-table") {
      if (token) {
        setViewBackdrop(true);
        dispatch(
          fetchPaginatedChangeOfAttributesNormal({
            page: currentPageNormal,
            pageSize: pageSizeNormal,
            dateFrom: dateFromNormal,
            dateTo: dateToNormal,
            applicationProgressId: applicationProgressIdNormal,
            objectionStatus: objectionStatusNormal,
            officeCode: selectedOfficeCode || code,
          })
        );
      }
    }
  }, [
    currentPageNormal,
    pageSizeNormal,
    dateFromNormal,
    dateToNormal,
    applicationProgressIdNormal,
    objectionStatusNormal,
    selectedOfficeCode,
  ]);

  // useEffect(() => {
  //   if (props.showTable && currentPath == "/change-of-attributes-table") {
  //     setViewBackdrop(true);
  //     dispatch(
  //       fetchPaginatedChangeOfAttributesNormal({
  //         page: currentPageNormal,
  //         pageSize: pageSizeNormal,
  //         dateFrom: dateFromNormal,
  //         dateTo: dateToNormal,
  //         applicationProgressId: applicationProgressIdNormal,
  //         objectionStatus: objectionStatusNormal,
  //         officeCode: selectedOfficeCode || code,
  //       })
  //     );
  //   }
  // }, []);
  //#region formiks

  const filterOptions = (options, { inputValue }, fields = []) => {
    const trimmedInputValue = inputValue.trim().toLowerCase();
    const inputLength = trimmedInputValue.length;
    let count = 0;

    return inputLength === 0
      ? options
      : options.filter((option) => {
        const optionLabel = fields
          .map((field) => option[field])
          .join("")
          .toLowerCase();

        const containsInput = optionLabel.includes(trimmedInputValue);
        const match = containsInput && count < 5;
        if (match) {
          count += 1;
        }
        return match;
      });
  };

  const arearsFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_property_reference_no: Yup.string()
        .required("Enter the reference number to get arrear details.")
        .min(14, "Enter 14 digit reference number.")
        .max(14, "Enter 14 digit reference number."),
    }),
    onSubmit: async (values, { resetForm }) => {
      var formdata = new FormData();
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      formdata.append("refNo", values.iv_property_reference_no);
      formdata.append("arrearAmount", arrearsDetails.arrearsAmount);
      formdata.append("meterStatus", arrearsDetails.meterStatus);
      formdata.append("tariff", arrearsDetails.tariffDesc);
      formdata.append("meterType", arrearsDetails.meterType);
      formdata.append("phase", arrearsDetails.phase);
      formdata.append("consumerName", arrearsDetails.consumerName);
      formdata.append("consumerPhoneNo", arrearsDetails.consumerNo);
      formdata.append("consumerEmail", arrearsDetails.consumerEmail);
      formdata.append("consumerAddress", arrearsDetails.consumerAddress);
      formdata.append("applicationNo", dialogRowData.applicationId);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "comman/insertArrear", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            if (arrearsDetails.arrearsAmount !== "") {
              callChangeObjectionStatus(
                "Arrears Verification",
                1,
                "Arrears Objection"
              );
              setArrearsEntryPopUpOpen(false);
            } else {
              callChangeObjectionStatus(
                "Arrears Verification",
                0,
                "Arrears Objection Removed"
              );
              callArrearVerificationAPI(
                3,
                "Arrears Verified",
                "Arrears Verified",
                "",
                dialogRowData.applicationId
              );
              resetForm();
              setArrearsEntryPopUpOpen(false);
              setOpen(false);
            }
          } else {
            setError("Arrears objection submission failed!");
          }
        })
        .catch((error) => console.log("error", error));
    },
  });

  const fieldFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_batch: Yup.mixed().when(["iv_batch_change", "iv_objection_Type"], {
        is: (iv_batch_change, iv_objection_Type) =>
          iv_batch_change === true ||
          iv_batch_change === "true" ||
          iv_objection_Type === "5" ||
          iv_objection_Type === 5,
        then: (schema) => schema.required("Select batch."),
        otherwise: (schema) => schema.notRequired(),
      }),

      iv_reference_to_allot: Yup.string().when(
        ["iv_batch_change", "iv_objection_Type"],
        {
          is: (iv_batch_change, iv_objection_Type) =>
            iv_batch_change === true ||
            iv_batch_change === "true" ||
            iv_objection_Type === "5" ||
            iv_objection_Type === 5,
          then: (schema) =>
            schema
              .required("Enter reference no. to allot.")
              .min(7, `Reference no. can't be < 7 digits.`)
              .max(7, `Reference no. can't > 7 digits.`)
              .matches(/^[0-9]+$/, "Enter reference no. as 0123456"),
          otherwise: (schema) => schema.notRequired(),
        }
      ),
      iv_remarks_others: Yup.string().when(["iv_objection_Type"], {
        is: (iv_objection_Type) =>
          iv_objection_Type === "6" || iv_objection_Type === 6,
        then: (schema) =>
          schema
            .required("Enter remarks.")
            .min(10, "Remarks must be at least 10 characters long."),
        otherwise: (schema) => schema.notRequired(),
      }),

      iv_sub_batch: Yup.mixed().when("iv_batch_change", {
        is: true,
        then: (schema) => schema.required("Select sub batch."),
        otherwise: (schema) => schema.notRequired(),
      }),

      iv_sketch_diagram: Yup.mixed().when("iv_material_required", {
        is: (iv_material_required) => iv_material_required === true,
        then: Yup.mixed().required("Upload the sketch diagram."),
        otherwise: Yup.mixed().optional(),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      if (values.iv_objection_Type == 1) {
        if (boqItems.length == 0 && values.iv_material_required === true) {
          setErrormessageBoqEstimation(
            "Please add BOQ items before submitting."
          );
          return;
        }

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          areaType: values.iv_area_type,
          tariff:
            dialogRowData.changeOfAttributesType == 3 ||
              dialogRowData.changeOfAttributesType == 4 ||
              dialogRowData.changeOfAttributesType == 6 ||
              dialogRowData.changeOfAttributesType == 7
              ? dialogRowData.newTariff?.replace(/-/g, "")
              : dialogRowData.currentTariff?.replace(/-/g, ""),
          connectionType:
            dialogRowData.changeOfAttributesType == 3 ||
              dialogRowData.changeOfAttributesType == 4 ||
              dialogRowData.changeOfAttributesType == 6 ||
              dialogRowData.changeOfAttributesType == 7
              ? dialogRowData.newConnectionType
              : dialogRowData.connectionType,
          sanctionLoad:
            dialogRowData.changeOfAttributesType == 2 ||
              dialogRowData.changeOfAttributesType == 4 ||
              dialogRowData.changeOfAttributesType == 5 ||
              dialogRowData.changeOfAttributesType == 7
              ? dialogRowData.newSanctionLoad
              : dialogRowData.currentSanctionLoad,
          applicationId: dialogRowData.applicationId,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(
          cfpBaseUrl + "changeOfAttributes/costEstimationForCOA",
          requestOptions
        )
          .then((response) => response.json())
          .then((result) => {
            setCostEstimationForNC(result.data[0]);
            setShowCostEstimation(true);
          })
          .catch((error) => console.error(error));
      } else {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          applicationProgressId: dialogRowData.applicationProgressId,
          objectionStatus: 1,
          remarks: "Field Surveyed with Objection.",
          remarksDetail:
            values.iv_objection_Type == 6
              ? values.iv_remarks_others
              : "Field Surveyed with Objection.",
          sketchDiagram: "",
          observationType: values.iv_objection_Type,
          alreadyInstalledRefNo:
            fieldFormik.values.iv_objection_Type == "5"
              ? fieldFormik.values.iv_batch +
              partialValue +
              fieldFormik.values.iv_reference_to_allot
              : "",
          isMaterialRequired: "",
          isMeterNeedsToBeReplaced: "",
          submittedThrough: "e-Operation",
          areaType: "",
          tariff: "",
          sanctionLoad: "",
          bankName: "",
          isBatchChangeRequired: "",
          batchNo: "",
          subBatchNo: "",
          connectionAccountNo: "",
          amountOfGridSharing: "",
          amountOfFeederRehab: "",
          civilWorkCharges: "",
          fixedChargesOfMetering: "",
          miscellaneousCharges: "",
          lessTheCost: "",
          capitalCostAmount: "",
          securityDepositAmount: "",
          meterType: "",
          BoQItems: [],
          seasonalFlag: "",
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(
          cfpBaseUrl +
          "changeOfAttributes/saveFieldSurveyAndCostEstimateForCOA",
          requestOptions
        )
          .then((response) => response.json())
          .then((result) => {
            setShowCostEstimation(false);
            handleClose();
          })
          .catch((error) => console.error(error));
      }
    },
  });

  const fieldRemoveObjectionFormik = useFormik({
    enableReinitialize: true, // ensures it reacts to changes
    initialValues: {
      iv_additional_civic_document: "",
      iv_remarks: "",
    },
    validationSchema: Yup.object({
      iv_additional_civic_document: Yup.string().when([], {
        is: () => fieldFormik?.values?.iv_objection_Type == "4",
        then: (schema) => schema.required("Please upload a document."),
        otherwise: (schema) => schema.notRequired(),
      }),
      iv_remarks: Yup.string()
        .min(10, "Minimum 10 characters required.")
        .max(300, "Maximum 300 characters allowed.")
        .required("Please enter remarks."),
    }),
    onSubmit: async (values) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: dialogRowData.applicationProgressId,
        objectionStatus: 0,
        remarks: "Field Survey Objection Removed.",
        remarksDetail: values.iv_remarks,
        submittedThrough: "e-Operation",
        civicAuthorityDocs:
          fieldFormik.values.iv_objection_Type == "4"
            ? additionalCivicDocumentThumbnail
            : "",
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "changeOfAttributes/romeveCOAFieldSurveyObjecton",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            handleClose();
          }
        })
        .catch((error) => console.error(error));
    },
  });

  const scoPart1Formik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_store_requisition_no: Yup.string()
        .required("Store Requisition No. is required")
        .test(
          "check-iv_store_requisition_no",
          "Store Requisition No. must be 6 digits",
          function (value) {
            const { dialogRowData } = this.options.context;
            const appId = dialogRowData?.applicationId || "";
            const status = dialogRowData?.status;
            if (appId.slice(3, 5) === "13") {
              return true;
            }

            if (status === "Approved") {
              return !!value && value.length === 6;
            }
            return true;
          }
        ),

      iv_store_requisition_date: dialogRowData?.storeRequisitionDate
        ? Yup.string()
        : Yup.string().required("Store Requisition Date is required"),
      iv_sanctioned_load: Yup.number()
        .when([], {
          is: () => dialogRowData.connectionType === "Domestic",
          then: Yup.number()
            .min(2, "Load can't be less than 2.")
            .max(1000, "Residential Maximum Load 1000kW.")
            .required("Enter sanctioned load."),
        })
        .when([], {
          is: () => dialogRowData.connectionType === "Commercial",
          then: Yup.number()
            .min(2, "Load can't be less than 2.")
            .max(5000, "Commercial Maximum Load 5000kW.")
            .required("Enter sanctioned load."),
        })
        .when([], {
          is: () => dialogRowData.connectionType === "Industrial",
          then: Yup.number()
            .min(2, "Load can't be less than 2.")
            .required("Enter sanctioned load."),
        })
        .when([], {
          is: () => dialogRowData.connectionType === "Agriculture",
          then: Yup.number()
            .min(2, "Load can't be less than 2.")
            .max(5000, "Applied load cannot be more than 5000kW.")
            .required("Enter sanctioned load."),
        })
        .when([], {
          is: () =>
            [
              "Tubewell",
              "Temporary",
              "GeneralServices",
              "Electrification",
              "StreetLight",
              "CorporateCompany",
            ].includes(dialogRowData.connectionType),
          then: Yup.number()
            .min(2, "Load can't be less than 2.")
            .max(5000, "Applied load cannot be more than 5000kW.")
            .required("Enter sanctioned load."),
        })
        .required("Enter sanctioned load."),
      iv_seasonal_flag: Yup.mixed().when("phase", {
        is: () => phase != "Single Phase" || phase != "3 Phase",
        then: Yup.mixed().required("Select seasonal / non seasonal value."),
        otherwise: Yup.mixed().optional(),
      }),
      iv_meter_range: Yup.number("Range should be a number.")
        .min(4, "Range can't be less than 4.")
        .max(8, "Range can't be greater than 8.")
        .required("Enter meter range."),
      iv_meter_code1: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase", // Apply validations if phase is 'Three Phase'
        then: Yup.string()
          .matches(/^[0-9]{6}$/, "Code must be a 6-digit number.") // Ensure it's a 6-digit number
          .test(
            "valid-start",
            "The first two digits must be 00, 01, 02, 03, 04, or 05.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const firstTwoDigits = parseInt(value.substring(0, 2), 10);
              return [0, 1, 2, 3, 4, 5].includes(firstTwoDigits);
            }
          )
          .test(
            "validate-3rd-digit",
            "The 3rd digit must be 0, 1, 2.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const thirdDigit = parseInt(value.substring(2, 3), 10);
              return [0, 1, 2].includes(thirdDigit);
            }
          )
          .test(
            "validate-4th-digit",
            "The 4th digit must be 1, 2, 6, 7.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const fourthDigit = parseInt(value.substring(3, 4), 10);
              return [1, 2, 6, 7].includes(fourthDigit);
            }
          )
          .test(
            "last-digits",
            "The last 2 digits must be 00, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12, 13.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const lastDigits = parseInt(value.substring(4), 10);
              return [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].includes(
                lastDigits
              );
            }
          )
          .test(
            "single-phase-code",
            "Code can't be of single phase.",
            (value) => {
              if (!value) return false;
              return value != "000002";
            }
          )
          .test(
            "three-phase-code",
            "Code can't be of 3 phase (whole current).",
            (value) => {
              if (!value) return false;
              return value != "050502" || value != "050602";
            }
          )
          .required("Enter meter code."),
        otherwise: Yup.string()
          .oneOf(
            ["000002", "050502"],
            "For Single Phase, the meter code must be 000002."
          )
          .required("Enter meter code."),
      }),
      iv_meter_code2: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .matches(/^[0-9]{6}$/, "Code must be a 6-digit number.") // Ensure it's a 6-digit number
          .test(
            "valid-start",
            "The first two digits must be 00, 01, 02, 03, 04, or 05.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const firstTwoDigits = parseInt(value.substring(0, 2), 10);
              return [0, 1, 2, 3, 4, 5].includes(firstTwoDigits);
            }
          )
          .test(
            "validate-3rd-digit",
            "The 3rd digit must be 0, 1, 2.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const thirdDigit = parseInt(value.substring(2, 3), 10);
              return [0, 1, 2].includes(thirdDigit);
            }
          )
          .test(
            "validate-4th-digit",
            "The 4th digit must be 1, 2, 6, 7.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const fourthDigit = parseInt(value.substring(3, 4), 10);
              return [1, 2, 6, 7].includes(fourthDigit);
            }
          )
          .test(
            "last-digits",
            "The last 2 digits must be 00, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12, 13.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const lastDigits = parseInt(value.substring(4), 10);
              return [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].includes(
                lastDigits
              );
            }
          )
          .test(
            "single-phase-code",
            "Code can't be of single phase.",
            (value) => {
              if (!value) return false;
              return value != "000002";
            }
          )
          .test(
            "three-phase-code",
            "Code can't be of 3 phase (whole current).",
            (value) => {
              if (!value) return false;
              return value != "050502" || value != "050602";
            }
          )
          .required("Enter meter code."),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_transformer_code: Yup.string().optional(),
      iv_transformer_refNo: Yup.string().when("$userCompany", {
        is: (val) => val !== "13", // Compare as string
        then: Yup.string()
          .required("Transformer reference no is required.")
          .min(14, "Please enter 14 digit transformer reference no.")
          .max(14, "Please enter 14 digit transformer reference no.")
          .matches(
            /^[0-9]+$/,
            "Enter 14 digit transformer reference no as 01234567891234"
          ),
        otherwise: Yup.string() // optional if userCompany is '13'
          .min(14, "Please enter 14 digit transformer reference no.")
          .max(14, "Please enter 14 digit transformer reference no.")
          .matches(
            /^[0-9]+$/,
            "Enter 14 digit transformer reference no as 01234567891234"
          )
          .optional(),
      }),

      iv_location_code: Yup.mixed().required("Select location."),
      iv_manufacturer_code: Yup.string().required("Select Manufacturer."),
      // iv_meter_serial_no: Yup.string()
      //   .required('Enter meter number.')
      //   .min(7, 'Meter no. should be 7 digits.')
      //   .max(15, 'Meter no. should be 15 digits.')
      //   .matches(/^[0-9]+$/, "Meter no. should be number only.")
      //   .when('iv_manufacturer_code', (iv_manufacturer_code, schema) => {
      //     return schema.test(
      //       'starts-with-manufacturer-code',
      //       'Meter number should start with the manufacturer code.',
      //       (value) => value && value.startsWith(iv_manufacturer_code.toString())
      //     )
      //   }
      //   ),
      // iv_meter_serial_no: Yup.string()
      //   .required('Enter meter number.')
      //   .length(10, 'Meter number should be exactly 10 digits.')
      //   .matches(/^\d{10}$/, 'Meter number should contain digits only.')
      //   .when('iv_manufacturer_code', (iv_manufacturer_code, schema) => {
      //     return schema.test(
      //       'starts-with-manufacturer-code',
      //       'Meter number should start with the manufacturer code.',
      //       (value) =>
      //         value &&
      //         iv_manufacturer_code &&
      //         value.startsWith(iv_manufacturer_code.toString())
      //     );
      //   }),
      iv_meter_serial_no: Yup.string()
        .required("Enter Meter serial no.")
        .length(10, "Meter serial no. should be exactly 10 digits.")
        .matches(/^\d{10}$/, "Meter serial no. should contain digits only."),

      // iv_sim_number: Yup.string().when([], {
      //   is: () => scoDetails?.meterType === 1 || scoDetails?.meterType === "1",
      //   then: (schema) =>
      //     schema
      //       .required('Enter SIM number.')
      //       .matches(/^03[0-9]{9}$/, 'SIM number must start with 03 and be 11 digits total.'),
      //   otherwise: (schema) => schema.notRequired(),
      // }),

      // iv_sim_ID: Yup.string().when([], {
      //   is: () => scoDetails?.meterType === 1 || scoDetails?.meterType === "1",
      //   then: (schema) =>
      //     schema
      //       .required('Enter SIM ID.')
      //       .min(18, 'SIM ID should be at least 18 characters.')
      //       .max(20, 'SIM ID should not exceed 20 characters.'),
      //   otherwise: (schema) => schema.notRequired(),
      // }),
      iv_sim_number: Yup.string()
        .nullable()
        .when([], {
          is: () =>
            scoDetails?.meterType !== 0 && scoDetails?.meterType !== "0",
          then: (schema) =>
            schema
              .required("Enter SIM number.")
              .matches(
                /^03[0-9]{9}$/,
                "SIM number must start with 03 and be 11 digits total."
              ),
          otherwise: (schema) => schema.notRequired(),
        }),

      iv_sim_ID: Yup.string()
        .nullable()
        .when([], {
          is: () =>
            scoDetails?.meterType !== 0 && scoDetails?.meterType !== "0",
          then: (schema) =>
            schema
              .required("Enter SIM ID.")
              .min(18, "SIM ID should be at least 18 characters.")
              .max(20, "SIM ID should not exceed 20 characters."),
          otherwise: (schema) => schema.notRequired(),
        }),

      iv_meter_reading: Yup.string().when("phase", {
        is: () => phase === "Single Phase",
        then: Yup.string()
          .max(9, "Meter reading can not be more than 999999999.")
          .min(1, "Meter reading can not be less than 1.")
          .required("Enter meter reading.")
          .matches(/^[0-9]+$/, "Enter meter reading in numbers."),
        otherwise: Yup.string().optional(),
      }),
      iv_meter_reading_peak_kwh: Yup.string().when("phase", {
        is: () => phase != "Single Phase",
        then: Yup.string()
          .required("Enter peak reading.")
          .test(
            "is-decimal",
            "Enter peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value)
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_meter_reading_off_peak_kwh: Yup.string().when("phase", {
        is: () => phase != "Single Phase",
        then: Yup.string()
          .required("Enter off peak reading.")
          .test(
            "is-decimal",
            "Enter off peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value)
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_meter_reading_peak_kvarh: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .required("Enter peak reading.")
          .test(
            "is-decimal",
            "Enter peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value)
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_meter_reading_off_peak_kvarh: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .required("Enter peak reading.")
          .test(
            "is-decimal",
            "Enter off peak reading in numbers with up to 3 decimal places.",
            (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value)
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_date_of_connection: Yup.date()
        .max(new Date(), "Connection date must be in the past.")
        .required("Enter connection date."),
      iv_connection_installer_name: Yup.string()
        .required("Enter installed by name.")
        .max(30, "Name should be less than 30 characters."),
      iv_installed_meter_image: Yup.mixed().when("scoDetails.scoP2FillFlag", {
        is: () => {
          return (
            scoDetails?.scoP2FillFlag === 0 ||
            scoDetails?.scoP2FillFlag === "" ||
            scoDetails?.scoP2FillFlag === null
          );
        },
        then: Yup.mixed().required("Upload meter image."),
        otherwise: Yup.mixed().optional(),
      }),
      iv_meter_type: Yup.mixed().required("Select meter type!"),
      iv_ct_nom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter CT Nom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter CT Nom in whole numbers greater than 0."
          )
          .test(
            "is-positive",
            "CT Nom must be greater than 0.",
            (value) => parseFloat(value) > 0
          )
          .test(
            "ct-standard-values",
            "The CT Nom must be 100, 200, 300, 400, 600, 800, 1000.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const ctNom = parseInt(value, 10);
              return [100, 200, 300, 400, 600, 800, 1000].includes(ctNom);
            }
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_ct_denom: Yup.string().when("phase", {
        is: (phase) => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter CT Denom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter CT Denom in whole numbers greater than 0."
          )
          .test(
            "is-positive",
            "CT Denom must be greater than 0.",
            (value) => parseFloat(value) > 0
          )
          .test(
            "is-less-than-nom",
            "CT Denom must be less than CT Nom.",
            function (value) {
              const { iv_ct_nom } = this.parent; // Access sibling field
              if (!iv_ct_nom || !value) return true; // Skip validation if either value is missing
              return (
                (iv_ct_nom == 1 && value == 1) ||
                parseInt(value, 10) < parseInt(iv_ct_nom, 10)
              );
            }
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_pt_nom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter PT Nom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter PT Nom in natural numbers greater than 0."
          )
          .test(
            "is-positive",
            "PT Denom must be greater than 0.",
            (value) => parseFloat(value) > 0
          )
          .test(
            "is-less-than-nom",
            "PT Denom must be less than PT Nom.",
            function (value) {
              const { iv_pt_nom } = this.parent; // Access sibling field
              if (!iv_pt_nom || !value) return true; // Skip validation if either value is missing
              return parseInt(value, 10) >= parseInt(iv_pt_nom, 10);
            }
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_pt_denom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter PT Nom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter PT Denom in natural numbers greater than 0."
          )
          .test(
            "is-positive",
            "PT Nom must be greater than 0.",
            (value) => parseFloat(value) > 0
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_mdi: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .required("Enter PT Denom.")
          .matches(/^[1-9]\d*$/, "Enter PT Denom in numbers greater than 0.")
          .test(
            "is-positive",
            "PT Denom must be greater than 0.",
            (value) => parseFloat(value) > 0
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_no_of_mdi_resets: Yup.string().when("phase", {
        is: () => phase != "Single Phase" && phase != "3 Phase",
        then: Yup.string()
          .max(5, "No. of MDI reset can not be more than 99999.")
          .min(1, "No. of MDI reset can not be less than 1.")
          .required("Enter No. of MDI reset.")
          .matches(/^[0-9]+$/, "Enter No. of MDI reset in numbers."),
        otherwise: Yup.string().optional().nullable(),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        objectionStatus: 0,
        applicationProgressId: 7,
        remarks: "Meter Installed on premises.",
        remarksDetail: "Meter Installed on premises.",
        scoFillFlag: 1,
        scoApprovalFlag: 0,
        storeRequisitionNo: values.iv_store_requisition_no,
        storeRequisitionDate: values.iv_store_requisition_date,
        seasonalFlag: values.iv_seasonal_flag,
        senctionLoad: values.iv_sanctioned_load,
        installedTransformerCapacity: values.iv_transformer_code,
        transformerRefNo: values.iv_transformer_refNo,
        meterNo: values.iv_meter_serial_no,
        locationCode: values.iv_location_code,

        meterCode1: values.iv_meter_code1,
        meterCode2: values.iv_meter_code2,
        manufacturerCode: values.iv_manufacturer_code,
        multiplyingFactor:
          phase != "Single Phase" && phase != "3 Phase"
            ? calculateMF(
              values.iv_ct_nom,
              values.iv_ct_denom,
              values.iv_pt_nom,
              values.iv_pt_denom
            )
            : "",
        meterRange: values.iv_meter_range,
        meterReading: phase === "Single Phase" ? values.iv_meter_reading : "",
        dateOfConnection: values.iv_date_of_connection,
        installedMeterImage: installedMeterImageThumbnail,

        cT:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_ct_nom / values.iv_ct_denom
            : "",
        cTD:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_ct_denom
            : "",
        cTN:
          phase != "Single Phase" && phase != "3 Phase" ? values.iv_ct_nom : "",
        pT:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_pt_nom / values.iv_pt_denom
            : "",
        pTD:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_pt_denom
            : "",
        pTN:
          phase != "Single Phase" && phase != "3 Phase" ? values.iv_pt_nom : "",
        threePhasePeakKVARH:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_meter_reading_peak_kvarh
            : "",
        threePhaseOffPeakKVARH:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_meter_reading_off_peak_kvarh
            : "",
        threePhasePeakKWH:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_meter_reading_peak_kwh
            : "",
        threePhaseOffPeakKWH:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_meter_reading_off_peak_kwh
            : "",
        connectionInstallerName: values.iv_connection_installer_name,
        meterType: values.iv_meter_type,
        threePhasePeak:
          phase === "3 Phase" ? values.iv_meter_reading_peak_kwh : "",
        threePhaseOffPeak:
          phase === "3 Phase" ? values.iv_meter_reading_off_peak_kwh : "",
        mdi: phase != "Single Phase" && phase != "3 Phase" ? values.iv_mdi : "",
        noOfMDIreset:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_no_of_mdi_resets
            : "",
        simId: values.iv_sim_ID,
        simNumber: values.iv_sim_number,
        submittedThrough: "e-Operation",
      });
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(cfpBaseUrl + "changeOfAttributes/processSCO", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setResponseMessage(result.message);
            setResponseType("success");
          } else {
            setResponseMessageError(
              result.message || "Unexpected error occurred."
            );
            setResponseType("error");
          }

          setOpenResponseModal(true);
          handleClose();
        })
        .catch((error) => console.error(error));
    },
  });

  const EditFbrDocument = (event) => {
    if (event.target.files) {
      const newFileName =
        "fbrDocument." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        () => {},
        setEditFbrDocument,
        setEditFbrDocumentError,
        setEditFbrDocumentThumbnail,
        newFileName
      );
    }
  };

  const AdditionalCivicDocument = (event) => {
    const file = event.target.files[0];
    if (file) {
      const newFileName =
        "additionalCivicDocument." + file.name.split(".").pop();

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setAdditionalCivicDocumentThumbnail(base64String);
        setAdditionalCivicDocument(newFileName);

        fieldRemoveObjectionFormik.setFieldValue(
          "iv_additional_civic_document",
          newFileName
        );
      };

      reader.readAsDataURL(file);
    }
  };

  const getTariffAndMeterType = async (
    appliedLoad,
    connectionType,
    seasonalNonSeasonal,
    tariffs,
    applicationProgressId
  ) => {
    let phase = "";
    if (connectionType === "Industrial") {
      if (seasonalNonSeasonal == 1) {
        const seasonalTariff = tariffs.find((item) => item.tariffCode === "F");
        if (seasonalTariff) {
          setTariff(seasonalTariff.tariffName || "");
          if (applicationProgressId === 4) {
            fieldFormik.values.iv_tariff_to_allot =
              seasonalTariff.tariffName || "";
          }
        } else {
          setTariff("");
          console.error("Seasonal tariff not found!");
        }
        if (appliedLoad <= 500) {
          setPhase("MDI (LT)(CT)");
          phase = "MDI (LT)(CT)";
        } else if (appliedLoad > 500) {
          setPhase("MDI (HT)(CT/PT)");
          phase = "MDI (HT)(CT/PT)";
        }
      } else if (seasonalNonSeasonal == 0 || !seasonalNonSeasonal) {
        let shortListedTariffsArray = tariffs.filter(
          (item) => item.consumerType === connectionType
        );
        shortListedTariffsArray = shortListedTariffsArray.filter(
          (item) =>
            parseInt(item.from) <= appliedLoad &&
            parseInt(item.to) > appliedLoad
        );
        let selectedTariff = shortListedTariffsArray[0];
        if (selectedTariff) {
          setTariff(selectedTariff.tariffName || "");
          if (applicationProgressId === 4) {
            fieldFormik.values.iv_tariff_to_allot =
              selectedTariff.tariffName || "";
          }
        } else {
          setTariff("");
        }
        if (appliedLoad <= 500) {
          setPhase("MDI (LT)(CT)");
          phase = "MDI (LT)(CT)";
        } else if (appliedLoad > 500) {
          setPhase("MDI (HT)(CT/PT)");
          phase = "MDI (HT)(CT/PT)";
        }
      }
    } else {
      if (appliedLoad && appliedLoad > 0 && tariffs) {

        let shortListedTariffsArray = tariffs.filter(
          (item) =>
            item.consumerType?.toLowerCase() === connectionType?.toLowerCase()
        );

        shortListedTariffsArray = shortListedTariffsArray.filter(
          (item) =>
            parseInt(item.from) <= appliedLoad &&
            parseInt(item.to) > appliedLoad
        );

        if (shortListedTariffsArray.length > 0) {
          setTariff(shortListedTariffsArray[0].tariffName);
          if (applicationProgressId === 4) {
            fieldFormik.values.iv_tariff_to_allot =
              shortListedTariffsArray[0].tariffName || "";
          }
          if (parseInt(appliedLoad) < 5) {
            setPhase("Single Phase");
            phase = "Single Phase";
          } else if (appliedLoad >= 5 && appliedLoad < 20) {
            setPhase("3 Phase");
            phase = "3 Phase";
          } else if (appliedLoad >= 20 && appliedLoad < 500) {
            setPhase("MDI (LT)(CT)");
            phase = "MDI (LT)(CT)";
          } else if (appliedLoad >= 500) {
            setPhase("MDI (HT)(CT/PT)");
            phase = "MDI (HT)(CT/PT)";
          }
        } else {
          setPhase("");
          phase = "";
          setTariff("");
        }
      }

    }
    return phase;
  };

  const hideInstalledMeterImageVerifyAlert = (x) => {
    setInstalledMeterImageVerifyPopUp(x);
  };

  const signedConsentImageFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_signed_consent_image: Yup.mixed().when("consentVerificationFlag", {
        is: () => consentVerificationFlag === 1,
        then: Yup.mixed().required("Upload the signed consent image."),
        otherwise: Yup.mixed().optional(),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      var formdata = new FormData();
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      formdata.append(
        "consentImageChnageofName",
        signedConsentFormImageThumbnail
      );
      formdata.append("applicationId", dialogRowData.applicationId);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "changeOfName/uploadConsentFormForChangeOfName",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            callArrearVerificationAPI(
              dialogRowData.applicationProgressId + 1,
              "Consent Uploaded",
              "",
              dialogRowData.applicationId
            );
          }
        })
        .catch((error) => console.log("error", error));
      setViewBackdrop(false);
    },
  });

  const masterDataFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_govt_dept: Yup.mixed().required("Select Govt Dept."),
      iv_ed_code: Yup.mixed().required("Select Electricity Duty code."),
      iv_standard_classification_code: Yup.mixed().required(
        "Select Std. classification code."
      ),
      iv_income_tax: Yup.mixed().required("Select Income tax value."),
      iv_authority: Yup.mixed().optional("Select Authority."),
    }),
    onSubmit: async (values, { resetForm }) => {
      var formdata = new FormData();
      formdata.append("applicationId", dialogRowData.applicationId);
      formdata.append("electricityDuty", masterDataFormik.values.iv_ed_code);
      formdata.append(
        "governmentDepartment",
        masterDataFormik.values.iv_govt_dept
      );
      formdata.append(
        "standardClassificationCode",
        masterDataFormik.values.iv_standard_classification_code
      );
      formdata.append("incomeTax", masterDataFormik.values.iv_income_tax);
      formdata.append("reason", "Change of Name");
      formdata.append("authority", "SDO");
      formdata.append("filledBy", userId);
      formdata.append("filledByFlag", 1);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "cpForm136/cpForm136DataInsertion",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            if (masterDataFormDetails.filledByFlag === null) {
              resetForm();
              setOpen(false);
            } else {
              resetForm();
              setOpen(false);
            }
          } else {
          }
        })
        .catch((error) => console.log(error));
    },
  });

  const arearBillDocumentFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_arear_paid_bill_document: Yup.mixed().required(
        "Upload arears paid bill document!"
      ),
      iv_arear_paid_bill_date: Yup.string().required(
        "Enter date on which arears are paid!"
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        paidBillDate: values.iv_arear_paid_bill_date,
        paidBillImage: arearPaidBillDocumentThumbnail,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "comman/updateENCArearPaidBillImage",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            callChangeObjectionStatus(
              "Arrears Verification",
              0,
              "Arrears Objection Removed"
            );
            callArrearVerificationAPI(
              3,
              "Arrears Verified",
              "Arrears Verified",
              dialogRowData.applicationId
            );
            resetForm();
            handleClose();
          } else {
            setError(result.message);
          }
        })
        .catch((error) => setError(error));
    },
  });

  let CONStatusBarArray = [
    {
      title1: "DOCUMENT",
      title2: "SUBMISSION",
    },
    {
      title1: "DOCUMENT",
      title2: "VERIFICATION",
    },
    {
      title1: "ARREAR",
      title2: "VERIFICATION",
    },
    {
      title1: "FIELD",
      title2: "SURVEY",
    },
    {
      title1: "DN",
      title2: "APPROVAL",
    },
    {
      title1: "DN",
      title2: "SUBMISSION",
    },
    {
      title1: "DN PAYMENT",
      title2: "VERIFICATION",
    },
    {
      title1: "SUNDARY",
      title2: "JOBS ORDER",
    },
    {
      title1: "READY FOR",
      title2: "BILLING",
    },
    {
      title1: "COMPLETED",
      title2: "",
    },
  ];
  const costEstimation = async (
    applicationId,
    referenceNo,
    applicationProgressId,
    objectionStatus,
    remarks,
    bankName,
    previousSecurityAmount,
    currentEstimatedSecurityAmount,
    totalEstimatedAmount
  ) => {

    setViewBackdrop(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId,
      referenceNo,
      applicationProgressId,
      objectionStatus,
      remarks,
      bankName,
      previousSecurityAmount,
      currentEstimatedSecurityAmount,
      totalEstimatedAmount,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        cfpBaseUrl + "changeOfName/saveCostEstimateForCON",
        requestOptions
      );
      const result = await response.json();

      if (result.status === "200") {
        setResponseMessage(result.message);
        setResponseType("success");
      } else {
        setResponseMessageError(result.message || "Unexpected error occurred.");
        setResponseType("error");
      }

      setOpenResponseModal(true);
      handleClose();
    } catch (error) {
      setResponseMessageError("Something went wrong. Please try again.");
      setResponseType("error");
      setOpenResponseModal(true);
    } finally {
      setViewBackdrop(false);
    }
  };

  const DNApproveAPI = async (
    applicationId,
    applicationProgressId,
    objectionStatus,
    remarks
  ) => {
    setViewBackdrop(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: applicationId,
      applicationProgressId: applicationProgressId,
      objectionStatus: objectionStatus,
      remarks: "Demand Note Issued",
      remarksDetail: "Demand Note Issued",
      submittedThrough: "e-Operation",
    });
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/approveDemandNote",
        requestOptions
      );
      const result = await response.json();

      if (result.status === "200") {
        setResponseMessage(result.message);
        setResponseType("success");
      } else {
        setResponseMessageError(result.message || "Unexpected error occurred.");
        setResponseType("error");
      }

      setOpenResponseModal(true);
      handleClose();
    } catch (error) {
      setResponseMessageError("Something went wrong. Please try again.");
      setResponseType("error");
      setOpenResponseModal(true);
    } finally {
      setViewBackdrop(false);
    }
  };

  // DN Renewal API for expired demand notes
  const callDemandNoteRenewalAPI = async (applicationId) => {
    try {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: applicationId,
        remarks: "DN Renewed.",
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "changeOfAttributes/renewExpiredDN", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setShowDnExpiryPopup(false);
            // Refresh data after renewal
            handleClose();
          } else {
            console.log("DN Renewal failed:", result.message);
          }
        })
        .catch((error) => console.error("DN Renewal error:", error));
    } catch (e) {
      console.log("DN Renewal exception:", e);
    } finally {
      setViewBackdrop(false);
    }
  };

  const DNPaymentVerificationAPI = async (
    applicationId,
    applicationProgressId,
    objectionStatus,
    remarks,
    remarksDetails
  ) => {

    setViewBackdrop(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: applicationId,
      objectionStatus: objectionStatus,
      applicationProgressId: applicationProgressId,
      remarks: remarks,
      remarksDetail: remarksDetails,
    });
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/verifyOrRejectPaidDemandNote",
        requestOptions
      );
      const result = await response.json();

      if (result.status === "200") {
        setResponseMessage(result.message);
        setResponseType("success");
      } else {
        setResponseMessageError(result.message || "Unexpected error occurred.");
        setResponseType("error");
      }

      setOpenResponseModal(true);
      handleClose();
    } catch (error) {
      setResponseMessageError("Something went wrong. Please try again.");
      setResponseType("error");
      setOpenResponseModal(true);
    } finally {
      setViewBackdrop(false); // Allow re-submission after completion
    }
  };

  const SundaryJobSubmissionAPI = async (
    applicationId,
    applicationProgressId,
    objectionStatus,
    remarks
  ) => {
    setViewBackdrop(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: dialogRowData.applicationId,
      objectionStatus: 0,
      applicationProgressId: 7,
      remarks: "Meter Installed on premises.",
      remarksDetail: "Meter Installed on premises.",
      scoFillFlag: 1,
      scoApprovalFlag: 0,
      storeRequisitionNo: 0,
      storeRequisitionDate: "",
      seasonalFlag: 0,
      installedTransformerCapacity: "",
      meterNo: 0,
      locationCode: "",
      meterCode1: "",
      meterCode2: "",
      manufacturerCode: 0,
      multiplyingFactor: 0,
      meterRange: 0,
      meterReading: "",
      dateOfConnection: "",
      installedMeterImage: "",
      cT: 0,
      cTD: "",
      cTN: "",
      pT: 0,
      pTD: "0",
      pTN: "0",
      threePhasePeakKVARH: "",
      threePhaseOffPeakKVARH: "",
      threePhasePeakKWH: "",
      threePhaseOffPeakKWH: "",
      connectionInstallerName: "",
      threePhasePeak: "",
      threePhaseOffPeak: "",
      mdi: "",
      noOfMDIreset: "",
      simId: "",
      simNumber: "",
      transformerRefNo: "",
      submittedThrough: "e-Operation",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(cfpBaseUrl + "changeOfAttributes/processSCO", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setViewBackdrop(false);
        if (result.status === "200") {
          setResponseMessage(result.message);
          setResponseType("success");
        } else {
          setResponseMessageError(
            result.message || "Unexpected error occurred."
          );
          setResponseType("error");
        }

        setOpenResponseModal(true);
        handleClose();
      })
      .catch((error) => console.error(error));
  };

  const InstalledMeterImage = (event) => {
    if (event.target.files) {
      const newFileName =
        "installedMeterImage." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        scoPart1Formik.handleChange,
        setInstalledMeterImage,
        setInstalledMeterImageError,
        setInstalledMeterImageThumbnail,
        newFileName
      );
      setInstalledMeterImageError("");
    }
  };

  const SundaryJobApprovalAPI = async () => {
    setViewBackdrop(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: dialogRowData.applicationId,
      objectionStatus: 0,
      applicationProgressId: 8,
      remarks: "Meter Installed on premises.",
      remarksDetail: "Meter Installed on premises.",
      scoFillFlag: 1,
      scoApprovalFlag: 1,
      storeRequisitionNo: 0,
      storeRequisitionDate: "",
      seasonalFlag: 0,
      installedTransformerCapacity: "",
      meterNo: 0,
      locationCode: "",
      meterCode1: "",
      meterCode2: "",
      manufacturerCode: 0,
      multiplyingFactor: 0,
      meterRange: 0,
      meterReading: "",
      dateOfConnection: "",
      installedMeterImage: "",
      cT: 0,
      cTD: "",
      cTN: "",
      pT: 0,
      pTD: "0",
      pTN: "0",
      threePhasePeakKVARH: "",
      threePhaseOffPeakKVARH: "",
      threePhasePeakKWH: "",
      threePhaseOffPeakKWH: "",
      connectionInstallerName: "",
      threePhasePeak: "",
      threePhaseOffPeak: "",
      mdi: "",
      noOfMDIreset: "",
      simId: "",
      simNumber: "",
      transformerRefNo: "",
      submittedThrough: "e-Operation",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(cfpBaseUrl + "changeOfAttributes/processSCO", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setViewBackdrop(false);
        if (result.status === "200") {
          // setOpenResponseModal(true);
          setResponseMessage(result.message);
          setResponseType("success");
        } else {
          // setOpenResponseModal(true);
          setResponseMessageError(
            result.message || "Unexpected error occurred."
          );
          setResponseType("error");
        }

        setOpenResponseModal(true);
        handleClose();
      })
      .catch((error) => console.error(error));
  };

  const [openRemarksDialog, setOpenRemarksDialog] = useState(false);
  const [readyForBillingError, setReadyForBillingError] = useState("");

  const [odRemarks, setOdRemarks] = useState("");

  const processForBilling = () => {
    setOpenRemarksDialog(true);
  };

  // 🚪 Close popup
  const handleCloseRemarks = () => {
    setOpenRemarksDialog(false);
    setOdRemarks("");
    setRemarksError("");
    setReadyForBillingError("");
  };

  const handleSubmitRemarks = () => {
    if (odRemarks.trim().length < 10) {
      setRemarksError("Remarks must be at least 10 characters long.");
      return; // stops execution here ✅
    }

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: dialogRowData.applicationId,
      applicationProgressId: dialogRowData.applicationProgressId + 1,
      remarks: odRemarks,
      objectionStatus: 0,
      submittedThrough: "e-Operation",
      electricityDuty: 0,
      governmentDepartment: 0,
      standardClassificationCode: "0000",
      incomeTax: 0,
      reason: odRemarks,
      filledByFlag: 1,
      approvalFlag: 1,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(cfpBaseUrl + "changeOfAttributes/processForBilling", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          setRemarksError("");
          setOpenRemarksDialog(false);
          setReadyForBillingError("");
          setOdRemarks("");
          handleClose();
        } else {
          setReadyForBillingError(result.message);
        }
      })
      .catch((error) => console.error(error));
  };

  const dnPymentReceiptFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_payment_date: Yup.date()
        .max(new Date(), "Payment date must be in the past!")
        .required("Payment date is required!"),
      iv_receipt_image: Yup.mixed().required(
        "Upload paid demand notice receipt image."
      ),
    }),
    onSubmit: async (values, { resetForm }) => {

      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: dialogRowData.applicationProgressId + 1,
        objectionStatus: 0,
        remarks: "Demand Note Uploaded.",
        remarksDetail: "Demand Note Uploaded.",
        submittedThrough: "e-Operation",
        paymentDate: values.iv_payment_date,
        paidDNImage: dnReceiptImageThumbnail,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "changeOfAttributes/uploadPaidDemandNote",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          // callArrearVerificationAPI(dialogRowData.applicationProgressId + 1, 'Demand Notice Paid', 'Demand Notice Paid', dialogRowData.applicationId)
          setViewBackdrop(true);
          resetForm();
          setDnReceiptImage();
          setDnReceiptImageThumbnail();
          setShowDNPayment(true);
          handleClose();
        })
        .catch((error) => console.error(error));
    },
  });

  const [thumbnail, setThumbnail] = useState("");

  const arrearPaymentReceiptFormik = useFormik({
    initialValues: {
      iv_arrear_paid_bill_document: "",
    },

    validationSchema: Yup.object().shape({
      iv_arrear_paid_bill_document: Yup.mixed()
        .required("Paid Bill Receipt is required.")
        .test(
          "file-present",
          "Paid Bill Receipt is required.",
          (value) => !!value
        ),
    }),

    onSubmit: (values) => {

      callArrearVerificationAPI(
        dialogRowData.applicationId,
        dialogRowData.applicationProgressId + 1,
        0,
        "Arrears Verified",
        "Arrears Verified",
        0,
        "",
        arearPaidBillDocumentThumbnail
      );
    },
  });

  const sjoFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({}),
    onSubmit: async (values, { resetForm }) => {
      var formdata = new FormData();

      formdata.append("applicationId", dialogRowData.applicationId);
      formdata.append("applicationSubmissionDate", dialogRowData.creationDate);
      formdata.append("accountNo", dialogRowData.referenceNumber);
      formdata.append("feederNo", "");
      formdata.append("batch", dialogRowData.referenceNumber.slice(0, 2));
      formdata.append("applicantNewName", dialogRowData.newName);
      formdata.append("applicantOldTariff", "");
      formdata.append("applicantOldLoad", "");
      formdata.append("applicantNewTariff", "");
      formdata.append("applicantNewLoad", "");
      formdata.append("applicationType", "3");
      formdata.append("mobileNo", dialogRowData.newPhone);
      formdata.append("date", "");
      formdata.append("materNo", "");
      formdata.append("cNICNo", dialogRowData.newCNIC);
      formdata.append("securityDepositDNNo", dnDetails.demandNoticeNo);
      formdata.append("dNCreationDate", dnDetails.issueDate);
      formdata.append("ammountOfSecurityDeposit", dnDetails.dNamount);
      formdata.append("dNPaymentDate", dnPaymentDate);
      formdata.append("ammountOfCapitalCost", 0);
      formdata.append("capitalCostPaymentDate", "");
      formdata.append("filledBy", userId);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "changeOfName/sjoDataInsertion", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            callSJOApproveAPI(dialogRowData.applicationId);
            resetForm();
            setOpen(false);
          } else {
          }
        })
        .catch((error) => console.log(error));
    },
  });

  const dnRejectFormik = useFormik({
    initialValues: {
      reasonType: "",
      remarks: "",
    },
    validationSchema: Yup.object({
      reasonType: Yup.string().required("Please select a reason."),
      remarks: Yup.string()
        .required("Remarks are required.")
        .min(10, "Remarks must be at least 10 characters long."),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          objectionStatus: 0,
          applicationProgressId: values.reasonType,
          remarks: `Revert to ${values.reasonType == 3
            ? "Field Survey"
            : values.reasonType == 2
              ? "Arrear Verification"
              : "Documents Verification"
            }`,
          remarksDetail: values.remarks,
          submittedThrough: "e-Operation",
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(
          cfpBaseUrl + "changeOfAttributes/revertApplication",
          requestOptions
        )
          .then((response) => response.json())
          .then((result) => {
            setDnRejectModalOpen(false);
            resetForm();
            handleClose();
          })
          .catch((error) => console.error(error));
      } catch (error) {
        console.error("Error rejecting demand note:", error);
      }
    },
  });

  useEffect(() => {
    if (changeOfNameApplications) {
      apiToDataGridConversionNormal();
    }
  }, [changeOfNameApplications]);

  useEffect(() => {
    if (changeOfNameApplicationsOverDue) apiToDataGridConversionOverdue();
  }, [changeOfNameApplicationsOverDue]);

  useEffect(() => {
    if (foundId && foundId !== "") {
      setFoundInCON(foundId);
    }
  }, [foundId]);

  useEffect(() => {
    if (foundInCON) {
      handleRowClick(foundInCON);
    }
  }, [foundInCON]);

  useLayoutEffect(() => {
    if (changeOfNameApplications.length >= 1) {
      if (foundInCON && foundInCON !== "") {
        handleRowClick(foundInCON);
      }
    }
  }, [changeOfNameApplications]);

  //#endregion

  //#region functions

  const updateDocFlag = (documentName, value, remarks) => {
    switch (documentName) {
      case "copyOfApplicantCNIC":
        setFlag_applicantCNICFront(value);
        setFlag_applicantCNICBack(value);
        setApplicantCNICFrontObjectionRemarks(remarks);
        setApplicantCNICBackObjectionRemarks(remarks);
        setCopyOfApplicantCNICVerifyPopUp(false);
        break;
      case "owenershipDocument":
        setFlag_owenershipDocument(value);
        setowenershipObjectionRemarks(remarks);
        setOwenershipDocumentVerifyPopUp(false);
        break;
      case "electricityBillDocument":
        setFlag_electricityBillDocument(value);
        setElectricityBillObjectionRemarks(remarks);
        setElectricityBillDocumentVerifyPopUp(false);
        break;
      case "fbrDocument":
        setFlag_fbrDocument(value);
        setFbrDocumentObjectionRemarks(remarks);
        setFbrDocumentVerifyPopUp(false);
        break;
      case "preOwnerCNIC":
        setFlag_PreOwnerCNICFront(value);
        setFlag_PreOwnerCNICBack(value);
        setpreOwnerCNICBackObjectionRemarks(remarks);
        setpreOwnerCNICFrontObjectionRemarks(remarks);
        setPreOwnerCNICVerifyPopUp(false);
        break;
      case "perOwenerNOC":
        setFlag_perOwenerNOC(value);
        setperOwenerNOCObjectionRemarks(remarks);
        setPerOwenerNOCVerifyPopUp(false);
        break;
      case "newOwenerAffidavite":
        setFlag_newOwenerAffidavite(value);
        setnewOwenerAffidaviteObjectionRemarks(remarks);
        setNewOwenerAffidaviteVerifyPopUp(false);
        break;
      case "addDocCivicAuthority":
        setFlag_addDocCivicAuthority(value);
        setaddDocCivicAuthorityObjectionRemarks(remarks);
        setAddDocCivicAuthorityVerifyPopUp(false);
        break;
      case "addDocAnyOther":
        setFlag_addDocAnyOther(value);
        setaddDocAnyOtherObjectionRemarks(remarks);
        setAddDocAnyOtherVerifyPopUp(false);
        break;
      case "addDocCONConsent":
        setFlag_addDocCONConsent(value);
        setaddCONConsentObjectionRemarks(remarks);
        setAddDocCONConsentVerifyPopUp(false);
        break;
      default:
        break;
    }
  };

  const applicationName = (code) => {
    if (code) {
      switch (code) {
        case 1:
          return "Change of Name";
        case 2:
          return "Change of Load";
        case 3:
          return "Change of Tariff";
        case 4:
          return "Change of Attributes";
        case 5:
          return "Change of Name | Load";
        case 6:
          return "Change of Name | Tariff";
        case 7:
          return "Change of Load | Tariff";
        default:
          return "Application Type";
      }
    }
  };

  const coaIncludesName = (type) => [1, 4, 5, 6].includes(Number(type));
  const coaIncludesLoad = (type) => [2, 4, 5, 7].includes(Number(type));
  const coaIncludesTariff = (type) => [3, 4, 6, 7].includes(Number(type));

  const hasMultipleCoaSections = (type) => {
    const t = Number(type);
    return (
      [coaIncludesName(t), coaIncludesLoad(t), coaIncludesTariff(t)].filter(Boolean)
        .length > 1
    );
  };

  const initEditSections = (type) => {
    const t = Number(type);
    const multiple = hasMultipleCoaSections(t);
    return {
      name: coaIncludesName(t) && !multiple,
      load: coaIncludesLoad(t) && !multiple,
      tariff: coaIncludesTariff(t) && !multiple,
    };
  };

  const requiresFbrDocument = (tariff) => {
    if (!tariff) return false;
    const cleaned = String(tariff).replace(/-/g, "");
    return /^(A2|B)/.test(cleaned);
  };

  const validateEditNtn = (ntn, tariff) => {
    if (!requiresFbrDocument(tariff)) return "";
    const trimmed = String(ntn || "").trim();
    if (!trimmed) return "NTN No. is required.";
    if (!/^\d+$/.test(trimmed)) return "NTN must contain only numbers.";
    if (trimmed.length > 13) return "NTN must be at most 13 digits.";
    return "";
  };

  const hasExistingEditNtn = (rowData) =>
    String(rowData?.ntnNo || "").trim().length > 0;

  const hasExistingEditFbrDocument = (rowData) =>
    Boolean(rowData?.fbrDocument);

  const getLoadChangeTypeName = (typeId) => {
    const item = lookUpDataOfCON?.lookupLoadChangeType?.find(
      (t) => Number(t.typeId) === Number(typeId)
    );
    return (item?.typeName || "").toLowerCase();
  };

  const validateEditName = () => {
    const errors = {
      newName: "",
      guardianName: "",
      newCNIC: "",
      newPhone: "",
    };
    const { newName, guardianName, newCNIC, newPhone, relation } = editFormData;

    if (!String(newName || "").trim()) {
      errors.newName = "Enter new name.";
    }

    let relationLabel = "guardian's";
    if (Number(relation) === 1 || Number(relation) === 2) {
      relationLabel = "father's";
    } else if (Number(relation) === 3) {
      relationLabel = "husband's";
    } else if (Number(relation) === 4) {
      relationLabel = "care of's";
    }

    if (!String(guardianName || "").trim()) {
      errors.guardianName = `Enter ${relationLabel} new name.`;
    }

    const cnic = String(newCNIC || "").trim();
    if (!cnic) {
      errors.newCNIC = "Enter new CNIC.";
    } else if (!/^\d{13}$/.test(cnic)) {
      errors.newCNIC = "CNIC must be 13 digits.";
    }

    const phone = String(newPhone || "").trim();
    if (!phone) {
      errors.newPhone = "Phone number is required.";
    } else if (!/^03[0-9]{9}$/.test(phone)) {
      errors.newPhone = "Phone must start with 03 and be 11 digits.";
    }

    return errors;
  };

  const validateEditTariff = (newTariff) => {
    if (!String(newTariff ?? "").trim()) {
      return "Please select new tariff.";
    }
    return "";
  };

  const getInitialEditNewTariff = (rowData) => {
    const fromApi = String(rowData?.newTariff || "").trim();
    if (!fromApi) return "";
    const matched = allTariffList?.find(
      (item) =>
        item.tariffName === fromApi ||
        String(item.tariffName || "").replace(/-/g, "") === fromApi.replace(/-/g, "")
    );
    return matched?.tariffName || fromApi;
  };

  const mergeEditApiResponseIntoDialog = (apiPayload, { resolvedNewTariff, shouldEditTariff }) => {
    const apiData = Array.isArray(apiPayload) ? apiPayload[0] : apiPayload;
    if (!apiData || typeof apiData !== "object") return;

    setDialogRowData((prev) => ({
      ...prev,
      ...apiData,
      ...(shouldEditTariff
        ? {
            newTariff:
              apiData.newTariff != null && String(apiData.newTariff).trim()
                ? apiData.newTariff
                : resolvedNewTariff,
            currentTariff: apiData.currentTariff ?? prev.currentTariff,
            ntnNo: apiData.ntnNo ?? prev.ntnNo,
            fbrDocument: apiData.fbrDocument ?? prev.fbrDocument,
          }
        : {}),
    }));
  };

  const refreshDialogRowFromServer = async (applicationId) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const response = await fetch(
      `${cfpBaseUrl}changeOfAttributes/getBasicCOAHistory`,
      {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ applicationId }),
      }
    );
    const result = await response.json();

    if (result.status === "200" && result.data?.currentStatus?.[0]) {
      const current = result.data.currentStatus[0];
      setDialogRowData((prev) => ({
        ...prev,
        ...current,
      }));
      return current;
    }
    return null;
  };

  const validateEditLoad = () => {
    const { loadChangeType, currentLoad, newLoad } = editFormData;
    const errors = { loadChangeType: "", newLoad: "" };

    if (
      loadChangeType === "" ||
      loadChangeType === null ||
      loadChangeType === undefined
    ) {
      errors.loadChangeType = "Please select load change type.";
    }

    const newLoadStr = String(newLoad ?? "").trim();
    if (!newLoadStr) {
      errors.newLoad = "Please enter new load.";
    }

    const current = parseFloat(currentLoad);
    const updated = parseFloat(newLoadStr);

    if (newLoadStr && Number.isNaN(updated)) {
      errors.newLoad = "Enter valid load value.";
    } else if (newLoadStr && updated < 0.1) {
      errors.newLoad = "New load cannot be less than 0.1 kW.";
    } else if (
      newLoadStr &&
      !Number.isNaN(current) &&
      !Number.isNaN(updated)
    ) {
      const typeName = getLoadChangeTypeName(loadChangeType);

      if (typeName.includes("addition") && updated <= current) {
        errors.newLoad =
          "For Addition, new load must be greater than sanctioned load.";
      }
      if (typeName.includes("reduction") && updated >= current) {
        errors.newLoad =
          "For Reduction, new load must be less than sanctioned load.";
      }
    }

    return errors;
  };

  const getFirstEditValidationError = (nameErrors, loadErrors, tariffError) => {
    const nameError = Object.values(nameErrors || {}).find(Boolean);
    if (nameError) return nameError;
    if (loadErrors?.loadChangeType) return loadErrors.loadChangeType;
    if (loadErrors?.newLoad) return loadErrors.newLoad;
    if (tariffError) return tariffError;
    return "";
  };

  const updateDocumentStatus = async () => {
    let remarksToSave = "";
    let objectionStatus = null;
    let applicationProgressId = dialogRowData.applicationProgressId;

    if (
      flag_applicantCNICFront === -1 ||
      flag_applicantCNICBack === -1 ||
      flag_owenershipDocument === -1 ||
      flag_electricityBillDocument === -1 ||
      flag_fbrDocument === -1 ||
      flag_addDocAnyOther === -1
    ) {
      objectionStatus = 1;
      applicationProgressId = 1;
      remarksToSave = "Documents objection in: ";

      if (flag_applicantCNICFront === -1) {
        remarksToSave += "Applicant CNIC Front, ";
      }
      if (flag_applicantCNICBack === -1) {
        remarksToSave += "Applicant CNIC Back, ";
      }
      if (flag_owenershipDocument === -1) {
        remarksToSave += "Ownership Document, ";
      }
      if (flag_electricityBillDocument === -1) {
        remarksToSave += "Electricity Bill Document, ";
      }
      if (flag_fbrDocument === -1) {
        remarksToSave += "FBR Document, ";
      }
      if (flag_addDocAnyOther === -1) {
        remarksToSave += "Any Other Document, ";
      }
    } else {
      objectionStatus = 0;
      remarksToSave = "Documents Verified.";
      applicationProgressId += 1;
    }

    if (
      (flag_applicantCNICFront !== null &&
        flag_applicantCNICBack !== null &&
        flag_owenershipDocument !== null &&
        flag_electricityBillDocument !== null) ||
      flag_fbrDocument != null
    ) {
      callingUpdateDocumentStatusAPI(
        dialogRowData.applicationId,
        applicationProgressId,
        objectionStatus,
        flag_applicantCNICFront,
        flag_applicantCNICBack,
        flag_owenershipDocument,
        flag_electricityBillDocument,
        flag_fbrDocument,
        flag_addDocAnyOther,
        applicantCNICBackObjectionRemarks,
        applicantCNICFrontObjectionRemarks,
        owenershipObjectionRemarks,
        electricityBillObjectionRemarks,
        fbrDocumentObjectionRemarks,
        addDocAnyOtherObjectionRemarks,
        remarksToSave
      );
    } else {
      console.log("❌ Check all the attached documents before submitting!");
    }
  };

  const numberFormatting = (num) => {
    const n = parseFloat(num);
    return isNaN(n) || n === 0 ? "0" : n.toLocaleString("en-US");
  };

  const getAmountText = (amount) => {
    if (amount == null || amount === "" || amount === undefined) return "0";
    const num = parseFloat(amount);
    return isNaN(num) ? "0" : numberFormatting(num);
  };

  const formatAmount = (value) => {
    const num = Number(value) || 0; // convert safely
    return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const downloadDNPDF = async (applicationId, dnDets, applicationData = null) => {
    setViewBackdrop(true);
    try {

      let application = applicationData ||
        changeOfNameApplications.find(
          (item) => item.applicationId === applicationId
        ) ||
        changeOfNameApplicationsOverDue.find(
          (item) => item.applicationId === applicationId
        );

      if (!application) {
        setViewBackdrop(false);
        toast.error("Application not found for DN download");
        return;
      }

      let DiscoCode = application.companyCode.toString();
      let officeCode = application.subDivisionCode.toString();
      let officeName = subdivisionName(parseInt(officeCode), subDivisions);
      let authorizedByName = dnDets.approvedBy ? dnDets.approvedBy : "---";
      let authorizedByDesignation = dnDets.approvedByDesignation
        ? dnDets.approvedByDesignation
        : "Role";
      let dateToPrint = dnDets.approvedDate
        ? new Date(dnDets.approvedDate).toLocaleDateString()
        : "---";
      let stampData = printStamp(
        officeCode,
        officeName,
        authorizedByName,
        authorizedByDesignation,
        dateToPrint
      );

      const yy = applicationId.slice(8, 10); // 25
      const mm = applicationId.slice(10, 12); // 11
      const dd = applicationId.slice(12, 14); // 18

      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      // Convert to: 18-Nov-2025
      const formattedDate = `${dd}-${monthNames[parseInt(mm) - 1]}-20${yy}`;


      const fontSize = 8;
      const doc = new jsPDF({ compressPdf: true });

      if (dnDets.approvedBy) {
        doc.addImage(stampData, "PNG", 20, 170, 55, 40); // 200 → 170
        doc.addImage(stampData, "PNG", 140, 250, 55, 40); // 265 → 235
      }

      //#region Line 1
      var padding = 10;
      var line2Height = 10;
      var lineHeightIncreament = 5;
      doc.setFontSize(fontSize);
      doc.setFont("helvetica", "bold");
      doc.text(
        (!dnDets.demandNoteExpiryCount ? "Due Date: " : "Extended Due Date: ") +
        convertDate(dnDets.dueDate),
        padding,
        line2Height,
        {}
      );

      doc.setFont("helvetica", "normal");
      doc.text(
        companyName(dnDets.connectionAccountNo.slice(2, 4)).concat(
          application.appliedLoad < 15
            ? "(" +
            dnDets.connectionAccountNo.slice(2, 7) +
            "-" +
            subdivisionName(
              parseInt(application.subDivisionCode),
              subDivisions
            ) +
            ")"
            : "(" +
            dnDets.connectionAccountNo.slice(2, 6) +
            "-" +
            divisionName(parseInt(application.divisionCode), subDivisions) +
            ")"
        ),
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );

      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        "(Department of Electricity)",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );

      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 12;
      var text1 = "Demand Notice Serial No.: ";
      var text2 = dnDets.demandNoteNo;
      var text3 = "Application Id: ";
      var text4 = applicationId;
      var text5 = "Apply Date: ";
      var text6 = formattedDate;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 3,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height
      );
      doc.text(
        text6,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 5,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        doc.getTextWidth(text6) +
        lineSpace * 2,
        line2Height + 1
      );
      //#endregion

      //#region Line 4
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 3.35;
      var text1 = "Demand Notice Issuance Date: ";
      var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
      var text3 = "Application Type: ";
      var text4 = application.changeOfAttributesType
        ? applicationName(application.changeOfAttributesType)
        : "-";
      var text5 = "Load: ";
      var text6 = application.newSanctionLoad
        ? String(application.newSanctionLoad)
        : application.currentSanctionLoad
          ? String(application.currentSanctionLoad)
          : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 3,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height
      );
      doc.text(
        text6,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 5,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        doc.getTextWidth(text6) +
        lineSpace * 2,
        line2Height + 1
      );

      // doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
      // doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
      // doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
      //#endregion

      //#region Line 5
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 6.6;
      var text1 = "Account No. for acquisition connection: ";
      var text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : "-";
      var text3 = "User Mobile No.: ";
      var text4 = application.applicantPhoneNo
        ? application.applicantPhoneNo
        : "-";
      var text5 = "Connection type: ";
      var text6 = dnDets.connectionType ? dnDets.connectionType : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 3,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height
      );
      doc.text(
        text6,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 5,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        doc.getTextWidth(text6) +
        lineSpace * 2,
        line2Height + 1
      );
      //#endregion

      //#region Line 6
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 7;
      var text1 =
        "(under which the funds are to be deposited in the bank with the concerned officer of the institution)";

      doc.setFontSize(8);
      doc.text(text1, padding, line2Height);

      //#endregion

      //#region Line 7
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 16;
      var text1 = "Alloted Tariff : ";
      var text2 = application.newTariff ? application.newTariff : application.currentTariff;
      var text3 = `Department's approved Bank name: `;
      var text4 = dnDets.bankName ? dnDets.bankName : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2 + 30),
        line2Height
      );
      doc.text(
        text4,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 3 + 30,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 + 30,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2) + 30,
        line2Height + 1
      );
      //#endregion

      //#region Line 10
      var line2Height = line2Height + lineHeightIncreament;

      doc.text(
        "DEMAND NOTICE",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );
      //#endregion

      //#region Line 11
      var line2Height = line2Height + lineHeightIncreament;

      doc.text(
        "(Notification of Approval Application and Demand Under Guarantee)",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );
      //#endregion

      //#region Line 12
      var line2Height = line2Height + lineHeightIncreament;

      doc.text(
        `Applicant's part`,
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );
      //#endregion

      //#region Line 13
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 16;
      text1 = "Mr. / Mrs.";
      const guardianRelation =
        application.applicantGuardianType == 1 ? "S/O"
          : application.applicantGuardianType == 2 ? "D/O"
            : application.applicantGuardianType == 3 ? "W/O"
              : application.applicantGuardianType == 4 ? "C/O"
                : "";
      const applicantNameText = application.applicantName
        ? application.applicantName.trim()
        : "";
      const rawGuardianName = application.applicantGuardianName
        ? application.applicantGuardianName.trim()
        : "";
      const guardianNameWithRelation = guardianRelation
        ? `${guardianRelation}${rawGuardianName ? ` ${rawGuardianName}` : ""}`
        : rawGuardianName;
      const addressText = application.consumerAddress
        ? application.consumerAddress.trim()
        : "";
      text2 = [applicantNameText, guardianNameWithRelation].filter(Boolean).join(" ").trim();
      text2 = text2
        ? `${text2}${addressText ? ` | ${addressText}` : ""}`
        : addressText || "-";


      var text3 = ``;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.setFontSize(6);
      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height
      );
      //#endregion

      //#region Line 14
      lineHeightIncreament = 4;
      var line2Height = line2Height + lineHeightIncreament;
      doc.setFontSize(fontSize);
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var text1 = `You are hereby informed by demand notice that your application for change of name/load/tariff whose particulars are mentioned above has been approved by the authorized officer.`;
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        doc.text(lines[i], padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 15
      doc.setFontSize(fontSize);
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var noOfDays = "30";
      var text1 = `1. You should deposit the following amounts in the approved bank of the department or with the concerned officer of the department itself within [word1] days from the date of issue of this notice and inform my office with the receipt number and date of their payment.`;
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        var lineText = lines[i].replace("[word1]", noOfDays);
        doc.text(lineText, padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }

      doc.setFontSize(fontSize);
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var noOfDays = "30";
      var text1 = `A. Expenditure service connection as per approved estimate ______________ and Security _______________ PKR. (this amount is to be deposited with the concerned officer of the department). If the charges are found to be more than the service approved estimate prior to connection, a deposit equal to the difference in the amount collected will be issued for which additional demand notice will be issued.`;

      // SAFE AMOUNTS
      const capitalText = getAmountText(dnDets.capitalCostAmount);
      const securityText = getAmountText(dnDets.securityDepositeAmount);

      var lines = doc.splitTextToSize(text1, maxWidth);

      // Print bold amounts first
      doc.setFont("helvetica", "bold");
      doc.text(capitalText, 90, line2Height);
      doc.text(securityText, 130, line2Height);
      doc.setFont("helvetica", "normal");

      // Print lines with replace
      for (var i = 0; i < lines.length; i++) {
        var lineText = lines[i]
          .replace("[capitalCost]", capitalText)
          .replace("[securityCost]", securityText);

        doc.text(lineText, padding, line2Height);
        line2Height = line2Height + lineHeightIncreament;
      }
      //#endregion

      //#region Line 18
      doc.setFontSize(fontSize);
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var noOfDays = "30";
      var text1 = `NOTE: If you are an applicant or consumer of domestic, commercial, industrial wholesale supply, you should fill the demand notice in this regard on the sub-layer (reserved for your business) and affix your signature and date on it and send back to my office.`;
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        doc.text(lines[i], padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 22
      doc.text(
        `(Irrelevant should be cut down)`,
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );
      //#endregion

      //#region Line 23
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var noOfMonth = "1";
      var text1 = `If you do not comply with the above conditions in response to the demand notice within the prescribed period, your application form for change of name/load/tariff will not be considered with the serial number allotted. Demand notices thereof ( [noOfMonth] month after the date of issue) shall automatically be deemed ineffective.`;
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        var lineText = lines[i].replace("[noOfMonth]", noOfMonth);
        doc.text(lineText, padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 24
      // doc.setFontSize(fontSize);
      // var line24Y = line2Height;
      // var text1 = "Regards";
      var spaceLeft = 100;
      // doc.text(text1, padding + spaceLeft, line24Y);

      //#endregion

      //#region Line 25
      // doc.setFontSize(fontSize);
      // var line2Height = line2Height + lineHeightIncreament;
      // var text1 =
      //   application.appliedLoad < 15
      //     ? "Sub-Division Office " +
      //       applicationId.slice(3, 8) +
      //       "-" +
      //       subdivisionName(
      //         parseInt(application.subDivisionCode),
      //         subDivisions
      //       ) +
      //       " SDO " +
      //       companyShortName(DiscoCode)
      //     : "Division Office " +
      //       applicationId.slice(3, 7) +
      //       " - " +
      //       divisionName(parseInt(application.divisionCode), subDivisions) +
      //       " XEN " +
      //       companyShortName(DiscoCode);
      // doc.text(text1, padding + spaceLeft, line2Height);
      //#endregion

      //#region Line 26
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var text1 = "Signature Bank Officer: ";
      // var text2 =
      //   application.appliedLoad < 15
      //     ? "Line Superintendent Office" +
      //     "(" +
      //     applicationId.slice(3, 8) +
      //     " - " +
      //     subdivisionName(
      //       parseInt(application.subDivisionCode),
      //       subDivisions
      //     ) +
      //     ") SDO " +
      //     companyShortName(DiscoCode)
      //     : "Line Superintendent Office" +
      //     "(" +
      //     applicationId.slice(3, 7) +
      //     " - " +
      //     divisionName(parseInt(application.divisionCode), subDivisions) +
      //     ") XEN " +
      //     companyShortName(DiscoCode);
      doc.text(text1, padding, line2Height);
      // doc.text(text2, padding + spaceLeft, line2Height);
      //#endregion

      //#region Line 27
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      spaceLeft = 10;
      var text1 =
        "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
      doc.text(text1, padding + spaceLeft, line2Height);
      //#endregion

      //#region Line 28
      lineHeightIncreament = 5;
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        "DUE Date: " + convertDate(dnDets.dueDate),
        padding,
        line2Height,
        {}
      );
      doc.text(
        "For Bank Use Only",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );
      //#endregion

      //#region Line 29
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        "(The concerned bank will separate this layer from the demand notice and send it to the revenue officer along with its bank scroll)",
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );
      //#endregion

      //#region Line 30
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 16;
      var spaceLeft = 50;

      var text1 = `1. Applicant's Name and Complete address `;
      // prefer DN-level guardian info when available
      var guardianType = (dnDets && dnDets.applicantGuardianType) || application.applicantGuardianType;
      var guardianName = (dnDets && dnDets.applicantGuardianName) || application.applicantGuardianName;
      var guardianText =
        guardianType == 1 || guardianType == 'S/O' ? 'S/O' :
          guardianType == 2 || guardianType == 'D/O' ? 'D/O' :
            guardianType == 3 || guardianType == 'W/O' ? 'W/O' :
              guardianType == 4 || guardianType == 'C/O' ? 'C/O' : '';

      var applicantAddressText = application.consumerAddress
        ? " | " + application.consumerAddress.trim()
        : "";

      var normalizedGuardianName = guardianName ? guardianName.trim() : '';
      var guardianDisplay = guardianText
        ? guardianText + (normalizedGuardianName ? ' ' + normalizedGuardianName : '')
        : normalizedGuardianName;

      var applicantDisplayName = [application.applicantName ? application.applicantName.trim() : '', guardianDisplay]
        .filter(Boolean)
        .join(' ')
        .trim();
      var text2 = applicantDisplayName
        ? applicantDisplayName + applicantAddressText
        : "-";

      var text3 = `Details of paid amount`;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.setFontSize(6);
      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2 + spaceLeft),
        line2Height
      );
      //#endregion

      //#region Line 31
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 6.6;

      var text1 = "2. Application Id: ";
      var text2 = application.applicationId ? application.applicationId : "-";
      var text3 = "Date: ";
      var text4 = application.creationDate
        ? convertDate(application.creationDate)
        : "-";
      var text5 = "1. Security:";
      var text6 = dnDets.securityDepositeAmount
        ? numberFormatting(dnDets.securityDepositeAmount)
        : "-";
      var leftSpace = 40;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 3,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        leftSpace +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height
      );

      doc.setFont("helvetica", "bold");
      doc.text(
        text6,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 5 +
        leftSpace,
        line2Height
      );
      doc.setFont("helvetica", "normal"); // reset back to normal

      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        leftSpace,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        doc.getTextWidth(text6) +
        lineSpace * 2 +
        leftSpace,
        line2Height + 1
      );

      //#region Line 32
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 6.6;
      var text1 = "3. Demand Notice Serial No.: ";
      var text2 = dnDets.demandNoteNo ? dnDets.demandNoteNo : "-";
      var text3 = "Date: ";
      var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
      var text5 = "2. Capital Cost: ";
      var text6 = dnDets.capitalCostAmount
        ? numberFormatting(dnDets.capitalCostAmount)
        : "-";
      var leftSpace = 35;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 3,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1
      );
      const marginTop = 2;

      doc.text(
        text5,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        20 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + marginTop
      );

      doc.setFont("helvetica", "bold");
      doc.text(
        text6,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 5 +
        20,
        line2Height + marginTop
      );

      doc.setFont("helvetica", "normal");
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        20,
        line2Height + 1 + marginTop,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        doc.getTextWidth(text6) +
        lineSpace * 2 +
        leftSpace,
        line2Height + 1 + marginTop
      );

      //#region Line 33
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 6.6;
      var text1 = "4. Account No. for acquisition connection: ";
      var text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : "-";
      var text3 = " ";
      var text4 = " ";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );
      //#endregion

      //#region Line 34
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 6.6;
      var text1 = "5. Approved bank name and address:";
      var text2 = dnDets.bankName ? dnDets.bankName : "-";
      var text5 = "3. Total: ";
      var text6 = getAmountText(
        parseInt(dnDets.securityDepositeAmount || 0) +
        parseInt(dnDets.capitalCostAmount || 0)
      );
      var leftSpace = 35;

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 3,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        30 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height
      );

      doc.setFont("helvetica", "bold");
      doc.text(
        text6,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 5 +
        30,
        line2Height
      );

      // 🟡 Add “(NOT Payable)” when applicable
      if (
        dnDets.isDNPayable === false ||
        dnDets.isDNPayable === "false" ||
        dnDets.isDNPayable === null ||
        dnDets.isDNPayable === "null" ||
        dnDets.isDNPayable === 0 ||
        dnDets.isDNPayable === "0" ||
        dnDets.isDNPayable === "" ||
        dnDets.isDNPayable === undefined
      ) {
        doc.setFont("helvetica", "normal");
        doc.setTextColor(255, 0, 0); // 🔴 set red color

        const notPayableText = "(Not Payable)";
        const notPayableX =
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          doc.getTextWidth(text6) +
          padding +
          lineSpace * 7 + // small gap
          30;

        doc.text(notPayableText, notPayableX, line2Height);

        doc.setTextColor(0, 0, 0); // ⚫ reset back to black
      }

      doc.setFont("helvetica", "normal");
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        30,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        doc.getTextWidth(text6) +
        lineSpace * 2 +
        leftSpace,
        line2Height + 1
      );

      //#endregion

      //#region Line 35
      doc.setFontSize(fontSize);
      var line2Height =
        line2Height + lineHeightIncreament + lineHeightIncreament;
      var lineSpace = 6.6;
      // var text1 = application.appliedLoad < 15 ? 'Signature Sub-Divisional Officer or Line Superintendent-in-charge' : 'Signature Divisional Officer or Line Superintendent-in-charge'
      var text1 =
        "                                                                         ";
      var text2 = " ";
      var text3 = " ";
      var text4 = " ";
      var text5 = " ";
      var text6 = "Signature Bank Officer ";
      var leftSpace = 20;
      doc.text(text1, padding, line2Height);
      doc.text(
        text6,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 5 +
        +leftSpace,
        line2Height
      );
      //#endregion

      //#region Line 36
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      var lineSpace = 6.6;
      var text1 = "                                     ";
      var text2 = " ";
      var text3 = " ";
      var text4 = " ";
      var text5 = " ";
      var text6 = " ";
      var leftSpace = 10;
      doc.setFontSize(6);
      doc.text(text1, padding, line2Height);
      //#endregion

      //#region Line 37
      doc.setFontSize(fontSize);
      var line2Height = line2Height + lineHeightIncreament;
      spaceLeft = 10;
      doc.text(
        "                                                                                               ",
        10,
        line2Height
      );
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        "                                                                                               ",
        10,
        line2Height
      );
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        "                                                                                               ",
        10,
        line2Height
      );
      var line2Height = line2Height + lineHeightIncreament;
      var text1 =
        "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
      doc.text(text1, padding + spaceLeft, line2Height);
      //#endregion

      //#region Line 38
      lineHeightIncreament = 4;
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        (!dnDets.demandNoteExpiryCount ? "Due Date: " : "Extended Due Date: ") +
        convertDate(dnDets.dueDate),
        padding,
        line2Height,
        {}
      );
      doc.text(
        `Applicant's Response`,
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );
      //#endregion

      //#region Line 39
      lineHeightIncreament = 4;
      var line2Height = line2Height + lineHeightIncreament;
      doc.setFontSize(fontSize);
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var text1 = `1. I/We have submitted the security amount of [securityCost] and service connection of [capitalCost] only in the department's approved bank [bankName] by receipt no. _______________________________________ on date _______________________________.`;
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        var lineText = lines[i].replace(
          "[capitalCost]",
          numberFormatting(dnDets.capitalCostAmount)
        );
        lineText = lineText.replace(
          "[securityCost]",
          numberFormatting(dnDets.securityDepositeAmount)
        );
        lineText = lineText.replace(
          "[bankName]",
          dnDets.bankName ? dnDets.bankName : "-"
        );
        doc.text(lineText, padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 40
      doc.setFontSize(fontSize);
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var noOfDays = "30";
      var text1 = `2. Since I/We did not provide funds to buy meter to the department, I am/We are responsible to pay monthly rent of ______ PKR as meter rent.`;
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        doc.text(lines[i], padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 41
      doc.setFontSize(fontSize);
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
      var noOfDays = "30";
      var text1 = `3. I am/We are sending herewith demand notice, a certified list report from a government approved wiring contractor to prove that the internal wiring of my/our building is sound and of standard and that the installation of my/our utility equipment has been completed. I will send within the specified period.`;
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        doc.text(lines[i], padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 42
      lineHeightIncreament = 5;
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        `For Computer Center Use`,
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );
      //#endregion

      //#region Line 43
      var line2Height = line2Height + lineHeightIncreament;
      doc.text(
        `(Demand Notice Data)`,
        doc.internal.pageSize.getWidth() / 2,
        line2Height,
        {
          align: "center",
        }
      );
      //#endregion

      //#region Line 44
      var line2Height = line2Height + lineHeightIncreament;
      var lineHeightIncreament = 5;
      var padding = 10;
      var lineSpace = 7.5;
      var text1 = "Demand Notice Serial No.: ";
      var text2 = dnDets.demandNoteNo ? dnDets.demandNoteNo : "-";
      var text3 = "Application Id: ";
      var text4 = applicationId ? applicationId : "-";
      var text5 = "Application Form No.: ";
      var text6 = dnDets.demandNoteNo ? dnDets.demandNoteNo : "-";

      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 3,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1
      );

      doc.text(
        text5,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height
      );
      doc.text(
        text6,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 5,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 4 +
        doc.getTextWidth(text6) +
        lineSpace * 2,
        line2Height + 1
      );
      //#endregion

      //#region Line 45
      var lineHeightIncreament = 5;
      var line2Height = line2Height + lineHeightIncreament;
      var padding = 10;
      var lineSpace = 7.5;

      var text1 = "Demand Notice Issuance Date: ";
      var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
      var text3 = "Amount to be paid: ";
      var text4 = dnDets.securityDepositeAmount
        ? numberFormatting(
          parseInt(dnDets.securityDepositeAmount) +
          parseInt(dnDets.capitalCostAmount || 0)
        )
        : "-";

      var text5 = " ";
      var text6 = " ";

      // ---- Normal text (left side)
      doc.setFont("helvetica", "normal");
      doc.text(text1, padding, line2Height);
      doc.text(
        text2,
        doc.getTextWidth(text1) + padding + lineSpace,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) + padding,
        line2Height + 1,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height + 1
      );

      // ---- Bold for Amount section
      doc.setFont("helvetica", "bold");
      doc.text(
        text3,
        doc.getTextWidth(text1) +
        padding +
        (doc.getTextWidth(text2) + lineSpace * 2),
        line2Height
      );
      doc.text(
        text4,
        doc.getTextWidth(text2) +
        doc.getTextWidth(text1) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 3,
        line2Height
      );
      doc.line(
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2,
        line2Height + 1,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        padding +
        lineSpace * 2 +
        (doc.getTextWidth(text4) + lineSpace * 2),
        line2Height + 1
      );

      if (
        dnDets.isDNPayable === false ||
        dnDets.isDNPayable === "false" ||
        dnDets.isDNPayable === null ||
        dnDets.isDNPayable === "null" ||
        dnDets.isDNPayable === 0 ||
        dnDets.isDNPayable === "0" ||
        dnDets.isDNPayable === "" ||
        dnDets.isDNPayable === undefined
      ) {
        doc.setFont("helvetica", "normal");
        doc.setTextColor(255, 0, 0); // 🔴 red color

        const notPayableText = "(Not Payable)";
        const notPayableX =
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          padding +
          lineSpace * 4;

        doc.text(notPayableText, notPayableX, line2Height);

        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "normal");
      }

      //#endregion

      //#region Line 46
      doc.setFontSize(fontSize);
      var line2Height =
        line2Height + lineHeightIncreament + lineHeightIncreament / 2;
      var lineSpace = 6.6;
      var text1 = " ";
      var text2 = " ";
      var text3 = " ";
      var text4 = " ";
      var text5 = " ";
      var text6 = application.appliedLoad < 15 ? " " : " ";
      var leftSpace = 110;
      doc.text(
        text6,
        doc.getTextWidth(text1) +
        doc.getTextWidth(text2) +
        doc.getTextWidth(text3) +
        doc.getTextWidth(text4) +
        doc.getTextWidth(text5) +
        padding +
        lineSpace * 5 +
        +leftSpace,
        line2Height
      );
      //#endregion

      //#region Line 47
      doc.setFontSize(6);
      lineHeightIncreament = 2;
      var maxWidth = doc.internal.pageSize.getWidth() - padding * 8;
      var text1 =
        "NOTE - Computer generated demand notice, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/appplicant. In case any document is found false at later stages,the said connection is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and campany reserved its rights to take legal action against owner/applicant. ";
      var lineSpace = 6.6;
      var lines = doc.splitTextToSize(text1, maxWidth);
      for (var i = 0; i < lines.length; i++) {
        doc.text(lines[i], padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#endregion

      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(userCompany),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight()
        );
      }

      // Save the PDF

      doc.save(application.applicationId + "- Demand Notice.pdf");
    } catch (e) {
      console.log(e, "error in dn creation");
    }
    setViewBackdrop(false);
  };

  // Handler for dialog DN download with expiry check
  const handleDialogDnDownload = () => {
    // Show expiry popup ONLY at DN Submission step (applicationProgressId === 5)
    // For other steps, download DN directly even if expired
    if (dialogDnExpiryFlag != 0 && dialogRowData.applicationProgressId === 5) {
      // DN is expired AND we're at DN Submission step, show the expiry popup
      setDnExpiryDialogData({
        applicationId: dialogRowData.applicationId,
        issueDate: dnDets.issueDate,
      });
      setShowDnExpiryPopup(true);
    } else {
      // DN is not expired OR we're not at DN Submission step, proceed with download
      downloadDNPDF(dialogRowData.applicationId, dnDets, dialogRowData);
    }
  };

  const downloadEFile = async (application) => {
    setViewBackdrop(true);
    try {
      // Round off values without decimal points for E-File
      const formatAmount = (value) => {
        const num = Number(value) || 0;
        const rounded = Math.round(num);
        return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      };
      let applicationId = application.applicationId;
      let DiscoCode = application.companyCode.toString();

      // ⬇⬇ GET DOCUMENTS FROM YOUR NEW API
      const applicationDocs = await getDocumentApi(applicationId);

      if (!applicationDocs) {
        return;
      }

      // ⬇⬇ CALL E-FILE API TO GET eFileData
      const eFileTableData = await callEfileAPI(applicationId, application);

      let paidDemandNoteImage = "";
      let dnDets = null;
      let boqItems = [];

      // Only call Demand Note API if application has reached step 4 or higher
      if (application.applicationProgressId >= 4) {
        try {
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          myHeaders.append("Content-Type", "application/json");

          const raw = JSON.stringify({
            applicationId: application.applicationId,
          });

          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          const response = await fetch(
            cfpBaseUrl + "changeOfAttributes/getDemandNoteData",
            requestOptions
          );

          const result = await response.json();

          if (
            result.status === "200" &&
            result.data &&
            result.data.length > 0
          ) {
            dnDets = result.data[0];
            paidDemandNoteImage = dnDets.paidDNImage || "";
            boqItems = result.BoQitems;
          } else {
            console.log("Demand Note not issued or not paid yet");
          }
        } catch (error) {
          console.error("Error fetching Demand Note data:", error);
        }
      } else {
      }

      // Read all document URLs safely
      const copyOfApplicantCNICFront = applicationDocs.applicantCNICFront || "";
      const copyOfApplicantCNICBack = applicationDocs.applicantCNICBack || "";
      const premisesDocument = applicationDocs.ownershipImage || "";
      console.log("premisesDocument", premisesDocument);
      const scannedCopyOfNearByElectricityBill =
        applicationDocs.electricityBill || "";
      const fbrDocument = applicationDocs.fbrDocument || "";
      const anyOtherDocument = applicationDocs.anyOtherDocument || "";


      const doc = new jsPDF({ compressPdf: true });

      // Helper function to add page header
      const addPageHeader = (doc, DiscoCode, applicationId, documentTitle) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const padding = 10;
        const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
        const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
        const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
        const logoX = (pageWidth - logoWidth) / 2;

        let height = 10;

        doc.addImage(
          getLogo(DiscoCode),
          "PNG",
          logoX,
          5,
          logoWidth,
          logoHeight
        );

        height += 15;
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
          align: "center",
        });

        height += 10;
        doc.setFont("helvetica", "normal");
        doc.text("Application Id: ", padding, height);
        doc.text(
          applicationId,
          padding + doc.getTextWidth("Application Id: "),
          height
        );

        height += 10;
        const rectWidth = 195;
        const rectHeight = 10;
        const rectX = (pageWidth - rectWidth) / 2;

        doc.setFillColor(199, 199, 199);
        doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
        doc.setFont("helvetica", "bold");
        doc.text(documentTitle, pageWidth / 2, height, { align: "center" });

        return height + 3.5;
      };

      // Helper function to add document image/PDF with fixed dimensions
      const addDocumentContent = async (doc, documentData, startHeight) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;

        doc.rect(rectX, startHeight, rectWidth, rectHeight);

        if (!documentData) {
          doc.setFontSize(12);
          doc.text("No document available", pageWidth / 2, startHeight + rectHeight / 2, { align: "center" });
          return;
        }

        const cardWidth = 190;
        const cardHeight = 228;
        const xPos = (pageWidth - cardWidth) / 2;
        const yPos = startHeight + 3;

        const isString = typeof documentData === "string";
        const lower = isString ? documentData.toLowerCase() : "";

        const blobToDataUrl = (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });

        try {
          if (isString && lower.startsWith("data:image/")) {
            if (lower.includes("jpeg") || lower.includes("jpg")) {
              doc.addImage(documentData, "JPEG", xPos, yPos, cardWidth, cardHeight);
            } else if (lower.includes("png")) {
              doc.addImage(documentData, "PNG", xPos, yPos, cardWidth, cardHeight);
            } else {
              doc.addImage(documentData, "JPEG", xPos, yPos, cardWidth, cardHeight);
            }
          } else if (isString && lower.startsWith("data:application/pdf")) {
            await addPdfasImage(documentData, rectX, startHeight, rectWidth, rectHeight);
          } else if (isString && (lower.startsWith("http://") || lower.startsWith("https://") || lower.startsWith("blob:"))) {
            // fetch remote resource and render based on content-type
            try {
              const response = await fetch(documentData);
              const contentType = (response.headers.get("content-type") || "").toLowerCase();
              const blob = await response.blob();

              if (contentType.includes("pdf")) {
                const dataUrl = await blobToDataUrl(blob);
                await addPdfasImage(dataUrl, rectX, startHeight, rectWidth, rectHeight);
              } else if (contentType.startsWith("image/")) {
                const dataUrl = await blobToDataUrl(blob);
                if (contentType.includes("png")) {
                  doc.addImage(dataUrl, "PNG", xPos, yPos, cardWidth, cardHeight);
                } else {
                  doc.addImage(dataUrl, "JPEG", xPos, yPos, cardWidth, cardHeight);
                }
              } else {
                doc.setFontSize(12);
                doc.text("Unsupported document type", pageWidth / 2, yPos + cardHeight / 2, { align: "center" });
              }
            } catch (err) {
              console.error("Error fetching remote document:", err);
              doc.setFontSize(12);
              doc.text("Failed to load remote document", pageWidth / 2, yPos + cardHeight / 2, { align: "center" });
            }
          } else if (isString) {
            // Fallback for non-data URL strings (try image)
            try {
              doc.addImage(documentData, "JPEG", xPos, yPos, cardWidth, cardHeight);
            } catch (err) {
              console.error("Fallback addImage failed:", err);
              doc.setFontSize(12);
              doc.text("Failed to render document", pageWidth / 2, yPos + cardHeight / 2, { align: "center" });
            }
          } else {
            doc.setFontSize(12);
            doc.text("Unsupported document format", pageWidth / 2, yPos + cardHeight / 2, { align: "center" });
          }
        } catch (err) {
          console.error("Error adding document content:", err);
          doc.setFontSize(12);
          doc.text("Failed to load document", pageWidth / 2, yPos + cardHeight / 2, { align: "center" });
        }
      };

      // Helper function to add CNIC images with fixed size to fit in border
      const addCNICImage = (
        doc,
        cnicData,
        startHeight,
        containerHeight = 234
      ) => {
        const pageWidth = doc.internal.pageSize.getWidth();

        const cardWidth = 150;
        const cardHeight = 95;
        const xPos = (pageWidth - cardWidth) / 2;
        const yPos = startHeight + (containerHeight - cardHeight) / 2;

        const fileType = cnicData.slice(0, 6);
        let extension = "";

        if (fileType === "data:i") {
          extension = cnicData.slice(11, 15);
        } else if (fileType === "data:a") {
          extension = cnicData.slice(17, 19);
        }

        if (extension.startsWith("jp")) {
          doc.addImage(cnicData, "jpeg", xPos, yPos, cardWidth, cardHeight);
        } else if (extension.startsWith("pn")) {
          doc.addImage(cnicData, "png", xPos, yPos, cardWidth, cardHeight);
        }

        return yPos + cardHeight;
      };

      const addPdfasImage = async (
        pdfInBase64,
        rectX,
        rectY,
        rectWidth,
        rectHeight
      ) => {
        let base64ImagesArray = [];

        try {
          if (!window.pdfjsLib) {
            await new Promise((resolve, reject) => {
              const script = document.createElement("script");
              script.src =
                "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.379/pdf.min.mjs";
              script.type = "module";
              script.onload = () => {
                setTimeout(resolve, 100);
              };
              script.onerror = reject;
              document.head.appendChild(script);
            });
          }

          const pdfjsLib = window.pdfjsLib;
          pdfjsLib.GlobalWorkerOptions.workerSrc =
            "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.379/pdf.worker.min.mjs";

          const pdfData = atob(pdfInBase64.split(",")[1]);
          const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
          const docPageNumbers = pdf.numPages;

          const renderPageToBase64 = async (pageNumber) => {
            try {
              const pdfPage = await pdf.getPage(pageNumber);
              const scale = 1.5;
              const viewport = pdfPage.getViewport({ scale });
              const canvas = document.createElement("canvas");
              const canvasContext = canvas.getContext("2d");
              canvas.width = viewport.width;
              canvas.height = viewport.height;
              await pdfPage.render({ canvasContext, viewport }).promise;
              const imageDataUrl = canvas.toDataURL("image/png");
              return imageDataUrl;
            } catch (error) {
              console.error("Error rendering PDF page:", error);
              return null;
            }
          };

          for (let i = 1; i <= docPageNumbers; i++) {
            const imageDataUrl = await renderPageToBase64(i);
            if (imageDataUrl) {
              base64ImagesArray.push(imageDataUrl);
            }
          }

          const cardWidth = 190;
          const cardHeight = 228;
          const xPos = (doc.internal.pageSize.getWidth() - cardWidth) / 2;
          const yPos = rectY + 3;

          base64ImagesArray.forEach((imageDataUrl, index) => {
            if (index > 0) {
              doc.addPage();
              const contentHeight = addPageHeader(
                doc,
                DiscoCode,
                applicationId,
                "Property Document (Continued)"
              );
              doc.rect(rectX, contentHeight, rectWidth, rectHeight);
              doc.addImage(
                imageDataUrl,
                "PNG",
                xPos,
                contentHeight + 3,
                cardWidth,
                cardHeight
              );
            } else {
              doc.addImage(
                imageDataUrl,
                "PNG",
                xPos,
                yPos,
                cardWidth,
                cardHeight
              );
            }
          });
        } catch (error) {
          console.error("Error loading PDF:", error);
          alert("Failed to process PDF document. Please try again.");
        }
      };

      // FIRST PAGE - Application Summary
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Generate the barcode
      const barcodeCanvas = document.createElement("canvas");
      JsBarcode(barcodeCanvas, applicationId);
      const barcodeDataURL = barcodeCanvas.toDataURL("image/png");

      const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
      const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
      const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
      const logoX = (pageWidth - logoWidth) / 2;

      doc.addImage(barcodeDataURL, "PNG", pageWidth - 50, 5, 40, 20);
      doc.addImage(getLogo(DiscoCode), "PNG", logoX, 5, logoWidth, logoHeight);

      let height = 25;
      const padding = 10;
      const leftMargin = 50;

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
        align: "center",
      });

      height += 8;
      doc.setFontSize(18);
      doc.text("E-Document", pageWidth / 2, height, { align: "center" });

      height += 8;
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      height += 8;

      doc.text("Document Type: ", padding, height);
      doc.text(
        `Change of ${application.changeOfAttributesType == 1
          ? "Name"
          : application.changeOfAttributesType == 2
            ? "Load"
            : application.changeOfAttributesType == 3
              ? "Tariff"
              : application.changeOfAttributesType == 4
                ? "Name, Load and Tariff"
                : application.changeOfAttributesType == 5
                  ? "Name and Load"
                  : application.changeOfAttributesType == 6
                    ? "Name and Tariff"
                    : application.changeOfAttributesType == 7
                      ? "Load and Tariff"
                      : ""
        }`,
        padding + leftMargin,
        height
      );
      doc.text("Tracking Id:", padding + leftMargin + leftMargin, height);
      doc.text(
        applicationId,
        padding + leftMargin + leftMargin + leftMargin,
        height
      );

      height += 6;
      doc.text("Application Status: ", padding, height);
      doc.text(
        statusFunc(
          application.applicationProgressId,
          application.objectionStatus
        ),
        padding + leftMargin,
        height
      );
      doc.text("Application Date:", padding + leftMargin + leftMargin, height);
      doc.text(
        convertDate(application.creationDate),
        padding + leftMargin + leftMargin + leftMargin,
        height
      );

      height += 6;
      doc.text("Sub-Division: ", padding, height);
      doc.text(
        subdivisionName(parseInt(application.subDivisionCode), subDivisions),
        padding + leftMargin,
        height
      );
      doc.text("Connection Type:", padding + leftMargin + leftMargin, height);
      doc.text(
        application.connectionType,
        padding + leftMargin + leftMargin + leftMargin,
        height
      );

      height += 6;
      doc.text("Phase / Load: ", padding, height);
      doc.text(
        application.currentSanctionLoad.toString(),
        padding + leftMargin,
        height
      );
      doc.text("Connection Date:", padding + leftMargin + leftMargin, height);
      doc.text("-", padding + leftMargin + leftMargin + leftMargin, height);

      height += 20;
      let rectWidth = 195;
      let rectHeight = 10;
      let rectX = (pageWidth - rectWidth) / 2;

      doc.setFillColor(200, 200, 200);
      doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
      doc.setFont("helvetica", "bold");
      doc.text("Applicant Particulars", pageWidth / 2, height, {
        align: "center",
      });

      height += 6;
      rectHeight = 30;
      doc.rect(rectX, height - 2.5, rectWidth, rectHeight);

      doc.setFont("helvetica", "normal");
      height += 8;
      const extraPadding = 5;

      doc.text("Applicant Name:", padding + extraPadding, height);
      doc.text(application.applicantName, padding + 70, height);

      height += 6;
      doc.text("CNIC:", padding + extraPadding, height);
      doc.text(application.applicantCNIC, padding + 70, height);

      height += 6;
      doc.text("Present Address:", padding + extraPadding, height);
      doc.text(application.consumerAddress, padding + 70, height);

      height += 6;
      doc.text("Phone No.:", padding + extraPadding, height);
      doc.text(application.applicantPhoneNo, padding + 70, height);

      // Add spacing before Application Summary section
      height += 15;
      rectHeight = 10;

      doc.setFillColor(199, 199, 199);
      doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
      doc.setFont("helvetica", "bold");
      doc.text("Application Summary", pageWidth / 2, height, {
        align: "center",
      });

      doc.setFontSize(12);
      height += 3.5;

      const summaryTableProps = {
        margin: { left: rectX, right: rectX },
        startY: height,
        tableWidth: rectWidth,
        styles: {
          fontSize: 11,
          fontStyle: "normal",
          halign: "center",
          valign: "middle",
          lineWidth: 0,
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          minCellHeight: 10,
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontSize: 11,
          fontStyle: "bold",
          halign: "center",
          valign: "middle",
          lineWidth: 0,
        },
        alternateRowStyles: {
          fillColor: [235, 235, 235],
        },
        columnStyles: {
          0: { halign: "center", cellWidth: 15 },
          1: { halign: "center", cellWidth: 40 },
          2: { halign: "center", cellWidth: 35 },
          3: { halign: "center", cellWidth: 30 },
          4: { halign: "center", cellWidth: 65 },
        },
        theme: "plain",
        tableLineWidth: 0.5,
        tableLineColor: [0, 0, 0],
      };

      const summaryData = [];
      // Check if eFileResult exists and has data
      if (eFileTableData && eFileTableData.length > 0) {
        // Sort the array by applicationProgressId in descending order
        const sortedData = [...eFileTableData].sort(
          (a, b) => b.applicationProgressId - a.applicationProgressId
        );

        let srNumber = sortedData.length;

        for (let i = 0; i < sortedData.length; i++) {
          const row = sortedData[i];

          const stepProgressId = stepName(
            row.applicationProgressId,
            row.remarks
          );

          // If applicationProgressId is 1, use "Application Submitted." as remarks
          const remarksToShow =
            row.applicationProgressId === 1
              ? "Application Submitted."
              : row.remarks || "";

          summaryData.push([
            srNumber.toString(),
            row.stepName || "",
            row.processedBy || "",
            convertDatewithTimeWithoutSecond(row.date).slice(0, 11),
            remarksToShow,
          ]);

          srNumber--;
        }
      }
      // Draw the table
      doc.autoTable({
        head: [["Sr.", "Step", "Processed By", "Date", "Remarks"]],
        body: summaryData,
        ...summaryTableProps,
      });

      // ADD OTHER DOCUMENTS ON NEW PAGES
      if (copyOfApplicantCNICFront !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Applicant CNIC - Front"
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(
          doc,
          copyOfApplicantCNICFront,
          contentHeight,
          rectHeight
        );
      }

      if (copyOfApplicantCNICBack !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Applicant CNIC - Back"
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(
          doc,
          copyOfApplicantCNICBack,
          contentHeight,
          rectHeight
        );
      }

      // PREMISES DOCUMENT
      if (premisesDocument !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Property Document"
        );
        await addDocumentContent(doc, premisesDocument, contentHeight);
      }

      // NEARBY ELECTRICITY BILL
      if (scannedCopyOfNearByElectricityBill !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Electricity Bill"
        );
        await addDocumentContent(
          doc,
          scannedCopyOfNearByElectricityBill,
          contentHeight
        );
      }

      // FBR DOCUMENT
      if (fbrDocument !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "FBR Document"
        );
        await addDocumentContent(doc, fbrDocument, contentHeight);
      }

      // ANY OTHER DOCUMENT
      if (anyOtherDocument !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Any Other Document"
        );
        await addDocumentContent(doc, anyOtherDocument, contentHeight);
      }

      if (
        application.applicationProgressId >= 5 &&
        paidDemandNoteImage !== ""
      ) {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Paid Demand Note"
        );
        await addDocumentContent(doc, paidDemandNoteImage, contentHeight);
      }
      // ⬇⬇ ADD DEMAND NOTE CONTENT ONLY IF CONDITIONS ARE MET
      if (
        dnDets &&
        dnDets.approvedFlag == 1 &&
        application.applicationProgressId > 4
      ) {
        doc.addPage();

        // === Setup ===
        const fontSize = 8;
        let padding = 10;
        let line2Height = 10;
        let lineHeightIncreament = 5;
        let lineSpace = 12;
        let spaceLeft = 100;
        let leftSpace = 40;

        // Stamp
        const officeCode = application.subDivisionCode;
        const officeName = subdivisionName(parseInt(officeCode), subDivisions);
        const authorizedByName = dnDets.approvedBy || "---";
        const authorizedByDesignation = dnDets.approvedByDesignation || "Role";
        const dateToPrint = dnDets.approvedDate
          ? new Date(dnDets.approvedDate).toLocaleDateString()
          : "---";
        const stampData = printStamp(
          officeCode,
          officeName,
          authorizedByName,
          authorizedByDesignation,
          dateToPrint
        );

        if (dnDets.approvedBy) {
          doc.addImage(stampData, "PNG", 20, 190, 55, 40);
          doc.addImage(stampData, "PNG", 140, 265, 55, 40);
        }

        // Application Date Formatting
        const yy = applicationId.slice(8, 10);
        const mm = applicationId.slice(10, 12);
        const dd = applicationId.slice(12, 14);
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        const formattedDate = `${dd}-${monthNames[parseInt(mm) - 1]}-20${yy}`;

        // Header: Due Date + Company Name
        doc.setFontSize(fontSize);
        doc.setFont("helvetica", "bold");
        doc.text(
          (!dnDets.demandNoteExpiryCount
            ? "Due Date: "
            : "Extended Due Date: ") + convertDate(dnDets.dueDate),
          padding,
          line2Height
        );

        doc.setFont("helvetica", "normal");
        const companyFullName =
          companyName(dnDets.connectionAccountNo.slice(2, 4)) +
          (application.appliedLoad < 15
            ? `(${dnDets.connectionAccountNo.slice(2, 7)}-${subdivisionName(
              parseInt(application.subDivisionCode),
              subDivisions
            )})`
            : `(${dnDets.connectionAccountNo.slice(2, 6)}-${divisionName(
              parseInt(application.divisionCode),
              subDivisions
            )})`);

        doc.text(
          companyFullName,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );
        line2Height += lineHeightIncreament;
        doc.text(
          "(Department of Electricity)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );

        // Line 3: Serial, App ID, Apply Date
        line2Height += lineHeightIncreament;
        lineSpace = 12;
        let text1 = "Demand Notice Serial No.: ";
        let text2 = dnDets.demandNoteNo || "-";
        let text3 = "Application Id: ";
        let text4 = applicationId;
        let text5 = "Apply Date: ";
        let text6 = formattedDate;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          doc.getTextWidth(text2) +
          lineSpace * 2,
          line2Height + 1
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace * 2,
          line2Height
        );
        doc.text(
          text4,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          doc.getTextWidth(text4) +
          lineSpace * 2,
          line2Height + 1
        );

        doc.text(
          text5,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          padding +
          lineSpace * 4,
          line2Height
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
          line2Height + 1
        );

        // Line 4
        line2Height += lineHeightIncreament;
        lineSpace = 3.35;
        text1 = "Demand Notice Issuance Date: ";
        text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        text3 = "Application Type: ";
        text4 = application.changeOfAttributesType
          ? applicationName(application.changeOfAttributesType)
          : "-";
        text5 = "Load: ";
        text6 = application.newSanctionLoad
          ? String(application.newSanctionLoad)
          : application.currentSanctionLoad
            ? String(application.currentSanctionLoad)
            : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          doc.getTextWidth(text2) +
          lineSpace * 2,
          line2Height + 1
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace * 2,
          line2Height
        );
        doc.text(
          text4,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          doc.getTextWidth(text4) +
          lineSpace * 2,
          line2Height + 1
        );

        doc.text(
          text5,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          padding +
          lineSpace * 4,
          line2Height
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
          line2Height + 1
        );

        // Line 5
        line2Height += lineHeightIncreament;
        lineSpace = 6.6;
        text1 = "Account No. for acquisition connection: ";
        text2 = dnDets.connectionAccountNo || "-";
        text3 = "User Mobile No.: ";
        text4 = application.applicantPhoneNo || "-";
        text5 = "Connection type: ";
        text6 = dnDets.connectionType || "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          doc.getTextWidth(text2) +
          lineSpace * 2,
          line2Height + 1
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace * 2,
          line2Height
        );
        doc.text(
          text4,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          doc.getTextWidth(text4) +
          lineSpace * 2,
          line2Height + 1
        );

        doc.text(
          text5,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          padding +
          lineSpace * 4,
          line2Height
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 6,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          doc.getTextWidth(text6) +
          lineSpace * 2,
          line2Height + 1
        );

        // Line 6
        line2Height += lineHeightIncreament;
        doc.text(
          "(under which the funds are to be deposited in the bank with the concerned officer of the institution)",
          padding,
          line2Height
        );

        // Line 7 - Tariff and Bank Name
        line2Height += lineHeightIncreament;
        lineSpace = 16;
        text1 = "Alloted Tariff : ";
        text2 = application.newTariff ? application.newTariff : application.currentTariff;
        text3 = "Department's approved Bank name: ";
        text4 = dnDets.bankName || "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          doc.getTextWidth(text2) +
          lineSpace * 2,
          line2Height + 1
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          padding +
          doc.getTextWidth(text2) +
          lineSpace * 2 + 30,
          line2Height
        );
        doc.text(
          text4,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3 + 30,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 + 30,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          doc.getTextWidth(text4) +
          lineSpace * 2 + 30,
          line2Height + 1
        );

        // Title
        line2Height += 15;
        doc.text(
          "DEMAND NOTICE",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );
        line2Height += 8;
        doc.setFont("helvetica", "normal");
        doc.setFontSize(fontSize);
        doc.text(
          "(Notification of Approval Application and Demand Under Guarantee)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );
        line2Height += lineHeightIncreament;
        doc.text(
          "Applicant's part",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );

        // Applicant Name
        line2Height += lineHeightIncreament;
        lineSpace = 16;
        text1 = "Mr. / Mrs.";
        const guardianRelation =
          application.applicantGuardianType == 1 ? "S/O"
            : application.applicantGuardianType == 2 ? "D/O"
              : application.applicantGuardianType == 3 ? "W/O"
                : application.applicantGuardianType == 4 ? "C/O"
                  : "";
        const applicantNameText = application.applicantName
          ? application.applicantName.trim()
          : "";
        const guardianNameWithRelation = guardianRelation
          ? `${guardianRelation}${application.applicantGuardianName ? ` ${application.applicantGuardianName}` : ""}`
          : "";
        const addressText = application.consumerAddress
          ? application.consumerAddress.trim()
          : "";
        text2 = [applicantNameText, guardianNameWithRelation].filter(Boolean).join(" ").trim();
        text2 = text2
          ? `${text2}${addressText ? ` | ${addressText}` : ""}`
          : addressText || "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          doc.getTextWidth(text2) +
          lineSpace * 2,
          line2Height + 1
        );

        // Main Content Paragraphs
        lineHeightIncreament = 4;
        line2Height += 5;
        const maxWidth = doc.internal.pageSize.getWidth() - padding * 2;

        const paras = [
          "You are hereby informed by demand notice that your application for change of name/load/tariff whose particulars are mentioned above has been approved by the authorized officer.",
          "1. You should deposit the following amounts in the approved bank of the department or with the concerned officer of the department itself within 30 days from the date of issue of this notice and inform my office with the receipt number and date of their payment.",
          "A. Expenditure service connection as per approved estimate ______________ and Security _______________ PKR. (this amount is to be deposited with the concerned officer of the department). If the charges are found to be more than the service approved estimate prior to connection, a deposit equal to the difference in the amount collected will be issued for which additional demand notice will be issued.",
          "NOTE: If you are an applicant or consumer of domestic, commercial, industrial wholesale supply, you should fill the demand notice in this regard on the sub-layer (reserved for your business) and affix your signature and date on it and send back to my office.",
          "(Irrelevant should be cut down)",
          "If you do not comply with the above conditions in response to the demand notice within the prescribed period, your application form for change of name/load/tariff will not be considered with the serial number allotted. Demand notices thereof (1 month after the date of issue) shall automatically be deemed ineffective.",
        ];

        const capitalText = getAmountText(dnDets.capitalCostAmount || 0);
        const securityText = getAmountText(dnDets.securityDepositeAmount || 0);

        paras.forEach((p, i) => {
          if (i === 4) {
            doc.text(p, doc.internal.pageSize.getWidth() / 2, line2Height, {
              align: "center",
            });
            line2Height += lineHeightIncreament;
            return;
          }

          // For paragraph with amounts, replace placeholders first
          let paraText = p;
          if (i === 2) {
            paraText = p
              .replace("______________", `{{CAPITAL}}`)
              .replace("_______________", `{{SECURITY}}`);
          }

          const lines = doc.splitTextToSize(paraText, maxWidth);

          lines.forEach((line) => {
            if (
              i === 2 &&
              (line.includes("{{CAPITAL}}") || line.includes("{{SECURITY}}"))
            ) {
              // Split line into parts around the placeholders
              const parts = line.split(/({{CAPITAL}}|{{SECURITY}})/g);
              let currentX = padding;

              parts.forEach((part) => {
                if (part === "{{CAPITAL}}") {
                  doc.setFont("helvetica", "bold");
                  doc.text(capitalText, currentX, line2Height);
                  const textWidth = doc.getTextWidth(capitalText);
                  // Draw line below the text
                  doc.line(
                    currentX,
                    line2Height + 1,
                    currentX + textWidth,
                    line2Height + 1
                  );
                  currentX += textWidth;
                  doc.setFont("helvetica", "normal");
                } else if (part === "{{SECURITY}}") {
                  doc.setFont("helvetica", "bold");
                  doc.text(securityText, currentX, line2Height);
                  const textWidth = doc.getTextWidth(securityText);
                  // Draw line below the text
                  doc.line(
                    currentX,
                    line2Height + 1,
                    currentX + textWidth,
                    line2Height + 1
                  );
                  currentX += textWidth;
                  doc.setFont("helvetica", "normal");
                } else if (part) {
                  doc.text(part, currentX, line2Height);
                  currentX += doc.getTextWidth(part);
                }
              });
            } else {
              doc.text(line, padding, line2Height);
            }
            line2Height += lineHeightIncreament;
          });
        });

        doc.setTextColor(220, 0, 0);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(24);
        doc.text(
          "NOT VALID FOR BANKS",
          doc.internal.pageSize.getWidth() / 2,
          145,
          {
            align: "center",
            angle: 320,
          },
        );
        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(fontSize);

        // // Signature
        // line2Height += 5;
        // doc.text("Regards", padding + spaceLeft, line2Height);
        // line2Height += 7;
        // doc.text(
        //   application.appliedLoad < 15
        //     ? `Sub-Division Office ${applicationId.slice(
        //       3,
        //       8
        //     )}-${subdivisionName(
        //       parseInt(application.subDivisionCode),
        //       subDivisions
        //     )} SDO ${companyShortName(DiscoCode)}`
        //     : `Division Office ${applicationId.slice(3, 7)} - ${divisionName(
        //       parseInt(application.divisionCode),
        //       subDivisions
        //     )} XEN ${companyShortName(DiscoCode)}`,
        //   padding + spaceLeft,
        //   line2Height
        // );

        // === BANK COPY SECTION (FULL FROM YOUR SECOND CODE) ===
        line2Height += lineHeightIncreament;
        doc.text("Signature Bank Officer: ", padding, line2Height);
        // doc.text(
        //   application.appliedLoad < 15
        //     ? "Line Superintendent Office(" +
        //     applicationId.slice(3, 8) +
        //     " - " +
        //     subdivisionName(
        //       parseInt(application.subDivisionCode),
        //       subDivisions
        //     ) +
        //     ") SDO " +
        //     companyShortName(DiscoCode)
        //     : "Line Superintendent Office(" +
        //     applicationId.slice(3, 7) +
        //     " - " +
        //     divisionName(parseInt(application.divisionCode), subDivisions) +
        //     ") XEN " +
        //     companyShortName(DiscoCode),
        //   padding + spaceLeft,
        //   line2Height
        // );

        line2Height += lineHeightIncreament;
        doc.text(
          "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------",
          padding + 10,
          line2Height
        );

        lineHeightIncreament = 5;
        line2Height += lineHeightIncreament;
        doc.text(
          (!dnDets.demandNoteExpiryCount
            ? "Due Date: "
            : "Extended Due Date: ") + convertDate(dnDets.dueDate),
          padding,
          line2Height
        );
        doc.text(
          "For Bank Use Only",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );

        line2Height += lineHeightIncreament;
        doc.text(
          "(The concerned bank will separate this layer from the demand notice and send it to the revenue officer along with its bank scroll)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );

        line2Height += lineHeightIncreament;
        lineSpace = 16;
        spaceLeft = 50;
        text1 = `1. Applicant's Name and Complete address `;
        var guardianType = (application && application.applicantGuardianType) || application.applicantGuardianType;
        var guardianName = (dnDets && dnDets.applicantGuardianName) || application.applicantGuardianName;

        var guardianText =
          guardianType == 1 || guardianType == 'S/O' ? 'S/O' :
            guardianType == 2 || guardianType == 'D/O' ? 'D/O' :
              guardianType == 3 || guardianType == 'W/O' ? 'W/O' :
                guardianType == 4 || guardianType == 'C/O' ? 'C/O' : '';

        var applicantAddressText = application.consumerAddress
          ? " | " + application.consumerAddress.trim()
          : "";

        var normalizedGuardianName = guardianName ? guardianName.trim() : '';
        var guardianDisplay = guardianText
          ? guardianText + (normalizedGuardianName ? ' ' + normalizedGuardianName : '')
          : normalizedGuardianName;

        var applicantDisplayName = [application.applicantName ? application.applicantName.trim() : '', guardianDisplay]
          .filter(Boolean)
          .join(' ')
          .trim();
        text2 = applicantDisplayName
          ? applicantDisplayName + applicantAddressText
          : "-";
        text3 = `Details of paid amount`;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1
        );

        doc.setFontSize(6);
        doc.text(
          text3,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2 + spaceLeft),
          line2Height
        );

        // Line 31
        doc.setFontSize(fontSize);
        line2Height += lineHeightIncreament;
        lineSpace = 6.6;
        text1 = "2. Application Id: ";
        text2 = application.applicationId ? application.applicationId : "-";
        text3 = "Date: ";
        text4 = application.creationDate
          ? convertDate(application.creationDate)
          : "-";
        text5 = "1. Security:";
        text6 = dnDets.securityDepositeAmount
          ? numberFormatting(dnDets.securityDepositeAmount)
          : "-";
        leftSpace = 40;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace * 2,
          line2Height
        );
        doc.text(
          text4,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1
        );

        doc.text(
          text5,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          leftSpace +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height
        );

        doc.setFont("helvetica", "bold");
        doc.text(
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          leftSpace,
          line2Height
        );
        doc.setFont("helvetica", "normal");

        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          leftSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2 +
          leftSpace,
          line2Height + 1
        );

        // Line 32
        line2Height += lineHeightIncreament;
        lineSpace = 6.6;
        text1 = "3. Demand Notice Serial No.: ";
        text2 = dnDets.demandNoteNo ? dnDets.demandNoteNo : "-";
        text3 = "Date: ";
        text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        text5 = "2. Capital Cost: ";
        text6 = dnDets.capitalCostAmount
          ? numberFormatting(dnDets.capitalCostAmount)
          : "-";
        leftSpace = 35;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace * 2,
          line2Height
        );
        doc.text(
          text4,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1
        );

        const marginTop = 2;
        doc.text(
          text5,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          20 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + marginTop
        );

        doc.setFont("helvetica", "bold");
        doc.text(
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          20,
          line2Height + marginTop
        );

        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          20,
          line2Height + 1 + marginTop,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2 +
          leftSpace,
          line2Height + 1 + marginTop
        );

        // Line 33
        line2Height += lineHeightIncreament;
        lineSpace = 6.6;
        text1 = "4. Account No. for acquisition connection: ";
        text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : "-";
        text3 = " ";
        text4 = " ";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1
        );

        // Line 34
        line2Height += lineHeightIncreament;
        lineSpace = 6.6;
        text1 = "5. Approved bank name and address:";
        text2 = dnDets.bankName ? dnDets.bankName : "-";
        text5 = "3. Total: ";
        text6 = getAmountText(
          parseInt(dnDets.securityDepositeAmount || 0) +
          parseInt(dnDets.capitalCostAmount || 0)
        );
        leftSpace = 35;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace * 2,
          line2Height
        );
        doc.text(
          text4,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1
        );

        doc.text(
          text5,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 2 +
          30 +
          (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height
        );

        doc.setFont("helvetica", "bold");
        doc.text(
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          30,
          line2Height
        );

        if (
          dnDets.isDNPayable === false ||
          dnDets.isDNPayable === "false" ||
          dnDets.isDNPayable === null ||
          dnDets.isDNPayable === "null" ||
          dnDets.isDNPayable === 0 ||
          dnDets.isDNPayable === "0" ||
          dnDets.isDNPayable === "" ||
          dnDets.isDNPayable === undefined
        ) {
          doc.setFont("helvetica", "normal");
          doc.setTextColor(255, 0, 0);
          const notPayableText = "(Not Payable)";
          const notPayableX =
            doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            doc.getTextWidth(text6) +
            padding +
            lineSpace * 7 +
            30;
          doc.text(notPayableText, notPayableX, line2Height);
          doc.setTextColor(0, 0, 0);
        }

        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          30,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text6) +
          lineSpace * 2 +
          leftSpace,
          line2Height + 1
        );

        //  // Line 35
        // line2Height += lineHeightIncreament + lineHeightIncreament;  // Keep original
        // lineSpace = 6.6;
        // text1 = " ";
        // text2 = " ";
        // text3 = " ";
        // text4 = " ";
        // text5 = " ";
        // text6 = "Signature Bank Officer ";
        // leftSpace = 20;
        // doc.text(text1, padding, line2Height);
        // doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + leftSpace, line2Height);

        // // Line 36 - Reduced spacing
        // line2Height += Math.round(lineHeightIncreament * 0.6);  // Was 5 → now ~3px only

        // lineSpace = 6.6;
        // text1 = " ";
        // text2 = " ";
        // text3 = " ";
        // text4 = " ";
        // text5 = " ";
        // text6 = " ";
        // leftSpace = 10;
        // doc.setFontSize(6);
        // doc.text(text1, padding, line2Height);

        // // Line 37 - MASSIVELY REDUCED GAP (from 4 lines → just 1 small gap)
        // line2Height += Math.round(lineHeightIncreament * 0.8);  // Tiny gap (~4px)

        // spaceLeft = 20;
        // doc.text(" ", 10, line2Height);                 // Only 1 blank line instead of 3
        // // Removed the other two blank lines completely

        // line2Height += lineHeightIncreament;  // Final normal spacing before dash
        // doc.text("--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------", padding + spaceLeft, line2Height);

        // Line 35 — "Signature Bank Officer" moved to FAR RIGHT
        line2Height += lineHeightIncreament + lineHeightIncreament;
        lineSpace = 6.6;

        // Keep your original dummy text1–text5 (required for spacing logic)
        text1 = " ";
        text2 = " ";
        text3 = " ";
        text4 = " ";
        text5 = " ";
        text6 = "Signature Bank Officer ";

        // Don't use getTextWidth chain anymore — it limits movement
        // Instead, place it directly at the right side
        const rightMargin = 20; // distance from right edge
        const signatureX =
          doc.internal.pageSize.getWidth() -
          rightMargin -
          doc.getTextWidth(text6);

        doc.text(text1, padding, line2Height); // keeps left spacing intact
        doc.text(text6, signatureX, line2Height); // ← NOW PERFECTLY AT RIGHT

        // Line 36 — tiny spacing
        line2Height += Math.round(lineHeightIncreament * 0.8);

        // Keep dummy text (no change)
        text1 = " ";
        text2 = " ";
        text3 = " ";
        text4 = " ";
        text5 = " ";
        text6 = " ";
        leftSpace = 10;
        doc.setFontSize(6);
        doc.text(text1, padding, line2Height);

        // Line 37 — reduced gap + dash line
        line2Height += Math.round(lineHeightIncreament * 0.8);
        doc.text(" ", 10, line2Height); // only one tiny blank line

        line2Height += lineHeightIncreament;
        doc.text(
          "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------",
          padding + 10,
          line2Height
        );

        // Line 38
        lineHeightIncreament = 4;
        line2Height += lineHeightIncreament;
        doc.text(
          (!dnDets.demandNoteExpiryCount
            ? "Due Date: "
            : "Extended Due Date: ") + convertDate(dnDets.dueDate),
          padding,
          line2Height
        );
        doc.text(
          `Applicant's Response`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );

        // Line 39
        lineHeightIncreament = 4;
        line2Height += lineHeightIncreament;
        doc.setFontSize(fontSize);
        let text = `1. I/We have submitted the security amount of [securityCost] and service connection of [capitalCost] only in the department's approved bank [bankName] by receipt no. _______________________________________ on date _______________________________.`;
        let lines = doc.splitTextToSize(text, maxWidth);
        for (let i = 0; i < lines.length; i++) {
          let lineText = lines[i]
            .replace(
              "[capitalCost]",
              numberFormatting(dnDets.capitalCostAmount)
            )
            .replace(
              "[securityCost]",
              numberFormatting(dnDets.securityDepositeAmount)
            )
            .replace("[bankName]", dnDets.bankName ? dnDets.bankName : "-");
          doc.text(lineText, padding, line2Height);
          line2Height += lineHeightIncreament;
        }

        // Line 40
        text = `2. Since I/We did not provide funds to buy meter to the department, I am/We are responsible to pay monthly rent of ______ PKR as meter rent.`;
        lines = doc.splitTextToSize(text, maxWidth);
        for (let i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height += lineHeightIncreament;
        }

        // Line 41
        text = `3. I am/We are sending herewith demand notice, a certified list report from a government approved wiring contractor to prove that the internal wiring of my/our building is sound and of standard and that the installation of my/our utility equipment has been completed. I will send within the specified period.`;
        lines = doc.splitTextToSize(text, maxWidth);
        for (let i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height += lineHeightIncreament;
        }

        // Line 42
        lineHeightIncreament = 5;
        line2Height += lineHeightIncreament;
        doc.text(
          `For Computer Center Use`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );

        // Line 43
        line2Height += lineHeightIncreament;
        doc.text(
          `(Demand Notice Data)`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );

        // Line 44
        line2Height += lineHeightIncreament;
        lineHeightIncreament = 5;
        padding = 10;
        lineSpace = 7.5;
        text1 = "Demand Notice Serial No.: ";
        text2 = dnDets.demandNoteNo ? dnDets.demandNoteNo : "-";
        text3 = "Application Id: ";
        text4 = applicationId ? applicationId : "-";
        text5 = "Application Form No.: ";
        text6 = dnDets.demandNoteNo ? dnDets.demandNoteNo : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          lineSpace +
          doc.getTextWidth(text2),
          line2Height + 1
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace * 2,
          line2Height
        );
        doc.text(
          text4,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 3,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          padding +
          lineSpace * 4 +
          doc.getTextWidth(text4),
          line2Height + 1
        );

        // Added extra spacing (lineSpace * 5) to move "Application Form No.:" to the right
        doc.text(
          text5,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          padding +
          lineSpace * 4,
          line2Height
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5,
          line2Height + 1,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 8 +
          doc.getTextWidth(text6),
          line2Height + 1
        );

        // Line 45
        lineHeightIncreament = 5;
        line2Height += lineHeightIncreament;
        padding = 10;
        lineSpace = 7.5;
        text1 = "Demand Notice Issuance Date: ";
        text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        text3 = "Amount to be paid: ";
        text4 = dnDets.securityDepositeAmount
          ? numberFormatting(
            parseInt(dnDets.securityDepositeAmount) +
            parseInt(dnDets.capitalCostAmount || 0)
          )
          : "-";
        text5 = " ";
        text6 = " ";

        doc.setFont("helvetica", "normal");
        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height
        );
        doc.line(
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height + 1,
          doc.getTextWidth(text1) +
          padding +
          lineSpace +
          doc.getTextWidth(text2),
          line2Height + 1
        );

        doc.setFont("helvetica", "normal");
        const text3X =
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          padding +
          lineSpace * 3;
        doc.text(text3, text3X, line2Height);

        doc.setFont("helvetica", "bold");
        const text4X = text3X + doc.getTextWidth(text3) + lineSpace;
        doc.text(text4, text4X, line2Height);
        const text4Width = doc.getTextWidth(text4);
        doc.line(text4X, line2Height + 1, text4X + text4Width, line2Height + 1);
        doc.setFont("helvetica", "normal");

        if (
          dnDets.isDNPayable === false ||
          dnDets.isDNPayable === "false" ||
          dnDets.isDNPayable === null ||
          dnDets.isDNPayable === "null" ||
          dnDets.isDNPayable === 0 ||
          dnDets.isDNPayable === "0" ||
          dnDets.isDNPayable === "" ||
          dnDets.isDNPayable === undefined
        ) {
          doc.setTextColor(255, 0, 0);
          const notPayableText = "(Not Payable)";
          const notPayableX = text4X + text4Width + lineSpace;
          doc.text(notPayableText, notPayableX, line2Height);
          doc.setTextColor(0, 0, 0);
        }

        // Line 46
        line2Height += lineHeightIncreament + lineHeightIncreament / 2;
        lineSpace = 6.6;
        text1 = " ";
        text2 = " ";
        text3 = " ";
        text4 = " ";
        text5 = " ";
        text6 = application.appliedLoad < 15 ? " " : " ";
        leftSpace = 110;
        doc.text(
          text6,
          doc.getTextWidth(text1) +
          doc.getTextWidth(text2) +
          doc.getTextWidth(text3) +
          doc.getTextWidth(text4) +
          doc.getTextWidth(text5) +
          padding +
          lineSpace * 5 +
          leftSpace,
          line2Height
        );

        // Line 47
        doc.setFontSize(6);
        lineHeightIncreament = 2;
        let noteText =
          "NOTE - Computer generated demand notice, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/applicant. In case any document is found false at later stages,the said connection is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and company reserved its rights to take legal action against owner/applicant. ";
        lines = doc.splitTextToSize(
          noteText,
          doc.internal.pageSize.getWidth() - padding * 8
        );
        for (let i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height += lineHeightIncreament;
        }
      }

      if (application.applicationProgressId >= 4) {

        if (boqItems.length >= 1) {
          doc.addPage();
          let height = 10;
          const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
          const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
          const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;

          const logoX = (pageWidth - logoWidth) / 2;
          doc.addImage(
            getLogo(DiscoCode),
            "PNG",
            logoX,
            5,
            logoWidth,
            logoHeight
          );

          var increment = 15;
          height += increment;
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
            align: "center",
          });

          increment = 10;
          height += increment;
          doc.text("Application Id: ", padding, height);
          doc.text(
            applicationId,
            padding + doc.getTextWidth("Application Id: "),
            height
          );
          doc.text("Name: ", pageWidth / 2 - 5, height);
          doc.text(
            String(
              application?.consumerName ||
              application?.applicantName ||
              application?.ownerName ||
              "-",
            ),
            pageWidth / 2 - 5 + doc.getTextWidth("Name: "),
            height,
          );
          height += increment;

          // Draw header rectangle
          doc.setFillColor(199, 199, 199);
          doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
          doc.setFont("helvetica", "bold");
          doc.text("Items List", pageWidth / 2, height, { align: "center" });

          height += 3.5;
          rectHeight = 230;
          doc.rect(rectX, height, rectWidth, rectHeight);

          // Table setup
          const boqTableProps = {
            margin: { top: 0, right: 20, bottom: 20, left: 20 },
            cellHeight: 10,
            headerColor: "#000",
            rowColors: ["#EEE", "#FFF"],
            lineWidth: 1,
            lineColor: "#000",
            headStyles: {
              fillColor: "#FFF",
              textColor: "#000",
              fontSize: 11,
              fontStyle: "bold",
              halign: "left",
              valign: "middle",
            },
            styles: {
              fontSize: 11,
              fontStyle: "normal",
              lineWidth: 0,
              lineColor: [0, 0, 0],
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
            },
            alternateRowStyles: { fillColor: [235, 235, 235] },
          };

          const boqHeaders = [
            ["Sr.", "Item Name", "Unit", "Qty", "Amount"],
          ];
          const boqData = [];
          let itemsTotal = 0;
          const materialsList = await callMaterials(applicationId, token);
          const normalizeCode = (code) => String(code).replace(/^0+/, "");

          for (let i = 0; i < boqItems.length; i++) {
            const rowData = boqItems[i];

            // Match BOQ item with material list using item_Code
            const item = materialsList.find(
              (mat) =>
                normalizeCode(mat.item_Code) ===
                normalizeCode(rowData.itemCode),
            );

            if (!item) {
              console.warn(
                `No matching item found for itemCode: ${rowData.itemCode}`
              );
              continue; // skip this row
            }

            const serialNo = i + 1;
            const itemName = item.item_Name;
            const unit = item.item_Unit;
            const qty = numberFormatting(rowData.qty);
            const rate = numberFormatting(item.item_Amount);
            const amount = numberFormatting(rowData.qty * item.item_Amount);
            itemsTotal += rowData.qty * item.item_Amount;

            const row = [
              serialNo.toString(),
              itemName,
              unit,
              qty,
              amount,
            ];
            boqData.push(row);
          }

          // Generate PDF table
          doc.autoTable({
            startY: 50,
            head: boqHeaders,
            body: boqData,
            theme: "grid",
            ...boqTableProps,
          });

          // Add page for Service Cost Estimate
          doc.addPage();
          height = 10;
          doc.addImage(
            getLogo(DiscoCode),
            "PNG",
            logoX,
            5,
            logoWidth,
            logoHeight
          );

          increment = 15;
          height += increment;
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
            align: "center",
          });

          increment = 10;
          height += increment;
          doc.text("Application Id: ", padding, height);
          doc.text(
            applicationId,
            padding + doc.getTextWidth("Application Id: "),
            height
          );
          doc.text("Name: ", pageWidth / 2 - 5, height);
          doc.text(
            String(
              application?.applicantName ||
              "-",
            ),
            pageWidth / 2 - 5 + doc.getTextWidth("Name: "),
            height,
          );
          height += increment;

          // Header for Service Cost Estimate
          rectWidth = 195;
          rectHeight = 10;
          rectX = (pageWidth - rectWidth) / 2;
          doc.setFillColor(199, 199, 199);
          doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
          doc.setFont("helvetica", "bold");
          doc.text("Service Cost Estimate", pageWidth / 2, height, {
            align: "center",
          });
          increment = 10;
          height += increment;

          const amountText = (value) => `${formatAmount(value)}.00 /-`;
          const roundInt = (value) => Math.round(Number(value) || 0);

          const itemsTotalValue = roundInt(itemsTotal);
          const isNC13 = applicationId?.slice(3, 5) === "13";
          const storeCharges = isNC13 ? 0 : roundInt(itemsTotalValue * 0.12);
          const installationCharges = roundInt(
            (itemsTotalValue + storeCharges) * 0.08,
          );
          const gridSharing = roundInt(dnDets.amountOfGridSharing);
          const feederRehab = roundInt(dnDets.amountOfFeederRehab);
          const civilWork = roundInt(dnDets.civilWorkCharges);
          const metering = roundInt(dnDets.fixedChargesOfMetering);
          const miscCharges = roundInt(dnDets.miscellaneousCharges);
          const mntChargesValue = roundInt(dnDets.mntCharges ?? dnDets.mtCharges);
          const labourChargesValue = roundInt(dnDets.labourCharges);
          const designVettingFeeValue = roundInt(
            dnDets.designVettingFee ?? dnDets.designVetteingFee,
          );
          const consultancyChargesValue = roundInt(dnDets.consultancyCharges);
          const variationChargesValue = roundInt(
            dnDets.variationCharges ?? dnDets.variationsCharges,
          );
          const dismantlementChargesValue = roundInt(
            dnDets.dismantlementCharges ?? dnDets.dismentalmentCharges,
          );
          const earthingChargesValue = roundInt(dnDets.earthingCharges);
          const lessCost = roundInt(dnDets.lessTheCost);
          const securityDeposit = roundInt(dnDets.securityDepositeAmount);

          const subtotalA = itemsTotalValue + storeCharges;
          const subtotalB = installationCharges + gridSharing + feederRehab;
          const subtotalC =
            civilWork + miscCharges + mntChargesValue + labourChargesValue;
          const subtotalD =
            metering +
            designVettingFeeValue +
            consultancyChargesValue +
            variationChargesValue +
            dismantlementChargesValue +
            earthingChargesValue;

          const calculatedNetTotal =
            subtotalA + subtotalB + subtotalC + subtotalD - lessCost;
          const hasApiCapitalCost =
            dnDets.capitalCostAmount !== null &&
            dnDets.capitalCostAmount !== undefined &&
            dnDets.capitalCostAmount !== "";
          const netTotal = hasApiCapitalCost
            ? roundInt(dnDets.capitalCostAmount)
            : calculatedNetTotal;
          const grossTotal = netTotal + lessCost;
          const grandTotal = netTotal + securityDeposit;

          const sectionHeader = (title) => {
            doc.setFillColor(233, 233, 233);
            doc.rect(padding, height - 5, pageWidth - padding * 2, 7, "F");
            doc.setFont("helvetica", "bold");
            doc.setTextColor(44, 62, 80);
            doc.text(title, padding + 3, height);
            doc.setTextColor(0, 0, 0);
            height += 8;
          };

          const drawLine = (label, amount, isBold = false) => {
            const labelX = padding + 12;
            const amountX = pageWidth - padding - 4;
            doc.setFont("helvetica", isBold ? "bold" : "normal");
            doc.text(label, labelX, height);
            doc.setDrawColor(190, 190, 190);
            doc.setLineDash([1, 1], 0);
            doc.line(labelX + 46, height - 1, amountX - 35, height - 1);
            doc.setLineDash([], 0);
            doc.text(amountText(amount), amountX, height, { align: "right" });
            height += 6;
          };

          sectionHeader("A. Material & Store Cost");
          drawLine("Items Total Amount", itemsTotalValue);
          drawLine(isNC13 ? "Store Charges (0%)" : "Store Charges (12%)", storeCharges);
          drawLine("Subtotal (A)", subtotalA, true);

          sectionHeader("B. Installation & Technical Cost");
          drawLine("Installation Charges (8%)", installationCharges);
          drawLine("Grid Sharing Cost", gridSharing);
          drawLine("Feeder Rehab Charges", feederRehab);
          drawLine("Subtotal (B)", subtotalB, true);

          sectionHeader("C. Civil & Miscellaneous");
          drawLine("Civil Work Charges", civilWork);
          drawLine("Misc. Charges", miscCharges);
          drawLine("MNT Charges", mntChargesValue);
          drawLine("Labour Charges", labourChargesValue);
          drawLine("Subtotal (C)", subtotalC, true);

          sectionHeader("D. Other Charges");
          drawLine("Fixed Charges Of Metering", metering);
          drawLine("Design Vetting Fee", designVettingFeeValue);
          drawLine("Consultancy Charges", consultancyChargesValue);
          drawLine("Variation Charges", variationChargesValue);
          drawLine("Dismantlement Charges", dismantlementChargesValue);
          drawLine("Earthing Charges", earthingChargesValue);
          drawLine("Subtotal (D)", subtotalD, true);

          height += 1;
          doc.setDrawColor(150, 150, 150);
          doc.line(padding, height, pageWidth - padding, height);
          height += 6;

          doc.setFont("helvetica", "bold");
          doc.text("Gross Total (A+B+C+D)", padding + 3, height);
          doc.text(amountText(grossTotal), pageWidth - padding - 4, height, {
            align: "right",
          });
          height += 6;

          doc.setTextColor(160, 30, 30);
          doc.text("Less:", padding + 3, height);
          doc.setTextColor(0, 0, 0);
          doc.text("Cost Adjustment", padding + 18, height);
          doc.text(`-${amountText(lessCost)}`, pageWidth - padding - 4, height, {
            align: "right",
          });
          height += 6;

          doc.setFillColor(236, 248, 236);
          doc.rect(padding, height - 5, pageWidth - padding * 2, 8, "F");
          doc.setTextColor(22, 120, 55);
          doc.setFont("helvetica", "bold");
          doc.text("Capital Cost (Net Total)", padding + 3, height);
          doc.text(amountText(netTotal), pageWidth - padding - 4, height, {
            align: "right",
          });
          doc.setTextColor(0, 0, 0);
          height += 6;

          doc.setFont("helvetica", "bold");
          doc.text("Security Deposit", padding + 3, height);
          doc.text(amountText(securityDeposit), pageWidth - padding - 4, height, {
            align: "right",
          });
          height += 7;

          doc.setFillColor(236, 248, 236);
          doc.rect(padding, height - 5, pageWidth - padding * 2, 8, "F");
          doc.setTextColor(22, 120, 55);
          doc.setFont("helvetica", "bold");
          doc.text("GRAND TOTAL PAYABLE", padding + 3, height);
          doc.text(amountText(grandTotal), pageWidth - padding - 4, height, {
            align: "right",
          });
          doc.setTextColor(0, 0, 0);
        }
      }

      // ⬇⬇ ADD SJO PAGE IF CONDITIONS ARE MET
      if (dnDets && dnDets.sjoData && application.applicationProgressId >= 5) {
        // Get SCO Details for stamp
        let scoDetails = null;
        try {
          const scoHeaders = new Headers();
          scoHeaders.append("Authorization", token);
          scoHeaders.append("Content-Type", "application/json");

          const scoRaw = JSON.stringify({
            applicationId: applicationId,
          });

          const scoRequestOptions = {
            method: "POST",
            headers: scoHeaders,
            body: scoRaw,
            redirect: "follow",
          };

          const scoResponse = await fetch(
            cfpBaseUrl + "changeOfAttributes/getSCODetail",
            scoRequestOptions
          );
          const scoResult = await scoResponse.json();
          if (scoResult.status === "200" && scoResult.data && scoResult.data.length > 0) {
            scoDetails = scoResult.data[0];
          }
        } catch (error) {
          console.error("Error fetching SCO details:", error);
        }

        doc.addPage();

        const sjoPageWidth = doc.internal.pageSize.getWidth();
        const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
        const sjoLogoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
        const sjoLogoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
        const sjoLogoX = (sjoPageWidth - sjoLogoWidth) / 2;

        let sjoHeight = 10;

        doc.addImage(getLogo(DiscoCode), "PNG", sjoLogoX, 5, sjoLogoWidth, sjoLogoHeight);

        sjoHeight += 15;
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(getCompanies(DiscoCode), sjoPageWidth / 2, sjoHeight, {
          align: "center",
        });

        doc.setFontSize(12);
        doc.text("Sundary Job Orders", 105, 34, { align: "center" });

        let sjoY = 50;
        doc.setFontSize(10);

        doc.setFont(undefined, "bold");
        doc.text("Application No.: ", 20, sjoY);
        doc.setFont(undefined, "normal");
        doc.text(applicationId || "-", 60, sjoY);
        doc.setFont(undefined, "bold");
        doc.text("Sub-Division: ", 110, sjoY);
        doc.setFont(undefined, "normal");
        doc.text(
          application.subDivisionCode +
          " (" +
          subdivisionName(
            parseInt(application.subDivisionCode),
            subDivisions
          ) +
          ")" || "-",
          150,
          sjoY
        );
        sjoY += 6;

        doc.setFont(undefined, "bold");
        doc.text("Reference No.: ", 20, sjoY);
        doc.setFont(undefined, "normal");
        doc.text(application.referenceNumber || "-", 60, sjoY);
        doc.setFont(undefined, "bold");
        doc.text("Customer Id: ", 110, sjoY);
        doc.setFont(undefined, "normal");
        doc.text(application.customerId || "-", 150, sjoY);
        sjoY += 10;

        doc.setFontSize(10);
        doc.setFont(undefined, "normal");

        const sjoText = dnDets.sjoData || "-";
        const sjoMaxWidth = sjoPageWidth - 40;
        const sjoLines = doc.splitTextToSize(sjoText, sjoMaxWidth);

        sjoLines.forEach((line, index) => {
          if (index < sjoLines.length - 1) {
            doc.text(line, 20, sjoY, { align: "justify", maxWidth: sjoMaxWidth });
          } else {
            doc.text(line, 20, sjoY);
          }
          sjoY += 6;
        });

        sjoY += 4;

        const isCurrentNewFormat = [1, 4, 5, 6].includes(
          application.changeOfAttributesType
        );
        const col2Header = isCurrentNewFormat ? "Current" : "Old";
        const col3Header = "New";

        const tableRows = getTableRows(application);

        doc.autoTable({
          startY: sjoY,
          head: [["", col2Header, col3Header]],
          body: tableRows.map((row) => [
            row.label || "-",
            row.current || "-",
            row.newVal || "-",
          ]),
          theme: "grid",
          headStyles: {
            fillColor: [30, 82, 167],
            textColor: [255, 255, 255],
            fontStyle: "bold",
            lineWidth: 0.5,
            lineColor: [21, 101, 192],
            halign: "left",
            cellPadding: { top: 3, right: 5, bottom: 3, left: 5 },
          },
          bodyStyles: {
            lineWidth: 0.5,
            lineColor: [224, 224, 224],
            cellPadding: { top: 4, right: 8, bottom: 4, left: 8 },
          },
          alternateRowStyles: { fillColor: [213, 229, 255] },
          columnStyles: { 0: { fontStyle: "bold" } },
          margin: { left: 20, right: 20 },
          tableWidth: "auto",
        });

        // Add stamp if SCO details available
        if (scoDetails && scoDetails.scoApprovedBy) {
          const sjoOfficeCode = application.subDivisionCode || "---";
          const sjoOfficeName = subdivisionName(parseInt(application.subDivisionCode), subDivisions) || "---";
          const sjoAuthorizedByName = scoDetails.scoApprovedBy || "---";
          const sjoAuthorizedByDesignation = scoDetails.scoApprovedByDesignation || "Role";
          const sjoDateToPrint = scoDetails.scoApprovalDate
            ? new Date(scoDetails.scoApprovalDate).toLocaleDateString()
            : "---";

          const sjoStampData = printStamp(
            sjoOfficeCode,
            sjoOfficeName,
            sjoAuthorizedByName,
            sjoAuthorizedByDesignation,
            sjoDateToPrint
          );

          doc.addImage(sjoStampData, "PNG", 170, 150, 55, 40);
        }
      }

      // Add watermark and page numbers
      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(DiscoCode),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight()
        );
      }

      doc.setFontSize(8);
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        const pageNumberY = doc.internal.pageSize.getHeight() - 10;
        doc.text(
          "Page " + i + " of " + totalPages,
          doc.internal.pageSize.getWidth() / 2,
          pageNumberY,
          { align: "center" }
        );
      }

      const pdfBlob = doc.output("blob");
      const pdfURL = URL.createObjectURL(pdfBlob);
      window.open(pdfURL, "_blank");

      setEFileData([]);
    } catch (e) {
      console.log(e);
    } finally {
      setViewBackdrop(false);
    }
  };

  const downloadApplicationPDF = async (application) => {
    setViewBackdrop(true);
    try {
      let applicationId = application.applicationId;
      let DiscoCode = application.companyCode.toString();

      // ⬇⬇ GET DOCUMENTS FROM YOUR NEW API
      const applicationDocs = await getDocumentApi(applicationId);

      if (!applicationDocs) {
        return;
      }

      await callEfileAPI(applicationId, application);

      // ⬇⬇ FETCH DEMAND NOTE DATA FOR CHARGES
      let demandNoteData = null;
      if (application.applicationProgressId >= 4) {
        try {
          const dnHeaders = new Headers();
          dnHeaders.append("Authorization", token);
          dnHeaders.append("Content-Type", "application/json");

          const dnResponse = await fetch(
            cfpBaseUrl + "changeOfAttributes/getDemandNoteData",
            {
              method: "POST",
              headers: dnHeaders,
              body: JSON.stringify({ applicationId }),
              redirect: "follow",
            }
          );
          const dnResult = await dnResponse.json();
          if (dnResult.status === "200" && dnResult.data && dnResult.data[0]) {
            demandNoteData = dnResult.data[0];
          }
        } catch (error) {
          console.error("Error fetching demand note data:", error);
        }
      }

      // Read all document URLs safely
      const copyOfApplicantCNICFront = applicationDocs.applicantCNICFront || "";
      const copyOfApplicantCNICBack = applicationDocs.applicantCNICBack || "";
      const premisesDocument = applicationDocs.ownershipImage || "";
      const scannedCopyOfNearByElectricityBill =
        applicationDocs.electricityBill || "";
      const fbrDocument = applicationDocs.fbrDocument || "";
      const anyOtherDocument = applicationDocs.anyOtherDocument || "";
      const doc = new jsPDF({ compressPdf: true });

      // Helper function to add page header
      const addPageHeader = (doc, DiscoCode, applicationId, documentTitle) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const padding = 10;
        const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
        const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
        const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
        const logoX = (pageWidth - logoWidth) / 2;

        let height = 10;

        // Add logo
        doc.addImage(
          getLogo(DiscoCode),
          "PNG",
          logoX,
          5,
          logoWidth,
          logoHeight
        );

        // Add company name
        height += 15;
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
          align: "center",
        });

        // Add application ID
        height += 10;
        doc.setFont("helvetica", "normal");
        doc.text("Application Id: ", padding, height);
        doc.text(
          applicationId,
          padding + doc.getTextWidth("Application Id: "),
          height
        );

        // Add document title with border
        height += 10;
        const rectWidth = 195;
        const rectHeight = 10;
        const rectX = (pageWidth - rectWidth) / 2;

        doc.setFillColor(199, 199, 199);
        doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
        doc.setFont("helvetica", "bold");
        doc.text(documentTitle, pageWidth / 2, height, { align: "center" });

        return height + 3.5; // Return the Y position where content should start
      };

      // Helper function to add document image/PDF with fixed dimensions
      const addDocumentContent = async (doc, documentData, startHeight) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;

        // Draw rectangle for document
        doc.rect(rectX, startHeight, rectWidth, rectHeight);

        if (!documentData) {
          doc.setFontSize(12);
          doc.text("No document available", pageWidth / 2, startHeight + rectHeight / 2, { align: "center" });
          return;
        }

        // Fixed dimensions to fit within the border (with small padding)
        const cardWidth = 190;
        const cardHeight = 228;
        const xPos = (pageWidth - cardWidth) / 2;
        const yPos = startHeight + 3;

        const isString = typeof documentData === "string";
        const lower = isString ? documentData.toLowerCase() : "";

        const blobToDataUrl = (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });

        try {
          if (isString && lower.startsWith("data:image/")) {
            if (lower.includes("jpeg") || lower.includes("jpg")) {
              doc.addImage(documentData, "JPEG", xPos, yPos, cardWidth, cardHeight);
            } else if (lower.includes("png")) {
              doc.addImage(documentData, "PNG", xPos, yPos, cardWidth, cardHeight);
            } else {
              doc.addImage(documentData, "JPEG", xPos, yPos, cardWidth, cardHeight);
            }
          } else if (isString && lower.startsWith("data:application/pdf")) {
            await addPdfasImage(documentData, rectX, startHeight, rectWidth, rectHeight);
          } else if (isString && (lower.startsWith("http://") || lower.startsWith("https://") || lower.startsWith("blob:"))) {
            // fetch remote resource and render based on content-type
            try {
              const response = await fetch(documentData);
              const contentType = (response.headers.get("content-type") || "").toLowerCase();
              const blob = await response.blob();

              if (contentType.includes("pdf")) {
                const dataUrl = await blobToDataUrl(blob);
                await addPdfasImage(dataUrl, rectX, startHeight, rectWidth, rectHeight);
              } else if (contentType.startsWith("image/")) {
                const dataUrl = await blobToDataUrl(blob);
                if (contentType.includes("png")) {
                  doc.addImage(dataUrl, "PNG", xPos, yPos, cardWidth, cardHeight);
                } else {
                  doc.addImage(dataUrl, "JPEG", xPos, yPos, cardWidth, cardHeight);
                }
              } else {
                doc.setFontSize(12);
                doc.text("Unsupported document type", pageWidth / 2, yPos + cardHeight / 2, { align: "center" });
              }
            } catch (err) {
              console.error("Error fetching remote document:", err);
              doc.setFontSize(12);
              doc.text("Failed to load remote document", pageWidth / 2, yPos + cardHeight / 2, { align: "center" });
            }
          } else if (isString) {
            // Fallback for non-data URL strings (try image)
            try {
              doc.addImage(documentData, "JPEG", xPos, yPos, cardWidth, cardHeight);
            } catch (err) {
              console.error("Fallback addImage failed:", err);
              doc.setFontSize(12);
              doc.text("Failed to render document", pageWidth / 2, yPos + cardHeight / 2, { align: "center" });
            }
          } else {
            doc.setFontSize(12);
            doc.text("Unsupported document format", pageWidth / 2, yPos + cardHeight / 2, { align: "center" });
          }
        } catch (err) {
          console.error("Error adding document content:", err);
          doc.setFontSize(12);
          doc.text("Failed to load document", pageWidth / 2, yPos + cardHeight / 2, { align: "center" });
        }
      };

      // Helper function to add CNIC images with fixed size to fit in border
      const addCNICImage = (
        doc,
        cnicData,
        startHeight,
        containerHeight = 234
      ) => {
        const pageWidth = doc.internal.pageSize.getWidth();

        // Fixed CNIC dimensions to fit nicely in the container
        const cardWidth = 150;
        const cardHeight = 95;
        const xPos = (pageWidth - cardWidth) / 2;

        // Center vertically within the container
        const yPos = startHeight + (containerHeight - cardHeight) / 2;

        const fileType = cnicData.slice(0, 6);
        let extension = "";

        if (fileType === "data:i") {
          extension = cnicData.slice(11, 15);
        } else if (fileType === "data:a") {
          extension = cnicData.slice(17, 19);
        }

        if (extension.startsWith("jp")) {
          doc.addImage(cnicData, "jpeg", xPos, yPos, cardWidth, cardHeight);
        } else if (extension.startsWith("pn")) {
          doc.addImage(cnicData, "png", xPos, yPos, cardWidth, cardHeight);
        }

        return yPos + cardHeight;
      };

      const addPdfasImage = async (
        pdfInBase64,
        rectX,
        rectY,
        rectWidth,
        rectHeight
      ) => {
        let base64ImagesArray = [];

        try {
          if (!window.pdfjsLib) {
            await new Promise((resolve, reject) => {
              const script = document.createElement("script");
              script.src =
                "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.379/pdf.min.mjs";
              script.type = "module";
              script.onload = () => {
                setTimeout(resolve, 100);
              };
              script.onerror = reject;
              document.head.appendChild(script);
            });
          }

          const pdfjsLib = window.pdfjsLib;
          pdfjsLib.GlobalWorkerOptions.workerSrc =
            "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.379/pdf.worker.min.mjs";

          const pdfData = atob(pdfInBase64.split(",")[1]);
          const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
          const docPageNumbers = pdf.numPages;

          const renderPageToBase64 = async (pageNumber) => {
            try {
              const pdfPage = await pdf.getPage(pageNumber);
              const scale = 1.5;
              const viewport = pdfPage.getViewport({ scale });
              const canvas = document.createElement("canvas");
              const canvasContext = canvas.getContext("2d");
              canvas.width = viewport.width;
              canvas.height = viewport.height;
              await pdfPage.render({ canvasContext, viewport }).promise;
              const imageDataUrl = canvas.toDataURL("image/png");
              return imageDataUrl;
            } catch (error) {
              console.error("Error rendering PDF page:", error);
              return null;
            }
          };

          for (let i = 1; i <= docPageNumbers; i++) {
            const imageDataUrl = await renderPageToBase64(i);
            if (imageDataUrl) {
              base64ImagesArray.push(imageDataUrl);
            }
          }

          // Fixed dimensions to fit within border
          const cardWidth = 190;
          const cardHeight = 228;
          const xPos = (doc.internal.pageSize.getWidth() - cardWidth) / 2;
          const yPos = rectY + 3;

          base64ImagesArray.forEach((imageDataUrl, index) => {
            if (index > 0) {
              doc.addPage();
              // Add header for additional PDF pages
              const contentHeight = addPageHeader(
                doc,
                DiscoCode,
                applicationId,
                "Property Document (Continued)"
              );
              doc.rect(rectX, contentHeight, rectWidth, rectHeight);
              doc.addImage(
                imageDataUrl,
                "PNG",
                xPos,
                contentHeight + 3,
                cardWidth,
                cardHeight
              );
            } else {
              doc.addImage(
                imageDataUrl,
                "PNG",
                xPos,
                yPos,
                cardWidth,
                cardHeight
              );
            }
          });
        } catch (error) {
          console.error("Error loading PDF:", error);
          alert("Failed to process PDF document. Please try again.");
        }
      };

      // FIRST PAGE - Application Summary
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Generate the barcode
      const barcodeCanvas = document.createElement("canvas");
      JsBarcode(barcodeCanvas, applicationId);
      const barcodeDataURL = barcodeCanvas.toDataURL("image/png");

      const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
      const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
      const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
      const logoX = (pageWidth - logoWidth) / 2;

      doc.addImage(barcodeDataURL, "PNG", pageWidth - 50, 5, 40, 20);
      doc.addImage(getLogo(DiscoCode), "PNG", logoX, 5, logoWidth, logoHeight);

      let height = 25;
      const padding = 10;
      const leftMargin = 50;

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
        align: "center",
      });

      height += 8;
      doc.setFontSize(18);
      doc.text("E-Document", pageWidth / 2, height, { align: "center" });

      height += 8;
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      height += 8;

      doc.text("Document Type: ", padding, height);
      doc.text(
        `Change of ${application.changeOfAttributesType == 1
          ? "Name"
          : application.changeOfAttributesType == 2
            ? "Load"
            : application.changeOfAttributesType == 3
              ? "Tariff"
              : application.changeOfAttributesType == 4
                ? "Name, Load and Tariff"
                : application.changeOfAttributesType == 5
                  ? "Name and Load"
                  : application.changeOfAttributesType == 6
                    ? "Name and Tariff"
                    : application.changeOfAttributesType == 7
                      ? "Load and Tariff"
                      : ""
        }`,
        padding + leftMargin,
        height
      );
      doc.text("Tracking Id:", padding + leftMargin + leftMargin, height);
      doc.text(
        applicationId,
        padding + leftMargin + leftMargin + leftMargin,
        height
      );

      height += 6;
      doc.text("Application Status: ", padding, height);
      doc.text(
        statusFunc(
          application.applicationProgressId,
          application.objectionStatus
        ),
        padding + leftMargin,
        height
      );
      doc.text("Application Date:", padding + leftMargin + leftMargin, height);
      doc.text(
        convertDate(application.creationDate),
        padding + leftMargin + leftMargin + leftMargin,
        height
      );

      height += 6;
      doc.text("Sub-Division: ", padding, height);
      doc.text(
        subdivisionName(parseInt(application.subDivisionCode), subDivisions),
        padding + leftMargin,
        height
      );
      doc.text("Connection Type:", padding + leftMargin + leftMargin, height);
      doc.text(
        application.connectionType,
        padding + leftMargin + leftMargin + leftMargin,
        height
      );

      height += 6;
      doc.text("Phase / Load: ", padding, height);
      doc.text(
        "34",
        //  application.appliedLoad.toString(),
        padding + leftMargin,
        height
      );
      doc.text("Connection Date:", padding + leftMargin + leftMargin, height);
      doc.text("-", padding + leftMargin + leftMargin + leftMargin, height);

      height += 20;
      let rectWidth = 195;
      let rectHeight = 10;
      let rectX = (pageWidth - rectWidth) / 2;

      doc.setFillColor(200, 200, 200);
      doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
      doc.setFont("helvetica", "bold");
      doc.text("Applicant Particulars", pageWidth / 2, height, {
        align: "center",
      });

      height += 6;
      rectHeight = 30;
      doc.rect(rectX, height - 2.5, rectWidth, rectHeight);

      doc.setFont("helvetica", "normal");
      height += 8;
      const extraPadding = 5;

      doc.text("Applicant Name:", padding + extraPadding, height);
      doc.text(application.applicantName, padding + 70, height);

      height += 6;
      doc.text("CNIC:", padding + extraPadding, height);
      doc.text(application.applicantCNIC, padding + 70, height);

      height += 6;
      doc.text("Present Address:", padding + extraPadding, height);
      doc.text(application.consumerAddress, padding + 70, height);

      height += 6;
      doc.text("Phone No.:", padding + extraPadding, height);
      doc.text(application.applicantPhoneNo, padding + 70, height);

      // Add spacing before Application Summary section
      height += 15;
      rectHeight = 10;

      doc.setFillColor(199, 199, 199);
      doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
      doc.setFont("helvetica", "bold");
      doc.text(
        "Application Summary",
        doc.internal.pageSize.getWidth() / 2,
        height,
        {
          align: "center",
        }
      );

      doc.setFontSize(12);
      height += 3.5; // Add small spacing after header

      // doc.rect(rectX, height, rectWidth, rectHeight);

      const summaryTableProps = {
        margin: { left: rectX, right: rectX },
        startY: height,
        tableWidth: rectWidth,
        styles: {
          fontSize: 11,
          fontStyle: "normal",
          halign: "center",
          valign: "middle",
          lineWidth: 0,
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          minCellHeight: 10,
        },
        headStyles: {
          fillColor: "#FFF",
          textColor: "#000",
          fontSize: 11,
          fontStyle: "bold",
          halign: "center",
          valign: "middle",
          lineWidth: 0,
        },
        alternateRowStyles: {
          fillColor: [235, 235, 235],
        },
        columnStyles: {
          0: { halign: "center", cellWidth: 15 }, // Sr.
          1: { halign: "center", cellWidth: 40 }, // Step
          2: { halign: "center", cellWidth: 30 }, // Processed By
          3: { halign: "center", cellWidth: 25 }, // Date
          4: { halign: "center", cellWidth: 20 }, // Time
          5: { halign: "left", cellWidth: 65 }, // Remarks
        },
      };

      const summaryData = [];

      // Sort the array by applicationProgressId in descending order
      const sortedData = [...eFileData].sort(
        (a, b) => b.applicationProgressId - a.applicationProgressId
      );

      let srNumber = sortedData.length;

      for (let i = 0; i < sortedData.length; i++) {
        const row = sortedData[i];

        const stepProgressId = stepName(row.applicationProgressId, row.remarks);

        // If applicationProgressId is 1, use "Application Submitted." as remarks
        const remarksToShow =
          row.applicationProgressId === 1
            ? "Application Submitted."
            : row.remarks;

        summaryData.push([
          srNumber.toString(),
          stepProgressId || "",
          row.lastModifiedBy,
          convertDatewithTimeWithoutSecond(row.lastModificationDate).slice(
            0,
            11
          ),
          convertDatewithTimeWithoutSecond(row.lastModificationDate).slice(11),
          remarksToShow,
        ]);

        srNumber--;
      }

      // Draw the table - it will automatically fit within the specified width
      doc.autoTable({
        startY: height + 5,
        head: [["Sr.", "Step", "Processed By", "Date", "Time", "Remarks"]],
        body: summaryData,
        theme: "grid",
        ...summaryTableProps,
      });

      // ⬇⬇ ADD CHARGES DETAILS SECTION (NEW PAGE)
      if (demandNoteData) {
        doc.addPage();

        // Add header for charges page
        const chargesPageWidth = doc.internal.pageSize.getWidth();
        const chargesPadding = 10;
        const chargesSmallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
        const chargesLogoWidth = chargesSmallLogoCodes.includes(DiscoCode) ? 25 : 30;
        const chargesLogoHeight = chargesSmallLogoCodes.includes(DiscoCode) ? 15 : 8;
        const chargesLogoX = (chargesPageWidth - chargesLogoWidth) / 2;

        let chargesHeight = 10;

        // Add logo
        doc.addImage(
          getLogo(DiscoCode),
          "PNG",
          chargesLogoX,
          5,
          chargesLogoWidth,
          chargesLogoHeight
        );

        // Add company name
        chargesHeight += 15;
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(getCompanies(DiscoCode), chargesPageWidth / 2, chargesHeight, {
          align: "center",
        });

        // Add application ID
        chargesHeight += 10;
        doc.setFont("helvetica", "normal");
        doc.text("Application Id: ", chargesPadding, chargesHeight);
        doc.text(
          applicationId,
          chargesPadding + doc.getTextWidth("Application Id: "),
          chargesHeight
        );

        // Add Charges Details title
        chargesHeight += 10;
        const chargesRectWidth = 195;
        const chargesRectX = (chargesPageWidth - chargesRectWidth) / 2;

        doc.setFillColor(199, 199, 199);
        doc.rect(chargesRectX, chargesHeight - 6.5, chargesRectWidth, 10, "DF");
        doc.setFont("helvetica", "bold");
        doc.text("Charges Details", chargesPageWidth / 2, chargesHeight, { align: "center" });

        chargesHeight += 10;

        // Helper function to format amounts
        const formatChargeAmount = (value) => {
          const num = parseFloat(value) || 0;
          return num.toLocaleString();
        };

        // Check if it's NC13 case (store charges 0%)
        const isNC13Case = applicationId?.slice(3, 5) === "13";

        // Calculate charges
        const itemsTotalValue = parseFloat(demandNoteData.capitalCostAmount) || 0;
        const storeChargesValue = isNC13Case ? 0 : Math.trunc(itemsTotalValue * 0.12);
        const installationChargesValue = Math.trunc((itemsTotalValue + storeChargesValue) * 0.08);
        const feederRehabValue = parseFloat(demandNoteData.amountOfFeederRehab) || 0;
        const civilWorkValue = parseFloat(demandNoteData.civilWorkCharges) || 0;
        const mntChargesValue =
          parseFloat(demandNoteData.mntCharges ?? demandNoteData.mtCharges) || 0;
        const labourChargesValue = parseFloat(demandNoteData.labourCharges) || 0;
        const designVettingFeeValue =
          parseFloat(
            demandNoteData.designVettingFee ?? demandNoteData.designVetteingFee
          ) || 0;
        const consultancyChargesValue = parseFloat(demandNoteData.consultancyCharges) || 0;
        const variationChargesValue =
          parseFloat(
            demandNoteData.variationCharges ?? demandNoteData.variationsCharges
          ) || 0;
        const dismantlementChargesValue =
          parseFloat(
            demandNoteData.dismantlementCharges ?? demandNoteData.dismentalmentCharges
          ) || 0;
        const earthingChargesValue = parseFloat(demandNoteData.earthingCharges) || 0;
        const fixedChargesValue = parseFloat(demandNoteData.fixedChargesOfMetering) || 0;
        const miscChargesValue = parseFloat(demandNoteData.miscellaneousCharges) || 0;
        const gridSharingValue = parseFloat(demandNoteData.amountOfGridSharing) || 0;
        const lessTheCostValue = parseFloat(demandNoteData.lessTheCost) || 0;
        const securityDepositValue = parseFloat(demandNoteData.securityDepositeAmount) || 0;

        // Calculate grand total
        const grandTotalValue =
          itemsTotalValue +
          storeChargesValue +
          installationChargesValue +
          feederRehabValue +
          civilWorkValue +
          mntChargesValue +
          labourChargesValue +
          designVettingFeeValue +
          consultancyChargesValue +
          variationChargesValue +
          dismantlementChargesValue +
          earthingChargesValue +
          fixedChargesValue +
          miscChargesValue +
          gridSharingValue -
          lessTheCostValue +
          securityDepositValue;

        // Build charges data for table
        const chargesData = [];

        if (itemsTotalValue > 0) {
          chargesData.push(["Material Cost", `Rs. ${formatChargeAmount(itemsTotalValue)}`]);
        }
        chargesData.push([isNC13Case ? "Store Charges (0%)" : "Store Charges (12%)", `Rs. ${formatChargeAmount(storeChargesValue)}`]);
        chargesData.push(["Installation Charges (8%)", `Rs. ${formatChargeAmount(installationChargesValue)}`]);
        if (feederRehabValue > 0) {
          chargesData.push(["Feeder Rehab. Charges", `Rs. ${formatChargeAmount(feederRehabValue)}`]);
        }
        if (civilWorkValue > 0) {
          chargesData.push(["Civil Work Charges", `Rs. ${formatChargeAmount(civilWorkValue)}`]);
        }
        if (mntChargesValue > 0) {
          chargesData.push(["M&T Charges", `Rs. ${formatChargeAmount(mntChargesValue)}`]);
        }
        if (labourChargesValue > 0) {
          chargesData.push(["Labour Charges", `Rs. ${formatChargeAmount(labourChargesValue)}`]);
        }
        if (designVettingFeeValue > 0) {
          chargesData.push(["Design Vetting Fee", `Rs. ${formatChargeAmount(designVettingFeeValue)}`]);
        }
        if (consultancyChargesValue > 0) {
          chargesData.push(["Consultancy Charges", `Rs. ${formatChargeAmount(consultancyChargesValue)}`]);
        }
        if (variationChargesValue > 0) {
          chargesData.push(["Variation Charges", `Rs. ${formatChargeAmount(variationChargesValue)}`]);
        }
        if (dismantlementChargesValue > 0) {
          chargesData.push(["Dismantlement Charges", `Rs. ${formatChargeAmount(dismantlementChargesValue)}`]);
        }
        if (earthingChargesValue > 0) {
          chargesData.push(["Earthing Charges", `Rs. ${formatChargeAmount(earthingChargesValue)}`]);
        }
        if (fixedChargesValue > 0) {
          chargesData.push(["Fixed Charges of Metering", `Rs. ${formatChargeAmount(fixedChargesValue)}`]);
        }
        if (miscChargesValue > 0) {
          chargesData.push(["Miscellaneous Charges", `Rs. ${formatChargeAmount(miscChargesValue)}`]);
        }
        if (gridSharingValue > 0) {
          chargesData.push(["Grid Sharing Cost", `Rs. ${formatChargeAmount(gridSharingValue)}`]);
        }
        if (lessTheCostValue > 0) {
          chargesData.push(["Less the Cost", `Rs. -${formatChargeAmount(lessTheCostValue)}`]);
        }
        if (securityDepositValue > 0) {
          chargesData.push(["Security Deposit", `Rs. ${formatChargeAmount(securityDepositValue)}`]);
        }
        chargesData.push(["Grand Total", `Rs. ${formatChargeAmount(grandTotalValue)}`]);

        // Draw charges table
        doc.autoTable({
          startY: chargesHeight,
          head: [["Description", "Amount"]],
          body: chargesData,
          theme: "grid",
          margin: { left: chargesRectX, right: chargesRectX },
          tableWidth: chargesRectWidth,
          styles: {
            fontSize: 11,
            fontStyle: "normal",
            halign: "left",
            valign: "middle",
            lineWidth: 0.1,
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            minCellHeight: 8,
          },
          headStyles: {
            fillColor: [200, 200, 200],
            textColor: [0, 0, 0],
            fontSize: 11,
            fontStyle: "bold",
            halign: "center",
            valign: "middle",
          },
          columnStyles: {
            0: { halign: "left", cellWidth: 120 },
            1: { halign: "right", cellWidth: 75 },
          },
          didParseCell: function (data) {
            // Make Grand Total row bold
            if (data.row.index === chargesData.length - 1) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.fillColor = [230, 230, 230];
            }
          },
        });
      }

      // ADD OTHER DOCUMENTS ON NEW PAGES
      if (copyOfApplicantCNICFront !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Applicant CNIC - Front"
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(
          doc,
          copyOfApplicantCNICFront,
          contentHeight,
          rectHeight
        );
      }

      if (copyOfApplicantCNICBack !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Applicant CNIC - Back"
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(
          doc,
          copyOfApplicantCNICBack,
          contentHeight,
          rectHeight
        );
      }

      // PREMISES DOCUMENT
      if (premisesDocument !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Property Document"
        );
        await addDocumentContent(doc, premisesDocument, contentHeight);
      }

      // NEARBY ELECTRICITY BILL
      if (scannedCopyOfNearByElectricityBill !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Electricity Bill"
        );
        await addDocumentContent(
          doc,
          scannedCopyOfNearByElectricityBill,
          contentHeight
        );
      }

      // FBR DOCUMENT
      if (fbrDocument !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "FBR Document"
        );
        await addDocumentContent(doc, fbrDocument, contentHeight);
      }

      // ANY OTHER DOCUMENT
      if (anyOtherDocument !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Any Other Document"
        );
        await addDocumentContent(doc, anyOtherDocument, contentHeight);
      }

      // Add watermark and page numbers
      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(DiscoCode),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight()
        );
      }

      doc.setFontSize(8);
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        const pageNumberY = doc.internal.pageSize.getHeight() - 10;
        doc.text(
          "Page " + i + " of " + totalPages,
          doc.internal.pageSize.getWidth() / 2,
          pageNumberY,
          { align: "center" }
        );
      }

      const pdfBlob = doc.output("blob");
      const pdfURL = URL.createObjectURL(pdfBlob);
      window.open(pdfURL, "_blank");
    } catch (e) {
      console.log(e);
    } finally {
      // This will run after download is triggered (and small delay)
      setViewBackdrop(false); // Hide loader ONLY when everything is done
    }
  };

  const hideDocVerifyAlert = () => {
    setDocVerifyAlert(false);
  };

  const hideArrearsEntryAlert = () => {
    setArrearsEntryPopUpOpen(false);
  };

  const getClassName = (x) => {
    if (x === "Pending") {
      return "pending-button";
    } else if (x === "In Process") {
      return "inprocess-button";
    } else if (x === "Approved") {
      return "approved-button";
    } else if (x === "Objection") {
      return "objection-button";
    }
  };

  const handleClose = async () => {
    //applied load field
    fieldFormik.values.iv_remarks_others = "";
    setBoqItems([]);
    setItemsAmount("");
    setStoreCharges("");
    setInstallationCharges("");
    setEFileData([]);
    setTableDataProcessingSummary([]);
    setTotalCharges("");
    setItemsArray("");
    setFixedChargesOfMetering("");
    fieldRemoveObjectionFormik.values.iv_objection_remarks = "";
    fieldRemoveObjectionFormik.values.iv_additional_civic_document = "";
    setAdditionalCivicDocumentThumbnail("");
    setOpenObjectionPopup(false);
    setFeederRehabilitationCharges(0);
    setInstallationCharges();
    setItemsAmount();
    setStoreCharges();
    setFixedChargesOfMetering("");
    setItemsArray([]);
    setBoqItems([]);
    setGridSharingCost(0);
    fieldFormik.resetForm();
    fieldItemFormik.resetForm();
    fieldFormik.values.iv_coverage_area = "";
    fieldFormik.values.iv_sanctioned_load = "";
    fieldFormik.values.iv_batch = "";
    fieldFormik.values.iv_reference_to_allot = "";
    fieldFormik.values.iv_meter_rent = 0;
    fieldFormik.values.iv_service_rent = 0;
    setArearPaidBillUpload(false);
    setArearPaidBillDocument("");
    setArearPaidBillDocumentThumbnail("");
    arearBillDocumentFormik.values.iv_arear_paid_bill_document = "";
    arearBillDocumentFormik.values.iv_arear_paid_bill_date = "";
    fieldFormik.values.iv_grid_sharing_cost = 0;
    fieldFormik.values.iv_feeder_rehab_charges = 0;
    fieldFormik.values.iv_tariff_to_allot = "";
    fieldFormik.values.iv_survey_date = "";
    fieldFormik.values.iv_surveyed_by = "";
    sjoFormik.resetForm();
    sjoFormik.values.iv_feeder_no = "";
    sjoFormik.values.iv_cantonment_board = "";
    sjoFormik.values.iv_fgovt = "";
    sjoFormik.values.iv_pgovt = "";
    sjoFormik.values.iv_local_bodies = "";
    sjoFormik.values.iv_batch = "";
    sjoFormik.values.iv_sub_batch = "";
    sjoFormik.resetForm();
    sjoFormik.values.iv_store_requisition_no = "";
    sjoFormik.values.iv_store_requisition_date = "";
    sjoFormik.values.iv_sanctioned_load = "";
    sjoFormik.values.iv_no_of_meters = 0;
    sjoFormik.values.iv_no_of_acs = 0;
    sjoFormik.values.iv_no_of_meter_sets = 0;
    sjoFormik.values.iv_no_of_sub_sets = 0;
    sjoFormik.values.iv_no_ofsupply_points = 0;
    sjoFormik.values.iv_installed_transformer_capacity = "";
    sjoFormik.values.iv_seasonal_flag = 1;
    sjoFormik.values.iv_meter_id = "";
    sjoFormik.values.iv_meter_no = "";
    sjoFormik.values.iv_location_code = "";
    sjoFormik.values.iv_meter_code = "";
    sjoFormik.values.iv_manufacturer_code = "";
    sjoFormik.values.iv_multiplying_factor = "";
    sjoFormik.values.iv_meter_range = "";
    sjoFormik.values.iv_meter_reading = "";
    sjoFormik.values.iv_seal_on_meter = "";
    sjoFormik.values.iv_seal_on_box = "";
    sjoFormik.values.iv_connection_installer_name = "";
    sjoFormik.values.iv_date_of_connection = "";
    sjoFormik.values.iv_cp_78_item_no = "";
    sjoFormik.values.iv_security_slip_or_price_bond_no = "";
    sjoFormik.values.iv_tie_up_non_tie_up = 0;
    masterDataFormik.resetForm();
    arearsFormik.values.iv_property_reference_no = "";
    masterDataFormik.values.iv_govt_dept = 0;
    masterDataFormik.values.iv_income_tax = 0;
    masterDataFormik.values.iv_standard_classification_code = "";
    setDnDetails({
      demandNoticeNo: "",
      issueDate: "",
      applicationId: "",
      dueDate: "",
      roOfficeAddress: "",
      consumerAccountNo: "",
      batchNo: "",
      tariff: "",
      bankName: "",
      industryFactoryType: null,
      connectionAccountNo: "",
      dnPaymentFlag: null,
      paymentMethod: null,
      dnPaymentVerificationFlag: null,
      previousSecurity: null,
      sanctionLoad: "",
      filledBy: null,
      filledDate: "",
      filledFlag: null,
      approvedBy: null,
      approvedDate: null,
      approvedFlag: null,
      connectionCatagoryType: null,
      dNamount: null,
    });
    setDnReceiptImage();
    setDnReceiptImageThumbnail();
    dnPymentReceiptFormik.resetForm();
    setSjoDetails({
      subDivisionCode: null,
      sCONo: "",
      scoCreationDate: "",
      applicationId: "",
      applicationSubmissionDate: null,
      accountNo: null,
      feederNo: null,
      batch: null,
      applicantNewName: null,
      applicantOldTariff: null,
      applicantOldLoad: null,
      applicantNewTariff: null,
      applicantNewLoad: null,
      applicationType: null,
      mobileNo: null,
      date: null,
      materNo: null,
      cNICNo: null,
      securityDepositDNNo: null,
      dNCreationDate: null,
      ammountOfSecurityDeposit: null,
      dNPaymentDate: null,
      ammountOfCapitalCost: 0,
      capitalCostPaymentDate: null,
      filledBy: null,
      filledDate: null,
      filledFlag: null,
      approvedBy: null,
      approvedDate: null,
      approvedFlag: null,
    });
    setDialogRowData((prevObject) => ({
      ...prevObject,
      copyOfApplicantCNIC: "",
      owenershipDocument: "",
      electricityBillDocument: "",
      fbrDocument: "",
      previousOwnerCNIC: "",
      perOwenerNOC: "",
      affidaviteApplicant: "",
      additionalCivicDocument: "",
      addDocAnyOther: "",
      addDocCONConsent: "",
    }));

    setFoundInCON();
    setShowMasterForm(false);
    setApplicantCNICBackObjectionRemarks("");
    setApplicantCNICFrontObjectionRemarks("");
    setowenershipObjectionRemarks("");
    setElectricityBillObjectionRemarks("");
    setFbrDocumentObjectionRemarks("");
    setpreOwnerCNICBackObjectionRemarks("");
    setpreOwnerCNICFrontObjectionRemarks("");
    setperOwenerNOCObjectionRemarks("");
    setnewOwenerAffidaviteObjectionRemarks("");
    setaddCONConsentObjectionRemarks("");
    setaddDocAnyOtherObjectionRemarks("");
    setaddDocCivicAuthorityObjectionRemarks("");
    setOpen(false);
    setEFileData([]);
    setPaymentStatus("");
    setArrearAmount("");
    setBillMonth("");
    setSketchDiagramThumbnail();
    setSketchDiagram();
    setSketchDiagramError();
    setSketchDiagramUploaded();
    dispatch(
      fetchPaginatedChangeOfAttributesNormal({
        page: currentPageNormal,
        pageSize: pageSizeNormal,
        dateFrom: dateFromNormal,
        dateTo: dateToNormal,
        applicationProgressId: applicationProgressIdNormal,
        objectionStatus: objectionStatusNormal,
        officeCode: selectedOfficeCode || code,
      })
    );
    dispatch(
      fetchPaginatedChangeOfAttributesOverdue({
        page: currentPageNormal,
        pageSize: pageSizeNormal,
        dateFrom: dateFromNormal,
        dateTo: dateToNormal,
        applicationProgressId: applicationProgressIdNormal,
        objectionStatus: objectionStatusNormal,
        officeCode: selectedOfficeCode || code,
      })
    );
    if (!props.showTable && typeof props.onCloseSearchResults === "function") {
      props.onCloseSearchResults();
    }
  };
  const SketchDiagram = (event) => {
    if (event.target.files) {
      const newFileName =
        "sketchDiagram." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        fieldFormik.handleChange,
        setSketchDiagram,
        setSketchDiagramError,
        setSketchDiagramThumbnail,
        newFileName
      );
    }
  };
  const ArearPaidBillDocument = (event) => {
    arearBillDocumentFormik.handleChange(event);
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      let fileName = file.name;
      let fileNameArray = fileName.split(".");
      let extension = fileNameArray[fileNameArray.length - 1];
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      const documentValidate = documentValidation(file, maxSize);
      if (documentValidate === 1) {
        const newFileName = "paidBillArear." + extension;
        const renamedFile = new File([file], newFileName, { type: file.type });
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const image = new Image();
        image.src = URL.createObjectURL(renamedFile);

        image.onload = () => {
          canvas.width = image.width;
          canvas.height = image.height;
          ctx.drawImage(image, 0, 0);
          const waterMarkText = "For MEPCO Use Only";
          ctx.font = "24px Arial";
          ctx.fillStyle = "rgba(255, 255, 255, 0.5)";
          ctx.fillText(waterMarkText, 10, canvas.height - 10);
          const watermarkedBase64 = canvas.toDataURL();
          setArearPaidBillDocument(renamedFile);
          arearBillDocumentFormik.values.iv_arear_paid_bill_document =
            "uploaded";
          setArearPaidBillDocumentThumbnail(watermarkedBase64);
        };
      } else if (documentValidate === 2) {
        setArearPaidBillDocumentError(
          "File size exceeds " + maxSize / 1024 / 1024 + "MB limit."
        );
      } else {
        setArearPaidBillDocumentError(
          "Invalid file type. Only JPG, PNG, and PDF are allowed."
        );
      }
    }
  };

  const SignedConsentFormImage = (event) => {
    signedConsentImageFormik.handleChange(event);
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      let fileName = file.name;
      let fileNameArray = fileName.split(".");
      let extension = fileNameArray[fileNameArray.length - 1];
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      const documentValidate = documentValidation(file, maxSize);
      if (documentValidate === 1) {
        const newFileName = "signedConsentFormImage." + extension;
        const renamedFile = new File([file], newFileName, { type: file.type });
        setSignedConsentFormImageImage(renamedFile);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          // Set the thumbnail image as the data URL
          const base64Image = reader.result;
          setSignedConsentFormImageImageThumbnail(base64Image);
        };
      } else if (documentValidate === 2) {
        setSignedConsentFormImageError(
          "File size exceeds " + maxSize / 1024 / 1024 + "MB limit."
        );
      } else {
        setSignedConsentFormImageError(
          "Invalid file type. Only JPG, PNG, and PDF are allowed."
        );
      }
    }
  };

  const DnReceiptImage = (event) => {
    dnPymentReceiptFormik.handleChange(event);
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      let fileName = file.name;
      let fileNameArray = fileName.split(".");
      let extension = fileNameArray[fileNameArray.length - 1];
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      const documentValidate = documentValidation(file, maxSize);
      if (documentValidate === 1) {
        const newFileName = "dnReceiptImage." + extension;
        const renamedFile = new File([file], newFileName, { type: file.type });
        setDnReceiptImage(renamedFile);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          // Set the thumbnail image as the data URL
          const base64Image = reader.result;
          setDnReceiptImageThumbnail(base64Image);
        };
      } else if (documentValidate === 2) {
        console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
      } else {
        console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
      }
    }
  };

  const ArrearPaidReceiptImage = (event) => {
    arrearPaymentReceiptFormik.handleChange(event);
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      let fileName = file.name;
      let fileNameArray = fileName.split(".");
      let extension = fileNameArray[fileNameArray.length - 1];
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      const documentValidate = documentValidation(file, maxSize);
      if (documentValidate === 1) {
        const newFileName = "ArrearPaidReceiptImage." + extension;
        const renamedFile = new File([file], newFileName, { type: file.type });
        setArrearPaidReceiptImage(renamedFile);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          // Set the thumbnail image as the data URL
          const base64Image = reader.result;
          setArrearPaidReceiptImageThumbnail(base64Image);
        };
      } else if (documentValidate === 2) {
        console.log("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
      } else {
        console.log("Invalid file type. Only JPG, PNG, and PDF are allowed.");
      }
    }
  };

  const [currentEfileApplication, setCurrentEfileApplication] = useState([]);

  const callEfileAPI = async (applicationId, application) => {
    try {
      setViewDropBackForEfile(true);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({ applicationId });

      const response = await fetch(
        `${cfpBaseUrl}changeOfAttributes/getBasicCOAHistory`,
        {
          method: "POST",
          headers: myHeaders,
          body: raw,
        }
      );

      const result = await response.json();

      if (result.status === "200" && result.data) {
        let applicationHistory = result.data.history || [];
        let applicationCurrentState = result.data.currentStatus?.[0] || {};

        // sort DESC
        const sortedApplicationHistory = [...applicationHistory].sort(
          (a, b) => {
            return (
              new Date(b.lastModificationDate || 0) -
              new Date(a.lastModificationDate || 0)
            );
          }
        );

        setEFileData(sortedApplicationHistory);

        const dataforTable = sortedApplicationHistory.map((item, index) => {
          const isEarliest = index === sortedApplicationHistory.length - 1;

          return {
            stepName: item.coaProgStatusName,
            processedBy:
              item.lastModifiedBy || applicationCurrentState.createdBy,
            date: item.lastModificationDate
              ? convertDatewithTime(item.lastModificationDate)
              : convertDatewithTime(applicationCurrentState.creationDate),
            remarks: isEarliest
              ? "Application Submitted."
              : item.remarks || "-",
            historyId: getCoaHistoryId(item),
            applicationProgressId: item.applicationProgressId,
            historyProgressId: item.historyProgressId,
            isApplicationUpdatedEntry: shouldOpenCoaApplicationUpdatedPopUp(
              item,
              { stepName: item.coaProgStatusName }
            ),
            _raw: item,
          };
        });

        // keep for UI
        setTableDataProcessingSummary(dataforTable);

        // ✅ IMPORTANT: RETURN DATA
        return dataforTable;
      }

      return [];
    } catch (error) {
      console.error("Error in callEfileAPI:", error);
      return [];
    } finally {
      setViewDropBackForEfile(false);
    }
  };

  const progFunc = (x) => {
    if (x === 0) {
      return "Documents Uploading";
    } else if (x === 1) {
      return "Documents Verification";
    } else if (x === 2) {
      return "Arrear Verification";
    } else if (x === 3) {
      return "Field Survey";
    } else if (x === 4) {
      return "DN Approval";
    } else if (x === 5) {
      return "DN Submission";
    } else if (x === 6) {
      return "DN Payment Verification";
    } else if (x === 7) {
      return "Sundary Jobs Order";
    } else if (x === 8) {
      return "Ready for Billing";
    } else if (x === 9) {
      return "Completed";
    }
  };

  const dnPaymentVerificationAlertBox = () => {
    setDnPaymentVerifyAlert(true);
  };

  const dnPaymentVerificationRejectionAlertBox = () => {
    setDnPaymentRejectAlert(true);
  };

  const apiToDataGridConversionNormal = async () => {
    try {
      setViewBackdrop(true);

      const tempArray = [];
      if (changeOfNameApplications) {
        changeOfNameApplications.forEach((item) => {
          let dataGridObject = {};
          if (item.applicationId) {
            if (item.objectionStatus === 0 || item.objectionStatus === 2) {
              dataGridObject = {
                applicationId: item.applicationId,
                creationDate: convertDate(item.creationDate),
                applicantName: item.applicantName,
                referenceno: item.referenceNumber,
                applicationStatusId: statusFunc(
                  item.applicationStatusId,
                  item.objectionStatus
                ),
                applicationStep: progFunc(item.applicationProgressId),
                // downloadDNPDF: async () => {
                //    console.log(item,"Download DN PDF called");
                //   let application = await filterCONApp(item.applicationId);
                //    console.log(application,dnDets,"Download DN PDF application");
                //   await downloadDNPDF(application,dnDets);
                // },
                downloadDNPDF: async () => {

                  let myHeaders = new Headers();
                  myHeaders.append("Authorization", token);
                  myHeaders.append("Content-Type", "application/json");

                  const raw = JSON.stringify({
                    applicationId: item.applicationId,
                  });

                  const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow",
                  };

                  try {
                    const response = await fetch(
                      cfpBaseUrl + "changeOfAttributes/getDemandNoteData",
                      requestOptions
                    );

                    const result = await response.json();

                    if (result.status === "200") {
                      const dnDets = result.data[0];
                      // Check multiple possible expiry flag sources
                      const dnExpiryFlag = result.dnExpiryFlag || dnDets.demandNoteExpiryFlag;
                      const dnExpiryCount = result.dnExpiryCount || dnDets.demandNoteExpiryCount;

                      console.log("=== DN Expiry Check ===");
                      console.log("result.dnExpiryFlag:", result.dnExpiryFlag);
                      console.log("dnDets.demandNoteExpiryFlag:", dnDets.demandNoteExpiryFlag);
                      console.log("result.dnExpiryCount:", result.dnExpiryCount);
                      console.log("dnDets.demandNoteExpiryCount:", dnDets.demandNoteExpiryCount);
                      console.log("Final dnExpiryFlag:", dnExpiryFlag);
                      console.log("Final dnExpiryCount:", dnExpiryCount);

                      // Check if DN is expired - check both flag and count
                      const isExpired = dnExpiryFlag === "1" || dnExpiryFlag === 1 ||
                        (dnExpiryCount !== null && dnExpiryCount !== undefined && dnExpiryCount > 0);

                      console.log("Is DN Expired:", isExpired);
                      console.log("Application Progress ID:", item.applicationProgressId);

                      // Show expiry popup ONLY at DN Submission step (applicationProgressId === 5)
                      // For other steps, download DN directly even if expired
                      if (isExpired && item.applicationProgressId === 5) {
                        setDnExpiryDialogData({
                          applicationId: item.applicationId,
                          issueDate: dnDets.issueDate,
                        });
                        setShowDnExpiryPopup(true);
                        return;
                      }

                      await downloadDNPDF(item.applicationId, dnDets);
                    } else {
                      console.log("API failed", result);
                    }
                  } catch (error) {
                    console.error("API Error:", error);
                    return;
                  }
                },
                downloadEFile: async () => {
                  let application = await filterCONApp(item.applicationId);
                  await downloadEFile(application);
                },
                applicationProgressId: item.applicationProgressId,
                applicationType: item.applicationType,
                releventApplicationFlage: item.releventApplicationFlage,
              };
            } else if (item.objectionStatus === 1) {
              dataGridObject = {
                applicationId: item.applicationId,
                creationDate: convertDate(item.creationDate),
                applicantName: item.applicantName,
                referenceno: item.referenceNumber,
                applicationStatusId: statusFunc(
                  item.applicationStatusId,
                  item.objectionStatus
                ),
                applicationStep: item.remarks,
                downloadDNPDF: async () => {

                  let myHeaders = new Headers();
                  myHeaders.append("Authorization", token);
                  myHeaders.append("Content-Type", "application/json");

                  const raw = JSON.stringify({
                    applicationId: item.applicationId,
                  });

                  const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow",
                  };

                  try {
                    const response = await fetch(
                      cfpBaseUrl + "changeOfAttributes/getDemandNoteData",
                      requestOptions
                    );

                    const result = await response.json();

                    if (result.status === "200") {
                      const dnDets = result.data[0];
                      // Check multiple possible expiry flag sources
                      const dnExpiryFlag = result.dnExpiryFlag || dnDets.demandNoteExpiryFlag;
                      const dnExpiryCount = result.dnExpiryCount || dnDets.demandNoteExpiryCount;

                      console.log("=== DN Expiry Check ===");
                      console.log("result.dnExpiryFlag:", result.dnExpiryFlag);
                      console.log("dnDets.demandNoteExpiryFlag:", dnDets.demandNoteExpiryFlag);
                      console.log("result.dnExpiryCount:", result.dnExpiryCount);
                      console.log("dnDets.demandNoteExpiryCount:", dnDets.demandNoteExpiryCount);
                      console.log("Final dnExpiryFlag:", dnExpiryFlag);
                      console.log("Final dnExpiryCount:", dnExpiryCount);

                      // Check if DN is expired - check both flag and count
                      const isExpired = dnExpiryFlag === "1" || dnExpiryFlag === 1 ||
                        (dnExpiryCount !== null && dnExpiryCount !== undefined && dnExpiryCount > 0);

                      console.log("Is DN Expired:", isExpired);
                      console.log("Application Progress ID:", item.applicationProgressId);

                      // Show expiry popup ONLY at DN Submission step (applicationProgressId === 5)
                      // For other steps, download DN directly even if expired
                      if (isExpired && item.applicationProgressId === 5) {
                        setDnExpiryDialogData({
                          applicationId: item.applicationId,
                          issueDate: dnDets.issueDate,
                        });
                        setShowDnExpiryPopup(true);
                        return;
                      }

                      await downloadDNPDF(item.applicationId, dnDets);
                    } else {
                      console.log("API failed", result);
                    }
                  } catch (error) {
                    console.error("API Error:", error);
                    return;
                  }
                },
                downloadEFile: async () => {
                  let application = await filterCONApp(item.applicationId);
                  await downloadEFile(application);
                },
                applicationProgressId: item.applicationProgressId,
                applicationType: item.applicationType,
                releventApplicationFlage: item.releventApplicationFlage,
              };
            }
            tempArray.push(dataGridObject);
          }
        });
      } else {
        const dataGridObject = {
          applicationId: " ",
          creationDate: "",
          applicantName: " ",
          referenceNo: " ",
          applicationStatusId: statusFunc(" "),
          description: " ",
        };
        tempArray.push(dataGridObject);
      }

      setChangeOfNameApplicationsToDataGrid(tempArray);
      setViewBackdrop(false);
    } catch (e) {
      console.log(e);
      console.log("Update Failed!");
    }
  };

  const apiToDataGridConversionOverdue = async () => {
    try {
      setViewBackdrop(true);

      const tempArray = [];
      if (changeOfNameApplicationsOverDue) {
        changeOfNameApplicationsOverDue.forEach((item) => {
          let dataGridObject = {};
          if (item.applicationId) {
            if (item.objectionStatus === 0 || item.objectionStatus === 2) {
              dataGridObject = {
                applicationId: item.applicationId,
                creationDate: convertDate(item.creationDate),
                applicantName: item.applicantName,
                referenceno: item.referenceNumber,
                applicationStatusId: statusFunc(
                  item.applicationStatusId,
                  item.objectionStatus
                ),
                applicationStep: progFunc(item.applicationProgressId),
                exceededDuration: item.exceededDuration,
                releventApplicationFlage: item.releventApplicationFlage,
                downloadDNPDF: async () => {

                  let myHeaders = new Headers();
                  myHeaders.append("Authorization", token);
                  myHeaders.append("Content-Type", "application/json");

                  const raw = JSON.stringify({
                    applicationId: item.applicationId,
                  });

                  const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow",
                  };

                  try {
                    const response = await fetch(
                      cfpBaseUrl + "changeOfAttributes/getDemandNoteData",
                      requestOptions
                    );

                    const result = await response.json();

                    if (result.status === "200") {
                      const dnDets = result.data[0];
                      // Check multiple possible expiry flag sources
                      const dnExpiryFlag = result.dnExpiryFlag || dnDets.demandNoteExpiryFlag;
                      const dnExpiryCount = result.dnExpiryCount || dnDets.demandNoteExpiryCount;

                      console.log("=== DN Expiry Check ===");
                      console.log("result.dnExpiryFlag:", result.dnExpiryFlag);
                      console.log("dnDets.demandNoteExpiryFlag:", dnDets.demandNoteExpiryFlag);
                      console.log("result.dnExpiryCount:", result.dnExpiryCount);
                      console.log("dnDets.demandNoteExpiryCount:", dnDets.demandNoteExpiryCount);
                      console.log("Final dnExpiryFlag:", dnExpiryFlag);
                      console.log("Final dnExpiryCount:", dnExpiryCount);

                      // Check if DN is expired - check both flag and count
                      const isExpired = dnExpiryFlag === "1" || dnExpiryFlag === 1 ||
                        (dnExpiryCount !== null && dnExpiryCount !== undefined && dnExpiryCount > 0);

                      console.log("Is DN Expired:", isExpired);
                      console.log("Application Progress ID:", item.applicationProgressId);

                      // Show expiry popup ONLY at DN Submission step (applicationProgressId === 5)
                      // For other steps, download DN directly even if expired
                      if (isExpired && item.applicationProgressId === 5) {
                        setDnExpiryDialogData({
                          applicationId: item.applicationId,
                          issueDate: dnDets.issueDate,
                        });
                        setShowDnExpiryPopup(true);
                        return;
                      }

                      await downloadDNPDF(item.applicationId, dnDets);
                    } else {
                      console.log("API failed", result);
                    }
                  } catch (error) {
                    console.error("API Error:", error);
                    return;
                  }
                },
                downloadEFile: async () => {
                  let application = await filterCONApp(item.applicationId);
                  await downloadEFile(application);
                },
                applicationProgressId: item.applicationProgressId,
                applicationType: item.applicationType,
              };
            } else if (item.objectionStatus === 1) {
              dataGridObject = {
                applicationId: item.applicationId,
                creationDate: convertDate(item.creationDate),
                applicantName: item.applicantName,
                referenceno: item.referenceNumber,
                applicationStatusId: statusFunc(
                  item.applicationStatusId,
                  item.objectionStatus
                ),
                applicationStep: item.remarks,
                downloadDNPDF: async () => {

                  let myHeaders = new Headers();
                  myHeaders.append("Authorization", token);
                  myHeaders.append("Content-Type", "application/json");

                  const raw = JSON.stringify({
                    applicationId: item.applicationId,
                  });

                  const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow",
                  };

                  try {
                    const response = await fetch(
                      cfpBaseUrl + "changeOfAttributes/getDemandNoteData",
                      requestOptions
                    );

                    const result = await response.json();

                    if (result.status === "200") {
                      const dnDets = result.data[0];
                      // Check multiple possible expiry flag sources
                      const dnExpiryFlag = result.dnExpiryFlag || dnDets.demandNoteExpiryFlag;
                      const dnExpiryCount = result.dnExpiryCount || dnDets.demandNoteExpiryCount;

                      console.log("=== DN Expiry Check ===");
                      console.log("result.dnExpiryFlag:", result.dnExpiryFlag);
                      console.log("dnDets.demandNoteExpiryFlag:", dnDets.demandNoteExpiryFlag);
                      console.log("result.dnExpiryCount:", result.dnExpiryCount);
                      console.log("dnDets.demandNoteExpiryCount:", dnDets.demandNoteExpiryCount);
                      console.log("Final dnExpiryFlag:", dnExpiryFlag);
                      console.log("Final dnExpiryCount:", dnExpiryCount);

                      // Check if DN is expired - check both flag and count
                      const isExpired = dnExpiryFlag === "1" || dnExpiryFlag === 1 ||
                        (dnExpiryCount !== null && dnExpiryCount !== undefined && dnExpiryCount > 0);

                      console.log("Is DN Expired:", isExpired);
                      console.log("Application Progress ID:", item.applicationProgressId);

                      // Show expiry popup ONLY at DN Submission step (applicationProgressId === 5)
                      // For other steps, download DN directly even if expired
                      if (isExpired && item.applicationProgressId === 5) {
                        setDnExpiryDialogData({
                          applicationId: item.applicationId,
                          issueDate: dnDets.issueDate,
                        });
                        setShowDnExpiryPopup(true);
                        return;
                      }

                      await downloadDNPDF(item.applicationId, dnDets);
                    } else {
                      console.log("API failed", result);
                    }
                  } catch (error) {
                    console.error("API Error:", error);
                    return;
                  }
                },
                downloadEFile: async () => {
                  let application = await filterCONApp(item.applicationId);
                  await downloadEFile(application);
                },
                applicationProgressId: item.applicationProgressId,
                applicationType: item.applicationType,
                exceededDuration: item.exceededDuration,
                releventApplicationFlage: item.releventApplicationFlage,
              };
            }
            tempArray.push(dataGridObject);
          }
        });
      } else {
        const dataGridObject = {
          applicationId: " ",
          creationDate: "",
          applicantName: " ",
          referenceNo: " ",
          applicationStatusId: statusFunc(" "),
          description: " ",
        };
        tempArray.push(dataGridObject);
      }

      setChangeOfNameApplicationsOverDueToDataGrid(tempArray);
      setViewBackdrop(false);
    } catch (e) {
      console.log(e);
      console.log("Update Failed!");
    }
  };

  useScanDetection({
    onComplete: async (code) => {
      if (code) {
        code = code.replace(/Shift/g, "");
        const regex = /^[A-Z]{2}-\d{14,15}$/;
        if (regex.test(code)) {
          await handleRowClick(code);
        } else {
          console.warn("Invalid code format:", code);
        }
      }
    },
    minLength: 4, // EAN13
  });

  const filterCONApp = async (applicationId) => {
    const nameArray = changeOfNameApplications;
    let allApplications = nameArray.concat(changeOfNameApplicationsOverDue);
    let itemFound = allApplications.find(
      (item) => item.applicationId === applicationId
    );
    if (itemFound === undefined) {
      itemFound = await SearchIndividualApplication(token, applicationId, "15");
    }
    return itemFound;
  };

  const submitObjection = () => {
    setObjectionPopUpOpen(false);
  };

  const docVerificationAlertBox = () => {
    setDocVerifyAlert(true);
  };

  const fieldVerificationAlertBox = () => {
    setFieldVerifyAlert(true);
  };

  const hideArrearsVerifyAlert = () => {
    setArrearsVerifyPopUpOpen(false);
  };

  const getDocumentApi = async (applicationId) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({ applicationId });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/getChangeOfAttributesDocuments",
        requestOptions
      );

      const result = await response.json();

      if (result?.data && result.data.length > 0) {
        const docData = {
          applicantCNICFront: result.data[0].applicantCNICFront,
          applicantCNICBack: result.data[0].applicantCNICBack,
          // keep existing key for backwards-compatibility
          ownershipDocument: result.data[0].ownershipImage,
          // also provide `ownershipImage` which other code expects
          ownershipImage: result.data[0].ownershipImage,
          electricityBill: result.data[0].electricityBill,
          fbrDocument: result.data[0].fbrDocument,
          anyOtherDocument: result.data[0].anyOtherDocument,
        };

        // ✅ Update your dialog state also
        setDialogRowData((prevObject) => ({
          ...prevObject,
          applicantCNICFront: docData.applicantCNICFront,
          applicantCNICBack: docData.applicantCNICBack,
          owenershipDocument: docData.ownershipDocument,
          electricityBillDocument: docData.electricityBill,
          fbrDocument: docData.fbrDocument,
          addDocAnyOther: docData.anyOtherDocument,
        }));

        // ✅ Return the data (important for PDF)
        return docData;
      }

      return null;
    } catch (error) {
      console.log("error", error);
      return null;
    }
  };

  const onPressViewActivityLog = async () => {
    if (dialogRowData.applicationProgressId >= 3) {
      getDocumentApi(dialogRowData.applicationId);
    }
    await callEfileAPI(dialogRowData.applicationId, dialogRowData);
  };

  useEffect(() => {
    callTariffList();
  }, []);
  const callTariffList = async () => {
    let tariffList = [];
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        redirect: "follow",
        headers: myHeaders,
      };

      await fetch(
        cfpBaseUrl + "customerFaciliationPortal/getTariffsDetail",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          tariffList = result.data;
          setAllTariffList(result.data);
        })
        .catch((error) => console.log("error", error));
      return tariffList;
    } catch (e) {
      console.log(e);
    } finally {
      return tariffList;
    }
  };

  const handleRowClick = async (applicationId) => {
    setViewBackdrop(true);

    callMaterials(applicationId);
    if (applicationId) {
      const item = await filterCONApp(applicationId);
      if (item && item.applicationId) {
        let phase = await getTariffAndMeterType(
          item.newSanctionLoad,
          item.connectionType,
          item.seasonalFlag,
          allTariffList,
          item.applicationProgressId
        );
        scoPart1Formik.values.iv_seasonal_flag = item.seasonalFlag;
        if (phase == "Single Phase") {
          scoPart1Formik.values.iv_meter_code1 = "000002";
        } else if (phase == "3 Phase") {
          scoPart1Formik.values.iv_meter_code1 = "050502";
          scoPart1Formik.values.iv_meter_code2 = "050602";
        }

        if (phase == "MDI (LT)(CT)" || phase == "MDI (HT)(CT/PT)") {
          scoPart1Formik.values.iv_ct_nom = "100";
          scoPart1Formik.values.iv_ct_denom = "5";
        } else {
          scoPart1Formik.values.iv_ct_nom = "1";
          scoPart1Formik.values.iv_ct_denom = "1";
        }

        if (phase == "MDI (HT)(CT/PT)") {
          scoPart1Formik.values.iv_pt_nom = "11000";
          scoPart1Formik.values.iv_pt_denom = "110";
        }
        scoPart1Formik.values.iv_connection_installer_name = userId;
        if (
          dialogRowData.changeOfAttributesType == 2 ||
          dialogRowData.changeOfAttributesType == 4 ||
          dialogRowData.changeOfAttributesType == 5 ||
          dialogRowData.changeOfAttributesType == 7
        ) {
          scoPart1Formik.values.iv_sanctioned_load = item.newSanctionLoad;
        } else {
          scoPart1Formik.values.iv_sanctioned_load = item.currentSanctionLoad;
        }

        setFlag_applicantCNICFront(item.applicantCNICFrontFlag);
        setFlag_applicantCNICBack(item.applicantCNICBackFlag);
        setFlag_owenershipDocument(item.ownershipImageFlag);
        setFlag_electricityBillDocument(item.electricityBillFlag);

        setFlag_fbrDocument(item.fbrDocumentFlag || null);
        setFlag_addDocAnyOther(item.anyOtherDocumentFlag || null);
        setApplicantCNICFrontObjectionRemarks(item.applicantCNICFrontRemarks || "");
        setApplicantCNICBackObjectionRemarks(item.applicantCNICBackRemarks || "");
        setowenershipObjectionRemarks(item.ownershipImageRemarks || "");
        setElectricityBillObjectionRemarks(item.electricityBillRemarks || "");
        setFbrDocumentObjectionRemarks(item.fbrDocumentRemarks || "");
        setaddDocAnyOtherObjectionRemarks(item.anyOtherDocumentRemarks || "");
        setDialogRowData(item);
        // await callEfileAPI(item.applicationId, item);
        // if (item.applicationProgressId < 3 || item.applicationProgressId == 6 || item.applicationProgressId == 1) {
        await getDocumentApi(item.applicationId);
        // }



        if (item.applicationProgressId == 3 || item.objectionStatus == 1) {

          fieldFormik.setFieldValue(
            "iv_objection_Type",
            item.observationType
          );
        } else {

          fieldFormik.setFieldValue(
            "iv_objection_Type",
            1
          );
        }

        let subDivisionObject = null;
        if (item.referenceNumber) {
          subDivisionObject = subDivisions.find(
            (objs) =>
              objs.subDivisionCode == parseInt(item.referenceNumber.slice(2, 7))
          );
          if (subDivisionObject) {
            setBankName(subDivisionObject.subDivBankName);
          }
        }

        if (item.applicationProgressId === 3 && item.objectionStatus === 0) {
          let subDivisionObject = subDivisions.find(
            (objs) => objs.subDivisionCode === item.subDivisionCode
          );
          if (subDivisionObject) {
            setBankName(subDivisionObject.subDivBankName);
          }
        }
        if (
          (item.applicationProgressId >= 4 &&
            (item.objectionStatus === 0 ||
              item.objectionStatus === 1 ||
              item.objectionStatus === 2)) ||
          (dialogRowData.applicationProgressId === 5 &&
            (dialogRowData.objectionStatus === 0 ||
              dialogRowData.objectionStatus === 2 ||
              dialogRowData.objectionStatus === 1)) ||
          (dialogRowData.applicationProgressId === 6 &&
            (dialogRowData.objectionStatus === 0 ||
              dialogRowData.objectionStatus === 2)) ||
          (dialogRowData.applicationProgressId === 7 &&
            (dialogRowData.objectionStatus === 0 ||
              dialogRowData.objectionStatus === 2))
        ) {
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          myHeaders.append("Content-Type", "application/json");

          const raw = JSON.stringify({
            applicationId: item.applicationId,
          });

          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          await fetch(
            cfpBaseUrl + "changeOfAttributes/getDemandNoteData",
            requestOptions
          )
            .then((response) => response.json())
            .then((result) => {
              if (result.status === "200") {
                setDnImage(result.data[0].paidDNImage);
                setDnApproveStep(result.data[0]);
                setDnDets(result.data[0]);
                // Store the expiry flag for dialog DN download check
                const dnExpiryFlag = result.dnExpiryFlag || result.data[0].demandNoteExpiryFlag;
                const isExpired = dnExpiryFlag === "1" || dnExpiryFlag === 1;
                setDialogDnExpiryFlag(isExpired);
              }
            })
            .catch((error) => console.error(error));
        }

        if (item.applicationProgressId >= 7) {
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          myHeaders.append("Content-Type", "application/json");

          const raw = JSON.stringify({
            applicationId: item.applicationId,
          });

          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          fetch(cfpBaseUrl + "changeOfAttributes/getSCODetail", requestOptions)
            .then((response) => response.json())
            .then((result) => {
              setScoDetails(result.data[0]);
            })
            .catch((error) => console.error(error));
        }
        // if (item.applicationProgressId >= 4) {
        //   var formdata = new FormData();
        //   const myHeaders = new Headers();
        //   myHeaders.append("Authorization", token);
        //   formdata.append("applicationId", item.applicationId);

        //   var requestOptions = {
        //     method: 'POST',
        //     body: formdata,
        //     headers: myHeaders,
        //     redirect: 'follow',
        //   };

        //   await fetch(cfpBaseUrl + "changeOfName/getPaidDNForChangeOfName", requestOptions)
        //     .then(response => response.json())
        //     .then(result => {
        //       if (result.status === "200") {
        //         setDnImage(result.data[0].paidDNImage)
        //         setDnPaymentDate(result.data[0].paymentDate)
        //       }
        //     })
        //     .catch(error => console.log('error', error));
        // }

        // if (item.applicationProgressId >= 5) {
        //   var formdata = new FormData();
        //   formdata.append("applicationId", item.applicationId);
        //   const myHeaders = new Headers();
        //   myHeaders.append("Authorization", token);;

        //   var requestOptions = {
        //     method: 'POST',
        //     body: formdata,
        //     headers: myHeaders,
        //     redirect: 'follow',
        //   };

        //   await fetch(cfpBaseUrl + "changeOfName/getDNForChangeOfName", requestOptions)
        //     .then(response => response.json())
        //     .then(result => {
        //       setDnDetails(result.data[0])
        //       sjoFormik.values.iv_batch = result.data[0].batchNo
        //     })
        //     .catch(error => console.log('error', error));

        //   callGetSJOAPI(item.applicationId)
        // }

        setViewBackdrop(false);
        setOpen(true);
      } else {
        setViewBackdrop(false);
      }
    } else {
      setViewBackdrop(false);
    }
  };

  const showArrearsVerifyPopup = () => {
    setArrearsVerifyPopUpOpen(true);
  };

  const showArrearsEntryPopup = async () => {
    await referenceApi();
    setArrearsEntryPopUpOpen(true);
  };

  const downloadSJOPDF = async (
    applicationId,
    scoDetails,
    dialogRowData,
    dnDets
  ) => {
    setViewBackdrop(true);
    try {
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();

      let application =
        changeOfNameApplications.find(
          (item) => item.applicationId === applicationId
        ) ||
        changeOfNameApplicationsOverDue.find(
          (item) => item.applicationId === applicationId
        ) ||
        dialogRowData;

      let officeCode = dialogRowData.subDivisionCode || "---";
      let officeName =
        subdivisionName(
          parseInt(dialogRowData.subDivisionCode),
          subDivisions
        ) || "---";
      let authorizedByName = scoDetails.scoApprovedBy || "---";
      let authorizedByDesignation =
        scoDetails.scoApprovedByDesignation || "Role";
      let dateToPrint = scoDetails.scoApprovalDate
        ? new Date(scoDetails.scoApprovalDate).toLocaleDateString()
        : "---";

      let stampData = printStamp(
        officeCode,
        officeName,
        authorizedByName,
        authorizedByDesignation,
        dateToPrint
      );
      // doc.addImage(stampData, "PNG", 170, 170, 55, 40);

      let CompanyName = dialogRowData.companyCode.toString();
      const DiscoCode = CompanyName;

      const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
      const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
      const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
      const logoX = (pageWidth - logoWidth) / 2;

      let height = 10;

      doc.addImage(getLogo(DiscoCode), "PNG", logoX, 5, logoWidth, logoHeight);

      height += 15;
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
        align: "center",
      });

      doc.setFontSize(12);
      doc.text("Sundary Job Orders", 105, 34, { align: "center" });

      let y = 50;

      doc.setFontSize(10);

      doc.setFont(undefined, "bold");
      doc.text("Application No.: ", 20, y);
      doc.setFont(undefined, "normal");
      doc.text(dialogRowData.applicationId || "-", 60, y);
      doc.setFont(undefined, "bold");
      doc.text("Sub-Division: ", 110, y);
      doc.setFont(undefined, "normal");
      doc.text(
        dialogRowData.subDivisionCode +
        " (" +
        subdivisionName(
          parseInt(dialogRowData.subDivisionCode),
          subDivisions
        ) +
        ")" || "-",
        150,
        y
      );
      y += 6;

      doc.setFont(undefined, "bold");
      doc.text("Reference No.: ", 20, y);
      doc.setFont(undefined, "normal");
      doc.text(dialogRowData.referenceNumber || "-", 60, y);
      doc.setFont(undefined, "bold");
      doc.text("Customer Id: ", 110, y);
      doc.setFont(undefined, "normal");
      doc.text(dialogRowData.customerId || "-", 150, y);
      y += 10;

      doc.setFontSize(10);
      doc.setFont(undefined, "normal");

      const sjoText = dnDets.sjoData || "-";
      const maxWidth = pageWidth - 40;
      const lines = doc.splitTextToSize(sjoText, maxWidth);

      lines.forEach((line, index) => {
        if (index < lines.length - 1) {
          doc.text(line, 20, y, { align: "justify", maxWidth: maxWidth });
        } else {
          doc.text(line, 20, y);
        }
        y += 6;
      });

      y += 4;

      const isCurrentNewFormat = [1, 4, 5, 6].includes(
        dialogRowData.changeOfAttributesType
      );
      const col2Header = isCurrentNewFormat ? "Current" : "Old";
      const col3Header = "New";

      const tableRows = getTableRows(dialogRowData);

      doc.autoTable({
        startY: y,
        head: [["", col2Header, col3Header]],
        body: tableRows.map((row) => [
          row.label || "-",
          row.current || "-",
          row.newVal || "-",
        ]),
        theme: "grid",
        headStyles: {
          fillColor: [30, 82, 167],
          textColor: [255, 255, 255],
          fontStyle: "bold",
          lineWidth: 0.5,
          lineColor: [21, 101, 192],
          halign: "left",
          cellPadding: { top: 3, right: 5, bottom: 3, left: 5 },
        },
        bodyStyles: {
          lineWidth: 0.5,
          lineColor: [224, 224, 224],
          cellPadding: { top: 4, right: 8, bottom: 4, left: 8 },
        },
        alternateRowStyles: { fillColor: [213, 229, 255] },
        columnStyles: { 0: { fontStyle: "bold" } },
        margin: { left: 20, right: 20 },
        tableWidth: "auto",
      });

      doc.addImage(stampData, "PNG", 170, 150, 55, 40);

      const totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(CompanyName),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight()
        );
      }

      const pdfBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");
    } catch (e) {
      console.log("Unable to generate Master Data Form!", e);
    }
    setViewBackdrop(false);
  };

  const hideArrearRejectionRemovalAlert = () => {
    setArearPaidBillDocument("");
    setArearPaidBillDocumentThumbnail("");
    arearBillDocumentFormik.resetForm();
    setArrearRejectionRemovalAlert(false);
  };

  const hideSignedConsentRejectionRemovalAlert = () => {
    setSignedConsentRejectionRemovalAlert(false);
    setSignedConsentFormImageImage("");
    setConsentVerificationFlag(0);
    setSignedConsentFormImageImageThumbnail("");
  };

  const [historyData, setHistoryData] = useState();

  const openCoaApplicationUpdatedPopUp = async (stepRow) => {
    const historyId = getCoaHistoryId(stepRow);
    if (!historyId || !dialogRowData?.applicationId) return;

    setViewBackdrop(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/getDetailByHistoryId",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({
            applicationId: dialogRowData.applicationId,
            historyId,
          }),
        }
      );
      const result = await response.json();

      if (result.status === "200" && result.data?.[0]) {
        setCoaApplicationUpdatedHistoryData(result.data[0]);
        setCoaApplicationUpdatedPopUp(true);
      }
    } catch (error) {
      console.error("Error loading application update history:", error);
    } finally {
      setViewBackdrop(false);
    }
  };

  const openDetailsPopUp = async (stepRowOrTableRow) => {
    const stepName = resolveActivityLogHistoryRow(stepRowOrTableRow);

    if (
      stepRowOrTableRow?.isApplicationUpdatedEntry === true ||
      shouldOpenCoaApplicationUpdatedPopUp(stepName, stepRowOrTableRow)
    ) {
      await openCoaApplicationUpdatedPopUp(stepName);
      return;
    }

    setViewBackdrop(true);

    if (
      stepName &&
      typeof stepName === "object" &&
      stepName.applicationProgressId != undefined
    ) {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        historyId: getCoaHistoryId(stepName),
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "changeOfAttributes/getDetailByHistoryId",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setViewBackdrop(false);
            const hist = result.data[0];

            if (shouldOpenCoaApplicationUpdatedPopUp(hist, stepRowOrTableRow)) {
              setCoaApplicationUpdatedHistoryData(hist);
              setCoaApplicationUpdatedPopUp(true);
              return;
            }

            setHistoryData(hist);

            // Sync flag states with historyData
            setFlag_applicantCNICFront(hist.applicantCNICFrontFlag);
            setFlag_applicantCNICBack(hist.applicantCNICBackFlag);
            setFlag_owenershipDocument(hist.ownershipImageFlag);
            setFlag_electricityBillDocument(hist.electricityBillFlag);
            setFlag_fbrDocument(hist.fbrDocumentFlag);
            if (
              stepName.applicationProgressId == 1 &&
              stepName.objectionStatus == 1
            ) {
              setDocumentsVerifiedSubPopUp(true);
            } else if (
              hist.applicationProgressId == 1 &&
              stepName.objectionStatus != 1 &&
              stepName.remarks !== "Revert to Documents Verification"
            ) {
              setApplicationSubmittedPopUp(true);
              // setDocumentsVerifiedSubPopUp(true);
            } else if (
              hist.applicationProgressId == 1 &&
              stepName.objectionStatus != 1 &&
              stepName.remarks === "Revert to Documents Verification"
            ) {
              // setApplicationSubmittedPopUp(true);
              setApplicationSubmittedPopUp(true);

              // setDocumentsVerifiedSubPopUp(true);
            } else if (
              result.data[0].applicationProgressId == 2 &&
              stepName.objectionStatus != 1 &&
              stepName.remarks !== "Revert to Arrear Verification"
            ) {
              setDocumentsVerifiedSubPopUp(true);
              // setArrearVerifiedSubPopUp(true);
            } else if (
              result.data[0].applicationProgressId == 2 &&
              stepName.objectionStatus != 1 &&
              stepName.remarks === "Revert to Arrear Verification"
            ) {
              setDocumentsVerifiedSubPopUp(true);
              // setArrearVerifiedSubPopUp(true);
            } else if (
              result.data[0].applicationProgressId == 1 &&
              stepName.objectionStatus == 2
            ) {
              setDocumentsVerifiedSubPopUp(true);
              // setArrearVerifiedSubPopUp(true);
            } else if (
              result.data[0].applicationProgressId == 2 &&
              stepName.objectionStatus == 1
            ) {
              // setDocumentsVerifiedSubPopUp(true);
              setArrearVerifiedSubPopUp(true);
              // setArrearVerifiedSubPopUp(true);
            } else if (
              result.data[0].applicationProgressId == 3 &&
              stepName.objectionStatus != 1 &&
              stepName.remarks === "Arrears Verified"
            ) {
              setArrearVerifiedSubPopUp(true);
              // setFieldSurveyedSubPopUp(true);
            } else if (
              result.data[0].applicationProgressId == 3 &&
              stepName.objectionStatus != 1 &&
              stepName.remarks === "Revert to Field Survey."
            ) {
              setFieldSurveyedSubPopUp(true);
            } else if (
              result.data[0].applicationProgressId == 3 &&
              stepName.objectionStatus != 1 &&
              stepName.remarks === "Field Survey Objection Removed."
            ) {
              // console.log("A gya 4")
              setFieldSurveyedSubPopUp(true);
              // setFieldSurveyedSubPopUp(true);
            } else if (
              result.data[0].applicationProgressId == 3 &&
              stepName.objectionStatus == 1
            ) {
              setFieldSurveyedSubPopUp(true);
            } else if (result.data[0].applicationProgressId == 4) {
              setFieldSurveyedSubPopUp(true);
              // setDnApprovalSubPopUp(true);
            } else if (result.data[0].applicationProgressId == 5) {
              setDnApprovalSubPopUp(true);
              // setDnPaymentSubmittedSubPopUp(true);
            } else if (result.data[0].applicationProgressId == 6) {
              setDnPaymentSubmittedSubPopUp(true);
              // setDnPaymentVerifiedSubPopUp(true);
            } else if (result.data[0].applicationProgressId == 7) {
              // setDnPaymentSubmittedSubPopUp(true);
              setDnPaymentVerifiedSubPopUp(true);
            }
          }
        })
        .catch((error) => console.error(error));
    }
    let id = dialogRowData.applicationId;
    if (
      stepName === "Application Submitted" ||
      stepName === "DOCUMENT SUBMISSION"
    ) {
      setApplicationSubmittedPopUp(true);
    } else if (
      stepName === "Document Verification" ||
      stepName === "DOCUMENT VERIFICATION"
    ) {
      // Sync flag states with dialogRowData for re-upload case
      setHistoryData(dialogRowData);
      setFlag_applicantCNICFront(dialogRowData.applicantCNICFrontFlag);
      setFlag_applicantCNICBack(dialogRowData.applicantCNICBackFlag);
      setFlag_owenershipDocument(dialogRowData.ownershipImageFlag);
      setFlag_electricityBillDocument(dialogRowData.electricityBillFlag);
      setFlag_fbrDocument(dialogRowData.fbrDocumentFlag);
      setDocumentsVerifiedSubPopUp(true);
    } else if (
      stepName === "Arrear Verification" ||
      stepName === "ARREAR VERIFICATION"
    ) {
      setArrearVerifiedSubPopUp(true);
    } else if (
      stepName === "Field Survey" ||
      stepName === "FIELD SURVEY"
    ) {
      await callAsyncGetConsentImage(dialogRowData.applicationId);
      setFieldSurveyedSubPopUp(true);
    } else if (stepName === "DN Approval" || stepName === "DN APPROVAL") {
      await callAsyncDnDetailsAPI(dialogRowData.applicationId);
      setDnApprovalSubPopUp(true);
    } else if (stepName === "DN Submission" || stepName === "DN SUBMISSION") {
      await callAsyncGetPaidDnImageAPI(dialogRowData.applicationId);
      setDnPaymentSubmittedSubPopUp(true);
    } else if (
      stepName === "DN Payment Verification" ||
      stepName === "DN PAYMENT VERIFICATION"
    ) {
      // await callAsyncGetPaidDnImageAPI(dialogRowData.applicationId)
      setDnPaymentVerifiedSubPopUp(true);
    } else if (
      stepName === "Sundary Jobs Order" ||
      stepName === "SUNDARY JOBS ORDER"
    ) {
      // await callAsyncGetSJOAPI(dialogRowData.applicationId)
      setServiceConnectionOrderedSubPopUp(true);
    }
  };

  const handleActivityLogRowClick = (tableRow) => {
    void openDetailsPopUp(tableRow);
  };

  const hideCopyOfApplicantCNICVerifyAlert = (x) => {
    setCopyOfApplicantCNICVerifyPopUp(x);
  };

  const hidePreOwenerCnicVerifyAlert = (x) => {
    setPreOwnerCNICVerifyPopUp(x);
  };

  const hideElectricityBillVerifyAlert = (x) => {
    setElectricityBillDocumentVerifyPopUp(x);
  };

  const hideFbrDocumentVerifyAlert = (x) => {
    setFbrDocumentVerifyPopUp(x);
  };

  const hidePaidBillAlert = (x) => {
    setPaidBillPopUp(x);
  };
  const hidePerOwenerNOCVerifyAlert = (x) => {
    setPerOwenerNOCVerifyPopUp(x);
  };

  const hideNewOwenerAffidaviteVerifyAlert = (x) => {
    setNewOwenerAffidaviteVerifyPopUp(x);
  };

  const hideAddDocCivicAuthorityVerifyAlert = (x) => {
    setAddDocCivicAuthorityVerifyPopUp(x);
  };

  const hideAddAnyOtherVerifyAlert = (x) => {
    setAddDocAnyOtherVerifyPopUp(x);
  };
  const hideAddConsentCONVerifyAlert = (x) => {
    setAddDocCONConsentVerifyPopUp(x);
  };

  const hidePropertyDocVerifyAlert = (x) => {
    setOwenershipDocumentVerifyPopUp(x);
  };

  const hideFbrDocVerifyAlert = (x) => {
    setFbrDocumentVerifyPopUp(x);
  };

  const hideConsentImagePopUp = () => {
    setConsentImagePopUp(false);
  };

  const hidePaidDnImagePopUp = (x) => {
    setPaidDNImagePopUp(x);
  };

  const stepName = (x) => {
    if (x === 0) {
      return "Document Submission";
    }
    // else if (x === 1) {
    //   return 'Document Submission'
    // }
    else if (x === 1) {
      return "Document Verification";
    } else if (x === 2) {
      return "Arrear Verification";
    } else if (x === 3) {
      return "Field Survey";
    } else if (x === 4) {
      return "DN Approval";
    } else if (x === 5) {
      return "DN Submission";
    } else if (x === 6) {
      return "DN Payment Verification";
    } else if (x === 7) {
      return "Sundary Jobs Order";
    }
  };

  //#endregion

  //#region API Functions

  const callResetObjectionStatus = async (applicationId) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "changeOfName/resetObjectionStatus",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          handleClose();
        } else {
        }
      })
      .catch((error) => console.log("error", error));
  };

  // const AdditionalCivicDocument = (event) => {
  //   const newFileName = 'additionalCivicDocument.' + event.target.files[0].name.split(".").pop();
  //   handleFileUpload(event, handleChange, setAdditionalCivicDocument, setAdditionalCivicDocumentError, setAdditionalCivicDocumentThumbnail, newFileName);
  // };

  // const callingUpdateDocumentStatusAPI = async (
  //   applicationId = dialogRowData.applicationId,
  //   applicationProgressId = dialogRowData.applicationProgressId,
  //   objectionStatus = dialogRowData.objectionStatus,
  //   flag_applicantCNICFront,
  //   flag_applicantCNICBack,
  //   flag_owenershipDocument,
  //   flag_electricityBillDocument,
  //   applicantCNICBackObjectionRemarks,
  //   applicantCNICFrontObjectionRemarks,
  //   owenershipObjectionRemarks,
  //   electricityBillObjectionRemarks,
  //   remarks
  // ) => {
  //   const myHeaders = new Headers();
  //   myHeaders.append("Authorization", token);
  //   myHeaders.append("Content-Type", "application/json");

  //   const remarksDetails = (
  //     (applicantCNICFrontObjectionRemarks
  //       ? `Applicant CNIC Front: ${applicantCNICFrontObjectionRemarks}`
  //       : "") +
  //     (applicantCNICBackObjectionRemarks
  //       ? `, Applicant CNIC Back: ${applicantCNICBackObjectionRemarks}`
  //       : "") +
  //     (electricityBillObjectionRemarks
  //       ? `, Electricity Bill Document: ${electricityBillObjectionRemarks}`
  //       : "") +
  //     (owenershipObjectionRemarks
  //       ? `, Ownership Document: ${owenershipObjectionRemarks}`
  //       : "") +
  //     (fbrDocumentObjectionRemarks
  //       ? `, Fbr Document: ${fbrDocumentObjectionRemarks}`
  //       : "")
  //   ).replace(/^, /, "");

  //   const raw = JSON.stringify({
  //     applicationId: applicationId,
  //     applicationProgressId: applicationProgressId,
  //     objectionStatus: objectionStatus,
  //     remarks:
  //       flag_applicantCNICFront === -1 ||
  //       flag_applicantCNICBack === -1 ||
  //       flag_owenershipDocument === -1 ||
  //       flag_electricityBillDocument === -1
  //         ? "Documents Rejected"
  //         : "Documents Verified",
  //     remarksDetail: remarksDetails,
  //     applicantCNICFrontFlag: flag_applicantCNICFront,
  //     applicantCNICBackFlag: flag_applicantCNICBack,
  //     electricityBillFlag: flag_electricityBillDocument,
  //     ownershipImageFlag: flag_owenershipDocument,
  //     fbrDocumentFlag: flag_fbrDocument,
  //     applicantCNICFrontRemarks: applicantCNICFrontObjectionRemarks,
  //     applicantCNICBackRemarks: applicantCNICFrontObjectionRemarks,
  //     electricityBillRemarks: electricityBillObjectionRemarks,
  //     ownershipImageRemarks: owenershipObjectionRemarks,
  //     fbrDocumentRemarks: fbrDocumentObjectionRemarks,
  //   });

  //   const requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: "follow",
  //   };

  //   await fetch(
  //     cfpBaseUrl + "changeOfAttributes/verifyDocuments",
  //     requestOptions
  //   )
  //     .then((response) => response.json())
  //     .then((result) => {
  //       if (result.status === "200") {
  //         setFlag_owenershipDocument(null);
  //         setFlag_electricityBillDocument(null);
  //         setFlag_fbrDocument(null);
  //         setFlag_applicantCNICBack(null);
  //         setFlag_applicantCNICFront(null);
  //         handleClose();
  //       } else {
  //         console.error("API Error: ", result.message);
  //       }
  //     })
  //     .catch((error) => console.error("Fetch Error: ", error));
  // };

  const callingUpdateDocumentStatusAPI = async (
    applicationId = dialogRowData.applicationId,
    applicationProgressId = dialogRowData.applicationProgressId,
    objectionStatus = dialogRowData.objectionStatus,
    flag_applicantCNICFront,
    flag_applicantCNICBack,
    flag_owenershipDocument,
    flag_electricityBillDocument,
    flag_fbrDocumentParam,
    flag_addDocAnyOtherParam,
    applicantCNICBackObjectionRemarks,
    applicantCNICFrontObjectionRemarks,
    owenershipObjectionRemarks,
    electricityBillObjectionRemarks,
    fbrDocumentObjectionRemarksParam,
    addDocAnyOtherObjectionRemarksParam,
    remarks
  ) => {
    setViewBackdrop(true); // 🔵 Loader ON

    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const remarksDetails = (
        (applicantCNICFrontObjectionRemarks
          ? `Applicant CNIC Front: ${applicantCNICFrontObjectionRemarks}`
          : "") +
        (applicantCNICBackObjectionRemarks
          ? `, Applicant CNIC Back: ${applicantCNICBackObjectionRemarks}`
          : "") +
        (electricityBillObjectionRemarks
          ? `, Electricity Bill Document: ${electricityBillObjectionRemarks}`
          : "") +
        (owenershipObjectionRemarks
          ? `, Ownership Document: ${owenershipObjectionRemarks}`
          : "") +
        (fbrDocumentObjectionRemarksParam
          ? `, FBR Document: ${fbrDocumentObjectionRemarksParam}`
          : "") +
        (addDocAnyOtherObjectionRemarksParam
          ? `, Any Other Document: ${addDocAnyOtherObjectionRemarksParam}`
          : "")
      ).replace(/^, /, "");

      const raw = JSON.stringify({
        applicationId,
        applicationProgressId,
        objectionStatus,
        remarks:
          flag_applicantCNICFront === -1 ||
            flag_applicantCNICBack === -1 ||
            flag_owenershipDocument === -1 ||
            flag_electricityBillDocument === -1 ||
            flag_addDocAnyOtherParam === -1
            ? "Documents Rejected"
            : "Documents Verified",
        remarksDetail: remarksDetails,
        applicantCNICFrontFlag: flag_applicantCNICFront,
        applicantCNICBackFlag: flag_applicantCNICBack,
        electricityBillFlag: flag_electricityBillDocument,
        ownershipImageFlag: flag_owenershipDocument,
        fbrDocumentFlag: flag_fbrDocumentParam ? flag_fbrDocumentParam : null,
        anyOtherDocumentFlag: flag_addDocAnyOtherParam ? flag_addDocAnyOtherParam : null,
        applicantCNICFrontRemarks: applicantCNICFrontObjectionRemarks,
        applicantCNICBackRemarks: applicantCNICBackObjectionRemarks
          ? applicantCNICBackObjectionRemarks
          : "Verified",
        electricityBillRemarks: electricityBillObjectionRemarks,
        ownershipImageRemarks: owenershipObjectionRemarks,
        fbrDocumentRemarks: fbrDocumentObjectionRemarksParam,
        anyOtherDocumentRemarks: addDocAnyOtherObjectionRemarksParam,
      });

      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/verifyDocuments",
        {
          method: "POST",
          headers: myHeaders,
          body: raw,
        }
      );

      const result = await response.json();

      if (result.status === "200") {
        setFlag_owenershipDocument(null);
        setFlag_electricityBillDocument(null);
        setFlag_fbrDocument(null);
        setFlag_addDocAnyOther(null);
        setFlag_applicantCNICBack(null);
        setFlag_applicantCNICFront(null);
        handleClose();
      } else {
        console.error("API Error:", result.message);
      }
    } catch (error) {
      console.error("Fetch Error:", error);
    } finally {
      setViewBackdrop(false); // 🔵 Loader OFF (always)
    }
  };

  const callArrearVerificationAPI = async (
    applicationId,
    applicationProgresId,
    objectionStatuss,
    remarks,
    remarksDetails,
    // billMonth,
    arrearsImg
  ) => {

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: applicationId,
      applicationProgressId: applicationProgresId,
      objectionStatus: objectionStatuss,
      remarks: remarks,
      remarksDetail: remarksDetails,
      arrearsAmount: arrearAmount,
      arrearsMonth: billMonth,
      electricityBill: arrearAmount > 0 ? arrearPaidReceiptImageThumbnail : "",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    try {
      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/processArrearsVerification",
        requestOptions
      );
      const result = await response.json();

      if (result.status === "200") {
        setResponseMessage(result.message);
        setResponseType("success");
        handleClose();
      } else {
        setResponseMessageError(result.message || "Unexpected error occurred.");
        setResponseType("error");
      }

      setOpenResponseModal(true);
      handleClose();
    } catch (error) {
      setResponseMessageError("Something went wrong. Please try again.");
      setResponseType("error");
      setOpenResponseModal(true);
    }

    setDocVerifyAlert(false);
    setArrearsVerifyPopUpOpen(false);
    setFieldVerifyAlert(false);
  };

  const callChangeObjectionStatus = async (
    step,
    objectionStatus,
    remarks,
    remarksDetails = "-"
  ) => {
    var formdata = new FormData();
    formdata.append("applicationId", dialogRowData.applicationId);
    formdata.append("objectionStatus", objectionStatus);
    formdata.append("remarks", remarks);
    formdata.append("remarksDetails", remarksDetails);
    formdata.append("lastModifiedBy", userId);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "comman/changeObjectionStatus", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          // let lclStrdCoNApp = JSON.parse(window.localStorage.getItem('change-of-name-applications'));
          // const index = lclStrdCoNApp.findIndex(item => item.applicationId === dialogRowData.applicationId);
          // lclStrdCoNApp[index].objectionStatus = objectionStatus
          // lclStrdCoNApp[index].remarks = remarks
          // window.localStorage.setItem('change-of-name-applications', JSON.stringify(lclStrdCoNApp));
          // setChangeOfNameApplications(JSON.parse(window.localStorage.getItem('change-of-name-applications')));
          // setOpen(false);
          handleClose();
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => console.log("error", error));
    setArrearRejectionRemovalAlert(false);
    setObjectionPopUpOpen(false);
  };

  useEffect(() => {
    if (
      dialogRowData.applicationProgressId === 2 &&
      dialogRowData.objectionStatus === 1
    ) {
      referenceApi(dialogRowData.referenceNumber);
    }
  }, [dialogRowData]);
  const referenceApi = async (referenceNo = dialogRowData.referenceNumber) => {
    setViewBackdrop(true);
    try {
      let apiResponse = await dBillAPI(token, referenceNo);
      if (apiResponse.status) {
        let basicInfo = apiResponse.basicInfo;
        let histInfo = apiResponse.histInfo;

        if (basicInfo?.netBill && histInfo?.payment13) {
          if (Number(basicInfo.netBill) > Number(histInfo.payment13)) {
            setPaymentStatus("Arrear exists");
            setArrearAmount(basicInfo.netBill);
            setBillMonth(basicInfo.billMonth);
          } else {
            setArrearAmount("");
            setBillMonth("");
            setPaymentStatus("No arrear exists");
          }
        }
      } else {
        console.log("Reference No. not found!");
      }
      setViewBackdrop(false);
    } catch (e) {
      console.log(e, "Error in getting reference number billing details");
    }
  };

  const callAsyncDnDetailsAPI = async (applicationId) => {
    try {
      let dnDets = {};

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: applicationId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "changeOfName/getDNData", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            dnDets = result.data[0];
          }
        })
        .catch((error) => console.log("error", error));
      return dnDets;
    } catch (e) {
      console.log(e, "Unable to get Demand Notice.");
    }
  };

  const callSJOCreationAPI = async (applicationId) => {
    if (applicationId) {
      var formdata = new FormData();
      formdata.append("paidDNImageVerifiedBy", userId);
      formdata.append("applicationId", applicationId);
      formdata.append(
        "subDivisionCode",
        dialogRowData.referenceNumber.slice(2, 7)
      );
      formdata.append("changeofAttributeTypeId", "2");
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "changeOfName/sjoCreation", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            callArrearVerificationAPI(
              dialogRowData.applicationProgressId + 1,
              "DN Payment Verified",
              "",
              dialogRowData.applicationID
            );
          } else {
            console.log(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const callAsyncResetDocsFlags = async (
    applicationId = dialogRowData.applicationId
  ) => {
    var formdata = new FormData();
    formdata.append("applicationNo", applicationId);
    formdata.append("applicantCNICFrontFlag", "");
    formdata.append("applicantCNICBackFlag", "");
    formdata.append("owenershipDocumentFlag", "");
    formdata.append("electricityBillDocumentFlag", "");
    formdata.append("preOwnerCNICFrontFlag", "");
    formdata.append("preOwnerCNICBackFlag", "");
    formdata.append("perOwenerNOCFlag", "");
    formdata.append("newOwenerAffidaviteFlag", "");
    formdata.append("addDocCivicAuthorityFlag", "");
    formdata.append("anyOtherDocumentFlag", "");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "changeOfName/updateCONDocumentFlag",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          let allApplications = changeOfNameApplications;
          let index = changeOfNameApplications.findIndex(
            (item) => item.applicationId === applicationId
          );
          allApplications[index].applicantCNICFrontFlag = null;
          allApplications[index].applicantCNICBackFlag = null;
          allApplications[index].owenershipDocumentFlag = null;
          allApplications[index].electricityBillDocumentFlag = null;
          allApplications[index].preOwnerCNICFrontFlag = null;
          allApplications[index].preOwnerCNICBackFlag = null;
          allApplications[index].perOwenerNOCFlag = null;
          allApplications[index].newOwenerAffidaviteFlag = null;
          allApplications[index].addDocCivicAuthorityFlag = null;
          allApplications[index].anyOtherDocumentFlag = null;
          window.localStorage.setItem(
            "change-of-name-applications",
            JSON.stringify(allApplications)
          );
        } else {
          console.log("Application Documents flags reset has been failed!");
        }
      })
      .catch((error) => console.log("error", error));
  };

  const callAsyncGetConsentImage = async (
    applicationId = dialogRowData.applicationId
  ) => {
    try {
      var formdata = new FormData();
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      formdata.append("applicationId", applicationId);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "changeOfName/getConsentFormForChangeOfName",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setConsentImageDetails(result.data[0]);
          }
        })
        .catch((error) => console.log("error", error));
    } catch (e) {
      console.log(e, "error in get conesnt form");
    }
  };

  const callBillingToGetPreviousSecurity = async (
    referenceNo = dialogRowData.referenceNumber
  ) => {
    try {
      let apiResponse = await dBillAPI(token, referenceNo);
      if (apiResponse.status) {
        let basicInfo = apiResponse.basicInfo;
        let previousSecurity = basicInfo.sec_amnt;
        let sanctionedLoad = basicInfo.sactionLoad ? basicInfo.sactionLoad : 3;
        let connectionCatagoryType = basicInfo.cons_cat;
        if (
          connectionCatagoryType === "DOMESTIC" ||
          connectionCatagoryType === "DOMMESTIC"
        ) {
          setConnectionCategoryType(1);
        } else if (connectionCatagoryType === "COMMERCIAL") {
          setConnectionCategoryType(2);
        } else if (connectionCatagoryType === "INDUSTRIAL") {
          setConnectionCategoryType(3);
        }
        setPreviousSecurity(previousSecurity);
        setSanctionedLoad(sanctionedLoad);
      } else {
        setError("Reference No. not found!");
      }
    } catch (e) {
      console.log(e, "error while fetching previous security");
    }
  };

  const callAsyncCreateDnForChangeOfName = async (
    applicationId = dialogRowData.applicationId
  ) => {
    try {
      var formdata = new FormData();

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      formdata.append("applicationId", applicationId);
      formdata.append(
        "previousSecurity",
        previousSecurity ? previousSecurity : 0
      );
      formdata.append("sanctionLoad", sanctionedLoad ? sanctionedLoad : 1);
      formdata.append(
        "connectionCatagoryType",
        connectionCategoryType ? connectionCategoryType : 1
      );
      formdata.append(
        "roOfficeAddress",
        divisionName(
          parseInt(dialogRowData.referenceNumber.slice(2, 6)),
          subDivisions
        )
      );
      formdata.append(
        "consumerAccountNo",
        dialogRowData.referenceNumber.slice(5)
      );
      formdata.append("batchNo", dialogRowData.referenceNumber.slice(0, 2));
      formdata.append("tariff", "Old Tariff");
      formdata.append("bankName", bankName);
      formdata.append("connectionAccountNo", dialogRowData.referenceNumber);
      formdata.append("filledBy", userId);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "/changeOfName/createDNforChangeOfName",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            callArrearVerificationAPI(
              dialogRowData.applicationProgressId + 2,
              "Demand Note Issued",
              "-",
              dialogRowData.applicationId
            );
          }
        })
        .catch((error) => console.log("error", error));
    } catch (e) {
      console.log(e, "error while creating demand notice");
    }
  };

  const callSJOApproveAPI = async (applicationId) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);
    formdata.append("approvedBy", userId);
    formdata.append("approvedFlag", 1);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "changeOfName/sjoApproval", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callArrearVerificationAPI(
            dialogRowData.applicationProgressId + 1,
            "Service Connection Order Approved",
            "Service Connection Order Approved"
          );
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => console.log(error));
  };

  const callAsyncGetPaidDnImageAPI = async (applicationId) => {
    try {
      let dnImage = "";
      var formdata = new FormData();

      formdata.append("applicationNo", applicationId);
      formdata.append("demandNoticeNo", "");

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "demandNotice/getPaidDNImage", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setPaidDnImageDetails(result.data[0]);
            dnImage = result.data[0].paidDNImage;
          }
        })
        .catch((error) => console.log("error", error));
      return dnImage;
    } catch (e) {
      console.log(e, "Error in calling paid dn image");
    }
  };

  //#endregion

  const tblColumns = [
    {
      field: "applicationId",
      type: "text",
      headerName: "Application No.",
      align: "center",
      sortable: false,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "creationDate",
      type: "date",
      headerName: "Submission Date",
      align: "center",
      sortable: false,
      filterable: true,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "applicantName",
      type: "text",
      headerName: "Applicant Name",
      align: "center",
      sortable: false,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "referenceno",
      type: "text",
      headerName: "Reference No.",
      align: "center",
      sortable: false,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    // {
    //   field: "applicationStatusId",
    //   headerStyle: tableStyle.headerStyle,
    //   headerCellStyle: tableStyle.headerCellStyle,
    //   rowCellStyle: tableStyle.rowCellStyle,
    //   headerName: "Status",
    //   align: "center",
    //   sortable: false,
    //   filterable: true,
    //   type: "singleSelect",
    //   valueOptions: [
    //     "Pending",
    //     "In Process",
    //     "Approved",
    //     "Completed",
    //     "Objection",
    //   ],
    //   renderCell: (params) => {
    //     let btnText = params.applicationStatusId;
    //     return <div className={getClassName(btnText)}>{btnText}</div>;
    //   },
    // },
    // {
    //   field: "description",
    //   type: "dateTime",
    //   headerName: "Description",
    //   align: "center",
    //   sortable: false,
    //   filterable: false,
    //   headerStyle: tableStyle.headerStyle,
    //   headerCellStyle: tableStyle.headerCellStyle,
    //   rowCellStyle: tableStyle.rowCellStyle,
    // },
    {
      field: "applicationStep",
      type: "singleSelect",
      sortable: false,
      filterable: true,
      valueOptions: [
        "Documents Uploading",
        "Documents Verification",
        "Arrear Verification",
        "Field Survey",
        "DN Approval",
        "DN Submission",
        "DN Payment Verification",
        "Sundary Jobs Order",
        "Ready for Billing",
        "Completed",
      ],
      headerName: "Description",
      align: "left",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: { ...tableStyle.rowCellStyle, fontSize: "12px" },
    },
    {
      headerName: "Docs.",
      disableColumnMenu: true,
      sortable: false,
      filterable: false,
      flex: 1,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: { ...tableStyle.rowCellStyle, fontSize: "15px" },
      field: "downloads",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <ActionsCell
            data={params}
            onOpenSRNDialog={() => {
              setSelectedRow(params);
            }}
          />
        );
      },
    },
  ];

  const tblColumnsOverDue = [
    {
      field: "applicationId",
      type: "text",
      headerName: "Application No.",
      align: "center",
      sortable: false,
      filterable: false,
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: tableStyleOverDue.rowCellStyle,
    },
    {
      field: "creationDate",
      type: "date",
      headerName: "Submission Date",
      align: "center",
      sortable: false,
      filterable: true,
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: tableStyleOverDue.rowCellStyle,
    },
    {
      field: "applicantName",
      type: "text",
      headerName: "Applicant Name",
      align: "center",
      sortable: false,
      filterable: false,
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: tableStyleOverDue.rowCellStyle,
    },
    {
      field: "referenceno",
      type: "text",
      headerName: "Reference No.",
      align: "center",
      sortable: false,
      filterable: false,
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: tableStyleOverDue.rowCellStyle,
    },
    // {
    //   field: "applicationStatusId",
    //   headerStyle: tableStyleOverDue.headerStyle,
    //   headerCellStyle: tableStyleOverDue.headerCellStyle,
    //   rowCellStyle: tableStyleOverDue.rowCellStyle,
    //   headerName: "Status",
    //   align: "center",
    //   sortable: false,
    //   filterable: true,
    //   type: "singleSelect",
    //   valueOptions: [
    //     "Pending",
    //     "In Process",
    //     "Approved",
    //     "Completed",
    //     "Objection",
    //   ],
    //   renderCell: (params) => {
    //     let btnText = params.applicationStatusId;
    //     return <div className={getClassName(btnText)}>{btnText}</div>;
    //   },
    // },
    // {
    //   field: "description",
    //   type: "dateTime",
    //   headerName: "Description",
    //   align: "center",
    //   sortable: false,
    //   filterable: false,
    //   headerStyle: tableStyleOverDue.headerStyle,
    //   headerCellStyle: tableStyleOverDue.headerCellStyle,
    //   rowCellStyle: tableStyleOverDue.rowCellStyle,
    // },
    {
      field: "applicationStep",
      type: "singleSelect",
      sortable: false,
      filterable: true,
      align: "center",
      valueOptions: [
        "Documents Uploading",
        "Documents Verification",
        "Arrear Verification",
        "Field Survey",
        "DN Approval",
        "DN Submission",
        "DN Payment Verification",
        "Sundary Jobs Order",
        "Ready for Billing",
        "Completed",
      ],
      headerName: "Description",
      align: "left",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: { ...tableStyleOverDue.rowCellStyle, fontSize: "12px" },
    },
    {
      field: "exceededDuration",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Days",
      align: "center",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: {
        ...tableStyleOverDue.rowCellStyle,
        color: "red",
        minWidth: "20px",
      },
    },
    {
      headerName: "Docs.",
      disableColumnMenu: true,
      sortable: false,
      filterable: false,
      flex: 1,
      filterable: false,
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: { ...tableStyleOverDue.rowCellStyle, fontSize: "15px" },
      field: "downloads",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return <ActionsCell data={params} />;
      },
    },
  ];

  useImperativeHandle(ref, () => ({
    handleRowClick,
  }));
  const location = useLocation();
  const currentPath = location.pathname;
  useEffect(() => {
    if (dialogRowData && dialogRowData.applicationId) {
      // callMaterials(dialogRowData.applicationId);
    }
  }, [dialogRowData]);
  const callMaterials = async (applicationId) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        // subDivisionCode: dialogRowData.applicationId.slice(3, 8)
        // subDivisionCode: '15175'
        subDivisionCode: applicationId.slice(3, 8),
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        "https://eopsapi.pitc.com.pk/enc/getMaterialDetails",
        requestOptions
      );
      const result = await response.json();
      setAllMaterialList(result.data);

      return result.data;
    } catch (e) {
      console.log("Error in callMaterials:", e);
      return [];
    }
  };
  const calculateTotalAmountOfItems = (arrayOfItems) => {
    return arrayOfItems.reduce(
      (total, item) => total + Math.round(Number(item.amount) || 0),
      0
    );
  };
  const calculateCharges = (arrayOfItems, isNC13 = false) => {
    const totalAmountofItems = calculateTotalAmountOfItems(arrayOfItems);
    const store_charges = isNC13 ? 0 : Math.trunc(totalAmountofItems * 0.12);
    const installation_charges = Math.trunc(
      (totalAmountofItems + store_charges) * 0.08
    );

    return { totalAmountofItems, store_charges, installation_charges };
  };
  const onPressAddPrepare = useCallback(() => {
    setShowBoq(true);
  }, []);
  const onSaveCostEstimationConfirm = () => {
    setErrormessageBoqEstimation("");
    setShowBoq(false);
    const BoQItems = itemsArray.map((item) => ({
      qty: String(item.qty),
      itemCode: String(item.item_Code),
      itemAmount: String(item.amount),
    }));
    setBoqItems(BoQItems);
    // }
  };
  const onPressCostEstimationConfirm = () => {
    if (fieldFormik.values.iv_objection_Type == "1") {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: dialogRowData.applicationProgressId + 1,
        objectionStatus: 0,
        remarks: "Field surveyed and Cost estimated.",
        remarksDetail: "Field surveyed and Cost estimated.",
        sketchDiagram: sketchDiagramThumbnail ? sketchDiagramThumbnail : "",
        observationType: fieldFormik.values.iv_objection_Type
          ? fieldFormik.values.iv_objection_Type
          : "",
        alreadyInstalledRefNo: "",
        isMaterialRequired: fieldFormik.values.iv_material_required,
        isMeterNeedsToBeReplaced: fieldFormik.values.iv_meter_to_replace,
        submittedThrough: "e-Operation",
        areaType: fieldFormik.values.iv_area_type
          ? fieldFormik.values.iv_area_type
          : "",
        tariff:
          dialogRowData.changeOfAttributesType == 3 ||
            dialogRowData.changeOfAttributesType == 4 ||
            dialogRowData.changeOfAttributesType == 6 ||
            dialogRowData.changeOfAttributesType == 7
            ? dialogRowData.newTariff?.replace(/-/g, "")
            : dialogRowData.currentTariff?.replace(/-/g, ""),
        sanctionLoad:
          dialogRowData.changeOfAttributesType == 2 ||
            dialogRowData.changeOfAttributesType == 4 ||
            dialogRowData.changeOfAttributesType == 5 ||
            dialogRowData.changeOfAttributesType == 7
            ? dialogRowData.newSanctionLoad
            : dialogRowData.currentSanctionLoad,
        bankName: bankName,
        isBatchChangeRequired: fieldFormik.values.iv_batch_change,
        batchNo: fieldFormik.values.iv_batch ? fieldFormik.values.iv_batch : "",
        subBatchNo: fieldFormik.values.iv_sub_batch
          ? fieldFormik.values.iv_sub_batch
          : "",
        connectionAccountNo:
          fieldFormik.values.iv_batch_change === false
            ? dialogRowData.referenceNumber
            : fieldFormik.values.iv_batch +
            partialValue +
            fieldFormik.values.iv_reference_to_allot,
        amountOfGridSharing: gridSharingCost ? gridSharingCost : 0,
        amountOfFeederRehab: feederRehabilitationCharges
          ? feederRehabilitationCharges
          : 0,
        civilWorkCharges: civilWorkCharges ? civilWorkCharges : 0,
        fixedChargesOfMetering: fixedChargesOfMetering
          ? fixedChargesOfMetering
          : 0,
        miscellaneousCharges: miscellaneousCharges ? miscellaneousCharges : 0,
        lessTheCost: lessTheCost ? lessTheCost : 0,
        mtCharges: mntCharges ? mntCharges : 0,
        labourCharges: labourCharges ? labourCharges : 0,
        designVetteingFee: designVettingFee ? designVettingFee : 0,
        consultancyCharges: consultancyCharges ? consultancyCharges : 0,
        variationsCharges: variationCharges ? variationCharges : 0,
        dismentalmentCharges: dismantlementCharges ? dismantlementCharges : 0,
        earthingCharges: earthingCharges ? earthingCharges : 0,
        capitalCostAmount:
          boqItems && boqItems.length > 0
            ? (itemsAmount || 0) +
            (dialogRowData?.applicationId?.slice(3, 5) === "13" ? 0 : (storeCharges || 0)) +
            (installationCharges || 0) +
            (civilWorkCharges || 0) +
            (fixedChargesOfMetering || 0) +
            (gridSharingCost || 0) +
            (feederRehabilitationCharges || 0) +
            (miscellaneousCharges || 0) +
            (mntCharges || 0) +
            (labourCharges || 0) +
            (designVettingFee || 0) +
            (consultancyCharges || 0) +
            (variationCharges || 0) +
            (dismantlementCharges || 0) +
            (earthingCharges || 0) -
            (lessTheCost || 0)
            : (costEstimationForNC?.estimatedCapitalCost) + (gridSharingCost || 0) + (feederRehabilitationCharges || 0) || 0,
        securityDepositAmount: (costEstimationForNC?.estimatedSecurityAmount)
          ? Math.max(
            (Number(costEstimationForNC?.estimatedSecurityAmount) || 0) -
            (Number(costEstimationForNC?.currentSecurityAmount) || 0),
            0
          )
          : 0,
        estimatedSecurityAmount: costEstimationForNC?.estimatedSecurityAmount
          ? costEstimationForNC?.estimatedSecurityAmount
          : 0,
        meterType: fieldFormik.values.iv_meter_type,
        BoQItems: boqItems ? boqItems : [],
        seasonalFlag: fieldFormik.values.iv_seasonal,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        cfpBaseUrl + "changeOfAttributes/saveFieldSurveyAndCostEstimateForCOA",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          setViewBackdrop(false);
          setShowCostEstimation(false);
          handleClose();
        })
        .catch((error) => console.error(error));
    } else {
    }
  };
  const deleteItem = (code) => {
    let itemsInArray = [...itemsArray];
    const index = itemsInArray.findIndex((item) => item.Id === code);

    if (index !== -1) {
      itemsInArray.splice(index, 1);

      const isNC13 = dialogRowData?.applicationId?.slice(3, 5) === "13";
      const { totalAmountofItems, store_charges, installation_charges } =
        calculateCharges(itemsInArray, isNC13);

      const total_charges =
        totalAmountofItems + store_charges + installation_charges;

      fieldItemFormik.setFieldValue("iv_items_array", itemsInArray);
      setItemsAmount(totalAmountofItems);
      setStoreCharges(store_charges);
      setInstallationCharges(installation_charges);
      setTotalCharges(total_charges);
      setItemsArray(itemsInArray);
    }
  };

  const updateItemQtyByDelta = (code, delta) => {
    if (dnDetails && dnDetails.filledFlag === 1) return;

    let itemsInArray = [...itemsArray];
    const index = itemsInArray.findIndex((item) => item.Id === code);
    if (index === -1) return;

    const currentQty = parseInt(itemsInArray[index].qty, 10) || 0;
    const nextQty = Math.max(1, currentQty + delta);
    itemsInArray[index].qty = nextQty;
    itemsInArray[index].amount = Math.round(
      nextQty * parseFloat(itemsInArray[index].rate || 0)
    );

    const isNC13 = dialogRowData?.applicationId?.slice(3, 5) === "13";
    const { totalAmountofItems, store_charges, installation_charges } =
      calculateCharges(itemsInArray, isNC13);
    const total_charges =
      totalAmountofItems + store_charges + installation_charges;

    fieldItemFormik.setFieldValue("iv_items_array", itemsInArray);
    setItemsAmount(totalAmountofItems);
    setStoreCharges(store_charges);
    setInstallationCharges(installation_charges);
    setTotalCharges(total_charges);
    setItemsArray(itemsInArray);
  };
  const fieldItemFormik = useFormik({
    initialValues: {
      iv_fieldItemId: "",
      iv_fieldItemQty: "",
      iv_fieldItemRate: "",
      iv_fieldItemUnit: "",
      iv_fieldItemAmount: "",
      iv_items_array: itemsArray,
    },
    validationSchema: Yup.object().shape({
      iv_fieldItemId: Yup.mixed().required("Select the item from list."),
      iv_fieldItemQty: Yup.number()
        .typeError("Enter qty.")
        .integer("Fractional qty not allowed.")
        .moreThan(0, "Qty must be greater than 0.")
        .required("Enter qty."),
      iv_fieldItemRate: Yup.string().optional(),
      iv_fieldItemUnit: Yup.string().optional(),
      iv_fieldItemAmount: Yup.string().optional(),
    }),
    // onSubmit: (values, { resetForm }) => {
    //   let itemToBeAdded = {};
    //   let arrayOfItems = [...itemsArray];
    //   itemToBeAdded.Id = values.iv_fieldItemId;

    //   let alreadyPresent = arrayOfItems.find(item => item.Id === itemToBeAdded.Id);

    //   if (alreadyPresent) {
    //     const index = arrayOfItems.findIndex(item => item.Id === itemToBeAdded.Id);
    //     arrayOfItems[index].qty = (parseInt(arrayOfItems[index].qty) + parseInt(values.iv_fieldItemQty)).toString();
    //     arrayOfItems[index].amount = parseInt(arrayOfItems[index].qty) * parseInt(arrayOfItems[index].rate);
    //   } else {
    //     let it = allMaterialList.find(item => item.Id === itemToBeAdded.Id);
    //     if (it) {
    //       itemToBeAdded.name = it.ItemName;
    //       itemToBeAdded.Id = it.Id;
    //       itemToBeAdded.itemCode = it.ItemCode;
    //     }
    //     itemToBeAdded.qty = values.iv_fieldItemQty;
    //     itemToBeAdded.rate = values.iv_fieldItemRate;
    //     itemToBeAdded.unit = values.iv_fieldItemUnit;
    //     itemToBeAdded.amount = parseInt(values.iv_fieldItemQty) * parseInt(values.iv_fieldItemRate);
    //     arrayOfItems.push(itemToBeAdded);
    //   }

    //   const { totalAmountofItems, store_charges, installation_charges } = calculateCharges(arrayOfItems);

    //   const total_charges = totalAmountofItems + store_charges + installation_charges

    //   setItemsAmount(totalAmountofItems);
    //   setStoreCharges(store_charges);
    //   setInstallationCharges(installation_charges);
    //   setTotalCharges(total_charges);
    //   setItemsArray(arrayOfItems);
    //   resetForm();
    // }
    onSubmit: (values, { resetForm }) => {
      let itemToBeAdded = {};
      let arrayOfItems = [...itemsArray];

      const qty = parseInt(values.iv_fieldItemQty, 10);
      const rate = parseFloat(values.iv_fieldItemRate);

      if (isNaN(qty) || qty <= 0) {
        return;
      }
      if (isNaN(rate) || rate < 0) {
        return;
      }

      itemToBeAdded.item_Code = values.iv_fieldItemId;

      let alreadyPresent = arrayOfItems.find(
        (item) => item.item_Code === itemToBeAdded.item_Code
      );

      if (alreadyPresent) {
        const index = arrayOfItems.findIndex(
          (item) => item.item_Code === itemToBeAdded.item_Code
        );
        arrayOfItems[index].qty = parseInt(arrayOfItems[index].qty, 10) + qty;
        arrayOfItems[index].amount = Math.round(
          arrayOfItems[index].qty * parseFloat(arrayOfItems[index].rate)
        );
      } else {
        let it = allMaterialList.find(
          (item) => item.item_Code === itemToBeAdded.item_Code
        );
        if (it) {
          itemToBeAdded.item_Code = it.item_Code;
          itemToBeAdded.item_Name = it.item_Name;
          itemToBeAdded.unit = it.item_Unit;
          itemToBeAdded.rate = it.item_Amount;
        } else {
          return;
        }
        itemToBeAdded.qty = qty;
        itemToBeAdded.amount = Math.round(qty * itemToBeAdded.rate);
        arrayOfItems.push(itemToBeAdded);
      }

      const isNC13 = dialogRowData?.applicationId?.slice(3, 5) === "13";
      const { totalAmountofItems, store_charges, installation_charges } =
        calculateCharges(arrayOfItems, isNC13);

      const total_charges =
        totalAmountofItems + store_charges + installation_charges;

      setItemsAmount(totalAmountofItems);
      setStoreCharges(store_charges);
      setInstallationCharges(installation_charges);
      setTotalCharges(total_charges);
      setItemsArray(arrayOfItems);

      resetForm();
    },
  });

  const sanitizeWholeNumberInput = (value) =>
    String(value ?? "")
      .replace(/,/g, "")
      .replace(/[^\d]/g, "");

  const formatWholeNumberInput = (value) => {
    const sanitized = sanitizeWholeNumberInput(value);
    if (!sanitized) {
      return "";
    }

    return Number(sanitized).toLocaleString("en-US");
  };

  const handleWholeNumberFieldChange = (fieldName, setter) => (event) => {
    const sanitized = sanitizeWholeNumberInput(event.target.value);
    fieldFormik.setFieldValue(fieldName, sanitized);
    setter(sanitized === "" ? 0 : Number(sanitized));
  };
  useEffect(() => {
    if (fieldItemFormik.values.iv_fieldItemId) {

      let item = allMaterialList.find(
        (item) => item.item_Code === fieldItemFormik.values.iv_fieldItemId
      );

      fieldItemFormik.values.iv_fieldItemRate = item.item_Amount;
      fieldItemFormik.values.iv_fieldItemUnit = item.item_Unit;
    }
  }, [fieldItemFormik.values.iv_fieldItemId]);

  useEffect(() => {
    let totalCost = totalCharges;

    const totalChargesValue = isNaN(parseInt(totalCharges))
      ? 0
      : parseInt(totalCharges);
    const gridSharingCostValue = isNaN(parseInt(gridSharingCost))
      ? 0
      : parseInt(gridSharingCost);
    const feederRehabilitationChargesValue = isNaN(
      parseInt(feederRehabilitationCharges)
    )
      ? 0
      : parseInt(feederRehabilitationCharges);
    const civilWorkChargesValue = isNaN(parseInt(civilWorkCharges))
      ? 0
      : parseInt(civilWorkCharges);
    const fixedChargesOfMeteringValue = isNaN(parseInt(fixedChargesOfMetering))
      ? 0
      : parseInt(fixedChargesOfMetering);
    const miscellaneousChargesValue = isNaN(parseInt(miscellaneousCharges))
      ? 0
      : parseInt(miscellaneousCharges);
    const lessTheCostValue = isNaN(parseInt(lessTheCost))
      ? 0
      : parseInt(lessTheCost);
    const mntChargesValue = isNaN(parseInt(mntCharges))
      ? 0
      : parseInt(mntCharges);
    const labourChargesValue = isNaN(parseInt(labourCharges))
      ? 0
      : parseInt(labourCharges);
    const designVettingFeeValue = isNaN(parseInt(designVettingFee))
      ? 0
      : parseInt(designVettingFee);
    const consultancyChargesValue = isNaN(parseInt(consultancyCharges))
      ? 0
      : parseInt(consultancyCharges);
    const variationChargesValue = isNaN(parseInt(variationCharges))
      ? 0
      : parseInt(variationCharges);
    const dismantlementChargesValue = isNaN(parseInt(dismantlementCharges))
      ? 0
      : parseInt(dismantlementCharges);
    const earthingChargesValue = isNaN(parseInt(earthingCharges))
      ? 0
      : parseInt(earthingCharges);

    totalCost =
      totalChargesValue +
      gridSharingCostValue +
      feederRehabilitationChargesValue +
      civilWorkChargesValue +
      fixedChargesOfMeteringValue +
      miscellaneousChargesValue +
      mntChargesValue +
      labourChargesValue +
      designVettingFeeValue +
      consultancyChargesValue +
      variationChargesValue +
      dismantlementChargesValue +
      earthingChargesValue -
      lessTheCostValue;

    setGrandTotalCharges(totalCost);
  }, [
    civilWorkCharges,
    fixedChargesOfMetering,
    miscellaneousCharges,
    lessTheCost,
    totalCharges,
    gridSharingCost,
    feederRehabilitationCharges,
    mntCharges,
    labourCharges,
    designVettingFee,
    consultancyCharges,
    variationCharges,
    dismantlementCharges,
    earthingCharges,
  ]);
  useEffect(() => {
    if (!boqItems || boqItems.length === 0) {
      fieldFormik.setFieldValue("iv_grid_sharing_cost", 0);
      setGridSharingCost(0);

      fieldFormik.setFieldValue("iv_feeder_rehab_charges", 0);
      setFeederRehabilitationCharges(0);
      fieldFormik.setFieldValue("iv_civil_work_charges", 0);
      setCivilWorkCharges(0);
      fieldFormik.setFieldValue("iv_miscellaneous_charges", 0);
      setMiscellaneousCharges(0);
      fieldFormik.setFieldValue("iv_fixed_charges_of_metering", 0);
      setFixedChargesOfMetering(0);
      fieldFormik.setFieldValue("iv_less_the_cost", 0);
      setLessTheCost(0);
      // Reset new charge fields
      fieldFormik.setFieldValue("iv_mnt_charges", 0);
      setMntCharges(0);
      fieldFormik.setFieldValue("iv_labour_charges", 0);
      setLabourCharges(0);
      fieldFormik.setFieldValue("iv_design_vetting_fee", 0);
      setDesignVettingFee(0);
      fieldFormik.setFieldValue("iv_consultancy_charges", 0);
      setConsultancyCharges(0);
      fieldFormik.setFieldValue("iv_variation_charges", 0);
      setVariationCharges(0);
      fieldFormik.setFieldValue("iv_dismantlement_charges", 0);
      setDismantlementCharges(0);
      fieldFormik.setFieldValue("iv_earthing_charges", 0);
      setEarthingCharges(0);
    }
  }, [boqItems]);

  useEffect(() => {
    if (dialogRowData && dialogRowData.areaType) {
      const areaType = dialogRowData.areaType.toLowerCase();

      if (areaType === "u") {
        fieldFormik.setFieldValue("iv_area_type", "U");
      } else if (areaType === "r") {
        fieldFormik.setFieldValue("iv_area_type", "R");
      }
    }
  }, [dialogRowData]);

  const handleCostEstimationClose = () => {
    setShowCostEstimation(false);
  };

  useEffect(() => {
    if (dialogRowData.objectionStatus !== 1) {
      fieldFormik.setFieldValue("iv_objection_Type", 1);
    }
  }, [dialogRowData]);

  const getTableRows = (data) => {
    const type = data.changeOfAttributesType;

    const rows = [];

    // Owner Change: Types 1,4,5,6
    if ([1, 5, 6].includes(type)) {
      rows.push({
        label: "Name",
        current: data.currentOwnerName,
        newVal: `${data.applicantName || ""} ${data.applicantGuardianType == 1
          ? "S/O"
          : data.applicantGuardianType == 2
            ? "D/O"
            : data.applicantGuardianType == 3
              ? "W/O"
              : data.applicantGuardianType == 4
                ? "C/O"
                : ""
          } ${data.applicantGuardianName || ""}`.trim(),
      });
      rows.push({
        label: "CNIC",
        current: data.currentOwnerCNIC,
        newVal: data.applicantCNIC,
      });
      rows.push({
        label: "Phone No.",
        current: data.currentOwnerPhoneNo,
        newVal: data.applicantPhoneNo,
      });
      rows.push({
        label: "Email",
        current: data.currentOwnerEmail,
        newVal: data.applicantEmail,
      });
    }

    if ([4].includes(type)) {
      rows.push({
        label: "Name",
        current: data.currentOwnerName,
        newVal: `${data.applicantName || ""} ${data.applicantGuardianType == 1
          ? "S/O"
          : data.applicantGuardianType == 2
            ? "D/O"
            : data.applicantGuardianType == 3
              ? "W/O"
              : data.applicantGuardianType == 4
                ? "C/O"
                : ""
          } ${data.applicantGuardianName || ""}`.trim(),
      });
      rows.push({
        label: "CNIC",
        current: data.currentOwnerCNIC,
        newVal: data.applicantCNIC,
      });
      rows.push({
        label: "Phone No.",
        current: data.currentOwnerPhoneNo,
        newVal: data.applicantPhoneNo,
      });
      rows.push({
        label: "Email",
        current: data.currentOwnerEmail,
        newVal: data.applicantEmail,
      });
      rows.push({
        label: "Tariff",
        current: data.currentTariff,
        newVal: data.newTariff,
      });
      rows.push({
        label: "Load",
        current: data.currentSanctionLoad,
        newVal: data.newSanctionLoad,
      });
    }
    if ([3, 6, 7].includes(type)) {
      rows.push({
        label: "Tariff",
        current: data.currentTariff,
        newVal: data.newTariff,
      });
    }
    if ([5].includes(type)) {
      rows.push({
        label: "Load",
        current: data.currentSanctionLoad,
        newVal: data.newSanctionLoad,
      });
    }
    if ([2, 7].includes(type)) {
      rows.push({
        label: "Load",
        current: data.currentSanctionLoad,
        newVal: data.newSanctionLoad,
      });
    }

    return rows;
  };

  const formatCoaApplicantDisplayName = (row, useApplicantFields = false) => {
    if (!row) return "";

    if (!useApplicantFields) {
      const currentName = row.currentOwnerName;
      if (currentName && String(currentName).trim()) {
        return String(currentName).trim();
      }
    }

    const guardianLabel =
      row.applicantGuardianType == 1
        ? "S/O"
        : row.applicantGuardianType == 2
          ? "D/O"
          : row.applicantGuardianType == 3
            ? "W/O"
            : row.applicantGuardianType == 4
              ? "C/O"
              : "";

    return `${row.applicantName || ""} ${guardianLabel} ${row.applicantGuardianName || ""}`.trim();
  };

  const displayCoaComparisonValue = (value) => {
    if (value === null || value === undefined) return "-";
    if (typeof value === "number") return String(value);
    return String(value).trim() ? String(value).trim() : "-";
  };

  const getCoaApplicationUpdatedTableRows = (
    historyRow,
    applicationRow = dialogRowData
  ) => {
    const type = Number(historyRow?.changeOfAttributesType);
    const hist = historyRow || {};
    const app = applicationRow || {};
    const rows = [];

    const previousValue = (historyKey, applicationKey) =>
      displayCoaComparisonValue(
        hist[historyKey] ?? app[applicationKey ?? historyKey]
      );

    const updatedValue = (primaryKey, fallbackKey) =>
      displayCoaComparisonValue(
        hist[primaryKey] ?? (fallbackKey ? hist[fallbackKey] : undefined)
      );

    if (coaIncludesName(type)) {
      rows.push({
        label: "Name",
        current: displayCoaComparisonValue(
          hist.currentOwnerName ??
            app.currentOwnerName ??
            formatCoaApplicantDisplayName(app, false)
        ),
        newVal: displayCoaComparisonValue(
          formatCoaApplicantDisplayName(hist, true)
        ),
      });
      rows.push({
        label: "CNIC",
        current: previousValue("currentOwnerCNIC", "currentOwnerCNIC"),
        newVal: updatedValue("applicantCNIC"),
      });
      rows.push({
        label: "Phone No.",
        current: previousValue("currentOwnerPhoneNo", "currentOwnerPhoneNo"),
        newVal: updatedValue("applicantPhoneNo"),
      });
      rows.push({
        label: "Email",
        current: previousValue("currentOwnerEmail", "currentOwnerEmail"),
        newVal: updatedValue("applicantEmail"),
      });
    }

    if (coaIncludesTariff(type)) {
      rows.push({
        label: "Tariff",
        current: previousValue("currentTariff", "currentTariff"),
        newVal: updatedValue("newTariff", "tariff"),
      });
    }

    if (coaIncludesLoad(type)) {
      rows.push({
        label: "Load",
        current: previousValue("currentSanctionLoad", "currentSanctionLoad"),
        newVal: updatedValue("newSanctionLoad", "sanctionLoad"),
      });
    }

    return rows;
  };

  const getTariff = (
    appliedLoad,
    connectionType,
    seasonalNonSeasonal,
    tariffs
  ) => {
    if (tariffs) {
      let tariff = "";
      if (connectionType === "Industrial") {
        if (seasonalNonSeasonal == 1) {
          const seasonalTariff = tariffs.find(
            (item) => item.tariffCode === "F"
          );
          if (seasonalTariff) {
            tariff = seasonalTariff.tariffName;
          } else {
            tariff = "";
          }
        } else if (seasonalNonSeasonal == 0 || !seasonalNonSeasonal) {
          let shortListedTariffsArray = tariffs.filter(
            (item) => item.consumerType === connectionType
          );
          shortListedTariffsArray = shortListedTariffsArray.filter(
            (item) =>
              parseInt(item.from) <= appliedLoad &&
              parseInt(item.to) > appliedLoad
          );
          let selectedTariff = shortListedTariffsArray[0];
          if (selectedTariff) {
            tariff = selectedTariff.tariffName;
          } else {
            tariff = "";
          }
        }
      } else {
        if (appliedLoad && appliedLoad > 0 && tariffs) {
          let shortListedTariffsArray = tariffs.filter(
            (item) => item.consumerType === connectionType
          );
          shortListedTariffsArray = shortListedTariffsArray.filter(
            (item) =>
              parseInt(item.from) <= appliedLoad &&
              parseInt(item.to) > appliedLoad
          );
          tariff = shortListedTariffsArray[0]
            ? shortListedTariffsArray[0].tariffName
            : "-";
        } else {
          tariff = "";
        }
      }
      return tariff;
    }
  };

  const pdfjsLib = window.pdfjsLib;
  pdfjsLib.GlobalWorkerOptions.workerSrc =
    "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.379/pdf.worker.min.mjs";

  const pdfToImage = async (base64) => {
    const pdfData = atob(base64.replace("data:application/pdf;base64,", ""));
    const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
    const page = await pdf.getPage(1);

    const viewport = page.getViewport({ scale: 1.5 });
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    canvas.height = viewport.height;
    canvas.width = viewport.width;

    await page.render({ canvasContext: context, viewport }).promise;
    return canvas.toDataURL("image/png");
  };

  useEffect(() => {
    const convert = async () => {
      if (
        dialogRowData.applicantCNICFront?.startsWith("data:application/pdf")
      ) {
        const img = await pdfToImage(dialogRowData.applicantCNICFront);
        setFrontImg(img);
      } else {
        setFrontImg(dialogRowData.applicantCNICFront);
      }

      if (dialogRowData.applicantCNICBack?.startsWith("data:application/pdf")) {
        const img = await pdfToImage(dialogRowData.applicantCNICBack);
        setBackImg(img);
      } else {
        setBackImg(dialogRowData.applicantCNICBack);
      }
    };

    convert();
  }, [dialogRowData]);

  const errorCloses = () => {
    setReadyForBillingError("");
  };

  return (
    <>
      {props.showTable && currentPath == "/change-of-attributes-table" && (
        <Box className="form-box">
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Box className="application-table" style={{ marginRight: "10px" }}>
              {code == 10 ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box>
                    <h3 style={{ color: "#006ad1", marginBottom: "10px" }}>
                      Change of Attribute ({" "}
                      {numberFormatting(totalRecordsNormal)
                        ? numberFormatting(totalRecordsNormal)
                        : "-"}{" "}
                      )
                    </h3>
                  </Box>

                  <Box style={{ marginBottom: "1px" }}>
                    <FormControl sx={{ minWidth: 200 }} variant="outlined">
                      <Select
                        value={selectedOfficeCode}
                        onChange={(e) => setSelectedOfficeCode(e.target.value)}
                        sx={{
                          backgroundColor: "white",
                          "& .MuiSelect-select": {
                            padding: "7.5px 14px",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid lightgray",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid lightgray",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid lightgray",
                          },
                        }}
                        renderValue={(selected) => {
                          const company = companies.find(
                            (c) => c.code === selected
                          );
                          return company ? (
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <img
                                src={company.logo}
                                alt={`${company.name} logo`}
                                style={{
                                  width: 30,
                                  height: 30,
                                  marginRight: 20,
                                }}
                              />
                              {company.name}
                            </div>
                          ) : (
                            "Select a company"
                          );
                        }}
                      >
                        {companies.map((company) => (
                          <MenuItem key={company.code} value={company.code}>
                            <ListItemIcon>
                              <img
                                src={company.logo}
                                alt={`${company.name} logo`}
                                style={{
                                  width: 30,
                                  height: 30,
                                  marginRight: 20,
                                }}
                              />
                            </ListItemIcon>
                            <ListItemText primary={company.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Box>
              ) : (
                <h3 style={{ color: "#006ad1", marginBottom: "10px" }}>
                  Change of Attribute ({" "}
                  {numberFormatting(totalRecordsNormal)
                    ? numberFormatting(totalRecordsNormal)
                    : "-"}{" "}
                  )
                </h3>
              )}
              <div className="div-datagrid">
                <BasicTable
                  columns={tblColumns}
                  data={changeOfNameApplicationsToDataGrid}
                  handleRowClick={(params) =>
                    handleRowClick(params.applicationId)
                  }
                  sx={tableStyle}
                  rowHeight={37.5}
                  pageSize={20}
                  totalPages={totalPagesNormal}
                  totalRecords={totalRecordsNormal}
                  currentPage={currentPageNormal}
                  handleFilterDateFrom={handleDateFromFilterNormal}
                  handleFilterDateTo={handleDateToFilterNormal}
                  resetDateFilter={handleResetDateFilterNormal}
                  handleFilterProgressId={handleProgressIdFilterNormal}
                  handleFilterObjectionStatus={
                    handleObjectionStatusFilterNormal
                  }
                  resetProgressIdFilter={handleResetProgressIdFilterNormal}
                  resetObjectionStatusFilter={
                    handleResetObjectionStatusFilterNormal
                  }
                  firstPage={handleFirstPageNormal}
                  nextPage={handleNextPageNormal}
                  isLoading={isLoad}
                  previousPage={handlePreviousPageNormal}
                  lastPage={handleLastPageNormal}
                  rowsPerPageOptions={[18, 30, 60]}
                  rowsPageOption={false}
                  getRowStyle={(params) => {
                    return params.indexRelativeToCurrentPage % 2 === 0
                      ? tableStyle.evenRow
                      : tableStyle.oddRow;
                  }}
                />
              </div>
            </Box>
            <Box className="application-table">
              <div style={{ display: "flex", alignItems: "end" }}>
                <h3 style={{ color: "#9d192f", marginBottom: "10px" }}>
                  <img
                    src={warning}
                    alt="icon"
                    style={{ width: "1vw", marginRight: "5px" }}
                  />
                  Over Due Applications ({" "}
                  {numberFormatting(totalRecordsOverdue)
                    ? numberFormatting(totalRecordsOverdue)
                    : "-"}{" "}
                  )
                </h3>
              </div>
              <div className="div-datagrid">
                <BasicTable
                  columns={tblColumnsOverDue}
                  data={changeOfNameApplicationsOverDueToDataGrid}
                  handleRowClick={(params) =>
                    handleRowClick(params.applicationId)
                  }
                  sx={tableStyleOverDue}
                  rowHeight={37.5}
                  pageSize={20}
                  firstPage={handleFirstPageOverdue}
                  lastPage={handleLastPageOverdue}
                  nextPage={handleNextPageOverdue}
                  previousPage={handlePreviousPageOverdue}
                  handleFilterDateFrom={handleDateFromFilterOverdue}
                  handleFilterDateTo={handleDateToFilterOverdue}
                  resetDateFilter={handleResetDateFilterOverdue}
                  resetProgressIdFilter={handleResetProgressIdFilterOverdue}
                  resetObjectionStatusFilter={
                    handleResetObjectionStatusFilterOverdue
                  }
                  handleFilterProgressId={handleProgressIdFilterOverdue}
                  handleFilterObjectionStatus={
                    handleObjectionStatusFilterOverdue
                  }
                  totalPages={totalPagesOverdue}
                  totalRecords={totalRecordsOverdue}
                  isLoading={isLoadd}
                  currentPage={currentPageOverdue}
                  rowsPerPageOptions={[18, 30, 60]}
                  rowsPageOption={false}
                  getRowStyle={(params) => {
                    return params.indexRelativeToCurrentPage % 2 === 0
                      ? tableStyleOverDue.evenRow
                      : tableStyleOverDue.oddRow;
                  }}
                />
              </div>
            </Box>
          </div>
        </Box>
      )}

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth={"false"}
        className="main-dialog"
      >
        <DialogTitle className="dialog-title">
          <Grid container spacing={1} className="headercontainer">
            <Grid item lg={0.5}></Grid>
            <Grid item lg={11} className="applicationTitleGrid">
              <Typography className="applicationTitleText">
                Change of{" "}
                {dialogRowData.changeOfAttributesType == 1
                  ? "Name"
                  : dialogRowData.changeOfAttributesType == 2
                    ? "Load"
                    : dialogRowData.changeOfAttributesType == 3
                      ? "Tariff"
                      : dialogRowData.changeOfAttributesType == 4
                        ? "Name, Load and Tariff"
                        : dialogRowData.changeOfAttributesType == 5
                          ? "Name and Load"
                          : dialogRowData.changeOfAttributesType == 6
                            ? "Name and Tariff"
                            : dialogRowData.changeOfAttributesType == 7
                              ? "Load and Tariff"
                              : ""}{" "}
                -
                <span style={{ color: "white" }}>
                  {dialogRowData.applicationProgressId === 0 &&
                    " Document Submission"}
                  {dialogRowData.applicationProgressId === 1 &&
                    " Document Verification"}
                  {dialogRowData.applicationProgressId === 2 &&
                    " Arrear Verification"}
                  {dialogRowData.applicationProgressId === 3 &&
                    " Field Survey"}
                  {dialogRowData.applicationProgressId === 4 && " DN Approval"}
                  {dialogRowData.applicationProgressId === 5 && "DN Submission"}
                  {dialogRowData.applicationProgressId === 6 &&
                    " DN Payment Verification"}
                  {dialogRowData.applicationProgressId === 7 &&
                    " Sundary Jobs Order"}
                  {dialogRowData.applicationProgressId === 8 &&
                    " Ready For Billing"}
                  {dialogRowData.applicationProgressId === 9 && " Completed"}
                </span>
              </Typography>
            </Grid>
            <Grid item lg={0.25} sx={{ marginTop: "0.5%" }}>
              <PrintIcon
                onClick={() => downloadEFile(dialogRowData)}
                sx={{ cursor: "pointer", color: "white" }}
              />
            </Grid>
            <Grid item lg={0.25} className="closeIcon">
              <CloseIcon
                id="clearPopup"
                onClick={handleClose}
                sx={{ color: "white" }}
              />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div" className="dialog-content">
            <Grid container spacing={1} className="headercontainer">
              <Grid item lg={12} className="status-bar">
                <StepProgressBar
                  array={CONStatusBarArray}
                  applicationProgressId={dialogRowData.applicationProgressId}
                  pageName="Change of Name"
                />
              </Grid>
              <Grid item lg={12} className="application-details" style={{ position: 'relative' }}>
                {/* Edit Button - all change-of-attribute types (before DN Approval) */}
                {dialogRowData.applicationProgressId < 4 &&
                  CheckPermissions(
                    permissions,
                    "General Services",
                    "Change of Attributes",
                    "Basic Permissions",
                    "Update"
                  ) && (
                    <img
                      src={pencilIcon}
                      alt="edit"
                      width={20}
                      height={20}
                      style={{
                        position: "absolute",
                        right: 10,
                        top: 10,
                        cursor: "pointer",
                        zIndex: 10,
                      }}
                      onClick={() => {
                        // Extract unique circles from subDivisions
                        const circles = [];
                        const circleMap = {};
                        subDivisions?.forEach(sd => {
                          if (sd.circleCode && !circleMap[sd.circleCode]) {
                            circleMap[sd.circleCode] = true;
                            circles.push({ code: sd.circleCode, name: sd.circleName || sd.circleCode });
                          }
                        });
                        setEditCircleList(circles);

                        // Extract divisions for current circle
                        const divisions = [];
                        const divisionMap = {};
                        subDivisions?.forEach(sd => {
                          if (sd.circleCode == dialogRowData.circleCode && sd.divisionCode && !divisionMap[sd.divisionCode]) {
                            divisionMap[sd.divisionCode] = true;
                            divisions.push({ code: sd.divisionCode, name: sd.divisionName || sd.divisionCode });
                          }
                        });
                        setEditDivisionList(divisions);

                        // Extract subdivisions for current division
                        const subdivisionsList = [];
                        subDivisions?.forEach(sd => {
                          if (sd.divisionCode == dialogRowData.divisionCode && sd.subDivisionCode) {
                            subdivisionsList.push({ code: sd.subDivisionCode, name: sd.subDivisionName || sd.subDivisionCode });
                          }
                        });
                        setEditSubDivisionList(subdivisionsList);

                        setEditFormData({
                          // Common fields
                          referenceNo: dialogRowData.referenceNumber || "",
                          address: dialogRowData.consumerAddress || "",
                          connectionType: dialogRowData.newConnectionType || "",
                          tariff: dialogRowData.currentTariff || "",
                          city: dialogRowData.cityDistrict || "",
                          circle: dialogRowData.circleCode || "",
                          division: dialogRowData.divisionCode || "",
                          subdivision: dialogRowData.subDivisionCode || "",
                          // Change of Name fields
                          currentName: dialogRowData.currentOwnerName || "",
                          currentCNIC: dialogRowData.currentOwnerCNIC || "",
                          currentPhone: dialogRowData.currentOwnerPhoneNo || "",
                          newName: dialogRowData.applicantName || "",
                          newCNIC: dialogRowData.applicantCNIC || "",
                          newPhone: dialogRowData.applicantPhoneNo || "",
                          relation: dialogRowData.applicantGuardianType || "",
                          guardianName: dialogRowData.applicantGuardianName || "",
                          telcoCode: dialogRowData.telcoCode || "",
                          newEmail: dialogRowData.applicantEmail || "",
                          // Change of Load fields
                          loadChangeType:
                            dialogRowData.changeOfLoadType != null &&
                            dialogRowData.changeOfLoadType !== ""
                              ? String(dialogRowData.changeOfLoadType)
                              : "",
                          currentLoad: dialogRowData.currentSanctionLoad || "",
                          newLoad:
                            dialogRowData.newSanctionLoad != null &&
                            dialogRowData.newSanctionLoad !== ""
                              ? String(dialogRowData.newSanctionLoad)
                              : "",
                          // Change of Tariff fields
                          currentTariff: dialogRowData.currentTariff || "",
                          newTariff: getInitialEditNewTariff(dialogRowData),
                          ntnNo: dialogRowData.ntnNo || "",
                        });
                        setEditSections(initEditSections(dialogRowData.changeOfAttributesType));
                        setEditLoadError("");
                        setEditLoadChangeTypeError("");
                        setEditNameErrors({
                          newName: "",
                          guardianName: "",
                          newCNIC: "",
                          newPhone: "",
                        });
                        setEditTariffError("");
                        setEditSaveError("");
                        setEditNtnError("");
                        setEditFbrDocument("");
                        setEditFbrDocumentThumbnail("");
                        setEditFbrDocumentError("");
                        setEditFbrDocumentCleared(false);
                        setShowEditPopup(true);
                      }}
                    />
                  )}
                <Grid container gap={"4%"} className="first-row">
                  <Grid item lg={1.5} className="first-row-item">
                    <p className="prop-title"> Application Id.</p>
                    <p className="prop-detail">
                      {" "}
                      {dialogRowData.applicationId}
                    </p>
                  </Grid>
                  <Grid item lg={1.5} className="first-row-item">
                    <p className="prop-title"> Reference No.</p>
                    <p className="prop-detail">
                      {" "}
                      {dialogRowData.referenceNumber
                        ? dialogRowData.referenceNumber
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={3.5} className="first-row-item">
                    <p className="prop-title"> Address</p>
                    <p className="prop-detail">
                      {" "}
                      {dialogRowData.consumerAddress
                        ? dialogRowData.consumerAddress
                        : "-"}
                    </p>
                  </Grid>
                  <Grid item lg={1} className="first-row-item">
                    <p className="prop-title"> Connection Type </p>
                    <p className="prop-detail">
                      {" "}
                      {dialogRowData.newConnectionType
                        ? dialogRowData.newConnectionType
                        : "-"}
                    </p>
                  </Grid>
                  {(dialogRowData.changeOfAttributesType == 1 ||
                    dialogRowData.changeOfAttributesType == 2 ||
                    dialogRowData.changeOfAttributesType == 5) && (
                      <Grid item lg={1} className="first-row-item">
                        <p className="prop-title"> Tariff </p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentTariff
                            ? dialogRowData.currentTariff
                            : "-"}
                        </p>
                      </Grid>
                    )}
                  <Grid item lg={1} className="first-row-item">
                    <p className="prop-title"> Subdivision </p>
                    <p className="prop-detail">
                      {" "}
                      {subdivisionName(
                        dialogRowData.subDivisionCode,
                        subDivisions
                      )}
                    </p>
                  </Grid>
                  {dialogRowData.changeOfAttributesType == 1 && (
                    <>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current Name </p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentOwnerName
                            ? dialogRowData.currentOwnerName
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current CNIC</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentOwnerCNIC
                            ? dialogRowData.currentOwnerCNIC
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current Phone</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentOwnerPhoneNo
                            ? dialogRowData.currentOwnerPhoneNo
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New Name</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.applicantName
                            ? `${dialogRowData.applicantName} ${dialogRowData.applicantGuardianType == 1 ? "S/O" :
                              dialogRowData.applicantGuardianType == 2 ? "D/O" :
                                dialogRowData.applicantGuardianType == 3 ? "W/O" :
                                  dialogRowData.applicantGuardianType == 4 ? "C/O" : ""
                            } ${dialogRowData.applicantGuardianName || ""}`
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New CNIC</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.applicantCNIC
                            ? dialogRowData.applicantCNIC
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New Phone</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.applicantPhoneNo
                            ? dialogRowData.applicantPhoneNo
                            : "-"}
                        </p>
                      </Grid>
                    </>
                  )}
                  {dialogRowData.changeOfAttributesType == 2 && (
                    <>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current Load </p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentSanctionLoad
                            ? dialogRowData.currentSanctionLoad
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New Load</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.newSanctionLoad
                            ? dialogRowData.newSanctionLoad
                            : "-"}
                        </p>
                      </Grid>
                    </>
                  )}
                  {dialogRowData.changeOfAttributesType == 3 && (
                    <>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current Tariff </p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentTariff
                            ? dialogRowData.currentTariff
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New Tariff</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.newTariff
                            ? dialogRowData.newTariff
                            : "-"}
                        </p>
                      </Grid>
                    </>
                  )}
                  {dialogRowData.changeOfAttributesType == 4 && (
                    <>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current Name </p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentOwnerName
                            ? dialogRowData.currentOwnerName
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current CNIC</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentOwnerCNIC
                            ? dialogRowData.currentOwnerCNIC
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current Phone</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentOwnerPhoneNo
                            ? dialogRowData.currentOwnerPhoneNo
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New Name</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.applicantName
                            ? `${dialogRowData.applicantName} ${dialogRowData.applicantGuardianType == 1 ? "S/O" :
                              dialogRowData.applicantGuardianType == 2 ? "D/O" :
                                dialogRowData.applicantGuardianType == 3 ? "W/O" :
                                  dialogRowData.applicantGuardianType == 4 ? "C/O" : ""
                            } ${dialogRowData.applicantGuardianName || ""}`
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New CNIC</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.applicantCNIC
                            ? dialogRowData.applicantCNIC
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New Phone</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.applicantPhoneNo
                            ? dialogRowData.applicantPhoneNo
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current Load </p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentSanctionLoad
                            ? dialogRowData.currentSanctionLoad
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New Load</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.newSanctionLoad
                            ? dialogRowData.newSanctionLoad
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current Tariff </p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentTariff
                            ? dialogRowData.currentTariff
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New Tariff</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.newTariff
                            ? dialogRowData.newTariff
                            : "-"}
                        </p>
                      </Grid>
                    </>
                  )}
                  {dialogRowData.changeOfAttributesType == 5 && (
                    <>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current Name </p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentOwnerName
                            ? dialogRowData.currentOwnerName
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current CNIC</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentOwnerCNIC
                            ? dialogRowData.currentOwnerCNIC
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current Phone</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentOwnerPhoneNo
                            ? dialogRowData.currentOwnerPhoneNo
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New Name</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.applicantName
                            ? `${dialogRowData.applicantName} ${dialogRowData.applicantGuardianType == 1 ? "S/O" :
                              dialogRowData.applicantGuardianType == 2 ? "D/O" :
                                dialogRowData.applicantGuardianType == 3 ? "W/O" :
                                  dialogRowData.applicantGuardianType == 4 ? "C/O" : ""
                            } ${dialogRowData.applicantGuardianName || ""}`
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New CNIC</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.applicantCNIC
                            ? dialogRowData.applicantCNIC
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New Phone</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.applicantPhoneNo
                            ? dialogRowData.applicantPhoneNo
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current Load </p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentSanctionLoad
                            ? dialogRowData.currentSanctionLoad
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New Load</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.newSanctionLoad
                            ? dialogRowData.newSanctionLoad
                            : "-"}
                        </p>
                      </Grid>
                    </>
                  )}
                  {dialogRowData.changeOfAttributesType == 6 && (
                    <>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current Name </p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentOwnerName
                            ? dialogRowData.currentOwnerName
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current CNIC</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentOwnerCNIC
                            ? dialogRowData.currentOwnerCNIC
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current Phone</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentOwnerPhoneNo
                            ? dialogRowData.currentOwnerPhoneNo
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New Name</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.applicantName
                            ? `${dialogRowData.applicantName} ${dialogRowData.applicantGuardianType == 1 ? "S/O" :
                              dialogRowData.applicantGuardianType == 2 ? "D/O" :
                                dialogRowData.applicantGuardianType == 3 ? "W/O" :
                                  dialogRowData.applicantGuardianType == 4 ? "C/O" : ""
                            } ${dialogRowData.applicantGuardianName || ""}`
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New CNIC</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.applicantCNIC
                            ? dialogRowData.applicantCNIC
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New Phone</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.applicantPhoneNo
                            ? dialogRowData.applicantPhoneNo
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current Tariff </p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentTariff
                            ? dialogRowData.currentTariff
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New Tariff</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.newTariff
                            ? dialogRowData.newTariff
                            : "-"}
                        </p>
                      </Grid>
                    </>
                  )}
                  {dialogRowData.changeOfAttributesType == 7 && (
                    <>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current Load </p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentSanctionLoad
                            ? dialogRowData.currentSanctionLoad
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New Load</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.newSanctionLoad
                            ? dialogRowData.newSanctionLoad
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> Current Tariff </p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.currentTariff
                            ? dialogRowData.currentTariff
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={1.5} className="first-row-item">
                        <p className="prop-title"> New Tariff</p>
                        <p className="prop-detail">
                          {" "}
                          {dialogRowData.newTariff
                            ? dialogRowData.newTariff
                            : "-"}
                        </p>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
              <Grid item className="processing-summary">
                <div
                  className="title"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <h2 style={{ margin: 0, fontSize: 22 }}>Activity Log</h2>
                </div>

                {viewDropBackForEfile ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "20px",
                    }}
                  >
                    <CircularProgress size={30} />
                  </div>
                ) : eFileData && eFileData.length > 0 ? (
                  // <ProcessingSummaryTable
                  //   key={eFileData.length}
                  //   data={tableDataProcessingSummary}
                  //   columns={tableColumnsProcessingSummary}
                  //   openDetailsPopUp={openDetailsPopUp}
                  // />

                  <ProcessingSummaryTableForCoa
                    key={tableDataProcessingSummary.length}
                    data={tableDataProcessingSummary}
                    columns={tableColumnsProcessingSummary}
                    onRowClick={(row) => handleActivityLogRowClick(row)}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "20px",
                    }}
                  >
                    <button
                      onClick={onPressViewActivityLog}
                      type="submit"
                      className="view-button"
                      style={{
                        marginBottom: "10px",
                        backgroundColor: "#003971",
                        borderRadius: "20px",
                        color: "white",
                        padding: "12px 25px",
                      }}
                    >
                      <span style={{ fontSize: "12px" }}>▼</span> Load Activity
                      Log
                    </button>
                  </div>
                )}
              </Grid>
              <Grid item className="action-form">
                <div className="fields">
                  {dialogRowData.applicationProgressId === 0 ? (
                    <>
                      <h3 className="step-title">Documents Pending</h3>
                      <div className="description-box">
                        <p className="group-description">
                          <InfoIcon className="icon" />
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes"
                          )
                            ? "To process application, some documents are yet to be provided by the customer. If available, you can upload the remaining documents by clicking below button."
                            : "To process application, some documents are yet to be provided by the customer."}
                        </p>
                      </div>
                    </>
                  ) : dialogRowData.applicationProgressId === 1 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Change of Attributes",
                      "Workflow Permissions",
                      "Documents Verification"
                    ) ? (
                      <>
                        <h3 className="step-title">Document Verification</h3>
                        <Grid
                          className="document-verification-container"
                          container
                          spacing={1}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            marginTop: "1%",
                            padding: "2%",
                          }}
                        >
                          {(dialogRowData.applicantCNICFront ||
                            dialogRowData.applicantCNICBack) && (
                              <Grid item lg={2}>
                                <Grid
                                  container
                                  sx={{
                                    backgroundColor: getDocumentBackGroundColor(
                                      flag_applicantCNICFront
                                    ),
                                    borderRadius: "10px",
                                    minHeight: "125px",
                                    height: "auto",
                                  }}
                                >
                                  <Grid
                                    item
                                    lg={12}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      paddingBottom: "5px",
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        if (!copyOfApplicantCNICVerifyPopUp) {
                                          setCopyOfApplicantCNICVerifyPopUp(true);
                                        }
                                      }}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        flexDirection: "column",
                                        alignItems: "center",
                                      }}
                                    >
                                      {dialogRowData.applicantCNICFront.slice(
                                        0,
                                        6
                                      ) === "data:i" ? (
                                        flag_applicantCNICFront === 1 ? (
                                          <>
                                            <Base64Image
                                              data={
                                                dialogRowData.applicantCNICFront
                                              }
                                              width="80"
                                              height="50"
                                            />
                                            <Base64Image
                                              data={
                                                dialogRowData.applicantCNICBack
                                              }
                                              width="80"
                                              height="50"
                                            />
                                            <img
                                              src={tickicon}
                                              width="25px"
                                              height="25px"
                                              alt="Tick Icon"
                                              style={{
                                                position: "relative",
                                                zIndex: "2",
                                                marginRight: "-120px",
                                                marginTop: "-30px",
                                              }}
                                            />
                                          </>
                                        ) : flag_applicantCNICFront === -1 ? (
                                          <>
                                            <Base64Image
                                              data={
                                                dialogRowData.applicantCNICFront
                                              }
                                              width="80"
                                              height="50"
                                            />
                                            <Base64Image
                                              data={
                                                dialogRowData.applicantCNICBack
                                              }
                                              width="80"
                                              height="50"
                                            />
                                            <img
                                              src={crossIcon}
                                              width="25px"
                                              height="25px"
                                              alt="Cross Icon"
                                              style={{
                                                position: "relative",
                                                zIndex: "2",
                                                marginRight: "-120px",
                                                marginTop: "-30px",
                                              }}
                                            />
                                          </>
                                        ) : (
                                          <>
                                            <Base64Image
                                              data={
                                                dialogRowData.applicantCNICFront
                                              }
                                              width="80"
                                              height="50"
                                            />
                                            <Base64Image
                                              data={
                                                dialogRowData.applicantCNICBack
                                              }
                                              width="80"
                                              height="50"
                                            />
                                          </>
                                        )
                                      ) : (
                                        <Base64Image data={pdfIcon} width="40" />
                                      )}
                                      {copyOfApplicantCNICVerifyPopUp && (
                                        <OpenBase64ImageInPopup
                                          docVerifyPopUp={
                                            copyOfApplicantCNICVerifyPopUp
                                          }
                                          hideDocVerifyPopup={
                                            hideCopyOfApplicantCNICVerifyAlert
                                          }
                                          documentName="Applicant CNIC"
                                          documentImage={
                                            dialogRowData.applicantCNICFront
                                          }
                                          backDocumentImage={
                                            dialogRowData.applicantCNICBack
                                          }
                                          width={"100%"}
                                          document={
                                            dialogRowData.applicantCNICFront
                                          }
                                          documentFlag={
                                            dialogRowData.applicantCNICFrontFlag
                                          }
                                          applicationProgressId={
                                            dialogRowData.applicationProgressId
                                          }
                                          objectionStatus={
                                            dialogRowData.objectionStatus
                                          }
                                          updateDocFlag={updateDocFlag}
                                          documentRemarks={
                                            applicantCNICBackObjectionRemarks
                                          }
                                          titleToUpdateFlag="copyOfApplicantCNIC"
                                          flag_document={flag_applicantCNICFront}
                                          flag_documentBack={
                                            flag_applicantCNICBack
                                          }
                                        />
                                      )}
                                    </div>
                                  </Grid>
                                  <Grid item lg={12} className="tittlegrid">
                                    <p className="docTitle">Applicant's CNIC.</p>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                          {dialogRowData.owenershipDocument && (
                            <Grid item lg={2}>
                              <Grid
                                container
                                sx={{
                                  backgroundColor: getDocumentBackGroundColor(
                                    flag_owenershipDocument
                                  ),
                                  borderRadius: "10px",
                                  minHeight: "125px",
                                  height: "auto",
                                }}
                              >
                                <Grid
                                  item
                                  lg={12}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    onClick={() => {
                                      if (!owenershipDocumentVerifyPopUp) {
                                        setOwenershipDocumentVerifyPopUp(true);
                                      }
                                    }}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {dialogRowData.owenershipDocument.slice(
                                      0,
                                      6
                                    ) === "data:i" ? (
                                      flag_owenershipDocument === 1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.owenershipDocument
                                            }
                                            width="80"
                                            height="110"
                                          />
                                          <img
                                            src={tickicon}
                                            width="25px"
                                            height="25px"
                                            alt="Tick Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-20px",
                                              marginTop: "60px",
                                            }}
                                          />
                                        </>
                                      ) : flag_owenershipDocument === -1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.owenershipDocument
                                            }
                                            width="80"
                                            height="110"
                                          />
                                          <img
                                            src={crossIcon}
                                            width="25px"
                                            height="25px"
                                            alt="Cross Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-20px",
                                              marginTop: "60px",
                                            }}
                                          />
                                        </>
                                      ) : (
                                        <Base64Image
                                          data={
                                            dialogRowData.owenershipDocument
                                          }
                                          width="80"
                                          height="110"
                                        />
                                      )
                                    ) : (
                                      <Base64Image data={pdfIcon} width="40" />
                                    )}
                                    {owenershipDocumentVerifyPopUp && (
                                      <OpenBase64ImageInPopup
                                        docVerifyPopUp={
                                          owenershipDocumentVerifyPopUp
                                        }
                                        hideDocVerifyPopup={
                                          hidePropertyDocVerifyAlert
                                        }
                                        documentName="Property Document"
                                        documentImage={
                                          dialogRowData.owenershipDocument
                                        }
                                        width={"100%"}
                                        document={
                                          dialogRowData.owenershipDocument
                                        }
                                        documentFlag={
                                          dialogRowData.owenershipDocumentFlag
                                        }
                                        applicationProgressId={
                                          dialogRowData.applicationProgressId
                                        }
                                        objectionStatus={
                                          dialogRowData.objectionStatus
                                        }
                                        updateDocFlag={updateDocFlag}
                                        documentRemarks={
                                          owenershipObjectionRemarks
                                        }
                                        titleToUpdateFlag="owenershipDocument"
                                        flag_document={flag_owenershipDocument}
                                      />
                                    )}
                                  </div>
                                </Grid>
                                <Grid item lg={12} className="tittlegrid">
                                  <p className="docTitle">Proof of Ownership</p>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                          {dialogRowData.electricityBillDocument && (
                            <Grid item lg={2}>
                              <Grid
                                container
                                sx={{
                                  backgroundColor: getDocumentBackGroundColor(
                                    flag_electricityBillDocument
                                  ),
                                  borderRadius: "10px",
                                  minHeight: "125px",
                                  height: "auto",
                                }}
                              >
                                <Grid
                                  item
                                  lg={12}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    onClick={() => {
                                      if (!electricityBillDocumentVerifyPopUp) {
                                        setElectricityBillDocumentVerifyPopUp(
                                          true
                                        );
                                      }
                                    }}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {dialogRowData.electricityBillDocument.slice(
                                      0,
                                      6
                                    ) === "data:i" ? (
                                      flag_electricityBillDocument === 1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.electricityBillDocument
                                            }
                                            width="80"
                                            height="110"
                                          />
                                          <img
                                            src={tickicon}
                                            width="25px"
                                            height="25px"
                                            alt="Tick Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-20px",
                                              marginTop: "60px",
                                            }}
                                          />
                                        </>
                                      ) : flag_electricityBillDocument ===
                                        -1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.electricityBillDocument
                                            }
                                            width="80"
                                            height="110"
                                          />
                                          <img
                                            src={crossIcon}
                                            width="25px"
                                            height="25px"
                                            alt="Cross Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-20px",
                                              marginTop: "60px",
                                            }}
                                          />
                                        </>
                                      ) : (
                                        <Base64Image
                                          data={
                                            dialogRowData.electricityBillDocument
                                          }
                                          width="80"
                                          height="110"
                                        />
                                      )
                                    ) : (
                                      <Base64Image data={pdfIcon} width="40" />
                                    )}
                                    {electricityBillDocumentVerifyPopUp && (
                                      <OpenBase64ImageInPopup
                                        docVerifyPopUp={
                                          electricityBillDocumentVerifyPopUp
                                        }
                                        hideDocVerifyPopup={
                                          hidePropertyDocVerifyAlert
                                        }
                                        documentName="Electricity Bill Document"
                                        documentImage={
                                          dialogRowData.electricityBillDocument
                                        }
                                        width={"100%"}
                                        document={
                                          dialogRowData.electricityBillDocument
                                        }
                                        documentFlag={
                                          dialogRowData.electricityBillDocumentFlag
                                        }
                                        applicationProgressId={
                                          dialogRowData.applicationProgressId
                                        }
                                        objectionStatus={
                                          dialogRowData.objectionStatus
                                        }
                                        updateDocFlag={updateDocFlag}
                                        documentRemarks={
                                          electricityBillObjectionRemarks
                                        }
                                        titleToUpdateFlag="electricityBillDocument"
                                        flag_document={
                                          flag_electricityBillDocument
                                        }
                                      />
                                    )}
                                  </div>
                                </Grid>
                                <Grid item lg={12} className="tittlegrid">
                                  <p className="docTitle">
                                    Electricity Bill Document
                                  </p>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}

                          {dialogRowData.fbrDocument && (
                            <Grid item lg={2}>
                              <Grid
                                container
                                sx={{
                                  backgroundColor: dialogRowData.fbrDocumentFlag
                                    ? getDocumentBackGroundColor(
                                      dialogRowData.fbrDocumentFlag
                                    )
                                    : getDocumentBackGroundColor(
                                      flag_fbrDocument
                                    ),
                                  borderRadius: "10px",
                                  minHeight: "125px",
                                  height: "auto",
                                }}
                              >
                                <Grid
                                  item
                                  lg={12}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    onClick={() => {
                                      if (!fbrDocumentVerifyPopUp) {
                                        setFbrDocumentVerifyPopUp(true);
                                      }
                                    }}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {dialogRowData.fbrDocument.slice(0, 6) ===
                                      "data:i" ? (
                                      flag_fbrDocument === 1 ? (
                                        <>
                                          <Base64Image
                                            data={dialogRowData.fbrDocument}
                                            width="80"
                                            height="110"
                                          />
                                          <img
                                            src={tickicon}
                                            width="25px"
                                            height="25px"
                                            alt="Tick Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-20px",
                                              marginTop: "60px",
                                            }}
                                          />
                                        </>
                                      ) : flag_fbrDocument === -1 ? (
                                        <>
                                          <Base64Image
                                            data={dialogRowData.fbrDocument}
                                            width="80"
                                            height="110"
                                          />
                                          <img
                                            src={crossIcon}
                                            width="25px"
                                            height="25px"
                                            alt="Cross Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-20px",
                                              marginTop: "60px",
                                            }}
                                          />
                                        </>
                                      ) : (
                                        <Base64Image
                                          data={dialogRowData.fbrDocument}
                                          width="80"
                                          height="110"
                                        />
                                      )
                                    ) : flag_fbrDocument === 1 ? (
                                      <>
                                        <Base64Image data={pdfIcon} width="40" />
                                        <img
                                          src={tickicon}
                                          width="25px"
                                          height="25px"
                                          alt="Tick Icon"
                                          style={{
                                            position: "relative",
                                            zIndex: "2",
                                            marginRight: "-20px",
                                            marginTop: "60px",
                                          }}
                                        />
                                      </>
                                    ) : flag_fbrDocument === -1 ? (
                                      <>
                                        <Base64Image data={pdfIcon} width="40" />
                                        <img
                                          src={crossIcon}
                                          width="25px"
                                          height="25px"
                                          alt="Cross Icon"
                                          style={{
                                            position: "relative",
                                            zIndex: "2",
                                            marginRight: "-20px",
                                            marginTop: "60px",
                                          }}
                                        />
                                      </>
                                    ) : (
                                      <Base64Image data={pdfIcon} width="40" />
                                    )}
                                    {fbrDocumentVerifyPopUp && (
                                      <OpenBase64ImageInPopup
                                        docVerifyPopUp={fbrDocumentVerifyPopUp}
                                        hideDocVerifyPopup={
                                          hideFbrDocVerifyAlert
                                        }
                                        documentName="FBR Document"
                                        documentImage={
                                          dialogRowData.fbrDocument
                                        }
                                        width={"100%"}
                                        document={dialogRowData.fbrDocument}
                                        documentFlag={
                                          dialogRowData.fbrDocumentFlag
                                        }
                                        applicationProgressId={
                                          dialogRowData.applicationProgressId
                                        }
                                        objectionStatus={
                                          dialogRowData.objectionStatus
                                        }
                                        updateDocFlag={updateDocFlag}
                                        documentRemarks={
                                          fbrDocumentObjectionRemarks
                                        }
                                        titleToUpdateFlag="fbrDocument"
                                        flag_document={flag_fbrDocument}
                                      />
                                    )}
                                  </div>
                                </Grid>
                                <Grid item lg={12} className="tittlegrid">
                                  <p className="docTitle">FBR Document</p>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}

                          {dialogRowData.addDocAnyOther && (
                            <Grid item lg={2}>
                              <Grid
                                container
                                sx={{
                                  backgroundColor: dialogRowData.anyOtherDocumentFlag
                                    ? getDocumentBackGroundColor(
                                      dialogRowData.anyOtherDocumentFlag
                                    )
                                    : getDocumentBackGroundColor(
                                      flag_addDocAnyOther
                                    ),
                                  borderRadius: "10px",
                                  minHeight: "125px",
                                  height: "auto",
                                }}
                              >
                                <Grid
                                  item
                                  lg={12}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    onClick={() => {
                                      if (!addDocAnyOtherVerifyPopUp) {
                                        setAddDocAnyOtherVerifyPopUp(true);
                                      }
                                    }}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {dialogRowData.addDocAnyOther.slice(0, 6) ===
                                      "data:i" ? (
                                      flag_addDocAnyOther === 1 ? (
                                        <>
                                          <Base64Image
                                            data={dialogRowData.addDocAnyOther}
                                            width="80"
                                            height="110"
                                          />
                                          <img
                                            src={tickicon}
                                            width="25px"
                                            height="25px"
                                            alt="Tick Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-20px",
                                              marginTop: "60px",
                                            }}
                                          />
                                        </>
                                      ) : flag_addDocAnyOther === -1 ? (
                                        <>
                                          <Base64Image
                                            data={dialogRowData.addDocAnyOther}
                                            width="80"
                                            height="110"
                                          />
                                          <img
                                            src={crossIcon}
                                            width="25px"
                                            height="25px"
                                            alt="Cross Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-20px",
                                              marginTop: "60px",
                                            }}
                                          />
                                        </>
                                      ) : (
                                        <Base64Image
                                          data={dialogRowData.addDocAnyOther}
                                          width="80"
                                          height="110"
                                        />
                                      )
                                    ) : flag_addDocAnyOther === 1 ? (
                                      <>
                                        <Base64Image data={pdfIcon} width="40" />
                                        <img
                                          src={tickicon}
                                          width="25px"
                                          height="25px"
                                          alt="Tick Icon"
                                          style={{
                                            position: "relative",
                                            zIndex: "2",
                                            marginRight: "-20px",
                                            marginTop: "60px",
                                          }}
                                        />
                                      </>
                                    ) : flag_addDocAnyOther === -1 ? (
                                      <>
                                        <Base64Image data={pdfIcon} width="40" />
                                        <img
                                          src={crossIcon}
                                          width="25px"
                                          height="25px"
                                          alt="Cross Icon"
                                          style={{
                                            position: "relative",
                                            zIndex: "2",
                                            marginRight: "-20px",
                                            marginTop: "60px",
                                          }}
                                        />
                                      </>
                                    ) : (
                                      <Base64Image data={pdfIcon} width="40" />
                                    )}
                                    {addDocAnyOtherVerifyPopUp && (
                                      <OpenBase64ImageInPopup
                                        docVerifyPopUp={addDocAnyOtherVerifyPopUp}
                                        hideDocVerifyPopup={
                                          hideAddAnyOtherVerifyAlert
                                        }
                                        documentName="Any Other Document"
                                        documentImage={
                                          dialogRowData.addDocAnyOther
                                        }
                                        width={"100%"}
                                        document={dialogRowData.addDocAnyOther}
                                        documentFlag={
                                          dialogRowData.anyOtherDocumentFlag
                                        }
                                        applicationProgressId={
                                          dialogRowData.applicationProgressId
                                        }
                                        objectionStatus={
                                          dialogRowData.objectionStatus
                                        }
                                        updateDocFlag={updateDocFlag}
                                        documentRemarks={
                                          addDocAnyOtherObjectionRemarks
                                        }
                                        titleToUpdateFlag="addDocAnyOther"
                                        flag_document={flag_addDocAnyOther}
                                      />
                                    )}
                                  </div>
                                </Grid>
                                <Grid item lg={12} className="tittlegrid">
                                  <p className="docTitle">Any Other Document</p>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      </>
                    ) : (
                      <>
                        <h3 className="step-title">Document Verification</h3>
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" /> Document verification
                            is in process by the Customer Service Lead.
                          </p>
                        </div>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 1 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <h3 className="step-title">Documents Objection</h3>
                      <Grid
                        className="document-verification-container"
                        container
                        spacing={1}
                        sx={{
                          display: "flex",
                          justifyContent: "flex-start",
                          marginTop: "1%",
                          padding: "2%",
                        }}
                      >
                        {(dialogRowData.applicantCNICFront ||
                          dialogRowData.applicantCNICBack) && (
                            <Grid item lg={2}>
                              <Grid
                                container
                                sx={{
                                  backgroundColor: getDocumentBackGroundColor(
                                    flag_applicantCNICFront
                                  ),
                                  borderRadius: "10px",
                                  minHeight: "125px",
                                  height: "auto",
                                }}
                              >
                                <Grid
                                  item
                                  lg={12}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    paddingBottom: "5px",
                                  }}
                                >
                                  <div
                                    onClick={() => {
                                      if (!copyOfApplicantCNICVerifyPopUp) {
                                        setCopyOfApplicantCNICVerifyPopUp(true);
                                      }
                                    }}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      flexDirection: "column",
                                      alignItems: "center",
                                    }}
                                  >
                                    {dialogRowData.applicantCNICFront.slice(
                                      0,
                                      6
                                    ) === "data:i" ? (
                                      flag_applicantCNICFront === 1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.applicantCNICFront
                                            }
                                            width="80"
                                            height="50"
                                          />
                                          <Base64Image
                                            data={dialogRowData.applicantCNICBack}
                                            width="80"
                                            height="50"
                                          />
                                          <img
                                            src={tickicon}
                                            width="25px"
                                            height="25px"
                                            alt="Tick Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-120px",
                                              marginTop: "-30px",
                                            }}
                                          />
                                        </>
                                      ) : flag_applicantCNICFront === -1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.applicantCNICFront
                                            }
                                            width="80"
                                            height="50"
                                          />
                                          <Base64Image
                                            data={dialogRowData.applicantCNICBack}
                                            width="80"
                                            height="50"
                                          />
                                          <img
                                            src={crossIcon}
                                            width="25px"
                                            height="25px"
                                            alt="Cross Icon"
                                            style={{
                                              position: "relative",
                                              zIndex: "2",
                                              marginRight: "-120px",
                                              marginTop: "-30px",
                                            }}
                                          />
                                        </>
                                      ) : (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.applicantCNICFront
                                            }
                                            width="80"
                                            height="50"
                                          />
                                          <Base64Image
                                            data={dialogRowData.applicantCNICBack}
                                            width="80"
                                            height="50"
                                          />
                                        </>
                                      )
                                    ) : (
                                      <Base64Image data={pdfIcon} width="40" />
                                    )}
                                    {copyOfApplicantCNICVerifyPopUp && (
                                      <OpenBase64ImageInPopup
                                        docVerifyPopUp={
                                          copyOfApplicantCNICVerifyPopUp
                                        }
                                        hideDocVerifyPopup={
                                          hideCopyOfApplicantCNICVerifyAlert
                                        }
                                        documentName="Applicant CNIC"
                                        documentImage={
                                          dialogRowData.applicantCNICFront
                                        }
                                        backDocumentImage={
                                          dialogRowData.applicantCNICBack
                                        }
                                        width={"100%"}
                                        document={
                                          dialogRowData.applicantCNICFront
                                        }
                                        documentFlag={
                                          dialogRowData.applicantCNICFrontFlag
                                        }
                                        applicationProgressId={
                                          dialogRowData.applicationProgressId
                                        }
                                        objectionStatus={
                                          dialogRowData.objectionStatus
                                        }
                                        updateDocFlag={updateDocFlag}
                                        documentRemarks={
                                          applicantCNICBackObjectionRemarks
                                        }
                                        titleToUpdateFlag="copyOfApplicantCNIC"
                                        flag_document={flag_applicantCNICFront}
                                        flag_documentBack={flag_applicantCNICBack}
                                      />
                                    )}
                                  </div>
                                </Grid>
                                <Grid item lg={12} className="tittlegrid">
                                  <p className="docTitle">Applicant's CNIC.</p>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                        {dialogRowData.owenershipDocument && (
                          <Grid item lg={2}>
                            <Grid
                              container
                              sx={{
                                backgroundColor: getDocumentBackGroundColor(
                                  flag_owenershipDocument
                                ),
                                borderRadius: "10px",
                                minHeight: "125px",
                                height: "auto",
                              }}
                            >
                              <Grid
                                item
                                lg={12}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  onClick={() => {
                                    if (!owenershipDocumentVerifyPopUp) {
                                      setOwenershipDocumentVerifyPopUp(true);
                                    }
                                  }}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {dialogRowData.owenershipDocument.slice(
                                    0,
                                    6
                                  ) === "data:i" ? (
                                    flag_owenershipDocument === 1 ? (
                                      <>
                                        <Base64Image
                                          data={
                                            dialogRowData.owenershipDocument
                                          }
                                          width="80"
                                          height="110"
                                        />
                                        <img
                                          src={tickicon}
                                          width="25px"
                                          height="25px"
                                          alt="Tick Icon"
                                          style={{
                                            position: "relative",
                                            zIndex: "2",
                                            marginRight: "-20px",
                                            marginTop: "60px",
                                          }}
                                        />
                                      </>
                                    ) : flag_owenershipDocument === -1 ? (
                                      <>
                                        <Base64Image
                                          data={
                                            dialogRowData.owenershipDocument
                                          }
                                          width="80"
                                          height="110"
                                        />
                                        <img
                                          src={crossIcon}
                                          width="25px"
                                          height="25px"
                                          alt="Cross Icon"
                                          style={{
                                            position: "relative",
                                            zIndex: "2",
                                            marginRight: "-20px",
                                            marginTop: "60px",
                                          }}
                                        />
                                      </>
                                    ) : (
                                      <Base64Image
                                        data={dialogRowData.owenershipDocument}
                                        width="80"
                                        height="110"
                                      />
                                    )
                                  ) : (
                                    <Base64Image data={pdfIcon} width="40" />
                                  )}
                                  {owenershipDocumentVerifyPopUp && (
                                    <OpenBase64ImageInPopup
                                      docVerifyPopUp={
                                        owenershipDocumentVerifyPopUp
                                      }
                                      hideDocVerifyPopup={
                                        hidePropertyDocVerifyAlert
                                      }
                                      documentName="Property Document"
                                      documentImage={
                                        dialogRowData.owenershipDocument
                                      }
                                      width={"100%"}
                                      document={
                                        dialogRowData.owenershipDocument
                                      }
                                      documentFlag={
                                        dialogRowData.owenershipDocumentFlag
                                      }
                                      applicationProgressId={
                                        dialogRowData.applicationProgressId
                                      }
                                      objectionStatus={
                                        dialogRowData.objectionStatus
                                      }
                                      updateDocFlag={updateDocFlag}
                                      documentRemarks={
                                        owenershipObjectionRemarks
                                      }
                                      titleToUpdateFlag="owenershipDocument"
                                      flag_document={flag_owenershipDocument}
                                    />
                                  )}
                                </div>
                              </Grid>
                              <Grid item lg={12} className="tittlegrid">
                                <p className="docTitle">Proof of Ownership</p>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                        {dialogRowData.electricityBillDocument && (
                          <Grid item lg={2}>
                            <Grid
                              container
                              sx={{
                                backgroundColor: getDocumentBackGroundColor(
                                  flag_electricityBillDocument
                                ),
                                borderRadius: "10px",
                                minHeight: "125px",
                                height: "auto",
                              }}
                            >
                              <Grid
                                item
                                lg={12}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  onClick={() => {
                                    if (!electricityBillDocumentVerifyPopUp) {
                                      setElectricityBillDocumentVerifyPopUp(
                                        true
                                      );
                                    }
                                  }}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {dialogRowData.electricityBillDocument.slice(
                                    0,
                                    6
                                  ) === "data:i" ? (
                                    flag_electricityBillDocument === 1 ? (
                                      <>
                                        <Base64Image
                                          data={
                                            dialogRowData.electricityBillDocument
                                          }
                                          width="80"
                                          height="110"
                                        />
                                        <img
                                          src={tickicon}
                                          width="25px"
                                          height="25px"
                                          alt="Tick Icon"
                                          style={{
                                            position: "relative",
                                            zIndex: "2",
                                            marginRight: "-20px",
                                            marginTop: "60px",
                                          }}
                                        />
                                      </>
                                    ) : flag_electricityBillDocument === -1 ? (
                                      <>
                                        <Base64Image
                                          data={
                                            dialogRowData.electricityBillDocument
                                          }
                                          width="80"
                                          height="110"
                                        />
                                        <img
                                          src={crossIcon}
                                          width="25px"
                                          height="25px"
                                          alt="Cross Icon"
                                          style={{
                                            position: "relative",
                                            zIndex: "2",
                                            marginRight: "-20px",
                                            marginTop: "60px",
                                          }}
                                        />
                                      </>
                                    ) : (
                                      <Base64Image
                                        data={
                                          dialogRowData.electricityBillDocument
                                        }
                                        width="80"
                                        height="110"
                                      />
                                    )
                                  ) : (
                                    <Base64Image data={pdfIcon} width="40" />
                                  )}
                                  {electricityBillDocumentVerifyPopUp && (
                                    <OpenBase64ImageInPopup
                                      docVerifyPopUp={
                                        electricityBillDocumentVerifyPopUp
                                      }
                                      hideDocVerifyPopup={
                                        hideElectricityBillVerifyAlert
                                      }
                                      documentName="Electricity Bill Document"
                                      documentImage={
                                        dialogRowData.electricityBillDocument
                                      }
                                      width={"100%"}
                                      document={
                                        dialogRowData.electricityBillDocument
                                      }
                                      documentFlag={
                                        dialogRowData.electricityBillDocumentFlag
                                      }
                                      applicationProgressId={
                                        dialogRowData.applicationProgressId
                                      }
                                      objectionStatus={
                                        dialogRowData.objectionStatus
                                      }
                                      updateDocFlag={updateDocFlag}
                                      documentRemarks={
                                        electricityBillObjectionRemarks
                                      }
                                      titleToUpdateFlag="electricityBillDocument"
                                      flag_document={
                                        flag_electricityBillDocument
                                      }
                                    />
                                  )}
                                </div>
                              </Grid>
                              <Grid item lg={12} className="tittlegrid">
                                <p className="docTitle">
                                  Electricity Bill Document
                                </p>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                        {dialogRowData.fbrDocument && (
                          <Grid item lg={2}>
                            <Grid
                              container
                              sx={{
                                backgroundColor: dialogRowData.fbrDocumentFlag
                                  ? getDocumentBackGroundColor(
                                    dialogRowData.fbrDocumentFlag
                                  )
                                  : getDocumentBackGroundColor(
                                    flag_fbrDocument
                                  ),
                                borderRadius: "10px",
                                minHeight: "125px",
                                height: "auto",
                              }}
                            >
                              <Grid
                                item
                                lg={12}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  onClick={() => {
                                    if (!fbrDocumentVerifyPopUp) {
                                      setFbrDocumentVerifyPopUp(true);
                                    }
                                  }}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {dialogRowData.fbrDocument.slice(0, 6) ===
                                    "data:i" ? (
                                    flag_fbrDocument === 1 ? (
                                      <>
                                        <Base64Image
                                          data={dialogRowData.fbrDocument}
                                          width="80"
                                          height="110"
                                        />
                                        <img
                                          src={tickicon}
                                          width="25px"
                                          height="25px"
                                          alt="Tick Icon"
                                          style={{
                                            position: "relative",
                                            zIndex: "2",
                                            marginRight: "-20px",
                                            marginTop: "60px",
                                          }}
                                        />
                                      </>
                                    ) : flag_fbrDocument === -1 ? (
                                      <>
                                        <Base64Image
                                          data={dialogRowData.fbrDocument}
                                          width="80"
                                          height="110"
                                        />
                                        <img
                                          src={crossIcon}
                                          width="25px"
                                          height="25px"
                                          alt="Cross Icon"
                                          style={{
                                            position: "relative",
                                            zIndex: "2",
                                            marginRight: "-20px",
                                            marginTop: "60px",
                                          }}
                                        />
                                      </>
                                    ) : (
                                      <Base64Image
                                        data={dialogRowData.fbrDocument}
                                        width="80"
                                        height="110"
                                      />
                                    )
                                  ) : (
                                    <Base64Image data={pdfIcon} width="40" />
                                  )}
                                  {fbrDocumentVerifyPopUp && (
                                    <OpenBase64ImageInPopup
                                      docVerifyPopUp={fbrDocumentVerifyPopUp}
                                      hideDocVerifyPopup={hideFbrDocVerifyAlert}
                                      documentName="FBR Document"
                                      documentImage={dialogRowData.fbrDocument}
                                      width={"100%"}
                                      document={dialogRowData.fbrDocument}
                                      documentFlag={
                                        dialogRowData.fbrDocumentFlag
                                      }
                                      applicationProgressId={
                                        dialogRowData.applicationProgressId
                                      }
                                      objectionStatus={
                                        dialogRowData.objectionStatus
                                      }
                                      updateDocFlag={updateDocFlag}
                                      documentRemarks={
                                        fbrDocumentObjectionRemarks
                                      }
                                      titleToUpdateFlag="fbrDocument"
                                      flag_document={flag_fbrDocument}
                                    />
                                  )}
                                </div>
                              </Grid>
                              <Grid item lg={12} className="tittlegrid">
                                <p className="docTitle">FBR Document</p>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                        {dialogRowData.addDocAnyOther && (
                          <Grid item lg={2}>
                            <Grid
                              container
                              sx={{
                                backgroundColor: dialogRowData.anyOtherDocumentFlag
                                  ? getDocumentBackGroundColor(
                                    dialogRowData.anyOtherDocumentFlag
                                  )
                                  : getDocumentBackGroundColor(
                                    flag_addDocAnyOther
                                  ),
                                borderRadius: "10px",
                                minHeight: "125px",
                                height: "auto",
                              }}
                            >
                              <Grid
                                item
                                lg={12}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  onClick={() => {
                                    if (!addDocAnyOtherVerifyPopUp) {
                                      setAddDocAnyOtherVerifyPopUp(true);
                                    }
                                  }}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {dialogRowData.addDocAnyOther.slice(0, 6) ===
                                    "data:i" ? (
                                    flag_addDocAnyOther === 1 ? (
                                      <>
                                        <Base64Image
                                          data={dialogRowData.addDocAnyOther}
                                          width="80"
                                          height="110"
                                        />
                                        <img
                                          src={tickicon}
                                          width="25px"
                                          height="25px"
                                          alt="Tick Icon"
                                          style={{
                                            position: "relative",
                                            zIndex: "2",
                                            marginRight: "-20px",
                                            marginTop: "60px",
                                          }}
                                        />
                                      </>
                                    ) : flag_addDocAnyOther === -1 ? (
                                      <>
                                        <Base64Image
                                          data={dialogRowData.addDocAnyOther}
                                          width="80"
                                          height="110"
                                        />
                                        <img
                                          src={crossIcon}
                                          width="25px"
                                          height="25px"
                                          alt="Cross Icon"
                                          style={{
                                            position: "relative",
                                            zIndex: "2",
                                            marginRight: "-20px",
                                            marginTop: "60px",
                                          }}
                                        />
                                      </>
                                    ) : (
                                      <Base64Image
                                        data={dialogRowData.addDocAnyOther}
                                        width="80"
                                        height="110"
                                      />
                                    )
                                  ) : (
                                    <Base64Image data={pdfIcon} width="40" />
                                  )}
                                  {addDocAnyOtherVerifyPopUp && (
                                    <OpenBase64ImageInPopup
                                      docVerifyPopUp={addDocAnyOtherVerifyPopUp}
                                      hideDocVerifyPopup={hideAddAnyOtherVerifyAlert}
                                      documentName="Any Other Document"
                                      documentImage={dialogRowData.addDocAnyOther}
                                      width={"100%"}
                                      document={dialogRowData.addDocAnyOther}
                                      documentFlag={
                                        dialogRowData.anyOtherDocumentFlag
                                      }
                                      applicationProgressId={
                                        dialogRowData.applicationProgressId
                                      }
                                      objectionStatus={
                                        dialogRowData.objectionStatus
                                      }
                                      updateDocFlag={updateDocFlag}
                                      documentRemarks={
                                        addDocAnyOtherObjectionRemarks
                                      }
                                      titleToUpdateFlag="addDocAnyOther"
                                      flag_document={flag_addDocAnyOther}
                                    />
                                  )}
                                </div>
                              </Grid>
                              <Grid item lg={12} className="tittlegrid">
                                <p className="docTitle">Any Other Document</p>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                        {/* {
                                dialogRowData.fbrDocument &&
                                <Grid item lg={2}>
                                  <Grid container sx={{ backgroundColor: dialogRowData.fbrDocumentFlag ? getDocumentBackGroundColor(dialogRowData.fbrDocumentFlag) : getDocumentBackGroundColor(flag_fbrDocument), borderRadius: "10px", minHeight: '125px', height: 'auto' }}>
                                    <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                      <div onClick={() => { if (!fbrDocumentVerifyPopUp) { setFbrDocumentVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                        {
                                          dialogRowData.fbrDocument.slice(0, 6) === 'data:i' ? (
                                            flag_fbrDocument === 1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.fbrDocument} width='80' height='110' />
                                                <img
                                                  src={tickicon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Tick Icon"
                                                  style={{ position: 'relative', zIndex: '2', marginRight: '-20px', marginTop: '60px' }}
                                                />
                                              </>
                                            ) : flag_fbrDocument === -1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.fbrDocument} width='80' height='110' />
                                                <img
                                                  src={crossIcon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Cross Icon"
                                                  style={{ position: 'relative', zIndex: '2', marginRight: '-20px', marginTop: '60px' }}
                                                />
                                              </>
                                            ) : (
                                              <Base64Image data={dialogRowData.fbrDocument} width='80' height='110' />
                                            )
                                          ) : (
                                            <Base64Image data={pdfIcon} width='40' />
                                          )
                                        }
                                        {
                                          fbrDocumentVerifyPopUp &&
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={fbrDocumentVerifyPopUp}
                                            hideDocVerifyPopup={hideFbrDocumentVerifyAlert}
                                            documentName="FBR Document"
                                            documentImage={dialogRowData.fbrDocument}
                                            width={'100%'}
                                            document={dialogRowData.fbrDocument}
                                            documentFlag={dialogRowData.fbrDocumentFlag}
                                            applicationProgressId={dialogRowData.applicationProgressId}
                                            objectionStatus={dialogRowData.objectionStatus}
                                            updateDocFlag={updateDocFlag}
                                            documentRemarks={fbrDocumentObjectionRemarks}
                                            titleToUpdateFlag="fbrDocument"
                                            flag_document={flag_fbrDocument}
                                          />
                                        }
                                      </div>
                                    </Grid>
                                    <Grid item lg={12} className="tittlegrid" >
                                      <p className='docTitle'>FBR Document</p>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              } */}
                      </Grid>
                    </>
                  ) : dialogRowData.applicationProgressId === 2 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <Grid
                        container
                        className="step-title"
                        sx={{ marginBottom: "1%", padding: "0.5%" }}
                      >
                        <Grid item lg={1}></Grid>
                        <Grid item lg={10} sx={{ textAlign: "center" }}>
                          <h4>Arrear Verification</h4>
                        </Grid>
                        {paymentStatus === "Arrear exists" && (
                          <Grid item lg={1}>
                            <Button
                              variant="outlined"
                              onClick={() =>
                                downloadBill(dialogRowData.referenceNumber)
                              }
                              sx={{
                                backgroundColor: "white",
                                cursor: "pointer",
                                border: "1px solid #006ad1",
                                boxShadow: "none",
                                width: "5%",
                              }}
                            >
                              <PrintIcon
                                sx={{ color: "#006ad1", marginLeft: "1%" }}
                              />{" "}
                              Bill{" "}
                            </Button>
                          </Grid>
                        )}
                      </Grid>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Change of Attributes",
                        "Workflow Permissions",
                        "Arrears Verification"
                      ) &&
                        (() => {
                          const sanctionLoad =
                            dialogRowData.newSanctionLoad ||
                            dialogRowData.currentSanctionLoad;
                          const currentTariff = dialogRowData.currentTariff
                            ?.replace(/-/g, "")
                            .trim();

                          return (
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "15"
                            ) &&
                              sanctionLoad > 0 &&
                              sanctionLoad <= 15 &&
                              ((CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Tariff Authority",
                                "A1"
                              ) &&
                                currentTariff?.startsWith("A1")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A2"
                                ) &&
                                  currentTariff?.startsWith("A2")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A3"
                                ) &&
                                  currentTariff?.startsWith("A3")))) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "70"
                            ) &&
                              sanctionLoad > 1 &&
                              sanctionLoad <= 70) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "500"
                            ) &&
                              sanctionLoad > 70 &&
                              sanctionLoad <= 500) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "5000"
                            ) &&
                              sanctionLoad > 500)
                          );
                        })() ? (
                        <>
                          <Grid
                            container
                            className="field-survey-container"
                            spacing={3}
                          >
                            {!paymentStatus && (
                              <>
                                <Grid
                                  item
                                  lg={12}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "20px",
                                  }}
                                >
                                  <button
                                    onClick={() =>
                                      referenceApi(
                                        dialogRowData.referenceNumber
                                      )
                                    }
                                    style={{
                                      backgroundColor: "#003971",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "20px",
                                      padding: "10px 40px",
                                      fontSize: "16px",
                                      cursor: "pointer",
                                    }}
                                    className="view-button"
                                  >
                                    Check Arrears
                                  </button>
                                </Grid>
                                <Grid item lg={12}>
                                  <Grid
                                    item
                                    lg={12}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginLeft: "5%",
                                      marginTop: "5%",
                                    }}
                                  >
                                    <img
                                      src={frontImg}
                                      alt="Cnic Front"
                                      style={{ width: "45%", height: "40%" }}
                                    ></img>
                                    <img
                                      src={backImg}
                                      alt="Cnic Back"
                                      style={{
                                        width: "45%",
                                        height: "40%",
                                        marginLeft: "2%",
                                      }}
                                    ></img>
                                  </Grid>
                                </Grid>
                              </>
                            )}

                            {paymentStatus && (
                              <Grid
                                item
                                lg={12}
                                sx={{ textAlign: "center", marginTop: "20px" }}
                              >
                                <Typography
                                  sx={{
                                    fontWeight: "bold",
                                    color:
                                      paymentStatus === "No arrear exists"
                                        ? "green"
                                        : "red",
                                    fontSize: "28px",
                                  }}
                                >
                                  {paymentStatus}
                                </Typography>
                              </Grid>
                            )}
                          </Grid>
                          {paymentStatus === "Arrear exists" && (
                            <>
                              <Grid
                                container
                                className="dn-payment-submission-container"
                              >
                                <Grid item lg={6} className="item">
                                  <Typography className="title">
                                    Arrear Amount
                                  </Typography>
                                  <Typography className="value">
                                    {arrearAmount
                                      ? numberFormatting(arrearAmount)
                                      : "-"}
                                  </Typography>
                                </Grid>
                                <Grid item lg={6} className="item">
                                  <Typography className="title">
                                    Bill Month
                                  </Typography>
                                  <Typography className="value">
                                    {billMonth ? convertDate(billMonth) : "-"}
                                  </Typography>
                                </Grid>
                              </Grid>

                              <Grid
                                container
                                className="dn-payment-submission-container"
                              >
                                <Grid item lg={4} className="item">
                                  <Typography className="title">
                                    Paid Bill Receipt
                                  </Typography>

                                  {arrearPaymentReceiptFormik.values
                                    .iv_arrear_paid_bill_document ? (
                                    <Button
                                      variant="outlined"
                                      component="label"
                                      startIcon={
                                        <CloseIcon
                                          sx={{ color: "red" }}
                                          onClick={() =>
                                            arrearPaymentReceiptFormik.setFieldValue(
                                              "iv_arrear_paid_bill_document",
                                              ""
                                            )
                                          }
                                        />
                                      }
                                    >
                                      <img
                                        src={URL.createObjectURL(
                                          arrearPaymentReceiptFormik.values
                                            .iv_arrear_paid_bill_document
                                        )}
                                        alt="Receipt Preview"
                                        width="80"
                                      />
                                    </Button>
                                  ) : (
                                    <Button
                                      variant="outlined"
                                      component="label"
                                      startIcon={<FileUploadOutlinedIcon />}
                                      sx={{
                                        padding: "4%",
                                        width: "100%",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      Upload
                                      <input
                                        hidden
                                        accept={documentExtensions}
                                        id="iv_arrear_paid_bill_document"
                                        name="iv_arrear_paid_bill_document"
                                        type="file"
                                        onChange={(event) => {
                                          const file =
                                            event.currentTarget.files[0];
                                          arrearPaymentReceiptFormik.setFieldValue(
                                            "iv_arrear_paid_bill_document",
                                            file
                                          );

                                          const reader = new FileReader();
                                          reader.readAsDataURL(file);
                                          reader.onload = () => {
                                            // Set the thumbnail image as the data URL
                                            const base64Image = reader.result;
                                            setArrearPaidReceiptImageThumbnail(
                                              base64Image
                                            );
                                          };
                                        }}
                                      />
                                    </Button>
                                  )}

                                  {/* ✅ Error directly under image */}
                                  <Box
                                    sx={{
                                      color: "red",
                                      fontSize: "0.85rem",
                                      marginTop: "4px",
                                    }}
                                  >
                                    {arrearPaymentReceiptFormik.touched
                                      .iv_arrear_paid_bill_document &&
                                      arrearPaymentReceiptFormik.errors
                                        .iv_arrear_paid_bill_document
                                      ? arrearPaymentReceiptFormik.errors
                                        .iv_arrear_paid_bill_document
                                      : null}
                                  </Box>
                                </Grid>
                              </Grid>
                            </>
                          )}
                          {paymentStatus === "No arrear exists" && (
                            <>
                              <Grid container spacing={2} sx={{}}>
                                <Grid container item spacing={2}>
                                  <Grid
                                    container
                                    spacing={2}
                                    alignItems="flex-start"
                                    justifyContent="space-between"
                                    marginLeft={10}
                                    marginRight={10}
                                    marginTop={2}
                                  >
                                    <Grid
                                      item
                                      lg={6}
                                      md={6}
                                      sm={12}
                                      className="item"
                                    >
                                      <Typography className="title">
                                        CNIC Front
                                      </Typography>
                                      <Grid
                                        container
                                        sx={{
                                          backgroundColor:
                                            getDocumentBackGroundColor(0),
                                          borderRadius: "10px",
                                          height: "250px",
                                          width: "100%",
                                        }}
                                        className="docContainer"
                                      >
                                        <img
                                          src={dialogRowData.applicantCNICFront}
                                          alt="Cnic Front"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: "10px",
                                          }}
                                        />
                                      </Grid>
                                    </Grid>

                                    <Grid
                                      item
                                      lg={6}
                                      md={6}
                                      sm={12}
                                      className="item"
                                    >
                                      <Typography className="title">
                                        CNIC Back
                                      </Typography>
                                      <Grid
                                        container
                                        sx={{
                                          backgroundColor:
                                            getDocumentBackGroundColor(0),
                                          borderRadius: "10px",
                                          height: "250px",
                                          width: "100%",
                                        }}
                                        className="docContainer"
                                      >
                                        <img
                                          src={dialogRowData.applicantCNICBack}
                                          alt="Cnic Back"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: "10px",
                                          }}
                                        />
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </>
                          )}
                        </>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            Arrears Verification is in process by sanctioning
                            authority.{" "}
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 2 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <Grid
                        container
                        className="step-title"
                        sx={{ marginBottom: "1%", padding: "0.5%" }}
                      >
                        <Grid item lg={1}></Grid>
                        <Grid item lg={10} sx={{ textAlign: "center" }}>
                          <h4>Arrear Verification</h4>
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        className="dn-payment-submission-container"
                      >
                        <Grid item lg={6} className="item">
                          <Typography className="title">
                            Arrear Amount
                          </Typography>
                          <Typography className="value">
                            {arrearAmount
                              ? numberFormatting(arrearAmount)
                              : "-"}
                          </Typography>
                        </Grid>
                        <Grid item lg={6} className="item">
                          <Typography className="title">Bill Month</Typography>
                          <Typography className="value">
                            {billMonth ? convertDate(billMonth) : "-"}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        className="dn-payment-submission-container"
                      >
                        <Grid item lg={4} className="item">
                          <Typography className="title">
                            Paid Bill Receipt
                          </Typography>

                          {arrearPaymentReceiptFormik.values
                            .iv_arrear_paid_bill_document ? (
                            <Button
                              variant="outlined"
                              component="label"
                              startIcon={
                                <CloseIcon
                                  sx={{ color: "red" }}
                                  onClick={() =>
                                    arrearPaymentReceiptFormik.setFieldValue(
                                      "iv_arrear_paid_bill_document",
                                      ""
                                    )
                                  }
                                />
                              }
                            >
                              <img
                                src={URL.createObjectURL(
                                  arrearPaymentReceiptFormik.values
                                    .iv_arrear_paid_bill_document
                                )}
                                alt="Receipt Preview"
                                width="80"
                              />
                            </Button>
                          ) : (
                            <Button
                              variant="outlined"
                              component="label"
                              startIcon={<FileUploadOutlinedIcon />}
                              sx={{
                                padding: "4%",
                                width: "100%",
                                backgroundColor: "white",
                              }}
                            >
                              Upload
                              <input
                                hidden
                                accept={documentExtensions}
                                id="iv_arrear_paid_bill_document"
                                name="iv_arrear_paid_bill_document"
                                type="file"
                                onChange={(event) => {
                                  const file = event.currentTarget.files[0];
                                  arrearPaymentReceiptFormik.setFieldValue(
                                    "iv_arrear_paid_bill_document",
                                    file
                                  );

                                  const reader = new FileReader();
                                  reader.readAsDataURL(file);
                                  reader.onload = () => {
                                    // Set the thumbnail image as the data URL
                                    const base64Image = reader.result;
                                    setArrearPaidReceiptImageThumbnail(
                                      base64Image
                                    );
                                  };
                                }}
                              />
                            </Button>
                          )}

                          {/* ✅ Error directly under image */}
                          <Box
                            sx={{
                              color: "red",
                              fontSize: "0.85rem",
                              marginTop: "4px",
                            }}
                          >
                            {arrearPaymentReceiptFormik.touched
                              .iv_arrear_paid_bill_document &&
                              arrearPaymentReceiptFormik.errors
                                .iv_arrear_paid_bill_document
                              ? arrearPaymentReceiptFormik.errors
                                .iv_arrear_paid_bill_document
                              : null}
                          </Box>
                        </Grid>
                      </Grid>
                    </>
                  ) : dialogRowData.applicationProgressId === 3 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <Grid
                        container
                        className="step-title"
                        sx={{ marginBottom: "1%", padding: "0.5%" }}
                      >
                        <Grid item lg={1}></Grid>
                        <Grid item lg={10} sx={{ textAlign: "center" }}>
                          {
                            // (dialogRowData.applicationProgressId === 3 && dialogRowData.observationType === 1) ?
                            <h4>Field Survey</h4>
                            // :
                            // <h4>Field Survey</h4>
                          }
                        </Grid>
                      </Grid>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Change of Attributes",
                        "Workflow Permissions",
                        "Field Survey"
                      ) &&
                        (() => {
                          const sanctionLoad =
                            dialogRowData.newSanctionLoad ||
                            dialogRowData.currentSanctionLoad;
                          const currentTariff = dialogRowData.currentTariff
                            ?.replace(/-/g, "")
                            .trim();

                          return (
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "15"
                            ) &&
                              sanctionLoad > 0 &&
                              sanctionLoad <= 15 &&
                              ((CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Tariff Authority",
                                "A1"
                              ) &&
                                currentTariff?.startsWith("A1")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A2"
                                ) &&
                                  currentTariff?.startsWith("A2")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A3"
                                ) &&
                                  currentTariff?.startsWith("A3")))) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "70"
                            ) &&
                              sanctionLoad > 1 &&
                              sanctionLoad <= 70) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "500"
                            ) &&
                              sanctionLoad > 70 &&
                              sanctionLoad <= 500) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "5000"
                            ) &&
                              sanctionLoad > 500)
                          );
                        })() ? (
                        <>
                          <Grid
                            container
                            item
                            spacing={0.5}
                            lg={12}
                            className="field-survey-container"
                          >
                            {dialogRowData.changeOfAttributesType == 1 ? (
                              <>
                                <Grid
                                  item
                                  lg={3}
                                  sx={{ marginTop: "2%", textAlign: "center" }}
                                >
                                  <Typography className="fieldLabel">
                                    Area Type
                                  </Typography>

                                  <FormControl>
                                    <RadioGroup
                                      name="iv_area_type"
                                      value={
                                        fieldFormik.values.iv_area_type === "U"
                                          ? "Urban"
                                          : fieldFormik.values.iv_area_type ===
                                            "R"
                                            ? "Rural"
                                            : ""
                                      }
                                      onChange={(e) => {
                                        const selectedValue =
                                          e.target.value === "Urban"
                                            ? "U"
                                            : "R";
                                        fieldFormik.setFieldValue(
                                          "iv_area_type",
                                          selectedValue
                                        );
                                      }}
                                      onBlur={fieldFormik.handleBlur}
                                      row
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "row",
                                        }}
                                      >
                                        <FormControlLabel
                                          value="Urban"
                                          control={<Radio />}
                                          label="Urban"
                                          disabled
                                          sx={{
                                            backgroundColor: "white",
                                            padding: "0px 10px",
                                            borderRadius: "5px",
                                            marginLeft: "0px",
                                            marginRight: "10px",
                                            border: "1px solid lightgrey",
                                            marginTop: "2%",
                                          }}
                                        />
                                        <FormControlLabel
                                          value="Rural"
                                          control={<Radio />}
                                          label="Rural"
                                          disabled
                                          sx={{
                                            backgroundColor: "white",
                                            padding: "0px 10px",
                                            borderRadius: "5px",
                                            border: "1px solid lightgrey",
                                            textAlign: "right",
                                            marginLeft: "2%",
                                            marginTop: "2%",
                                          }}
                                        />
                                      </Box>
                                    </RadioGroup>
                                  </FormControl>

                                  <Box className="from-Error-load">
                                    {fieldFormik.errors.iv_area_type &&
                                      fieldFormik.touched.iv_area_type
                                      ? fieldFormik.errors.iv_area_type
                                      : null}
                                  </Box>
                                </Grid>

                                {/* <Grid item lg={3} sx={{ marginTop: '2%', textAlign: 'center' }}>
                                          <Typography className="fieldLabel">Batch Change Required</Typography>

                                          <FormControl>
                                            <RadioGroup
                                              name="iv_batch_change"
                                              value={
                                                fieldFormik.values.iv_batch_change === true
                                                  ? 'true'
                                                  : fieldFormik.values.iv_batch_change === false
                                                    ? 'false'
                                                    : ''
                                              }
                                              onChange={(e) => {
                                                const isBatchChange = e.target.value === 'true';
                                                fieldFormik.setFieldValue('iv_batch_change', isBatchChange);

                                                if (!isBatchChange) {
                                                  fieldFormik.setFieldValue('iv_batch', '');
                                                  fieldFormik.setFieldValue('iv_sub_batch', '');
                                                  fieldFormik.setFieldValue('iv_reference_to_allot', '');
                                                }
                                              }}
                                              onBlur={fieldFormik.handleBlur}
                                              row
                                            >
                                              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                                <FormControlLabel
                                                  value="true"
                                                  control={<Radio />}
                                                  label="Yes"
                                                  sx={{
                                                    backgroundColor: 'white',
                                                    padding: '0px 10px',
                                                    borderRadius: '5px',
                                                    marginLeft: '0px',
                                                    marginRight: '10px',
                                                    border: '1px solid lightgrey',
                                                    marginTop: '2%',
                                                  }}
                                                />
                                                <FormControlLabel
                                                  value="false"
                                                  control={<Radio />}
                                                  label="No"
                                                  sx={{
                                                    backgroundColor: 'white',
                                                    padding: '0px 10px',
                                                    borderRadius: '5px',
                                                    border: '1px solid lightgrey',
                                                    textAlign: 'right',
                                                    marginLeft: '2%',
                                                    marginTop: '2%',
                                                  }}
                                                />
                                              </Box>
                                            </RadioGroup>
                                          </FormControl>

                                          <Box className="from-Error-load">
                                            {fieldFormik.errors.iv_batch_change && fieldFormik.touched.iv_batch_change
                                              ? fieldFormik.errors.iv_batch_change
                                              : null}
                                          </Box>
                                        </Grid>

                                        {
                                          fieldFormik.values.iv_batch_change === true &&
                                          <>
                                            <Grid item lg={4} sx={{ marginTop: '2%', textAlign: 'center' }}>
                                              <Typography className='fieldLabel'>Allot Reference No.</Typography>
                                              <Grid container spacing={1} display='flex'>
                                                <Grid item lg={4.5}>
                                                  <Select
                                                    sx={{ width: '100%' }}
                                                    value={fieldFormik.values.iv_batch}
                                                    onChange={fieldFormik.handleChange}
                                                    onBlur={fieldFormik.handleBlur}
                                                    displayEmpty
                                                    className='fieldBatch'
                                                    name="iv_batch"
                                                    id="iv_batch"
                                                    MenuProps={{
                                                      PaperProps: {
                                                        style: {
                                                          width: 20,
                                                          height: 180,
                                                        },
                                                      },
                                                    }}
                                                  >
                                                    <MenuItem value='' sx={{ fontSize: '12px' }}>Batch</MenuItem>
                                                    {batchArray.map((option) => (
                                                      <MenuItem key={option} value={option} sx={{ fontSize: '12px' }}>
                                                        {option}
                                                      </MenuItem>
                                                    ))}
                                                  </Select>
                                                  <Box className='form-error'>
                                                    {fieldFormik.errors.iv_batch && fieldFormik.touched.iv_batch
                                                      ? fieldFormik.errors.iv_batch
                                                      : null}
                                                  </Box>
                                                </Grid>

                                                <Grid item lg={7.5}>
                                                  <TextField
                                                    name="iv_reference_to_allot"
                                                    value={fieldFormik.values.iv_reference_to_allot}
                                                    fullWidth
                                                    onChange={fieldFormik.handleChange}
                                                    onBlur={fieldFormik.handleBlur}
                                                    type='text'
                                                    sx={{ width: '100%' }}
                                                    inputProps={{ maxLength: 7 }}
                                                    InputProps={{
                                                      startAdornment: (
                                                        <InputAdornment
                                                          position="start"
                                                          sx={{ fontSize: '12px' }}
                                                          style={{ background: '#F2F4F6' }}
                                                        >
                                                          {partialValue}
                                                        </InputAdornment>
                                                      ),
                                                    }}
                                                    className='fieldCoverageMarla'
                                                  />
                                                  <Box className='form-error'>
                                                    {fieldFormik.errors.iv_reference_to_allot &&
                                                      fieldFormik.touched.iv_reference_to_allot
                                                      ? fieldFormik.errors.iv_reference_to_allot
                                                      : null}
                                                  </Box>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                            <Grid item lg={2} sx={{ marginTop: '2%', textAlign: 'center' }}>
                                              <Typography className='fieldLabel'>Sub Batch</Typography>
                                              <Select
                                                sx={{ width: '100%' }}
                                                value={fieldFormik.values.iv_sub_batch}
                                                onChange={fieldFormik.handleChange}
                                                onBlur={fieldFormik.handleBlur}
                                                displayEmpty
                                                className='fieldBatch'
                                                name="iv_sub_batch"
                                                id="iv_sub_batch"
                                                MenuProps={{
                                                  PaperProps: {
                                                    style: {
                                                      width: 20,
                                                      height: 180,
                                                    },
                                                  },
                                                }}
                                              >
                                                <MenuItem value='' sx={{ fontSize: '12px' }}>Select Sub Batch</MenuItem>
                                                {subBatchArray.map((option) => (
                                                  <MenuItem key={option} value={option} sx={{ fontSize: '12px' }}>
                                                    {option}
                                                  </MenuItem>
                                                ))}
                                              </Select>
                                              <p className='form-error'>
                                                {fieldFormik.errors.iv_sub_batch && fieldFormik.touched.iv_sub_batch
                                                  ? fieldFormik.errors.iv_sub_batch
                                                  : null}
                                              </p>
                                            </Grid>
                                          </>
                                        } */}
                              </>
                            ) : (
                              <>
                                <Grid item lg={3} sx={{ marginTop: "2%" }}>
                                  <Typography className="fieldLabel">
                                    Site Observation
                                  </Typography>

                                  <FormControl
                                    className="form-control"
                                    sx={{
                                      marginLeft: "0 !important",
                                      paddingLeft: 0,
                                    }}
                                    style={{ marginLeft: 0 }}
                                    fullWidth
                                  >
                                    <Select
                                      labelId="site-observation-label"
                                      id="iv_objection_Type"
                                      name="iv_objection_Type"
                                      value={
                                        fieldFormik.values.iv_objection_Type ||
                                        ""
                                      }
                                      onChange={(e) => {
                                        fieldFormik.setFieldValue(
                                          "iv_objection_Type",
                                          e.target.value
                                        );
                                        if (e.target.value != "1") {
                                          fieldFormik.setFieldValue(
                                            "iv_batch_change",
                                            false
                                          );
                                          fieldFormik.setFieldValue(
                                            "iv_material_required",
                                            false
                                          );
                                        }
                                      }}
                                      onBlur={fieldFormik.handleBlur}
                                      className="textInputField"
                                      style={{ fontSize: "14px" }}
                                      displayEmpty
                                    >
                                      {/* <MenuItem value="">
                                                        <em>Select Site Observation</em>
                                                      </MenuItem> */}

                                      {lookUpDataOfCON?.lookupFSObservation?.map(
                                        (item) => (
                                          <MenuItem
                                            key={item.observationType}
                                            value={item.observationType}
                                            style={{ fontSize: "14px" }}
                                          >
                                            {item.observationDetails}
                                          </MenuItem>
                                        )
                                      )}
                                    </Select>
                                  </FormControl>

                                  <Box className="from-Error-load">
                                    {fieldFormik.errors.iv_objection_Type &&
                                      fieldFormik.touched.iv_objection_Type
                                      ? fieldFormik.errors.iv_objection_Type
                                      : null}
                                  </Box>
                                </Grid>

                                {fieldFormik.values.iv_objection_Type ==
                                  "6" && (
                                    <Grid item lg={3}>
                                      <Typography
                                        className="documentLabel"
                                        sx={{
                                          display: "block",
                                          marginBottom: "6px",
                                        }}
                                      >
                                        Remarks
                                      </Typography>

                                      <textarea
                                        id="iv_remarks_others"
                                        name="iv_remarks_others"
                                        placeholder="Enter your remarks..."
                                        rows={4}
                                        style={{
                                          width: "100%",
                                          fontSize: "14px",
                                          padding: "8px",
                                          borderRadius: "8px",
                                          border: "1px solid #ccc",
                                          resize: "none",
                                        }}
                                        value={
                                          fieldFormik.values.iv_remarks_others
                                        }
                                        onChange={fieldFormik.handleChange}
                                        onBlur={fieldFormik.handleBlur}
                                      />

                                      <Box
                                        className="documentError"
                                        sx={{ color: "red" }}
                                      >
                                        {fieldFormik.touched.iv_remarks_others &&
                                          fieldFormik.errors.iv_remarks_others}
                                      </Box>
                                    </Grid>
                                  )}

                                {fieldFormik.values.iv_objection_Type ==
                                  "5" && (
                                    <>
                                      <Grid
                                        item
                                        lg={3}
                                        sx={{
                                          marginTop: "2%",
                                          textAlign: "center",
                                        }}
                                      >
                                        <Typography className="fieldLabel">
                                          Allot Reference No.
                                        </Typography>
                                        <Grid
                                          container
                                          spacing={1}
                                          display="flex"
                                        >
                                          <Grid item lg={4.5}>
                                            <Select
                                              sx={{ width: "100%" }}
                                              value={fieldFormik.values.iv_batch}
                                              onChange={fieldFormik.handleChange}
                                              onBlur={fieldFormik.handleBlur}
                                              displayEmpty
                                              className="fieldBatch"
                                              name="iv_batch"
                                              id="iv_batch"
                                              MenuProps={{
                                                PaperProps: {
                                                  style: {
                                                    width: 20,
                                                    height: 180,
                                                  },
                                                },
                                              }}
                                            >
                                              <MenuItem
                                                value=""
                                                sx={{ fontSize: "12px" }}
                                              >
                                                Batch
                                              </MenuItem>
                                              {batchArray.map((option) => (
                                                <MenuItem
                                                  key={option}
                                                  value={option}
                                                  sx={{ fontSize: "12px" }}
                                                >
                                                  {option}
                                                </MenuItem>
                                              ))}
                                            </Select>
                                            <Box className="form-error">
                                              {fieldFormik.errors.iv_batch &&
                                                fieldFormik.touched.iv_batch
                                                ? fieldFormik.errors.iv_batch
                                                : null}
                                            </Box>
                                          </Grid>

                                          <Grid item lg={7.5}>
                                            <TextField
                                              name="iv_reference_to_allot"
                                              value={
                                                fieldFormik.values
                                                  .iv_reference_to_allot
                                              }
                                              fullWidth
                                              onChange={fieldFormik.handleChange}
                                              onBlur={fieldFormik.handleBlur}
                                              type="text"
                                              sx={{ width: "100%" }}
                                              inputProps={{ maxLength: 7 }}
                                              InputProps={{
                                                startAdornment: (
                                                  <InputAdornment
                                                    position="start"
                                                    sx={{ fontSize: "12px" }}
                                                    style={{
                                                      background: "#F2F4F6",
                                                    }}
                                                  >
                                                    {partialValue}
                                                  </InputAdornment>
                                                ),
                                              }}
                                              className="fieldCoverageMarla"
                                            />
                                            <Box className="form-error">
                                              {fieldFormik.errors
                                                .iv_reference_to_allot &&
                                                fieldFormik.touched
                                                  .iv_reference_to_allot
                                                ? fieldFormik.errors
                                                  .iv_reference_to_allot
                                                : null}
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </>
                                  )}
                                {fieldFormik.values.iv_objection_Type ==
                                  "1" && (
                                    <>
                                      <Grid
                                        item
                                        lg={3}
                                        sx={{
                                          marginTop: "2%",
                                          textAlign: "center",
                                        }}
                                      >
                                        <Typography className="fieldLabel">
                                          Material Required
                                        </Typography>

                                        <FormControl>
                                          <RadioGroup
                                            name="iv_material_required"
                                            value={
                                              fieldFormik.values
                                                .iv_material_required === true
                                                ? "true"
                                                : fieldFormik.values
                                                  .iv_material_required ===
                                                  false
                                                  ? "false"
                                                  : ""
                                            }
                                            // onChange={(e) =>
                                            //   fieldFormik.setFieldValue(
                                            //     'iv_material_required',
                                            //     e.target.value === 'true'
                                            //   )
                                            // }
                                            onChange={(e) => {
                                              const isMaterialRequired =
                                                e.target.value === "true";
                                              fieldFormik.setFieldValue(
                                                "iv_material_required",
                                                isMaterialRequired
                                              );

                                              if (!isMaterialRequired) {
                                                // setBoqItems();

                                                setBoqItems([]);
                                                setItemsAmount("");
                                                setStoreCharges("");
                                                setInstallationCharges("");
                                                setTotalCharges("");
                                                setItemsArray("");
                                                setFixedChargesOfMetering("");

                                                // fieldFormik.setFieldValue('iv_meter_to_replace', '');
                                                // fieldFormik.setFieldValue('iv_meter_type', '');
                                                setSketchDiagram(null);
                                                setSketchDiagramUploaded("");
                                                setSketchDiagramThumbnail("");
                                              }
                                            }}
                                            onBlur={fieldFormik.handleBlur}
                                            row
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                              }}
                                            >
                                              <FormControlLabel
                                                value="true"
                                                control={<Radio />}
                                                label="Yes"
                                                sx={{
                                                  backgroundColor: "white",
                                                  padding: "0px 10px",
                                                  borderRadius: "5px",
                                                  marginLeft: "0px",
                                                  marginRight: "10px",
                                                  border: "1px solid lightgrey",
                                                  marginTop: "2%",
                                                }}
                                              />
                                              <FormControlLabel
                                                value="false"
                                                control={<Radio />}
                                                label="No"
                                                sx={{
                                                  backgroundColor: "white",
                                                  padding: "0px 10px",
                                                  borderRadius: "5px",
                                                  border: "1px solid lightgrey",
                                                  textAlign: "right",
                                                  marginLeft: "2%",
                                                  marginTop: "2%",
                                                }}
                                              />
                                            </Box>
                                          </RadioGroup>
                                        </FormControl>

                                        <Box className="from-Error-load">
                                          {fieldFormik.errors
                                            .iv_material_required &&
                                            fieldFormik.touched.iv_material_required
                                            ? fieldFormik.errors
                                              .iv_material_required
                                            : null}
                                        </Box>
                                      </Grid>
                                      {fieldFormik.values.iv_material_required ===
                                        true && (
                                          <>
                                            <Grid
                                              item
                                              lg={3}
                                              sx={{
                                                marginTop: "2%",
                                                textAlign: "center",
                                              }}
                                            >
                                              <Typography className="fieldLabel">
                                                Meter needs to be replaced
                                              </Typography>

                                              <FormControl>
                                                <RadioGroup
                                                  name="iv_meter_to_replace"
                                                  value={
                                                    fieldFormik.values
                                                      .iv_meter_to_replace === true
                                                      ? "true"
                                                      : fieldFormik.values
                                                        .iv_meter_to_replace ===
                                                        false
                                                        ? "false"
                                                        : ""
                                                  }
                                                  onChange={(e) => {
                                                    const value =
                                                      e.target.value === "true";
                                                    fieldFormik.setFieldValue(
                                                      "iv_meter_to_replace",
                                                      value
                                                    );
                                                  }}
                                                  onBlur={fieldFormik.handleBlur}
                                                  row
                                                >
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      flexDirection: "row",
                                                    }}
                                                  >
                                                    <FormControlLabel
                                                      value="true"
                                                      control={<Radio />}
                                                      label="Yes"
                                                      sx={{
                                                        backgroundColor: "white",
                                                        padding: "0px 10px",
                                                        borderRadius: "5px",
                                                        marginLeft: "0px",
                                                        marginRight: "10px",
                                                        border:
                                                          "1px solid lightgrey",
                                                        marginTop: "2%",
                                                      }}
                                                    />
                                                    <FormControlLabel
                                                      value="false"
                                                      control={<Radio />}
                                                      label="No"
                                                      sx={{
                                                        backgroundColor: "white",
                                                        padding: "0px 10px",
                                                        borderRadius: "5px",
                                                        border:
                                                          "1px solid lightgrey",
                                                        textAlign: "right",
                                                        marginLeft: "2%",
                                                        marginTop: "2%",
                                                      }}
                                                    />
                                                  </Box>
                                                </RadioGroup>
                                              </FormControl>

                                              <Box className="from-Error-load">
                                                {fieldFormik.errors
                                                  .iv_meter_to_replace &&
                                                  fieldFormik.touched
                                                    .iv_meter_to_replace
                                                  ? fieldFormik.errors
                                                    .iv_meter_to_replace
                                                  : null}
                                              </Box>
                                            </Grid>
                                            <Grid
                                              item
                                              lg={3}
                                              sx={{
                                                marginTop: "2%",
                                                textAlign: "center",
                                              }}
                                            >
                                              <Typography className="fieldLabel">
                                                Sketch / Diagram
                                              </Typography>

                                              {/* Formik + Custom Error Messages */}
                                              <Box className="form-error">
                                                {fieldFormik.errors
                                                  .iv_sketch_diagram &&
                                                  fieldFormik.touched
                                                    .iv_sketch_diagram
                                                  ? fieldFormik.errors
                                                    .iv_sketch_diagram
                                                  : null}
                                              </Box>
                                              <Box className="form-error">
                                                {sketchDiagramError
                                                  ? sketchDiagramError
                                                  : null}
                                              </Box>

                                              {/* Conditional Rendering */}
                                              {sketchDiagramUploaded &&
                                                sketchDiagramUploaded !== "" ? (
                                                // If image already uploaded (from DB or previous session)
                                                <Grid container>
                                                  <Grid item sm={6}>
                                                    <a
                                                      href="#"
                                                      onClick={() =>
                                                        openBase64Image(
                                                          sketchDiagramUploaded
                                                        )
                                                      }
                                                      target="_blank"
                                                      rel="noreferrer"
                                                      style={{
                                                        display: "flex",
                                                        justifyContent:
                                                          "space-between",
                                                        marginTop: "2%",
                                                      }}
                                                    >
                                                      <img
                                                        src={sketchDiagramThumbnail}
                                                        alt="Sketch Diagram"
                                                        style={{ width: "100%" }}
                                                      />
                                                    </a>
                                                  </Grid>

                                                  <Grid item sm={6}>
                                                    <Button
                                                      variant="outlined"
                                                      component="label"
                                                      startIcon={
                                                        <CloseIcon
                                                          sx={{ color: "red" }}
                                                        />
                                                      }
                                                    >
                                                      Change
                                                      <input
                                                        hidden
                                                        accept={documentExtensions}
                                                        id="iv_sketch_diagram"
                                                        name="iv_sketch_diagram"
                                                        type="file"
                                                        onChange={SketchDiagram}
                                                      />
                                                    </Button>
                                                  </Grid>
                                                </Grid>
                                              ) : sketchDiagram &&
                                                sketchDiagram !== "" ? (
                                                <Button
                                                  variant="contained"
                                                  component="label"
                                                  startIcon={
                                                    <CloseIcon
                                                      sx={{ color: "red" }}
                                                      onClick={() =>
                                                        setSketchDiagram(null)
                                                      }
                                                    />
                                                  }
                                                  sx={{ marginTop: "2%" }}
                                                >
                                                  {sketchDiagramThumbnail && (
                                                    <img
                                                      src={sketchDiagramThumbnail}
                                                      alt="Sketch Diagram"
                                                      width="100"
                                                    />
                                                  )}
                                                </Button>
                                              ) : (
                                                // Default: Show Upload button
                                                <Button
                                                  variant="outlined"
                                                  component="label"
                                                  startIcon={
                                                    <FileUploadOutlinedIcon />
                                                  }
                                                  sx={{
                                                    width: "80%",
                                                    backgroundColor: "white",
                                                    textTransform: "capitalize",
                                                    marginTop: "2%",
                                                  }}
                                                  disabled={
                                                    dnDetails &&
                                                    dnDetails.filledFlag === 1 &&
                                                    CheckPermissions(
                                                      permissions,
                                                      "General Services",
                                                      "Change of Attributes",
                                                      "Workflow Permissions",
                                                      "Field Survey",
                                                      "Survey Form Creation"
                                                    )
                                                  }
                                                >
                                                  Upload
                                                  <input
                                                    hidden
                                                    accept={documentExtensions}
                                                    id="iv_sketch_diagram"
                                                    name="iv_sketch_diagram"
                                                    type="file"
                                                    onChange={SketchDiagram}
                                                  />
                                                </Button>
                                              )}
                                            </Grid>

                                            <Grid
                                              item
                                              lg={3}
                                              sx={{
                                                marginTop: "2%",
                                                textAlign: "center",
                                              }}
                                            >
                                              <Typography className="fieldLabel">
                                                Meter Type
                                              </Typography>
                                              <FormControl className="form-control">
                                                <RadioGroup
                                                  className="radio-group"
                                                  row
                                                  name="iv_meter_type"
                                                  value={
                                                    dialogRowData.applicationId?.slice(
                                                      3,
                                                      5
                                                    ) === "13" ||
                                                      dialogRowData.applicationId?.slice(
                                                        3,
                                                        5
                                                      ) === "15"
                                                      ? "1"
                                                      : fieldFormik.values
                                                        .iv_meter_type
                                                  }
                                                  onChange={
                                                    fieldFormik.handleChange
                                                  }
                                                >
                                                  <FormControlLabel
                                                    value="1"
                                                    className="form-control-label"
                                                    control={<Radio />}
                                                    label="Smart"
                                                    labelPlacement="end"
                                                    disabled={
                                                      // dialogRowData.appliedLoad < 5 ||
                                                      // dialogRowData.applicationId?.slice(3, 5) === '13'
                                                      dialogRowData.applicationId?.slice(
                                                        3,
                                                        5
                                                      ) === "13" ||
                                                      dialogRowData.applicationId?.slice(
                                                        3,
                                                        5
                                                      ) === "15"
                                                    }
                                                    sx={{
                                                      backgroundColor: "white",
                                                      padding: "0px 10px",
                                                      borderRadius: "5px",
                                                      marginLeft: "0px",
                                                      marginRight: "5px",
                                                      border: "1px solid lightgrey",
                                                    }}
                                                  />
                                                  <FormControlLabel
                                                    value="0"
                                                    className="form-control-label"
                                                    control={<Radio />}
                                                    label="Normal"
                                                    labelPlacement="end"
                                                    disabled={
                                                      // dialogRowData.appliedLoad < 5 ||
                                                      // dialogRowData.applicationId?.slice(3, 5) === '13'
                                                      dialogRowData.applicationId?.slice(
                                                        3,
                                                        5
                                                      ) === "13" ||
                                                      dialogRowData.applicationId?.slice(
                                                        3,
                                                        5
                                                      ) === "15"
                                                    }
                                                    sx={{
                                                      backgroundColor: "white",
                                                      padding: "0px 10px",
                                                      borderRadius: "5px",
                                                      marginLeft: "0px",
                                                      marginRight: "10px",
                                                      border: "1px solid lightgrey",
                                                    }}
                                                  />
                                                </RadioGroup>
                                              </FormControl>

                                              {fieldFormik.touched.iv_meter_type &&
                                                fieldFormik.errors
                                                  .iv_meter_type && (
                                                  <p className="form-error">
                                                    {
                                                      fieldFormik.errors
                                                        .iv_meter_type
                                                    }
                                                  </p>
                                                )}
                                            </Grid>
                                          </>
                                        )}
                                      <Grid
                                        item
                                        lg={3}
                                        sx={{
                                          marginTop: "2%",
                                          textAlign: "center",
                                        }}
                                      >
                                        <Typography className="fieldLabel">
                                          Area Type
                                        </Typography>

                                        <FormControl>
                                          <RadioGroup
                                            name="iv_area_type"
                                            value={
                                              fieldFormik.values.iv_area_type ===
                                                "U"
                                                ? "Urban"
                                                : fieldFormik.values
                                                  .iv_area_type === "R"
                                                  ? "Rural"
                                                  : ""
                                            }
                                            onChange={(e) => {
                                              const selectedValue =
                                                e.target.value === "Urban"
                                                  ? "U"
                                                  : "R";
                                              fieldFormik.setFieldValue(
                                                "iv_area_type",
                                                selectedValue
                                              );
                                            }}
                                            onBlur={fieldFormik.handleBlur}
                                            row
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                              }}
                                            >
                                              <FormControlLabel
                                                value="Urban"
                                                control={<Radio />}
                                                label="Urban"
                                                disabled
                                                sx={{
                                                  backgroundColor: "white",
                                                  padding: "0px 10px",
                                                  borderRadius: "5px",
                                                  marginLeft: "0px",
                                                  marginRight: "10px",
                                                  border: "1px solid lightgrey",
                                                  marginTop: "2%",
                                                }}
                                              />
                                              <FormControlLabel
                                                value="Rural"
                                                control={<Radio />}
                                                label="Rural"
                                                disabled
                                                sx={{
                                                  backgroundColor: "white",
                                                  padding: "0px 10px",
                                                  borderRadius: "5px",
                                                  border: "1px solid lightgrey",
                                                  textAlign: "right",
                                                  marginLeft: "2%",
                                                  marginTop: "2%",
                                                }}
                                              />
                                            </Box>
                                          </RadioGroup>
                                        </FormControl>

                                        <Box className="from-Error-load">
                                          {fieldFormik.errors.iv_area_type &&
                                            fieldFormik.touched.iv_area_type
                                            ? fieldFormik.errors.iv_area_type
                                            : null}
                                        </Box>
                                      </Grid>

                                      <Grid
                                        item
                                        lg={3}
                                        sx={{
                                          marginTop: "2%",
                                          textAlign: "center",
                                        }}
                                      >
                                        <Typography className="fieldLabel">
                                          Batch Change Required
                                        </Typography>

                                        <FormControl>
                                          <RadioGroup
                                            name="iv_batch_change"
                                            value={
                                              fieldFormik.values
                                                .iv_batch_change === true
                                                ? "true"
                                                : fieldFormik.values
                                                  .iv_batch_change === false
                                                  ? "false"
                                                  : ""
                                            }
                                            onChange={(e) => {
                                              const isBatchChange =
                                                e.target.value === "true";
                                              fieldFormik.setFieldValue(
                                                "iv_batch_change",
                                                isBatchChange
                                              );

                                              if (!isBatchChange) {
                                                fieldFormik.setFieldValue(
                                                  "iv_batch",
                                                  ""
                                                );
                                                fieldFormik.setFieldValue(
                                                  "iv_sub_batch",
                                                  ""
                                                );
                                                fieldFormik.setFieldValue(
                                                  "iv_reference_to_allot",
                                                  ""
                                                );
                                              }
                                            }}
                                            onBlur={fieldFormik.handleBlur}
                                            row
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                              }}
                                            >
                                              <FormControlLabel
                                                value="true"
                                                control={<Radio />}
                                                label="Yes"
                                                sx={{
                                                  backgroundColor: "white",
                                                  padding: "0px 10px",
                                                  borderRadius: "5px",
                                                  marginLeft: "0px",
                                                  marginRight: "10px",
                                                  border: "1px solid lightgrey",
                                                  marginTop: "2%",
                                                }}
                                              />
                                              <FormControlLabel
                                                value="false"
                                                control={<Radio />}
                                                label="No"
                                                sx={{
                                                  backgroundColor: "white",
                                                  padding: "0px 10px",
                                                  borderRadius: "5px",
                                                  border: "1px solid lightgrey",
                                                  textAlign: "right",
                                                  marginLeft: "2%",
                                                  marginTop: "2%",
                                                }}
                                              />
                                            </Box>
                                          </RadioGroup>
                                        </FormControl>

                                        <Box className="from-Error-load">
                                          {fieldFormik.errors.iv_batch_change &&
                                            fieldFormik.touched.iv_batch_change
                                            ? fieldFormik.errors.iv_batch_change
                                            : null}
                                        </Box>
                                      </Grid>
                                      {dialogRowData.changeOfAttributesType ==
                                        3 ||
                                        dialogRowData.changeOfAttributesType ==
                                        4 ||
                                        dialogRowData.changeOfAttributesType ==
                                        6 ||
                                        (dialogRowData.changeOfAttributesType ==
                                          7 && (
                                            <>
                                              {dialogRowData.newTariff &&
                                                dialogRowData.newTariff
                                                  .replace("-", "")
                                                  .startsWith("B") && (
                                                  <Grid
                                                    item
                                                    lg={3}
                                                    sx={{
                                                      marginTop: "2%",
                                                      display: "flex",
                                                      flexDirection: "column",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    <Typography
                                                      className="fieldLabel"
                                                      sx={{ marginBottom: "6px" }}
                                                    >
                                                      Seasonal / Non Seasonal
                                                    </Typography>

                                                    <FormControl fullWidth>
                                                      <RadioGroup
                                                        row
                                                        name="iv_seasonal"
                                                        value={
                                                          fieldFormik.values
                                                            .iv_seasonal
                                                            ? "1"
                                                            : "0"
                                                        } // default Non Seasonal
                                                        onChange={(e) => {
                                                          const isSeasonal =
                                                            e.target.value === "1";
                                                          fieldFormik.setFieldValue(
                                                            "iv_seasonal",
                                                            isSeasonal
                                                          );
                                                        }}
                                                        onBlur={
                                                          fieldFormik.handleBlur
                                                        }
                                                        sx={{
                                                          display: "flex",
                                                          flexDirection: "row",
                                                          justifyContent:
                                                            "space-between",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <FormControlLabel
                                                          value="1"
                                                          control={<Radio />}
                                                          label="Seasonal"
                                                          sx={{
                                                            backgroundColor:
                                                              "white",
                                                            padding: "4px 12px",
                                                            borderRadius: "6px",
                                                            border:
                                                              "1px solid lightgrey",
                                                            margin: 0,
                                                          }}
                                                        />
                                                        <FormControlLabel
                                                          value="0"
                                                          control={<Radio />}
                                                          label="Non Seasonal"
                                                          sx={{
                                                            backgroundColor:
                                                              "white",
                                                            padding: "4px 12px",
                                                            borderRadius: "6px",
                                                            border:
                                                              "1px solid lightgrey",
                                                            margin: 0,
                                                          }}
                                                        />
                                                      </RadioGroup>
                                                    </FormControl>
                                                  </Grid>
                                                )}
                                            </>
                                          ))}

                                      {fieldFormik.values.iv_batch_change ===
                                        true && (
                                          <>
                                            <Grid
                                              item
                                              lg={3}
                                              sx={{
                                                marginTop: "2%",
                                                textAlign: "center",
                                              }}
                                            >
                                              <Typography className="fieldLabel">
                                                Allot Reference No.
                                              </Typography>
                                              <Grid
                                                container
                                                spacing={1}
                                                display="flex"
                                              >
                                                <Grid item lg={4.5}>
                                                  <Select
                                                    sx={{ width: "100%" }}
                                                    value={
                                                      fieldFormik.values.iv_batch
                                                    }
                                                    onChange={
                                                      fieldFormik.handleChange
                                                    }
                                                    onBlur={fieldFormik.handleBlur}
                                                    displayEmpty
                                                    className="fieldBatch"
                                                    name="iv_batch"
                                                    id="iv_batch"
                                                    MenuProps={{
                                                      PaperProps: {
                                                        style: {
                                                          width: 20,
                                                          height: 180,
                                                        },
                                                      },
                                                    }}
                                                  >
                                                    <MenuItem
                                                      value=""
                                                      sx={{ fontSize: "12px" }}
                                                    >
                                                      Batch
                                                    </MenuItem>
                                                    {batchArray.map((option) => (
                                                      <MenuItem
                                                        key={option}
                                                        value={option}
                                                        sx={{ fontSize: "12px" }}
                                                      >
                                                        {option}
                                                      </MenuItem>
                                                    ))}
                                                  </Select>
                                                  <Box className="form-error">
                                                    {fieldFormik.errors.iv_batch &&
                                                      fieldFormik.touched.iv_batch
                                                      ? fieldFormik.errors.iv_batch
                                                      : null}
                                                  </Box>
                                                </Grid>

                                                <Grid item lg={7.5}>
                                                  <TextField
                                                    name="iv_reference_to_allot"
                                                    value={
                                                      fieldFormik.values
                                                        .iv_reference_to_allot
                                                    }
                                                    fullWidth
                                                    onChange={
                                                      fieldFormik.handleChange
                                                    }
                                                    onBlur={fieldFormik.handleBlur}
                                                    type="text"
                                                    sx={{ width: "100%" }}
                                                    inputProps={{ maxLength: 7 }}
                                                    InputProps={{
                                                      startAdornment: (
                                                        <InputAdornment
                                                          position="start"
                                                          sx={{ fontSize: "12px" }}
                                                          style={{
                                                            background: "#F2F4F6",
                                                          }}
                                                        >
                                                          {partialValue}
                                                        </InputAdornment>
                                                      ),
                                                    }}
                                                    className="fieldCoverageMarla"
                                                  />
                                                  <Box className="form-error">
                                                    {fieldFormik.errors
                                                      .iv_reference_to_allot &&
                                                      fieldFormik.touched
                                                        .iv_reference_to_allot
                                                      ? fieldFormik.errors
                                                        .iv_reference_to_allot
                                                      : null}
                                                  </Box>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                            <Grid
                                              item
                                              lg={2}
                                              sx={{
                                                marginTop: "2%",
                                                textAlign: "center",
                                              }}
                                            >
                                              <Typography className="fieldLabel">
                                                Sub Batch
                                              </Typography>
                                              <Select
                                                sx={{ width: "100%" }}
                                                value={
                                                  fieldFormik.values.iv_sub_batch
                                                }
                                                onChange={fieldFormik.handleChange}
                                                onBlur={fieldFormik.handleBlur}
                                                displayEmpty
                                                className="fieldBatch"
                                                name="iv_sub_batch"
                                                id="iv_sub_batch"
                                                MenuProps={{
                                                  PaperProps: {
                                                    style: {
                                                      width: 20,
                                                      height: 180,
                                                    },
                                                  },
                                                }}
                                              >
                                                <MenuItem
                                                  value=""
                                                  sx={{ fontSize: "12px" }}
                                                >
                                                  Select Sub Batch
                                                </MenuItem>
                                                {subBatchArray.map((option) => (
                                                  <MenuItem
                                                    key={option}
                                                    value={option}
                                                    sx={{ fontSize: "12px" }}
                                                  >
                                                    {option}
                                                  </MenuItem>
                                                ))}
                                              </Select>
                                              <p className="form-error">
                                                {fieldFormik.errors.iv_sub_batch &&
                                                  fieldFormik.touched.iv_sub_batch
                                                  ? fieldFormik.errors.iv_sub_batch
                                                  : null}
                                              </p>
                                            </Grid>
                                          </>
                                        )}

                                      {/* Show Prepare Estimate only when Material Required */}
                                      {fieldFormik.values.iv_material_required === true && (
                                        <Grid
                                          item
                                          lg={2}
                                          sx={{ marginTop: "2%" }}
                                        >
                                          <Typography className="fieldLabel">
                                            Prepare Estimate
                                          </Typography>
                                          <Button
                                            variant="contained"
                                            fullWidth
                                            component="label"
                                            sx={{ textTransform: "capitalize" }}
                                            startIcon={<AddIcon />}
                                            onClick={() => onPressAddPrepare()}
                                          >
                                            Prepare
                                          </Button>
                                          {errormessageBoqEstimation && (
                                            <Typography
                                              variant="body2"
                                              color="error"
                                              sx={{ mt: 1 }}
                                            >
                                              {errormessageBoqEstimation}
                                            </Typography>
                                          )}
                                        </Grid>
                                      )}

                                      {/* Show inline charge fields when Material Required = No AND load > 4 */}
                                      {/* Material Required = No: Only Grid Sharing Cost and Feeder Rehab Charges */}
                                      {fieldFormik.values.iv_material_required === false &&
                                        (dialogRowData.newSanctionLoad || dialogRowData.currentSanctionLoad) > 4 && (
                                          <>
                                            {/* <Grid item lg={12} sx={{ marginTop: "2%" }}>
                                            <Typography className="fieldLabel" sx={{ fontWeight: "bold", marginBottom: "1%" }}>
                                              Charges Details
                                            </Typography>
                                          </Grid> */}

                                            {/* Grid Sharing Cost */}
                                            <Grid item lg={2} sx={{ marginTop: "1%" }}>
                                              <Typography className="fieldLabel">
                                                Grid Sharing Cost
                                              </Typography>
                                              <TextField
                                                name="iv_grid_sharing_cost"
                                                value={formatWholeNumberInput(fieldFormik.values.iv_grid_sharing_cost)}
                                                type="text"
                                                inputProps={{ inputMode: "numeric" }}
                                                fullWidth
                                                size="small"
                                                onChange={handleWholeNumberFieldChange(
                                                  "iv_grid_sharing_cost",
                                                  setGridSharingCost
                                                )}
                                              />
                                            </Grid>

                                            {/* Feeder Rehab Charges */}
                                            <Grid item lg={2} sx={{ marginTop: "1%" }}>
                                              <Typography className="fieldLabel">
                                                Feeder Rehab Charges
                                              </Typography>
                                              <TextField
                                                name="iv_feeder_rehab_charges"
                                                value={formatWholeNumberInput(fieldFormik.values.iv_feeder_rehab_charges)}
                                                type="text"
                                                inputProps={{ inputMode: "numeric" }}
                                                fullWidth
                                                size="small"
                                                onChange={handleWholeNumberFieldChange(
                                                  "iv_feeder_rehab_charges",
                                                  setFeederRehabilitationCharges
                                                )}
                                              />
                                            </Grid>
                                          </>
                                        )}

                                      {/* Material Required = Yes: All other charges */}
                                    </>
                                  )}
                              </>
                            )}
                          </Grid>
                        </>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            Field Survey is in process by sanctioning authority.{" "}
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 3 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <Grid
                        container
                        className="step-title"
                        sx={{ marginBottom: "1%", padding: "0.5%" }}
                      >
                        <Grid item lg={1}></Grid>
                        <Grid item lg={10} sx={{ textAlign: "center" }}>
                          <h4>Field Survey</h4>
                        </Grid>
                      </Grid>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Change of Attributes",
                        "Workflow Permissions",
                        "Field Survey"
                      ) &&
                        (() => {
                          const sanctionLoad =
                            dialogRowData.newSanctionLoad ||
                            dialogRowData.currentSanctionLoad;
                          const currentTariff = dialogRowData.currentTariff
                            ?.replace(/-/g, "")
                            .trim();

                          return (
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "15"
                            ) &&
                              sanctionLoad > 0 &&
                              sanctionLoad <= 15 &&
                              ((CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Tariff Authority",
                                "A1"
                              ) &&
                                currentTariff?.startsWith("A1")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A2"
                                ) &&
                                  currentTariff?.startsWith("A2")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A3"
                                ) &&
                                  currentTariff?.startsWith("A3")))) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "70"
                            ) &&
                              sanctionLoad > 1 &&
                              sanctionLoad <= 70) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "500"
                            ) &&
                              sanctionLoad > 70 &&
                              sanctionLoad <= 500) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "5000"
                            ) &&
                              sanctionLoad > 500)
                          );
                        })() ? (
                        <>
                          <Grid
                            container
                            sx={{
                              marginBottom: "1%",
                              padding: 3,
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            spacing={2}
                          >
                            <Grid item lg={4} sx={{ marginTop: "2%" }}>
                              <Typography className="fieldLabel">
                                Site Observation
                              </Typography>

                              <FormControl
                                className="form-control"
                                sx={{
                                  marginLeft: "0 !important",
                                  paddingLeft: 0,
                                }}
                                style={{ marginLeft: 0 }}
                                fullWidth
                              >
                                <Select
                                  labelId="site-observation-label"
                                  id="iv_objection_Type"
                                  name="iv_objection_Type"
                                  value={
                                    fieldFormik.values.iv_objection_Type || ""
                                  }
                                  onChange={(e) => {
                                    fieldFormik.setFieldValue(
                                      "iv_objection_Type",
                                      e.target.value
                                    );
                                    if (e.target.value != "1") {
                                      fieldFormik.setFieldValue(
                                        "iv_batch_change",
                                        false
                                      );
                                    }
                                  }}
                                  onBlur={fieldFormik.handleBlur}
                                  className="textInputField"
                                  style={{ fontSize: "14px" }}
                                  displayEmpty
                                  disabled
                                >
                                  <MenuItem value="">
                                    <em>Select Site Observation</em>
                                  </MenuItem>

                                  {lookUpDataOfCON?.lookupFSObservation?.map(
                                    (item) => (
                                      <MenuItem
                                        key={item.observationType}
                                        value={item.observationType}
                                        style={{ fontSize: "14px" }}
                                      >
                                        {item.observationDetails}
                                      </MenuItem>
                                    )
                                  )}
                                </Select>
                              </FormControl>

                              <Box className="from-Error-load">
                                {fieldFormik.errors.iv_objection_Type &&
                                  fieldFormik.touched.iv_objection_Type
                                  ? fieldFormik.errors.iv_objection_Type
                                  : null}
                              </Box>
                            </Grid>
                            <Grid item lg={3}>
                              <Typography
                                className="documentLabel"
                                sx={{ display: "block", marginBottom: "6px" }}
                              >
                                Remarks
                              </Typography>

                              <textarea
                                id="iv_remarks"
                                name="iv_remarks"
                                placeholder="Enter your remarks..."
                                rows={4}
                                style={{
                                  width: "100%",
                                  fontSize: "14px",
                                  padding: "8px",
                                  borderRadius: "8px",
                                  border: "1px solid #ccc",
                                  resize: "none",
                                }}
                                value={
                                  fieldRemoveObjectionFormik.values.iv_remarks
                                }
                                onChange={
                                  fieldRemoveObjectionFormik.handleChange
                                }
                                onBlur={fieldRemoveObjectionFormik.handleBlur}
                              />

                              <Box
                                className="documentError"
                                sx={{ color: "red" }}
                              >
                                {fieldRemoveObjectionFormik.touched
                                  .iv_remarks &&
                                  fieldRemoveObjectionFormik.errors.iv_remarks}
                              </Box>
                            </Grid>
                            {fieldFormik.values.iv_objection_Type == "4" && (
                              <Grid
                                item
                                lg={4}
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <Typography
                                  className="documentLabel"
                                  sx={{ mb: 1 }}
                                >
                                  Document from Civic Authority
                                </Typography>

                                {additionalCivicDocument ? (
                                  <>
                                    {additionalCivicDocumentThumbnail && (
                                      <img
                                        src={additionalCivicDocumentThumbnail}
                                        alt="Civic Document"
                                        style={{
                                          width: "100%",
                                          maxWidth: "250px",
                                          borderRadius: "8px",
                                          marginBottom: "10px",
                                          objectFit: "contain",
                                          border: "1px solid #ccc",
                                        }}
                                      />
                                    )}

                                    <Button
                                      variant="outlined"
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        gap: 1,
                                        minWidth: "220px",
                                        textTransform: "none",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {additionalCivicDocument}
                                      </span>

                                      <CloseIcon
                                        sx={{
                                          color: "red",
                                          cursor: "pointer",
                                          "&:hover": { color: "darkred" },
                                        }}
                                        onClick={() => {
                                          setAdditionalCivicDocument("");
                                          setAdditionalCivicDocumentThumbnail(
                                            ""
                                          );
                                          fieldRemoveObjectionFormik.setFieldValue(
                                            "iv_additional_civic_document",
                                            ""
                                          );
                                        }}
                                      />
                                    </Button>
                                  </>
                                ) : (
                                  <>
                                    <Button
                                      variant="outlined"
                                      component="label"
                                      startIcon={<FileUploadOutlinedIcon />}
                                      className="btn"
                                    >
                                      Upload
                                      <input
                                        hidden
                                        accept={documentExtensions}
                                        id="iv_additional_civic_document"
                                        name="iv_additional_civic_document"
                                        type="file"
                                        onChange={AdditionalCivicDocument}
                                      />
                                    </Button>
                                    <Box
                                      className="documentError"
                                      sx={{ color: "red", mt: 1 }}
                                    >
                                      {fieldRemoveObjectionFormik.touched
                                        .iv_additional_civic_document &&
                                        fieldRemoveObjectionFormik.errors
                                          .iv_additional_civic_document}
                                    </Box>
                                  </>
                                )}
                              </Grid>
                            )}
                          </Grid>
                        </>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            Field Survey is in process by sanctioning authority.{" "}
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 4 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <Grid
                        container
                        className="step-title"
                        sx={{ marginBottom: "1%", padding: "0.5%" }}
                      >
                        <Grid item lg={1}></Grid>
                        <Grid item lg={10} sx={{ textAlign: "center" }}>
                          <h4>DN Approval</h4>
                        </Grid>
                        <Grid item lg={1}></Grid>
                      </Grid>
                      {
                        // CheckPermissions(permissions, 'General Services', 'Change of Attributes', 'Workflow Permissions', 'DN Approval') &&
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Demand Note Approval"
                        ) &&
                          (() => {
                            const sanctionLoad =
                              dialogRowData.newSanctionLoad ||
                              dialogRowData.currentSanctionLoad;
                            const currentTariff = dialogRowData.currentTariff
                              ?.replace(/-/g, "")
                              .trim();

                            return (
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "15"
                              ) &&
                                sanctionLoad > 0 &&
                                sanctionLoad <= 15 &&
                                ((CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A1"
                                ) &&
                                  currentTariff?.startsWith("A1")) ||
                                  (CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "Change of Attributes",
                                    "Workflow Permissions",
                                    "Approval Category",
                                    "Tariff Authority",
                                    "A2"
                                  ) &&
                                    currentTariff?.startsWith("A2")) ||
                                  (CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "Change of Attributes",
                                    "Workflow Permissions",
                                    "Approval Category",
                                    "Tariff Authority",
                                    "A3"
                                  ) &&
                                    currentTariff?.startsWith("A3")))) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "70"
                              ) &&
                                sanctionLoad > 1 &&
                                sanctionLoad <= 70) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "500"
                              ) &&
                                sanctionLoad > 70 &&
                                sanctionLoad <= 500) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "5000"
                              ) &&
                                sanctionLoad > 500)
                            );
                          })() ? (
                          <>
                            {dnApproveStep && (
                              <Grid
                                container
                                spacing={2}
                                className="dn-payment-submission-container"
                              >
                                {(() => {
                                  const total =
                                    (parseFloat(
                                      dnApproveStep.securityDepositeAmount
                                    ) || 0) +
                                    // (parseFloat(dnApproveStep.amountOfGridSharing) || 0) +
                                    // (parseFloat(dnApproveStep.amountOfFeederRehab) || 0) +
                                    (parseFloat(
                                      dnApproveStep.capitalCostAmount
                                    ) || 0);
                                  // (parseFloat(dnApproveStep.civilWorkCharges) || 0) +
                                  // (parseFloat(dnApproveStep.fixedChargesOfMetering) || 0) +
                                  // (parseFloat(dnApproveStep.miscellaneousCharges) || 0) -
                                  // (parseFloat(dnApproveStep.lessTheCost) || 0);

                                  // const fields = [
                                  //   { label: "Issue Date", value: dnApproveStep.issueDate ? convertDate(dnApproveStep.issueDate) : null },
                                  //   { label: "Due Date", value: dnApproveStep.dueDate ? convertDate(dnApproveStep.dueDate) : null },
                                  //   { label: "Bank Name", value: dnApproveStep.bankName },
                                  //   { label: "Previous Security Cost", value: parseFloat(dnApproveStep.previousSecurity) || 0 },
                                  //   { label: "Current Estimated Security Cost", value: parseFloat(dnApproveStep.securityDepositeAmount) || 0 },
                                  //   { label: "Amount of Grid Sharing", value: parseFloat(dnApproveStep.amountOfGridSharing) || 0 },
                                  //   { label: "Amount of Feeder Rehab", value: parseFloat(dnApproveStep.amountOfFeederRehab) || 0 },
                                  //   { label: "Capital Cost Amount", value: parseFloat(dnApproveStep.capitalCostAmount) || 0 },
                                  //   { label: "Civil Work Charges", value: parseFloat(dnApproveStep.civilWorkCharges) || 0 },
                                  //   { label: "Fixed Charges Of Metering", value: parseFloat(dnApproveStep.fixedChargesOfMetering) || 0 },
                                  //   { label: "Miscellaneous Charges", value: parseFloat(dnApproveStep.miscellaneousCharges) || 0 },
                                  //   { label: "Less the Cost", value: parseFloat(dnApproveStep.lessTheCost) || 0 },
                                  //   { label: "Grand Total", value: total },
                                  // ];
                                  const fields = [
                                    {
                                      label: "Issue Date",
                                      value: dnApproveStep.issueDate
                                        ? convertDate(dnApproveStep.issueDate)
                                        : null,
                                    },
                                    {
                                      label: "Due Date",
                                      value: dnApproveStep.dueDate
                                        ? convertDate(dnApproveStep.dueDate)
                                        : null,
                                    },
                                    {
                                      label: "Bank Name",
                                      value: dnApproveStep.bankName,
                                    },
                                    {
                                      label: "Capital Cost Amount",
                                      value:
                                        parseFloat(
                                          dnApproveStep.capitalCostAmount
                                        ) || 0,
                                    },
                                    {
                                      label: "Security Deposite Amount",
                                      value:
                                        parseFloat(
                                          dnApproveStep.securityDepositeAmount
                                        ) || 0,
                                    },
                                    {
                                      label:
                                        "Grand Total (Capital Amount + Security Amount)",
                                      value: total,
                                    },
                                  ];

                                  return fields
                                    .filter((item) => {
                                      // Special handling for Issue Date, Due Date, Bank Name
                                      if (
                                        [
                                          "Issue Date",
                                          "Due Date",
                                          "Bank Name",
                                        ].includes(item.label)
                                      ) {
                                        return (
                                          item.value !== null &&
                                          item.value !== undefined &&
                                          item.value !== ""
                                        );
                                      }
                                      return item.value > 0;
                                    })
                                    .map((item, index) => (
                                      <Grid
                                        item
                                        lg={4}
                                        md={6}
                                        sm={12}
                                        key={index}
                                        className="item"
                                      >
                                        <Typography
                                          className="title"
                                          sx={{
                                            fontWeight: 600,
                                            color:
                                              item.label === "Grand Total"
                                                ? "#1976d2"
                                                : "#333",
                                          }}
                                        >
                                          {item.label}
                                        </Typography>
                                        <Typography
                                          className="value"
                                          sx={
                                            item.label === "Grand Total"
                                              ? {
                                                backgroundColor:
                                                  "#1976d2 !important",
                                                color: "#fff !important",
                                                fontSize: "1.1rem",
                                              }
                                              : { color: "#444" }
                                          }
                                        >
                                          {["Issue Date", "Due Date"].includes(
                                            item.label
                                          )
                                            ? item.value
                                            : item.label === "Bank Name"
                                              ? item.value
                                              : numberFormatting(item.value)}
                                        </Typography>
                                      </Grid>
                                    ));
                                })()}
                              </Grid>
                            )}
                          </>
                        ) : (
                          <div className="description-box">
                            <p className="group-description">
                              <InfoIcon className="icon" />
                              Demand Note Approval is in process by sanctioning
                              authority.{" "}
                            </p>
                          </div>
                        )
                      }
                    </>
                  ) : dialogRowData.applicationProgressId === 5 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2 ||
                      dialogRowData.objectionStatus === 1) ? (
                    <>
                      <Grid
                        container
                        className="step-title"
                        sx={{ marginBottom: "1%", padding: "0.5%" }}
                      >
                        <Grid item lg={1}></Grid>
                        <Grid item lg={10} sx={{ textAlign: "center" }}>
                          <h4>DN Submission</h4>
                        </Grid>
                        <Grid item lg={1}>
                          <Button
                            variant="outlined"
                            onClick={handleDialogDnDownload}
                            sx={{
                              backgroundColor: "white",
                              cursor: "pointer",
                              border: "1px solid #006ad1",
                              boxShadow: "none",
                              width: "5%",
                            }}
                          >
                            <PrintIcon
                              sx={{ color: "#006ad1", marginLeft: "1%" }}
                            />{" "}
                            DN{" "}
                          </Button>
                        </Grid>
                      </Grid>
                      {
                        // CheckPermissions(permissions, 'General Services', 'Change of Attributes', 'Workflow Permissions', 'DN Submission') &&
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Demand Note Submission"
                        ) &&
                          (() => {
                            const sanctionLoad =
                              dialogRowData.newSanctionLoad ||
                              dialogRowData.currentSanctionLoad;
                            const currentTariff = dialogRowData.currentTariff
                              ?.replace(/-/g, "")
                              .trim();

                            return (
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "15"
                              ) &&
                                sanctionLoad > 0 &&
                                sanctionLoad <= 15 &&
                                ((CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A1"
                                ) &&
                                  currentTariff?.startsWith("A1")) ||
                                  (CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "Change of Attributes",
                                    "Workflow Permissions",
                                    "Approval Category",
                                    "Tariff Authority",
                                    "A2"
                                  ) &&
                                    currentTariff?.startsWith("A2")) ||
                                  (CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "Change of Attributes",
                                    "Workflow Permissions",
                                    "Approval Category",
                                    "Tariff Authority",
                                    "A3"
                                  ) &&
                                    currentTariff?.startsWith("A3")))) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "70"
                              ) &&
                                sanctionLoad > 1 &&
                                sanctionLoad <= 70) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "500"
                              ) &&
                                sanctionLoad > 70 &&
                                sanctionLoad <= 500) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "5000"
                              ) &&
                                sanctionLoad > 500)
                            );
                          })() ? (
                          <>
                            {dnApproveStep && (
                              <Grid
                                container
                                spacing={2}
                                className="dn-payment-submission-container"
                              >
                                {(() => {
                                  const total =
                                    (parseFloat(
                                      dnApproveStep.securityDepositeAmount
                                    ) || 0) +
                                    // (parseFloat(dnApproveStep.amountOfGridSharing) || 0) +
                                    // (parseFloat(dnApproveStep.amountOfFeederRehab) || 0) +
                                    (parseFloat(
                                      dnApproveStep.capitalCostAmount
                                    ) || 0);
                                  // (parseFloat(dnApproveStep.civilWorkCharges) || 0) +
                                  // (parseFloat(dnApproveStep.fixedChargesOfMetering) || 0) +
                                  // (parseFloat(dnApproveStep.miscellaneousCharges) || 0) -
                                  // (parseFloat(dnApproveStep.lessTheCost) || 0);

                                  const fields = [
                                    {
                                      label: "Issue Date",
                                      value: dnApproveStep.issueDate
                                        ? convertDate(dnApproveStep.issueDate)
                                        : null,
                                    },
                                    {
                                      label: "Due Date",
                                      value: dnApproveStep.dueDate
                                        ? convertDate(dnApproveStep.dueDate)
                                        : null,
                                    },
                                    {
                                      label: "Bank Name",
                                      value: dnApproveStep.bankName,
                                    },
                                    {
                                      label: "Capital Cost",
                                      value:
                                        parseFloat(
                                          dnApproveStep.capitalCostAmount
                                        ) || 0,
                                    },
                                    {
                                      label: "Security Deposite Amount",
                                      value:
                                        parseFloat(
                                          dnApproveStep.securityDepositeAmount
                                        ) || 0,
                                    },
                                    {
                                      label:
                                        "Grand Total (Capital Amount + Security Amount)",
                                      value: total,
                                    },
                                  ];

                                  return fields
                                    .filter((item) => {
                                      // Special handling for Issue Date, Due Date, Bank Name
                                      if (
                                        [
                                          "Issue Date",
                                          "Due Date",
                                          "Bank Name",
                                        ].includes(item.label)
                                      ) {
                                        return (
                                          item.value !== null &&
                                          item.value !== undefined &&
                                          item.value !== ""
                                        );
                                      }
                                      // For all other fields: show only if value > 0
                                      return item.value > 0;
                                    })
                                    .map((item, index) => (
                                      <Grid
                                        item
                                        lg={4}
                                        md={6}
                                        sm={12}
                                        key={index}
                                        className="item"
                                      >
                                        <Typography
                                          className="title"
                                          sx={{
                                            fontWeight: 600,
                                            color:
                                              item.label === "Grand Total"
                                                ? "#1976d2"
                                                : "#333",
                                          }}
                                        >
                                          {item.label}
                                        </Typography>
                                        <Typography
                                          className="value"
                                          sx={
                                            item.label === "Grand Total"
                                              ? {
                                                backgroundColor:
                                                  "#1976d2 !important",
                                                color: "#fff !important",
                                                fontSize: "1.1rem",
                                              }
                                              : { color: "#444" }
                                          }
                                        >
                                          {["Issue Date", "Due Date"].includes(
                                            item.label
                                          )
                                            ? item.value
                                            : item.label === "Bank Name"
                                              ? item.value
                                              : numberFormatting(item.value)}
                                        </Typography>
                                      </Grid>
                                    ));
                                })()}
                              </Grid>
                            )}

                            <Grid container spacing={3} sx={{ paddingLeft: 2 }}>
                              <Grid item lg={3} sx={{ marginTop: "2%" }}>
                                <Typography className="fieldLabel">
                                  Receipt Image
                                </Typography>

                                {dnReceiptImageUploaded &&
                                  dnReceiptImageUploaded !== "" ? (
                                  <Grid container>
                                    <Grid item sm={6}>
                                      <a
                                        href="#"
                                        onClick={() =>
                                          openBase64Image(
                                            dnReceiptImageUploaded
                                          )
                                        }
                                        target="_blank"
                                        rel="noreferrer"
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          marginTop: "2%",
                                        }}
                                      >
                                        <img
                                          src={dnReceiptImageThumbnail}
                                          alt="Receipt Image"
                                          style={{ width: "100%" }}
                                        />
                                      </a>
                                    </Grid>

                                    <Grid item sm={6}>
                                      <Button
                                        variant="outlined"
                                        component="label"
                                        startIcon={
                                          <CloseIcon sx={{ color: "red" }} />
                                        }
                                      >
                                        Change
                                        <input
                                          hidden
                                          accept={documentExtensions}
                                          id="iv_receipt_image"
                                          name="iv_receipt_image"
                                          type="file"
                                          onChange={DnReceiptImage}
                                        />
                                      </Button>
                                    </Grid>
                                  </Grid>
                                ) : dnReceiptImage && dnReceiptImage !== "" ? (
                                  <Button
                                    variant="contained"
                                    component="label"
                                    startIcon={
                                      <CloseIcon
                                        sx={{ color: "red" }}
                                        onClick={() => setDnReceiptImage(null)}
                                      />
                                    }
                                    sx={{ marginTop: "2%" }}
                                  >
                                    {dnReceiptImageThumbnail && (
                                      <img
                                        src={dnReceiptImageThumbnail}
                                        alt="Receipt Image"
                                        width="100"
                                      />
                                    )}
                                  </Button>
                                ) : (
                                  <Button
                                    variant="outlined"
                                    component="label"
                                    startIcon={<FileUploadOutlinedIcon />}
                                    sx={{
                                      width: "80%",
                                      backgroundColor: "white",
                                      textTransform: "capitalize",
                                      marginTop: "2%",
                                    }}
                                    disabled={
                                      dnDetails &&
                                      dnDetails.filledFlag === 1 &&
                                      CheckPermissions(
                                        permissions,
                                        "General Services",
                                        "Change of Attributes",
                                        "Workflow Permissions",
                                        "Field Survey",
                                        "Survey Form Creation"
                                      )
                                    }
                                  >
                                    Upload
                                    <input
                                      hidden
                                      accept={documentExtensions}
                                      id="iv_receipt_image"
                                      name="iv_receipt_image"
                                      type="file"
                                      onChange={DnReceiptImage}
                                    />
                                  </Button>
                                )}

                                <Box
                                  className="form-error"
                                  sx={{ color: "red" }}
                                >
                                  {dnPymentReceiptFormik.errors
                                    .iv_receipt_image &&
                                    dnPymentReceiptFormik.touched.iv_receipt_image
                                    ? dnPymentReceiptFormik.errors
                                      .iv_receipt_image
                                    : null}
                                </Box>
                                <Box
                                  className="form-error"
                                  sx={{ color: "red" }}
                                >
                                  {receiptImageError ? receiptImageError : null}
                                </Box>
                              </Grid>

                              <Grid
                                item
                                xs={12}
                                md={3}
                                sx={{ marginTop: "2%" }}
                              >
                                <Typography className="fieldLabel">
                                  Payment Date
                                </Typography>

                                <Box
                                  onClick={() =>
                                    document
                                      .getElementById("iv_payment_date_field")
                                      ?.showPicker?.()
                                  } // triggers date picker
                                  sx={{
                                    backgroundColor: "white",
                                    borderRadius: 1,
                                    cursor: "pointer",
                                    "&:hover": { borderColor: "primary.main" },
                                  }}
                                >
                                  <TextField
                                    fullWidth
                                    size="small"
                                    id="iv_payment_date_field"
                                    name="iv_payment_date"
                                    type="date"
                                    value={
                                      dnPymentReceiptFormik.values
                                        .iv_payment_date || ""
                                    }
                                    onChange={
                                      dnPymentReceiptFormik.handleChange
                                    }
                                    onBlur={dnPymentReceiptFormik.handleBlur}
                                    sx={{
                                      backgroundColor: "white",
                                      "& .MuiInputBase-root": {
                                        cursor: "pointer",
                                      },
                                    }}
                                    inputProps={{
                                      max: new Date()
                                        .toISOString()
                                        .split("T")[0],
                                      min: (() => {
                                        if (!dnApproveStep?.approvedDate)
                                          return undefined;
                                        const [datePart] =
                                          dnApproveStep.approvedDate.split(" ");
                                        const [month, day, year] =
                                          datePart.split("/");
                                        return `${year}-${month.padStart(
                                          2,
                                          "0"
                                        )}-${day.padStart(2, "0")}`;
                                      })(),
                                    }}
                                  // error={
                                  //   dnPymentReceiptFormik.touched.iv_payment_date &&
                                  //   Boolean(dnPymentReceiptFormik.errors.iv_payment_date)
                                  // }
                                  // helperText={
                                  //   dnPymentReceiptFormik.touched.iv_payment_date &&
                                  //   dnPymentReceiptFormik.errors.iv_payment_date
                                  // }
                                  />
                                </Box>

                                {/* Show Formik validation error */}
                                <Box
                                  className="form-error"
                                  sx={{ color: "red" }}
                                >
                                  {dnPymentReceiptFormik.errors
                                    .iv_payment_date &&
                                    dnPymentReceiptFormik.touched.iv_payment_date
                                    ? dnPymentReceiptFormik.errors
                                      .iv_payment_date
                                    : null}
                                </Box>

                                {/* Optional custom manual error (if any) */}
                                <Box
                                  className="form-error"
                                  sx={{ color: "red" }}
                                >
                                  {paymentDateError ? paymentDateError : null}
                                </Box>
                              </Grid>
                            </Grid>
                          </>
                        ) : (
                          <div className="description-box">
                            <p className="group-description">
                              <InfoIcon className="icon" />
                              Demand Note Submission is in process by
                              sanctioning authority.{" "}
                            </p>
                          </div>
                        )
                      }
                    </>
                  ) : dialogRowData.applicationProgressId === 6 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <Grid
                        container
                        className="step-title"
                        sx={{ marginBottom: "1%", padding: "0.5%" }}
                      >
                        <Grid item lg={1}></Grid>
                        <Grid item lg={10} sx={{ textAlign: "center" }}>
                          <h4>DN Payment Verification</h4>
                        </Grid>
                        <Grid item lg={1}>
                          <Button
                            variant="outlined"
                            onClick={handleDialogDnDownload}
                            sx={{
                              backgroundColor: "white",
                              cursor: "pointer",
                              border: "1px solid #006ad1",
                              boxShadow: "none",
                              width: "5%",
                            }}
                          >
                            <PrintIcon
                              sx={{ color: "#006ad1", marginLeft: "1%" }}
                            />{" "}
                            DN{" "}
                          </Button>
                        </Grid>
                      </Grid>
                      {
                        // CheckPermissions(permissions, 'General Services', 'Change of Attributes', 'Workflow Permissions', 'DN Payment Verification') &&

                        CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Demand Note Payment Verification"
                        ) &&
                          (() => {
                            const sanctionLoad =
                              dialogRowData.newSanctionLoad ||
                              dialogRowData.currentSanctionLoad;
                            const currentTariff = dialogRowData.currentTariff
                              ?.replace(/-/g, "")
                              .trim();

                            return (
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "15"
                              ) &&
                                sanctionLoad > 0 &&
                                sanctionLoad <= 15 &&
                                ((CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A1"
                                ) &&
                                  currentTariff?.startsWith("A1")) ||
                                  (CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "Change of Attributes",
                                    "Workflow Permissions",
                                    "Approval Category",
                                    "Tariff Authority",
                                    "A2"
                                  ) &&
                                    currentTariff?.startsWith("A2")) ||
                                  (CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "Change of Attributes",
                                    "Workflow Permissions",
                                    "Approval Category",
                                    "Tariff Authority",
                                    "A3"
                                  ) &&
                                    currentTariff?.startsWith("A3")))) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "70"
                              ) &&
                                sanctionLoad > 1 &&
                                sanctionLoad <= 70) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "500"
                              ) &&
                                sanctionLoad > 70 &&
                                sanctionLoad <= 500) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Load Sanctioning",
                                "5000"
                              ) &&
                                sanctionLoad > 500)
                            );
                          })() ? (
                          <>
                            <Grid
                              container
                              className="dn-payment-submission-container"
                            >
                              <Grid item lg={6} className="item">
                                <Typography className="title">
                                  Demand Notice No
                                </Typography>
                                <Typography className="value">
                                  {dnApproveStep.demandNoteNo
                                    ? dnApproveStep.demandNoteNo
                                    : "-"}
                                </Typography>
                              </Grid>
                              <Grid item lg={6} className="item">
                                <Typography className="title">
                                  Reference No
                                </Typography>
                                <Typography className="value">
                                  {dnApproveStep.connectionAccountNo
                                    ? dnApproveStep.connectionAccountNo
                                    : "-"}
                                </Typography>
                              </Grid>
                              <Grid item lg={6} className="item">
                                <Typography className="title">
                                  DN Amount
                                </Typography>
                                <Typography className="value">
                                  {(() => {
                                    const total =
                                      (parseFloat(
                                        dnApproveStep.securityDepositeAmount
                                      ) || 0) +
                                      
                                      (parseFloat(
                                        dnApproveStep.capitalCostAmount
                                      ) || 0);

                                    return total > 0
                                      ? numberFormatting(total)
                                      : "-";
                                  })()}
                                </Typography>{" "}
                              </Grid>
                              <Grid item lg={6} className="item">
                                <Typography className="title">
                                  Payment Date
                                </Typography>
                                <Typography className="value">
                                  {dnApproveStep.paymentDate
                                    ? convertDate(dnApproveStep.paymentDate)
                                    : "-"}
                                </Typography>
                              </Grid>
                              <Grid item lg={12}></Grid>
                              <Grid item lg={3} className="paidDnDocument item">
                                <Typography className="title">
                                  Paid Demand Notice
                                </Typography>
                                <Grid
                                  container
                                  sx={{
                                    backgroundColor:
                                      getDocumentBackGroundColor(0),
                                    borderRadius: "10px",
                                    height: "250px",
                                    width: "100%",
                                    marginRight: "2%",
                                  }}
                                  className="docContainer"
                                >
                                  <Grid
                                    item
                                    lg={12}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      paddingBottom: "5px",
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        if (!paidDNImagePopUp) {
                                          setPaidDNImagePopUp(true);
                                        }
                                      }}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <Base64Image data={dnImage} width={80} />
                                    </div>
                                    {paidDNImagePopUp && (
                                      <OpenBase64ImageInPopup
                                        docVerifyPopUp={paidDNImagePopUp}
                                        hideDocVerifyPopup={
                                          hidePaidDnImagePopUp
                                        }
                                        documentName="Paid DN Image"
                                        documentImage={dnImage}
                                        width={"100%"}
                                        document={dnImage}
                                        documentFlag={1}
                                        applicationProgressId={
                                          dialogRowData.applicationProgressId
                                        }
                                        objectionStatus={
                                          dialogRowData.objectionStatus
                                        }
                                        updateDocFlag={updateDocFlag}
                                        titleToUpdateFlag="copyOfApplicantCNIC"
                                        flag_document={1}
                                      />
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item lg={4.5} className="item">
                                <Typography className="title">
                                  Customer ID. Front
                                </Typography>
                                <Grid
                                  container
                                  sx={{
                                    backgroundColor:
                                      getDocumentBackGroundColor(0),
                                    borderRadius: "10px",
                                    height: "250px",
                                    width: "100%",
                                  }}
                                  className="docContainer"
                                >
                                  <img
                                    src={dialogRowData.applicantCNICFront}
                                    alt="Cnic Front"
                                    style={{ width: "100%", height: "100%" }}
                                  ></img>
                                </Grid>
                              </Grid>
                              <Grid item lg={4.5} className="item">
                                <Typography className="title">
                                  Customer ID. Back
                                </Typography>
                                <Grid
                                  container
                                  sx={{
                                    backgroundColor:
                                      getDocumentBackGroundColor(0),
                                    borderRadius: "10px",
                                    height: "250px",
                                    width: "100%",
                                  }}
                                  className="docContainer"
                                >
                                  <img
                                    src={dialogRowData.applicantCNICBack}
                                    alt="Cnic Back"
                                    style={{ width: "100%", height: "100%" }}
                                  ></img>
                                </Grid>
                              </Grid>
                            </Grid>
                          </>
                        ) : (
                          <div className="description-box">
                            <p className="group-description">
                              <InfoIcon className="icon" />
                              DN Payment Verification is in process by
                              sanctioning authority.{" "}
                            </p>
                          </div>
                        )
                      }
                    </>
                  ) : dialogRowData.applicationProgressId === 7 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) &&
                    dialogRowData.scoFillFlag === null ? (
                    <>
                      {(dialogRowData.changeOfAttributesType == 1 ||
                        dialogRowData.changeOfAttributesType == 2 ||
                        dialogRowData.changeOfAttributesType == 3 ||
                        dialogRowData.changeOfAttributesType == 4 ||
                        dialogRowData.changeOfAttributesType == 5 ||
                        dialogRowData.changeOfAttributesType == 6 ||
                        dialogRowData.changeOfAttributesType == 7) && (
                          <>
                            {/* Title & Button - Sirf Ek Dafa */}
                            <Grid
                              container
                              className="step-title"
                              sx={{ marginBottom: "1%", padding: "0.5%" }}
                            >
                              <Grid item lg={1}></Grid>
                              <Grid item lg={10} sx={{ textAlign: "center" }}>
                                <h4>Sundry Jobs Order</h4>
                              </Grid>
                            </Grid>

                            {CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Sundry Job Order",
                              "SJO Submission"
                            ) &&
                              (() => {
                                const sanctionLoad =
                                  dialogRowData.newSanctionLoad ||
                                  dialogRowData.currentSanctionLoad;
                                const currentTariff = dialogRowData.currentTariff
                                  ?.replace(/-/g, "")
                                  .trim();

                                return (
                                  (CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "Change of Attributes",
                                    "Workflow Permissions",
                                    "Approval Category",
                                    "Load Sanctioning",
                                    "15"
                                  ) &&
                                    sanctionLoad > 0 &&
                                    sanctionLoad <= 15 &&
                                    ((CheckPermissions(
                                      permissions,
                                      "General Services",
                                      "Change of Attributes",
                                      "Workflow Permissions",
                                      "Approval Category",
                                      "Tariff Authority",
                                      "A1"
                                    ) &&
                                      currentTariff?.startsWith("A1")) ||
                                      (CheckPermissions(
                                        permissions,
                                        "General Services",
                                        "Change of Attributes",
                                        "Workflow Permissions",
                                        "Approval Category",
                                        "Tariff Authority",
                                        "A2"
                                      ) &&
                                        currentTariff?.startsWith("A2")) ||
                                      (CheckPermissions(
                                        permissions,
                                        "General Services",
                                        "Change of Attributes",
                                        "Workflow Permissions",
                                        "Approval Category",
                                        "Tariff Authority",
                                        "A3"
                                      ) &&
                                        currentTariff?.startsWith("A3")))) ||
                                  (CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "Change of Attributes",
                                    "Workflow Permissions",
                                    "Approval Category",
                                    "Load Sanctioning",
                                    "70"
                                  ) &&
                                    sanctionLoad > 1 &&
                                    sanctionLoad <= 70) ||
                                  (CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "Change of Attributes",
                                    "Workflow Permissions",
                                    "Approval Category",
                                    "Load Sanctioning",
                                    "500"
                                  ) &&
                                    sanctionLoad > 70 &&
                                    sanctionLoad <= 500) ||
                                  (CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "Change of Attributes",
                                    "Workflow Permissions",
                                    "Approval Category",
                                    "Load Sanctioning",
                                    "5000"
                                  ) &&
                                    sanctionLoad > 500)
                                );
                              })() ? (
                              <Grid
                                container
                                className="dn-payment-submission-container"
                              >
                                <Grid item lg={12} className="item">
                                  <Typography
                                    sx={{ fontSize: "1.5rem", fontWeight: 500 }}
                                  >
                                    {dnApproveStep.sjoData
                                      ? dnApproveStep.sjoData
                                      : "-"}
                                  </Typography>
                                </Grid>

                                {/* Table - Content Type ke Hisaab se Change */}
                                <Grid item lg={12} mt={2}>
                                  <Table
                                    sx={{
                                      borderCollapse: "collapse",
                                      width: "100%",
                                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <TableHead>
                                      <TableRow
                                        sx={{
                                          backgroundImage:
                                            "linear-gradient(180deg, #1e52a7, #a0bbe7)",
                                        }}
                                      >
                                        <TableCell
                                          sx={{
                                            color: "white",
                                            fontWeight: "bold",
                                            border: "1px solid #1565c0",
                                            padding: "6px 10px",
                                          }}
                                        ></TableCell>

                                        {/* Column Labels: Current/New ya New/Old */}
                                        {[1, 4, 5, 6].includes(
                                          dialogRowData.changeOfAttributesType
                                        ) ? (
                                          <>
                                            <TableCell
                                              sx={{
                                                color: "white",
                                                fontWeight: "bold",
                                                border: "1px solid #1565c0",
                                                padding: "6px 10px",
                                              }}
                                            >
                                              Current
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                color: "white",
                                                fontWeight: "bold",
                                                border: "1px solid #1565c0",
                                                padding: "6px 10px",
                                              }}
                                            >
                                              New
                                            </TableCell>
                                          </>
                                        ) : (
                                          <>
                                            <TableCell
                                              sx={{
                                                color: "white",
                                                fontWeight: "bold",
                                                border: "1px solid #1565c0",
                                                padding: "6px 10px",
                                              }}
                                            >
                                              Old
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                color: "white",
                                                fontWeight: "bold",
                                                border: "1px solid #1565c0",
                                                padding: "6px 10px",
                                              }}
                                            >
                                              New
                                            </TableCell>
                                          </>
                                        )}
                                      </TableRow>
                                    </TableHead>

                                    <TableBody>
                                      {getTableRows(dialogRowData).map(
                                        (row, index) => (
                                          <TableRow
                                            key={index}
                                            sx={{
                                              backgroundColor:
                                                index % 2 === 0
                                                  ? "white"
                                                  : "rgb(213, 229, 255)",
                                              "&:hover": {
                                                backgroundColor: "#e3f2fd",
                                              },
                                            }}
                                          >
                                            <TableCell
                                              sx={{
                                                fontWeight: "bold",
                                                border: "1px solid #e0e0e0",
                                                padding: "8px 16px",
                                              }}
                                            >
                                              {row.label || "-"}
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                border: "1px solid #e0e0e0",
                                                padding: "8px 16px",
                                              }}
                                            >
                                              {row.current}
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                border: "1px solid #e0e0e0",
                                                padding: "8px 16px",
                                              }}
                                            >
                                              {row.newVal}
                                            </TableCell>
                                          </TableRow>
                                        )
                                      )}
                                    </TableBody>
                                  </Table>
                                </Grid>
                              </Grid>
                            ) : (
                              <div className="description-box">
                                <p className="group-description">
                                  <InfoIcon className="icon" />
                                  Sundary Job Order Submission is in process by
                                  sanctioning authority.{" "}
                                </p>
                              </div>
                            )}
                          </>
                        )}
                    </>
                  ) : dialogRowData.applicationProgressId === 7 &&
                    dialogRowData.scoFillFlag === 1 ? (
                    <>
                      {(dialogRowData.changeOfAttributesType == 1 ||
                        dialogRowData.changeOfAttributesType == 2 ||
                        dialogRowData.changeOfAttributesType == 3 ||
                        dialogRowData.changeOfAttributesType == 4 ||
                        dialogRowData.changeOfAttributesType == 5 ||
                        dialogRowData.changeOfAttributesType == 6 ||
                        dialogRowData.changeOfAttributesType == 7) && (
                          <>
                            <Grid
                              container
                              className="step-title"
                              sx={{ marginBottom: "1%", padding: "0.5%" }}
                            >
                              <Grid item lg={1}></Grid>
                              <Grid item lg={10} sx={{ textAlign: "center" }}>
                                <h4>Sundry Jobs Order</h4>
                              </Grid>
                            </Grid>

                            {CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Sundry Job Order",
                              "SJO Approval"
                            ) &&
                              (() => {
                                const sanctionLoad =
                                  dialogRowData.newSanctionLoad ||
                                  dialogRowData.currentSanctionLoad;
                                const currentTariff = dialogRowData.currentTariff
                                  ?.replace(/-/g, "")
                                  .trim();

                                return (
                                  (CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "Change of Attributes",
                                    "Workflow Permissions",
                                    "Approval Category",
                                    "Load Sanctioning",
                                    "15"
                                  ) &&
                                    sanctionLoad > 0 &&
                                    sanctionLoad <= 15 &&
                                    ((CheckPermissions(
                                      permissions,
                                      "General Services",
                                      "Change of Attributes",
                                      "Workflow Permissions",
                                      "Approval Category",
                                      "Tariff Authority",
                                      "A1"
                                    ) &&
                                      currentTariff?.startsWith("A1")) ||
                                      (CheckPermissions(
                                        permissions,
                                        "General Services",
                                        "Change of Attributes",
                                        "Workflow Permissions",
                                        "Approval Category",
                                        "Tariff Authority",
                                        "A2"
                                      ) &&
                                        currentTariff?.startsWith("A2")) ||
                                      (CheckPermissions(
                                        permissions,
                                        "General Services",
                                        "Change of Attributes",
                                        "Workflow Permissions",
                                        "Approval Category",
                                        "Tariff Authority",
                                        "A3"
                                      ) &&
                                        currentTariff?.startsWith("A3")))) ||
                                  (CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "Change of Attributes",
                                    "Workflow Permissions",
                                    "Approval Category",
                                    "Load Sanctioning",
                                    "70"
                                  ) &&
                                    sanctionLoad > 1 &&
                                    sanctionLoad <= 70) ||
                                  (CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "Change of Attributes",
                                    "Workflow Permissions",
                                    "Approval Category",
                                    "Load Sanctioning",
                                    "500"
                                  ) &&
                                    sanctionLoad > 70 &&
                                    sanctionLoad <= 500) ||
                                  (CheckPermissions(
                                    permissions,
                                    "General Services",
                                    "Change of Attributes",
                                    "Workflow Permissions",
                                    "Approval Category",
                                    "Load Sanctioning",
                                    "5000"
                                  ) &&
                                    sanctionLoad > 500)
                                );
                              })() ? (
                              <Grid
                                container
                                className="dn-payment-submission-container"
                              >
                                <Grid item lg={12} className="item">
                                  <Typography
                                    sx={{ fontSize: "1.5rem", fontWeight: 500 }}
                                  >
                                    {dnApproveStep.sjoData
                                      ? dnApproveStep.sjoData
                                      : "-"}
                                  </Typography>
                                </Grid>

                                {/* Table - Content Type ke Hisaab se Change */}
                                <Grid item lg={12} mt={2}>
                                  <Table
                                    sx={{
                                      borderCollapse: "collapse",
                                      width: "100%",
                                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <TableHead>
                                      <TableRow
                                        sx={{
                                          backgroundImage:
                                            "linear-gradient(180deg, #1e52a7, #a0bbe7)",
                                        }}
                                      >
                                        <TableCell
                                          sx={{
                                            color: "white",
                                            fontWeight: "bold",
                                            border: "1px solid #1565c0",
                                            padding: "6px 10px",
                                          }}
                                        ></TableCell>

                                        {/* Column Labels: Current/New ya New/Old */}
                                        {[1, 4, 5, 6].includes(
                                          dialogRowData.changeOfAttributesType
                                        ) ? (
                                          <>
                                            <TableCell
                                              sx={{
                                                color: "white",
                                                fontWeight: "bold",
                                                border: "1px solid #1565c0",
                                                padding: "6px 10px",
                                              }}
                                            >
                                              Current
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                color: "white",
                                                fontWeight: "bold",
                                                border: "1px solid #1565c0",
                                                padding: "6px 10px",
                                              }}
                                            >
                                              New
                                            </TableCell>
                                          </>
                                        ) : (
                                          <>
                                            <TableCell
                                              sx={{
                                                color: "white",
                                                fontWeight: "bold",
                                                border: "1px solid #1565c0",
                                                padding: "6px 10px",
                                              }}
                                            >
                                              Old
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                color: "white",
                                                fontWeight: "bold",
                                                border: "1px solid #1565c0",
                                                padding: "6px 10px",
                                              }}
                                            >
                                              New
                                            </TableCell>
                                          </>
                                        )}
                                      </TableRow>
                                    </TableHead>

                                    <TableBody>
                                      {getTableRows(dialogRowData).map(
                                        (row, index) => (
                                          <TableRow
                                            key={index}
                                            sx={{
                                              backgroundColor:
                                                index % 2 === 0
                                                  ? "white"
                                                  : "rgb(213, 229, 255)",
                                              "&:hover": {
                                                backgroundColor: "#e3f2fd",
                                              },
                                            }}
                                          >
                                            <TableCell
                                              sx={{
                                                fontWeight: "bold",
                                                border: "1px solid #e0e0e0",
                                                padding: "8px 16px",
                                              }}
                                            >
                                              {row.label || "-"}
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                border: "1px solid #e0e0e0",
                                                padding: "8px 16px",
                                              }}
                                            >
                                              {row.current}
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                border: "1px solid #e0e0e0",
                                                padding: "8px 16px",
                                              }}
                                            >
                                              {row.newVal}
                                            </TableCell>
                                          </TableRow>
                                        )
                                      )}
                                    </TableBody>
                                  </Table>
                                </Grid>
                              </Grid>
                            ) : (
                              <div className="description-box">
                                <p className="group-description">
                                  <InfoIcon className="icon" />
                                  Sundary Job Order Approval is in process by
                                  sanctioning authority.{" "}
                                </p>
                              </div>
                            )}
                          </>
                        )}
                    </>
                  ) : dialogRowData.applicationProgressId === 8 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <Grid
                        container
                        className="step-title"
                        sx={{ marginBottom: "1%", padding: "0.5%" }}
                      >
                        <Grid item lg={1}></Grid>
                        <Grid item lg={10} sx={{ textAlign: "center" }}>
                          <h4>Ready for Billing</h4>
                        </Grid>
                      </Grid>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Change of Attributes",
                        "Workflow Permissions",
                        "Ready For Billing"
                      ) &&
                        (() => {
                          const sanctionLoad =
                            dialogRowData.newSanctionLoad ||
                            dialogRowData.currentSanctionLoad;
                          const currentTariff = dialogRowData.currentTariff
                            ?.replace(/-/g, "")
                            .trim();

                          return (
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "15"
                            ) &&
                              sanctionLoad > 0 &&
                              sanctionLoad <= 15 &&
                              ((CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Tariff Authority",
                                "A1"
                              ) &&
                                currentTariff?.startsWith("A1")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A2"
                                ) &&
                                  currentTariff?.startsWith("A2")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A3"
                                ) &&
                                  currentTariff?.startsWith("A3")))) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "70"
                            ) &&
                              sanctionLoad > 1 &&
                              sanctionLoad <= 70) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "500"
                            ) &&
                              sanctionLoad > 70 &&
                              sanctionLoad <= 500) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "5000"
                            ) &&
                              sanctionLoad > 500)
                          );
                        })() ? (
                        <Grid
                          container
                          className="dn-payment-submission-container"
                        >
                          <Grid item lg={12} className="item">
                            <Typography
                              sx={{ fontSize: "1.5rem", fontWeight: 500 }}
                            >
                              {dnApproveStep.sjoData
                                ? dnApproveStep.sjoData
                                : "-"}
                            </Typography>
                          </Grid>

                          {/* Table - Content Type ke Hisaab se Change */}
                          <Grid item lg={12} mt={2}>
                            <Table
                              sx={{
                                borderCollapse: "collapse",
                                width: "100%",
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                overflow: "hidden",
                              }}
                            >
                              <TableHead>
                                <TableRow
                                  sx={{
                                    backgroundImage:
                                      "linear-gradient(180deg, #1e52a7, #a0bbe7)",
                                  }}
                                >
                                  <TableCell
                                    sx={{
                                      color: "white",
                                      fontWeight: "bold",
                                      border: "1px solid #1565c0",
                                      padding: "6px 10px",
                                    }}
                                  ></TableCell>

                                  {/* Column Labels: Current/New ya New/Old */}
                                  {[1, 4, 5, 6].includes(
                                    dialogRowData.changeOfAttributesType
                                  ) ? (
                                    <>
                                      <TableCell
                                        sx={{
                                          color: "white",
                                          fontWeight: "bold",
                                          border: "1px solid #1565c0",
                                          padding: "6px 10px",
                                        }}
                                      >
                                        Current
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          color: "white",
                                          fontWeight: "bold",
                                          border: "1px solid #1565c0",
                                          padding: "6px 10px",
                                        }}
                                      >
                                        New
                                      </TableCell>
                                    </>
                                  ) : (
                                    <>
                                      <TableCell
                                        sx={{
                                          color: "white",
                                          fontWeight: "bold",
                                          border: "1px solid #1565c0",
                                          padding: "6px 10px",
                                        }}
                                      >
                                        Old
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          color: "white",
                                          fontWeight: "bold",
                                          border: "1px solid #1565c0",
                                          padding: "6px 10px",
                                        }}
                                      >
                                        New
                                      </TableCell>
                                    </>
                                  )}
                                </TableRow>
                              </TableHead>

                              <TableBody>
                                {getTableRows(dialogRowData).map(
                                  (row, index) => (
                                    <TableRow
                                      key={index}
                                      sx={{
                                        backgroundColor:
                                          index % 2 === 0
                                            ? "white"
                                            : "rgb(213, 229, 255)",
                                        "&:hover": {
                                          backgroundColor: "#e3f2fd",
                                        },
                                      }}
                                    >
                                      <TableCell
                                        sx={{
                                          fontWeight: "bold",
                                          border: "1px solid #e0e0e0",
                                          padding: "8px 16px",
                                        }}
                                      >
                                        {row.label || "-"}
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          border: "1px solid #e0e0e0",
                                          padding: "8px 16px",
                                        }}
                                      >
                                        {row.current}
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          border: "1px solid #e0e0e0",
                                          padding: "8px 16px",
                                        }}
                                      >
                                        {row.newVal}
                                      </TableCell>
                                    </TableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </Grid>
                        </Grid>
                      ) : (
                        <div className="description-box">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            Ready for Billing Approval is in process by
                            sanctioning authority.{" "}
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 9 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <Grid
                        container
                        className="step-title"
                        sx={{ marginBottom: "1%", padding: "0.5%" }}
                      >
                        <Grid item lg={1}></Grid>
                        <Grid item lg={10} sx={{ textAlign: "center" }}>
                          <h4>Application Completed</h4>
                        </Grid>
                        <Grid item lg={1}>
                          <Button
                            variant="outlined"
                            onClick={() =>
                              downloadSJOPDF(
                                dialogRowData.applicationId,
                                scoDetails,
                                dialogRowData,
                                dnDets
                              )
                            }
                            sx={{
                              backgroundColor: "white",
                              cursor: "pointer",
                              border: "1px solid #006ad1",
                              boxShadow: "none",
                              width: "5%",
                            }}
                          >
                            <PrintIcon
                              sx={{ color: "#006ad1", marginLeft: "1%" }}
                            />{" "}
                            SJO
                          </Button>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} mb={2}></Grid>
                      <Grid item lg={12} mb={2}></Grid>
                      <Grid item lg={12} mb={2}></Grid>

                      <Grid item lg={12} mb={2}>
                        <Box display="flex" justifyContent="center">
                          <Alert
                            // variant="filled"
                            severity="success"
                            sx={{
                              fontSize: "1.5rem",
                              fontWeight: "bold",
                              minHeight: "70px", // Increased height
                              width: "50%", // Reduced width (you can adjust e.g., '60%' or '400px')
                              display: "flex",
                              alignItems: "center",
                              // justifyContent: 'center', // center the text inside
                              // textAlign: 'center'
                            }}
                          >
                            Application Completed.
                          </Alert>
                        </Box>
                      </Grid>
                    </>
                  ) : null}
                </div>
                <div className="actions">
                  {dialogRowData.applicationProgressId === 0 ? ( //Document Submission
                    // CheckPermissions(permissions, 'General Services', 'Change of Attributes', 'Basic Permissions', 'Update') ?
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Change of Attributes"
                    ) ? (
                      <Button
                        onClick={() =>
                          navigate("/change-of-name-update", {
                            state: { dialogRowData },
                          })
                        }
                        variant="contained"
                        sx={{ backgroundColor: "blue" }}
                      >
                        Upload Pending Documents
                      </Button>
                    ) : null
                  ) : dialogRowData.applicationProgressId === 1 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? ( //
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Change of Attributes",
                      "Workflow Permissions",
                      "Documents Verification"
                    ) ? (
                      <>
                        {dialogRowData.applicantCNICFrontFlag !== 1 ||
                          dialogRowData.applicantCNICBackFlag !== 1 ||
                          dialogRowData.owenershipDocumentFlag !== 1 ||
                          dialogRowData.electricityBillDocumentFlag !== 1 ||
                          dialogRowData.fbrDocument !== 1 ? (
                          <>
                            <button
                              disabled={
                                !flag_applicantCNICFront ||
                                !flag_applicantCNICBack ||
                                !flag_owenershipDocument ||
                                !flag_electricityBillDocument ||
                                ((dialogRowData.newTariff?.replace('-', '').startsWith('A2') ||
                                  dialogRowData.newTariff?.replace('-', '').startsWith('B')) &&
                                  !flag_fbrDocument)
                              }
                              onClick={() => updateDocumentStatus()}
                              className="view-button"
                              style={{
                                backgroundColor:
                                  flag_applicantCNICFront === -1 ||
                                    flag_applicantCNICBack === -1 ||
                                    flag_owenershipDocument === -1 ||
                                    flag_electricityBillDocument === -1 ||
                                    flag_fbrDocument === -1 ||
                                    flag_addDocAnyOther === -1
                                    ? "#E11B3C"
                                    : "#003971",
                              }}
                            >
                              {flag_applicantCNICFront === -1 ||
                                flag_applicantCNICBack === -1 ||
                                flag_owenershipDocument === -1 ||
                                flag_electricityBillDocument === -1 ||
                                flag_fbrDocument === -1 ||
                                flag_addDocAnyOther === -1
                                ? "Reject"
                                : "Verify"}
                            </button>
                          </>
                        ) : null}
                      </>
                    ) : (
                      <></>
                    )
                  ) : dialogRowData.applicationProgressId === 1 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Change of Attributes",
                        "Basic Permissions",
                        "Update"
                      ) ? (
                        <>
                          <button
                            onClick={() => {
                              setOpen(false);
                              navigate("/change-of-attributes-update", {
                                state: { dialogRowData },
                              });
                            }}
                            className="view-button"
                          >
                            Re-Upload Document
                          </button>
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 2 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Change of Attributes",
                        "Workflow Permissions",
                        "Arrears Verification"
                      ) &&
                        (() => {
                          const sanctionLoad =
                            dialogRowData.newSanctionLoad ||
                            dialogRowData.currentSanctionLoad;
                          const currentTariff = dialogRowData.currentTariff
                            ?.replace(/-/g, "")
                            .trim();

                          return (
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "15"
                            ) &&
                              sanctionLoad > 0 &&
                              sanctionLoad <= 15 &&
                              ((CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Tariff Authority",
                                "A1"
                              ) &&
                                currentTariff?.startsWith("A1")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A2"
                                ) &&
                                  currentTariff?.startsWith("A2")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A3"
                                ) &&
                                  currentTariff?.startsWith("A3")))) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "70"
                            ) &&
                              sanctionLoad > 1 &&
                              sanctionLoad <= 70) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "500"
                            ) &&
                              sanctionLoad > 70 &&
                              sanctionLoad <= 500) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "5000"
                            ) &&
                              sanctionLoad > 500)
                          );
                        })() && (
                          <Grid container spacing={2} justifyContent="end">
                            {paymentStatus === "No arrear exists" && (
                              <Grid item>
                                <button
                                  className="view-button"
                                  onClick={() =>
                                    callArrearVerificationAPI(
                                      dialogRowData.applicationId,
                                      dialogRowData.applicationProgressId + 1,
                                      0,
                                      "Arrears Verified",
                                      "Arrears Verified",
                                      0,
                                      "",
                                      null
                                    )
                                  }
                                  style={{
                                    backgroundColor: "#003971",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "20px",
                                    padding: "10px 40px",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    width: "100%",
                                  }}
                                >
                                  Approve
                                </button>
                              </Grid>
                            )}

                            {paymentStatus === "Arrear exists" && (
                              <>
                                <Grid item>
                                  <button
                                    className="view-button"
                                    onClick={() =>
                                      callArrearVerificationAPI(
                                        dialogRowData.applicationId,
                                        dialogRowData.applicationProgressId,
                                        1,
                                        "Arrears Exist",
                                        `Arrears Exist For Bill Month: ${billMonth}, Rs. : ${arrearAmount}`,
                                        arrearAmount,
                                        billMonth,
                                        null
                                      )
                                    }
                                    style={{
                                      backgroundColor: "#e11b3c",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "20px",
                                      padding: "10px 40px",
                                      fontSize: "16px",
                                      cursor: "pointer",
                                      width: "100%",
                                    }}
                                  >
                                    Reject
                                  </button>
                                </Grid>

                                <Grid item>
                                  <button
                                    className="view-button"
                                    onClick={
                                      arrearPaymentReceiptFormik.handleSubmit
                                    }
                                    style={{
                                      backgroundColor: "#003971",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "20px",
                                      padding: "10px 40px",
                                      fontSize: "16px",
                                      cursor: "pointer",
                                      width: "100%",
                                    }}
                                  >
                                    Approve
                                  </button>
                                </Grid>
                              </>
                            )}
                          </Grid>
                        )}
                    </>
                  ) : dialogRowData.applicationProgressId === 2 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Change of Attributes",
                        "Workflow Permissions",
                        "Arrears Verification"
                      ) &&
                        (() => {
                          const sanctionLoad =
                            dialogRowData.newSanctionLoad ||
                            dialogRowData.currentSanctionLoad;
                          const currentTariff = dialogRowData.currentTariff
                            ?.replace(/-/g, "")
                            .trim();

                          return (
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "15"
                            ) &&
                              sanctionLoad > 0 &&
                              sanctionLoad <= 15 &&
                              ((CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Tariff Authority",
                                "A1"
                              ) &&
                                currentTariff?.startsWith("A1")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A2"
                                ) &&
                                  currentTariff?.startsWith("A2")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A3"
                                ) &&
                                  currentTariff?.startsWith("A3")))) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "70"
                            ) &&
                              sanctionLoad > 1 &&
                              sanctionLoad <= 70) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "500"
                            ) &&
                              sanctionLoad > 70 &&
                              sanctionLoad <= 500) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "5000"
                            ) &&
                              sanctionLoad > 500)
                          );
                        })() && (
                          <Grid item>
                            <button
                              className="view-button"
                              onClick={arrearPaymentReceiptFormik.handleSubmit}
                              style={{
                                backgroundColor: "#e11b3c",
                                color: "white",
                                border: "none",
                                borderRadius: "20px",
                                padding: "10px 40px",
                                fontSize: "16px",
                                cursor: "pointer",
                                width: "20%",
                              }}
                            >
                              Remove & Approve
                            </button>
                          </Grid>
                        )}
                    </>
                  ) : dialogRowData.applicationProgressId === 3 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Change of Attributes",
                        "Workflow Permissions",
                        "Field Survey"
                      ) &&
                        (() => {
                          const sanctionLoad =
                            dialogRowData.newSanctionLoad ||
                            dialogRowData.currentSanctionLoad;
                          const currentTariff = dialogRowData.currentTariff
                            ?.replace(/-/g, "")
                            .trim();

                          return (
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "15"
                            ) &&
                              sanctionLoad > 0 &&
                              sanctionLoad <= 15 &&
                              ((CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Tariff Authority",
                                "A1"
                              ) &&
                                currentTariff?.startsWith("A1")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A2"
                                ) &&
                                  currentTariff?.startsWith("A2")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A3"
                                ) &&
                                  currentTariff?.startsWith("A3")))) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "70"
                            ) &&
                              sanctionLoad > 1 &&
                              sanctionLoad <= 70) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "500"
                            ) &&
                              sanctionLoad > 70 &&
                              sanctionLoad <= 500) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "5000"
                            ) &&
                              sanctionLoad > 500)
                          );
                        })() && (
                          <Grid item container justifyContent="end" spacing={2}>
                            <Grid item>
                              <button
                                type="submit"
                                style={{
                                  backgroundColor: "#003971",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "20px",
                                  padding: "10px 40px",
                                  fontSize: "16px",
                                  cursor: "pointer",
                                }}
                                onClick={fieldFormik.handleSubmit}
                              >
                                Submit
                              </button>
                            </Grid>
                          </Grid>
                        )}
                    </>
                  ) : dialogRowData.applicationProgressId === 3 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Change of Attributes",
                        "Workflow Permissions",
                        "Field Survey"
                      ) &&
                        (() => {
                          const sanctionLoad =
                            dialogRowData.newSanctionLoad ||
                            dialogRowData.currentSanctionLoad;
                          const currentTariff = dialogRowData.currentTariff
                            ?.replace(/-/g, "")
                            .trim();

                          return (
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "15"
                            ) &&
                              sanctionLoad > 0 &&
                              sanctionLoad <= 15 &&
                              ((CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Tariff Authority",
                                "A1"
                              ) &&
                                currentTariff?.startsWith("A1")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A2"
                                ) &&
                                  currentTariff?.startsWith("A2")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A3"
                                ) &&
                                  currentTariff?.startsWith("A3")))) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "70"
                            ) &&
                              sanctionLoad > 1 &&
                              sanctionLoad <= 70) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "500"
                            ) &&
                              sanctionLoad > 70 &&
                              sanctionLoad <= 500) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "5000"
                            ) &&
                              sanctionLoad > 500)
                          );
                        })() && (
                          <Grid item container justifyContent="end" spacing={2}>
                            <Grid item>
                              <button
                                type="submit"
                                style={{
                                  backgroundColor: "#003971",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "20px",
                                  padding: "10px 40px",
                                  fontSize: "16px",
                                  cursor: "pointer",
                                }}
                                onClick={
                                  fieldRemoveObjectionFormik.handleSubmit
                                }
                              >
                                Remove Objection
                              </button>
                            </Grid>
                          </Grid>
                        )}
                    </>
                  ) : dialogRowData.applicationProgressId === 3 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) &&
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Change of Attributes",
                      "Workflow Permissions",
                      "Field Survey"
                    ) &&
                    (() => {
                      const sanctionLoad =
                        dialogRowData.newSanctionLoad ||
                        dialogRowData.currentSanctionLoad;
                      const currentTariff = dialogRowData.currentTariff
                        ?.replace(/-/g, "")
                        .trim();

                      return (
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "15"
                        ) &&
                          sanctionLoad > 0 &&
                          sanctionLoad <= 15 &&
                          ((CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A1"
                          ) &&
                            currentTariff?.startsWith("A1")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A2"
                            ) &&
                              currentTariff?.startsWith("A2")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A3"
                            ) &&
                              currentTariff?.startsWith("A3")))) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70"
                        ) &&
                          sanctionLoad > 1 &&
                          sanctionLoad <= 70) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500"
                        ) &&
                          sanctionLoad > 70 &&
                          sanctionLoad <= 500) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000"
                        ) &&
                          sanctionLoad > 500)
                      );
                    })() ? (
                    <>
                      <button
                        className="view-button"
                        onClick={() => {
                          costEstimation(
                            dialogRowData.applicationId,
                            dialogRowData.referenceNumber,
                            4,
                            0,
                            "Cost Estimated.",
                            bankName,
                            dnDetails.previousSecurityAmount,
                            dnDetails.currentEstimatedSecurityAmount,
                            dnDetails.totalEstimatedAmount
                          );
                        }}
                      >
                        Save Estimation
                      </button>
                    </>
                  ) : dialogRowData.applicationProgressId === 4 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) &&
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Change of Attributes",
                      "Workflow Permissions",
                      "Demand Note Approval"
                    ) &&
                    (() => {
                      const sanctionLoad =
                        dialogRowData.newSanctionLoad ||
                        dialogRowData.currentSanctionLoad;
                      const currentTariff = dialogRowData.currentTariff
                        ?.replace(/-/g, "")
                        .trim();

                      return (
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "15"
                        ) &&
                          sanctionLoad > 0 &&
                          sanctionLoad <= 15 &&
                          ((CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A1"
                          ) &&
                            currentTariff?.startsWith("A1")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A2"
                            ) &&
                              currentTariff?.startsWith("A2")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A3"
                            ) &&
                              currentTariff?.startsWith("A3")))) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70"
                        ) &&
                          sanctionLoad > 1 &&
                          sanctionLoad <= 70) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500"
                        ) &&
                          sanctionLoad > 70 &&
                          sanctionLoad <= 500) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000"
                        ) &&
                          sanctionLoad > 500)
                      );
                    })() ? (
                    <div>
                      <button
                        onClick={() => {
                          DNApproveAPI(
                            dialogRowData.applicationId,
                            dialogRowData.applicationProgressId + 1,
                            0,
                            "Demand Note approved."
                          );
                        }}
                        className="view-button"
                      >
                        Approval
                      </button>
                      {/* <button onClick={() => { DNApproveAPI(dialogRowData.applicationId, dialogRowData.applicationProgressId, 1, "Demand Note rejected.") }} className='reject-button' style={{ float: 'right', marginRight: '10px' }}>Reject</button> */}
                      <button
                        onClick={() => {
                          setDnRejectModalOpen(true);
                        }}
                        className="reject-button"
                        style={{ float: "right", marginRight: "10px" }}
                      >
                        Reject
                      </button>
                    </div>
                  ) : dialogRowData.applicationProgressId === 5 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2 ||
                      dialogRowData.objectionStatus === 1) &&
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Change of Attributes",
                      "Workflow Permissions",
                      "Demand Note Submission"
                    ) &&
                    (() => {
                      const sanctionLoad =
                        dialogRowData.newSanctionLoad ||
                        dialogRowData.currentSanctionLoad;
                      const currentTariff = dialogRowData.currentTariff
                        ?.replace(/-/g, "")
                        .trim();

                      return (
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "15"
                        ) &&
                          sanctionLoad > 0 &&
                          sanctionLoad <= 15 &&
                          ((CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A1"
                          ) &&
                            currentTariff?.startsWith("A1")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A2"
                            ) &&
                              currentTariff?.startsWith("A2")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A3"
                            ) &&
                              currentTariff?.startsWith("A3")))) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70"
                        ) &&
                          sanctionLoad > 1 &&
                          sanctionLoad <= 70) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500"
                        ) &&
                          sanctionLoad > 70 &&
                          sanctionLoad <= 500) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000"
                        ) &&
                          sanctionLoad > 500)
                      );
                    })() ? (
                    <button
                      onClick={() => {
                        dnPymentReceiptFormik.validateForm().then((errors) => {
                          if (Object.keys(errors).length === 0) {
                            // optional: set your payload
                            setDnApprovalPayload({
                              applicationId: dialogRowData.applicationId,
                              applicationProgressId:
                                dialogRowData.applicationProgressId + 1,
                              objectionStatus: 0,
                              remarks: "Paid DN Uploaded.",
                            });
                            dnPymentReceiptFormik.handleSubmit();
                          } else {
                            // show errors if invalid
                            dnPymentReceiptFormik.setTouched({
                              iv_payment_date: true,
                              iv_receipt_image: true,
                            });
                          }
                        });
                      }}
                      type="submit"
                      className="view-button"
                    >
                      Submit
                    </button>
                  ) : dialogRowData.applicationProgressId === 6 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) &&
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Change of Attributes",
                      "Workflow Permissions",
                      "Demand Note Payment Verification"
                    ) &&
                    (() => {
                      const sanctionLoad =
                        dialogRowData.newSanctionLoad ||
                        dialogRowData.currentSanctionLoad;
                      const currentTariff = dialogRowData.currentTariff
                        ?.replace(/-/g, "")
                        .trim();

                      return (
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "15"
                        ) &&
                          sanctionLoad > 0 &&
                          sanctionLoad <= 15 &&
                          ((CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A1"
                          ) &&
                            currentTariff?.startsWith("A1")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A2"
                            ) &&
                              currentTariff?.startsWith("A2")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A3"
                            ) &&
                              currentTariff?.startsWith("A3")))) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70"
                        ) &&
                          sanctionLoad > 1 &&
                          sanctionLoad <= 70) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500"
                        ) &&
                          sanctionLoad > 70 &&
                          sanctionLoad <= 500) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000"
                        ) &&
                          sanctionLoad > 500)
                      );
                    })() ? (
                    <div>
                      <button
                        onClick={() => {
                          DNPaymentVerificationAPI(
                            dialogRowData.applicationId,
                            dialogRowData.applicationProgressId + 1,
                            0,
                            "Demand Note Payment Verified.",
                            "Demand Note Payment Verified."
                          );
                        }}
                        className="view-button"
                      >
                        Verify
                      </button>
                      {/* <button onClick={() => { DNPaymentVerificationAPI(dialogRowData.applicationId, dialogRowData.applicationProgressId - 1, 1, "Demand Note Payment rejected.") }} className='reject-button' style={{ float: 'right', marginRight: '10px' }}>Reject</button> */}
                      <button
                        onClick={() => setRejectModalOpen(true)}
                        className="reject-button"
                        style={{ float: "right", marginRight: "10px" }}
                      >
                        {" "}
                        Reject{" "}
                      </button>
                    </div>
                  ) : dialogRowData.applicationProgressId === 7 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2 ||
                      dialogRowData.objectionStatus === 1) &&
                    dialogRowData.scoFillFlag === null &&
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Change of Attributes",
                      "Workflow Permissions",
                      "Sundry Job Order",
                      "SJO Submission"
                    ) &&
                    (() => {
                      const sanctionLoad =
                        dialogRowData.newSanctionLoad ||
                        dialogRowData.currentSanctionLoad;
                      const currentTariff = dialogRowData.currentTariff
                        ?.replace(/-/g, "")
                        .trim();

                      return (
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "15"
                        ) &&
                          sanctionLoad > 0 &&
                          sanctionLoad <= 15 &&
                          ((CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A1"
                          ) &&
                            currentTariff?.startsWith("A1")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A2"
                            ) &&
                              currentTariff?.startsWith("A2")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A3"
                            ) &&
                              currentTariff?.startsWith("A3")))) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70"
                        ) &&
                          sanctionLoad > 1 &&
                          sanctionLoad <= 70) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500"
                        ) &&
                          sanctionLoad > 70 &&
                          sanctionLoad <= 500) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000"
                        ) &&
                          sanctionLoad > 500)
                      );
                    })() ? (
                    <>
                      <button
                        onClick={() =>
                          SundaryJobSubmissionAPI(
                            dialogRowData.applicationId,
                            8,
                            0,
                            "Approved for billing."
                          )
                        }
                        type="submit"
                        className="view-button"
                      >
                        Submit
                      </button>
                    </>
                  ) : dialogRowData.applicationProgressId === 7 &&
                    dialogRowData.scoFillFlag === 1 &&
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Change of Attributes",
                      "Workflow Permissions",
                      "Sundry Job Order",
                      "SJO Approval"
                    ) &&
                    (() => {
                      const sanctionLoad =
                        dialogRowData.newSanctionLoad ||
                        dialogRowData.currentSanctionLoad;
                      const currentTariff = dialogRowData.currentTariff
                        ?.replace(/-/g, "")
                        .trim();

                      return (
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "15"
                        ) &&
                          sanctionLoad > 0 &&
                          sanctionLoad <= 15 &&
                          ((CheckPermissions(
                            permissions,
                            "General Services",
                            "Change of Attributes",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A1"
                          ) &&
                            currentTariff?.startsWith("A1")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A2"
                            ) &&
                              currentTariff?.startsWith("A2")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A3"
                            ) &&
                              currentTariff?.startsWith("A3")))) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70"
                        ) &&
                          sanctionLoad > 1 &&
                          sanctionLoad <= 70) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500"
                        ) &&
                          sanctionLoad > 70 &&
                          sanctionLoad <= 500) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Change of Attributes",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000"
                        ) &&
                          sanctionLoad > 500)
                      );
                    })() ? (
                    <>
                      <button
                        onClick={() => SundaryJobApprovalAPI()}
                        type="submit"
                        className="view-button"
                      >
                        Approve
                      </button>
                    </>
                  ) : dialogRowData.applicationProgressId === 8 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Change of Attributes",
                        "Workflow Permissions",
                        "Ready For Billing"
                      ) &&
                        (() => {
                          const sanctionLoad =
                            dialogRowData.newSanctionLoad ||
                            dialogRowData.currentSanctionLoad;
                          const currentTariff = dialogRowData.currentTariff
                            ?.replace(/-/g, "")
                            .trim();

                          return (
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "15"
                            ) &&
                              sanctionLoad > 0 &&
                              sanctionLoad <= 15 &&
                              ((CheckPermissions(
                                permissions,
                                "General Services",
                                "Change of Attributes",
                                "Workflow Permissions",
                                "Approval Category",
                                "Tariff Authority",
                                "A1"
                              ) &&
                                currentTariff?.startsWith("A1")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A2"
                                ) &&
                                  currentTariff?.startsWith("A2")) ||
                                (CheckPermissions(
                                  permissions,
                                  "General Services",
                                  "Change of Attributes",
                                  "Workflow Permissions",
                                  "Approval Category",
                                  "Tariff Authority",
                                  "A3"
                                ) &&
                                  currentTariff?.startsWith("A3")))) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "70"
                            ) &&
                              sanctionLoad > 1 &&
                              sanctionLoad <= 70) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "500"
                            ) &&
                              sanctionLoad > 70 &&
                              sanctionLoad <= 500) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Change of Attributes",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "5000"
                            ) &&
                              sanctionLoad > 500)
                          );
                        })() && (
                          <button
                            // onClick={() => SundaryJobApprovalAPI()}
                            onClick={() => processForBilling()}
                            type="submit"
                            className="view-button"
                          >
                            Approve
                          </button>
                        )}
                    </>
                  ) : null}
                </div>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {/* Application Submitted Sub pop up */}
      <Dialog
        open={applicationSubittedPopUp}
        onClose={() => {
          setApplicationSubmittedPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"lg"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          {historyData?.applicationProgressId == 1 &&
            historyData.remarks !== "Revert to Documents Verification" ? (
            <p className="title">Application Submitted</p>
          ) : (
            historyData?.applicationProgressId == 1 &&
              historyData.remarks === "Revert to Documents Verification" ? (
              <p className="title">Objection</p>
            )
              : (historyData?.applicationProgressId == 1 &&
                historyData.remarks === "Documents Rejected") && (
                <>
                  <p className="title">Document Objections</p>
                </>
              )

          )}
          <CloseIcon
            id="clearPopup"
            className="closeIcon"
            onClick={() => {
              setApplicationSubmittedPopUp(false);
            }}
          />
        </DialogTitle>
        {historyData?.applicationProgressId == 1 &&
          historyData.remarks !== "Revert to Documents Verification" ? (
          <DialogContent className="dialog-content">
            <Grid container spacing={2} className="container">
              <Grid item lg={12} className="application-details">
                <Grid item lg={3} className="first-row-item">
                  <Typography className="prop-title">Application Id</Typography>
                  <Typography className="prop-detail">
                    {historyData?.applicationId
                      ? historyData?.applicationId
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item lg={3} className="first-row-item">
                  <Typography className="prop-title">Applicant Name</Typography>
                  <Typography className="prop-detail">
                    {historyData?.applicantName
                      ? historyData?.applicantName
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item lg={3} className="first-row-item">
                  <Typography className="prop-title">
                    Applicant CNIC.
                  </Typography>
                  <Typography className="prop-detail">
                    {historyData?.applicantCNIC
                      ? historyData?.applicantCNIC
                      : "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item lg={12} className="application-details">
                <Grid item lg={3} className="first-row-item">
                  <Typography className="prop-title">
                    Applicant Phone
                  </Typography>
                  <Typography className="prop-detail">
                    {historyData?.applicantPhoneNo
                      ? historyData?.applicantPhoneNo
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item lg={3} className="first-row-item">
                  <Typography className="prop-title">
                    Applicant Email
                  </Typography>
                  <Typography className="prop-detail">
                    {historyData?.applicantEmail
                      ? historyData?.applicantEmail
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item lg={3} className="first-row-item">
                  <Typography className="prop-title">Applied Date</Typography>
                  <Typography className="prop-detail">
                    {historyData?.creationDate
                      ? convertDate(historyData?.creationDate)
                      : "-"}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item lg={12} className="application-details">
                <Grid item lg={3} className="first-row-item">
                  <Typography className="prop-title">Subdivision</Typography>
                  <Typography className="prop-detail">
                    {historyData?.subDivisionCode && subDivisions
                      ? subdivisionName(
                        historyData?.subDivisionCode,
                        subDivisions
                      )
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item lg={3} className="first-row-item">
                  <Typography className="prop-title">
                    Submitted Through
                  </Typography>
                  <Typography className="prop-detail">
                    {historyData?.submittedThrough
                      ? historyData?.submittedThrough
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item lg={3} sx={{ background: "#eef0f4" }}>
                  <Typography sx={{ color: "#eef0f4" }}></Typography>
                  <Typography sx={{ background: "#eef0f4" }}></Typography>
                </Grid>
              </Grid>
              <Grid
                container
                sx={{ display: "flex", flexDirection: "row", gap: 2 }}
              >
                <Grid item lg={2.5}>
                  <Grid
                    container
                    sx={{
                      borderRadius: "10px",
                      minHeight: "125px",
                      height: "auto",
                    }}
                  >
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      <div
                        onClick={() => {
                          if (!copyOfApplicantCNICVerifyPopUp) {
                            setCopyOfApplicantCNICVerifyPopUp(true);
                          }
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        {historyData?.applicantCNICFront?.slice(0, 6) ===
                          "data:i" ? (
                          flag_applicantCNICFront === 1 ? (
                            <>
                              <Base64Image
                                data={historyData?.applicantCNICFront}
                                width="80"
                                height="50"
                              />
                              <Base64Image
                                data={historyData?.applicantCNICBack}
                                width="80"
                                height="50"
                              />
                            </>
                          ) : flag_applicantCNICFront === -1 ? (
                            <>
                              <Base64Image
                                data={historyData?.applicantCNICFront}
                                width="80"
                                height="50"
                              />
                              <Base64Image
                                data={historyData?.applicantCNICBack}
                                width="80"
                                height="50"
                              />
                            </>
                          ) : (
                            <>
                              <Base64Image
                                data={historyData?.applicantCNICFront}
                                width="80"
                                height="50"
                              />
                              <Base64Image
                                data={historyData?.applicantCNICBack}
                                width="80"
                                height="50"
                              />
                            </>
                          )
                        ) : (
                          <Base64Image data={pdfIcon} width="40" />
                        )}
                        {copyOfApplicantCNICVerifyPopUp && (
                          <OpenBase64ImageInPopup
                            docVerifyPopUp={copyOfApplicantCNICVerifyPopUp}
                            hideDocVerifyPopup={
                              hideCopyOfApplicantCNICVerifyAlert
                            }
                            documentName="Applicant CNIC"
                            documentImage={historyData?.applicantCNICFront}
                            backDocumentImage={historyData?.applicantCNICBack}
                            width={"100%"}
                            document={historyData?.applicantCNICFront}
                            documentFlag={historyData?.applicantCNICFrontFlag}
                            applicationProgressId={
                              historyData?.applicationProgressId
                            }
                            objectionStatus={historyData?.objectionStatus}
                            updateDocFlag={updateDocFlag}
                            titleToUpdateFlag="copyOfApplicantCNIC"
                            flag_document={flag_applicantCNICFront}
                            flag_documentBack={flag_applicantCNICBack}
                          />
                        )}
                      </div>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      className="tittlegrid"
                      sx={{ textAlign: "center" }}
                    >
                      <p className="docTitle">Applicant's CNIC.</p>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={2.5}>
                  <Grid
                    container
                    sx={{
                      borderRadius: "10px",
                      minHeight: "125px",
                      height: "auto",
                    }}
                  >
                    {/* <Grid container sx={{ backgroundColor: (historyData?.ownershipImage && historyData?.ownershipImage) ? getDocumentBackGroundColor(historyData?.ownershipImage) : getDocumentBackGroundColor(flag_owenershipDocument), borderRadius: "10px", minHeight: '125px', height: 'auto' }}> */}
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      <div
                        onClick={() => {
                          if (!owenershipDocumentVerifyPopUp) {
                            setOwenershipDocumentVerifyPopUp(true);
                          }
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        {historyData?.ownershipImage?.slice(0, 6) ===
                          "data:i" ? (
                          flag_owenershipDocument === 1 ? (
                            <>
                              <Base64Image
                                data={historyData?.ownershipImage}
                                width="80"
                                height="50"
                              />
                            </>
                          ) : flag_owenershipDocument === -1 ? (
                            <>
                              <Base64Image
                                data={historyData?.ownershipImage}
                                width="80"
                                height="50"
                              />
                            </>
                          ) : (
                            <>
                              <Base64Image
                                data={historyData?.ownershipImage}
                                width="80"
                                height="50"
                              />
                            </>
                          )
                        ) : (
                          <Base64Image data={pdfIcon} width="40" />
                        )}
                        {owenershipDocumentVerifyPopUp && (
                          <OpenBase64ImageInPopup
                            docVerifyPopUp={owenershipDocumentVerifyPopUp}
                            hideDocVerifyPopup={hidePropertyDocVerifyAlert}
                            documentName="OwnerShip Document"
                            documentImage={historyData?.ownershipImage}
                            width={"100%"}
                            document={historyData?.ownershipImage}
                            documentFlag={historyData?.ownershipImageFlag}
                            applicationProgressId={
                              historyData?.applicationProgressId
                            }
                            objectionStatus={historyData?.objectionStatus}
                            updateDocFlag={updateDocFlag}
                            titleToUpdateFlag="ownershipDocument"
                            flag_document={flag_owenershipDocument}
                          />
                        )}
                      </div>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      className="tittlegrid"
                      sx={{ textAlign: "center" }}
                    >
                      <p className="docTitle">Proof Of OwnerShip</p>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={2.5}>
                  <Grid
                    container
                    sx={{
                      borderRadius: "10px",
                      minHeight: "125px",
                      height: "auto",
                    }}
                  >
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      <div
                        onClick={() => {
                          if (!electricityBillDocumentVerifyPopUp) {
                            setElectricityBillDocumentVerifyPopUp(true);
                          }
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        {historyData?.electricityBill?.slice(0, 6) ===
                          "data:i" ? (
                          flag_electricityBillDocument === 1 ? (
                            <>
                              <Base64Image
                                data={historyData?.electricityBill}
                                width="80"
                                height="50"
                              />
                            </>
                          ) : flag_electricityBillDocument === -1 ? (
                            <>
                              <Base64Image
                                data={historyData?.electricityBill}
                                width="80"
                                height="50"
                              />
                            </>
                          ) : (
                            <>
                              <Base64Image
                                data={historyData?.electricityBill}
                                width="80"
                                height="50"
                              />
                              {/* <Base64Image data={historyData?.electricityBill} width='80' height='50' /> */}
                            </>
                          )
                        ) : (
                          <Base64Image data={pdfIcon} width="40" />
                        )}
                        {electricityBillDocumentVerifyPopUp && (
                          <OpenBase64ImageInPopup
                            docVerifyPopUp={electricityBillDocumentVerifyPopUp}
                            hideDocVerifyPopup={hideElectricityBillVerifyAlert}
                            documentName="Electricity Bill"
                            documentImage={historyData?.electricityBill}
                            // backDocumentImage={historyData?.applicantCNICBack}
                            width={"100%"}
                            document={historyData?.electricityBill}
                            documentFlag={historyData?.electricityBillFlag}
                            applicationProgressId={
                              historyData?.applicationProgressId
                            }
                            objectionStatus={historyData?.objectionStatus}
                            updateDocFlag={updateDocFlag}
                            titleToUpdateFlag="electricityBill"
                            flag_document={flag_electricityBillDocument}
                          // flag_documentBack={flag_applicantCNICBack}
                          />
                        )}
                      </div>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      className="tittlegrid"
                      sx={{ textAlign: "center" }}
                    >
                      <p className="docTitle">Electricity Bill</p>
                    </Grid>
                  </Grid>
                </Grid>

                {historyData?.fbrDocument && (
                  <Grid item lg={2.5}>
                    <Grid
                      container
                      sx={{
                        borderRadius: "10px",
                        minHeight: "125px",
                        height: "auto",
                      }}
                    >
                      <Grid
                        item
                        lg={12}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          paddingBottom: "5px",
                        }}
                      >
                        <div
                          onClick={() => {
                            if (!fbrDocumentVerifyPopUp) {
                              setFbrDocumentVerifyPopUp(true);
                            }
                          }}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          {historyData?.fbrDocument?.slice(0, 6) === "data:i" ? (
                            flag_fbrDocument === 1 ? (
                              <>
                                <Base64Image
                                  data={historyData?.fbrDocument}
                                  width="80"
                                  height="50"
                                />
                              </>
                            ) : flag_fbrDocument === -1 ? (
                              <>
                                <Base64Image
                                  data={historyData?.fbrDocument}
                                  width="80"
                                  height="50"
                                />
                              </>
                            ) : (
                              <>
                                <Base64Image
                                  data={historyData?.fbrDocument}
                                  width="80"
                                  height="50"
                                />
                              </>
                            )
                          ) : (
                            <Base64Image data={pdfIcon} width="40" />
                          )}
                          {fbrDocumentVerifyPopUp && (
                            <OpenBase64ImageInPopup
                              docVerifyPopUp={fbrDocumentVerifyPopUp}
                              hideDocVerifyPopup={hideFbrDocumentVerifyAlert}
                              documentName="Fbr Document"
                              documentImage={historyData?.fbrDocument}
                              // backDocumentImage={historyData?.applicantCNICBack}
                              width={"100%"}
                              document={historyData?.fbrDocument}
                              documentFlag={historyData?.fbrDocumentFlag}
                              applicationProgressId={
                                historyData?.applicationProgressId
                              }
                              objectionStatus={historyData?.objectionStatus}
                              updateDocFlag={updateDocFlag}
                              titleToUpdateFlag="fbrDocument"
                              flag_document={flag_fbrDocument}
                            // flag_documentBack={flag_applicantCNICBack}
                            />
                          )}
                        </div>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        className="tittlegrid"
                        sx={{ textAlign: "center" }}
                      >
                        <p className="docTitle">Fbr Document</p>
                      </Grid>
                    </Grid>
                  </Grid>
                )}

                {dialogRowData.addDocAnyOther && (
                  <Grid item lg={2}>
                    <Grid
                      container
                      sx={{
                        // backgroundColor: dialogRowData.anyOtherDocumentFlag
                        //   ? getDocumentBackGroundColor(
                        //     dialogRowData.anyOtherDocumentFlag
                        //   )
                        //   : getDocumentBackGroundColor(
                        //     flag_addDocAnyOther
                        //   ),
                        borderRadius: "10px",
                        minHeight: "125px",
                        height: "auto",
                      }}
                    >
                      <Grid
                        item
                        lg={12}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div
                          onClick={() => {
                            if (!addDocAnyOtherVerifyPopUp) {
                              setAddDocAnyOtherVerifyPopUp(true);
                            }
                          }}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          {dialogRowData.addDocAnyOther.slice(0, 6) ===
                            "data:i" ? (
                            flag_addDocAnyOther === 1 ? (
                              <>
                                <Base64Image
                                  data={dialogRowData.addDocAnyOther}
                                  width="80"
                                  height="110"
                                />
                                {/* <img
                                  src={tickicon}
                                  width="25px"
                                  height="25px"
                                  alt="Tick Icon"
                                  style={{
                                    position: "relative",
                                    zIndex: "2",
                                    marginRight: "-20px",
                                    marginTop: "60px",
                                  }}
                                /> */}
                              </>
                            ) : flag_addDocAnyOther === -1 ? (
                              <>
                                <Base64Image
                                  data={dialogRowData.addDocAnyOther}
                                  width="80"
                                  height="110"
                                />
                                {/* <img
                                  src={crossIcon}
                                  width="25px"
                                  height="25px"
                                  alt="Cross Icon"
                                  style={{
                                    position: "relative",
                                    zIndex: "2",
                                    marginRight: "-20px",
                                    marginTop: "60px",
                                  }}
                                /> */}
                              </>
                            ) : (
                              <Base64Image
                                data={dialogRowData.addDocAnyOther}
                                width="80"
                                height="110"
                              />
                            )
                          ) : (
                            <Base64Image data={pdfIcon} width="40" />
                          )}
                          {addDocAnyOtherVerifyPopUp && (
                            <OpenBase64ImageInPopup
                              docVerifyPopUp={addDocAnyOtherVerifyPopUp}
                              hideDocVerifyPopup={
                                hideAddAnyOtherVerifyAlert
                              }
                              documentName="Any Other Document"
                              documentImage={
                                dialogRowData.addDocAnyOther
                              }
                              width={"100%"}
                              document={dialogRowData.addDocAnyOther}
                              documentFlag={
                                dialogRowData.anyOtherDocumentFlag
                              }
                              applicationProgressId={
                                dialogRowData.applicationProgressId
                              }
                              objectionStatus={
                                dialogRowData.objectionStatus
                              }
                              updateDocFlag={updateDocFlag}
                              documentRemarks={
                                addDocAnyOtherObjectionRemarks
                              }
                              titleToUpdateFlag="addDocAnyOther"
                              flag_document={flag_addDocAnyOther}
                            />
                          )}
                        </div>
                      </Grid>
                      {/* <Grid item lg={12} className="tittlegrid">
                        <p className="docTitle">Any Other Document</p>
                      </Grid> */}
                      <Grid
                        item
                        lg={12}
                        className="tittlegrid"
                        sx={{ textAlign: "center" }}
                      >
                        <p className="docTitle">Any Other Document</p>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </DialogContent>
        ) :
          historyData?.applicationProgressId == 1 &&
            historyData.remarks === "Revert to Documents Verification" ? (
            <DialogContent className="dialog-content">
              <Typography style={{ color: "red" }}>
                Application revert to Document Verification from DN Approval.
              </Typography>
            </DialogContent>

          ) : (
            historyData?.applicationProgressId == 1 &&
            historyData.remarks === "Documents Rejected" && (
              <DialogContent className="dialog-content">
                <Typography style={{ color: "red" }}>
                  Application revert to Document Verification from DN Approval.
                </Typography>
              </DialogContent>
            )
          )}

        <DialogActions className="dialog-action">
          <p className="description">
            Application Submitted by: {historyData?.createdBy} on:{" "}
            {convertDatewithTime(historyData?.creationDate)}
          </p>
        </DialogActions>
      </Dialog>

      <Dialog
        open={documentsVerifiedSubPopUp}
        onClose={() => {
          setDocumentsVerifiedSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"lg"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          {historyData?.applicationProgressId == 2 &&
            historyData?.objectionStatus == 0 &&
            historyData.remarks !== "Revert to Arrear Verification" ? (
            <p className="title">Documents Verified</p>
          ) : (
            historyData?.applicationProgressId == 2 &&
            historyData?.objectionStatus == 0 &&
            historyData.remarks === "Revert to Arrear Verification" && (
              <p className="title">Objection</p>
            )
          )}
          <CloseIcon
            id="clearPopup"
            className="closeIcon"
            onClick={() => {
              setDocumentsVerifiedSubPopUp(false);
            }}
          />
        </DialogTitle>
        {(historyData?.applicationProgressId == 2 &&
          historyData?.objectionStatus == 0 &&
          historyData.remarks !== "Revert to Arrear Verification") ||
          (historyData?.applicationProgressId == 1 &&
            historyData?.objectionStatus == 1) ? (
          <DialogContent className="dialog-content">
            <Grid
              container
              sx={{ display: "flex", flexDirection: "row", gap: 2 }}
            >
              <Grid item lg={2.5}>
                <Grid
                  container
                  sx={{
                    backgroundColor: getDocumentBackGroundColor(
                      flag_applicantCNICFront
                    ),
                    borderRadius: "10px",
                    minHeight: "125px",
                    height: "auto",
                  }}
                >
                  <Grid
                    item
                    lg={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingBottom: "5px",
                    }}
                  >
                    <div
                      onClick={() => {
                        if (!copyOfApplicantCNICVerifyPopUp) {
                          setCopyOfApplicantCNICVerifyPopUp(true);
                        }
                      }}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      {historyData?.applicantCNICFront?.slice(0, 6) ===
                        "data:i" ? (
                        flag_applicantCNICFront === 1 ? (
                          <>
                            <Base64Image
                              data={historyData?.applicantCNICFront}
                              width="80"
                              height="50"
                            />
                            <Base64Image
                              data={historyData?.applicantCNICBack}
                              width="80"
                              height="50"
                            />
                            <img
                              src={tickicon}
                              width="25px"
                              height="25px"
                              alt="Tick Icon"
                              style={{
                                position: "relative",
                                zIndex: "2",
                                marginRight: "-120px",
                                marginTop: "-30px",
                              }}
                            />
                          </>
                        ) : flag_applicantCNICFront === -1 ? (
                          <>
                            <Base64Image
                              data={historyData?.applicantCNICFront}
                              width="80"
                              height="50"
                            />
                            <Base64Image
                              data={historyData?.applicantCNICBack}
                              width="80"
                              height="50"
                            />
                            <img
                              src={crossIcon}
                              width="25px"
                              height="25px"
                              alt="Cross Icon"
                              style={{
                                position: "relative",
                                zIndex: "2",
                                marginRight: "-120px",
                                marginTop: "-30px",
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <Base64Image
                              data={historyData?.applicantCNICFront}
                              width="80"
                              height="50"
                            />
                            <Base64Image
                              data={historyData?.applicantCNICBack}
                              width="80"
                              height="50"
                            />
                          </>
                        )
                      ) : (
                        <Base64Image data={pdfIcon} width="40" />
                      )}
                      {copyOfApplicantCNICVerifyPopUp && (
                        <OpenBase64ImageInPopup
                          docVerifyPopUp={copyOfApplicantCNICVerifyPopUp}
                          hideDocVerifyPopup={
                            hideCopyOfApplicantCNICVerifyAlert
                          }
                          documentName="Applicant CNIC"
                          documentImage={historyData?.applicantCNICFront}
                          backDocumentImage={historyData?.applicantCNICBack}
                          width={"100%"}
                          document={historyData?.applicantCNICFront}
                          documentFlag={historyData?.applicantCNICFrontFlag}
                          applicationProgressId={
                            historyData?.applicationProgressId
                          }
                          objectionStatus={historyData?.objectionStatus}
                          updateDocFlag={updateDocFlag}
                          titleToUpdateFlag="copyOfApplicantCNIC"
                          flag_document={flag_applicantCNICFront}
                          flag_documentBack={flag_applicantCNICBack}
                        />
                      )}
                    </div>
                  </Grid>
                  <Grid
                    item
                    lg={12}
                    className="tittlegrid"
                    sx={{ textAlign: "center" }}
                  >
                    <p className="docTitle">Applicant's CNIC.</p>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item lg={2.5}>
                {/* <Grid container sx={{ backgroundColor: (historyData?.electricityBillFlag && historyData?.electricityBillFlag) ? getDocumentBackGroundColor(historyData?.electricityBillFlag) : getDocumentBackGroundColor(flag_electricityBillDocument), borderRadius: "10px", minHeight: '125px', height: 'auto' }}> */}
                <Grid
                  container
                  sx={{
                    backgroundColor: getDocumentBackGroundColor(
                      flag_owenershipDocument
                    ),
                    borderRadius: "10px",
                    minHeight: "125px",
                    height: "auto",
                  }}
                >
                  {/* <Grid container sx={{ backgroundColor: (historyData?.ownershipImage && historyData?.ownershipImage) ? getDocumentBackGroundColor(historyData?.ownershipImage) : getDocumentBackGroundColor(flag_owenershipDocument), borderRadius: "10px", minHeight: '125px', height: 'auto' }}> */}
                  <Grid
                    item
                    lg={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingBottom: "5px",
                    }}
                  >
                    <div
                      onClick={() => {
                        if (!owenershipDocumentVerifyPopUp) {
                          setOwenershipDocumentVerifyPopUp(true);
                        }
                      }}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      {historyData?.ownershipImage?.slice(0, 6) === "data:i" ? (
                        flag_owenershipDocument === 1 ? (
                          <>
                            <Base64Image
                              data={historyData?.ownershipImage}
                              width="80"
                              height="50"
                            />
                            <img
                              src={tickicon}
                              width="25px"
                              height="25px"
                              alt="Tick Icon"
                              style={{
                                position: "relative",
                                zIndex: "2",
                                marginRight: "-120px",
                                marginTop: "-30px",
                              }}
                            />
                          </>
                        ) : flag_owenershipDocument === -1 ? (
                          <>
                            <Base64Image
                              data={historyData?.ownershipImage}
                              width="80"
                              height="50"
                            />
                            <img
                              src={crossIcon}
                              width="25px"
                              height="25px"
                              alt="Cross Icon"
                              style={{
                                position: "relative",
                                zIndex: "2",
                                marginRight: "-120px",
                                marginTop: "-30px",
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <Base64Image
                              data={historyData?.ownershipImage}
                              width="80"
                              height="50"
                            />
                          </>
                        )
                      ) : (
                        <Base64Image data={pdfIcon} width="40" />
                      )}
                      {owenershipDocumentVerifyPopUp && (
                        <OpenBase64ImageInPopup
                          docVerifyPopUp={owenershipDocumentVerifyPopUp}
                          hideDocVerifyPopup={hidePropertyDocVerifyAlert}
                          documentName="OwnerShip Document"
                          documentImage={historyData?.ownershipImage}
                          width={"100%"}
                          document={historyData?.ownershipImage}
                          documentFlag={historyData?.ownershipImageFlag}
                          applicationProgressId={
                            historyData?.applicationProgressId
                          }
                          objectionStatus={historyData?.objectionStatus}
                          updateDocFlag={updateDocFlag}
                          titleToUpdateFlag="ownershipDocument"
                          flag_document={flag_owenershipDocument}
                        />
                      )}
                    </div>
                  </Grid>
                  <Grid
                    item
                    lg={12}
                    className="tittlegrid"
                    sx={{ textAlign: "center" }}
                  >
                    <p className="docTitle">Proof Of OwnerSHip</p>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item lg={2.5}>
                <Grid
                  container
                  sx={{
                    backgroundColor: getDocumentBackGroundColor(
                      flag_electricityBillDocument
                    ),
                    borderRadius: "10px",
                    minHeight: "125px",
                    height: "auto",
                  }}
                >
                  <Grid
                    item
                    lg={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingBottom: "5px",
                    }}
                  >
                    <div
                      onClick={() => {
                        if (!electricityBillDocumentVerifyPopUp) {
                          setElectricityBillDocumentVerifyPopUp(true);
                        }
                      }}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      {historyData?.electricityBill?.slice(0, 6) === "data:i" ? (
                        flag_electricityBillDocument === 1 ? (
                          <>
                            <Base64Image
                              data={historyData?.electricityBill}
                              width="80"
                              height="50"
                            />
                            {/* <Base64Image data={historyData?.applicantCNICBack} width='80' height='50' /> */}
                            <img
                              src={tickicon}
                              width="25px"
                              height="25px"
                              alt="Tick Icon"
                              style={{
                                position: "relative",
                                zIndex: "2",
                                marginRight: "-120px",
                                marginTop: "-30px",
                              }}
                            />
                          </>
                        ) : flag_electricityBillDocument === -1 ? (
                          <>
                            <Base64Image
                              data={historyData?.electricityBill}
                              width="80"
                              height="50"
                            />
                            {/* <Base64Image data={historyData?.applicantCNICBack} width='80' height='50' /> */}
                            <img
                              src={crossIcon}
                              width="25px"
                              height="25px"
                              alt="Cross Icon"
                              style={{
                                position: "relative",
                                zIndex: "2",
                                marginRight: "-120px",
                                marginTop: "-30px",
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <Base64Image
                              data={historyData?.electricityBill}
                              width="80"
                              height="50"
                            />
                            {/* <Base64Image data={historyData?.electricityBill} width='80' height='50' /> */}
                          </>
                        )
                      ) : (
                        <Base64Image data={pdfIcon} width="40" />
                      )}
                      {electricityBillDocumentVerifyPopUp && (
                        <OpenBase64ImageInPopup
                          docVerifyPopUp={electricityBillDocumentVerifyPopUp}
                          hideDocVerifyPopup={hideElectricityBillVerifyAlert}
                          documentName="Electricity Bill"
                          documentImage={historyData?.electricityBill}
                          // backDocumentImage={historyData?.applicantCNICBack}
                          width={"100%"}
                          document={historyData?.electricityBill}
                          documentFlag={historyData?.electricityBillFlag}
                          applicationProgressId={
                            historyData?.applicationProgressId
                          }
                          objectionStatus={historyData?.objectionStatus}
                          updateDocFlag={updateDocFlag}
                          titleToUpdateFlag="electricityBill"
                          flag_document={flag_electricityBillDocument}
                        // flag_documentBack={flag_applicantCNICBack}
                        />
                      )}
                    </div>
                  </Grid>
                  <Grid
                    item
                    lg={12}
                    className="tittlegrid"
                    sx={{ textAlign: "center" }}
                  >
                    <p className="docTitle">Electricity Bill</p>
                  </Grid>
                </Grid>
              </Grid>

              {historyData?.fbrDocument && (
                <Grid item lg={2.5}>
                  <Grid
                    container
                    sx={{
                      backgroundColor:
                        getDocumentBackGroundColor(flag_fbrDocument),
                      borderRadius: "10px",
                      minHeight: "125px",
                      height: "auto",
                    }}
                  >
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "5px",
                      }}
                    >
                      <div
                        onClick={() => {
                          if (!fbrDocumentVerifyPopUp) {
                            setFbrDocumentVerifyPopUp(true);
                          }
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        {historyData?.fbrDocument?.slice(0, 6) === "data:i" ? (
                          flag_fbrDocument === 1 ? (
                            <>
                              <Base64Image
                                data={historyData?.fbrDocument}
                                width="80"
                                height="50"
                              />
                              {/* <Base64Image data={historyData?.fbrDocument} width='80' height='50' /> */}
                              <img
                                src={tickicon}
                                width="25px"
                                height="25px"
                                alt="Tick Icon"
                                style={{
                                  position: "relative",
                                  zIndex: "2",
                                  marginRight: "-120px",
                                  marginTop: "-30px",
                                }}
                              />
                            </>
                          ) : flag_fbrDocument === -1 ? (
                            <>
                              <Base64Image
                                data={historyData?.fbrDocument}
                                width="80"
                                height="50"
                              />
                              {/* <Base64Image data={historyData?.fbrDocument} width='80' height='50' /> */}
                              <img
                                src={crossIcon}
                                width="25px"
                                height="25px"
                                alt="Cross Icon"
                                style={{
                                  position: "relative",
                                  zIndex: "2",
                                  marginRight: "-120px",
                                  marginTop: "-30px",
                                }}
                              />
                            </>
                          ) : (
                            <>
                              <Base64Image
                                data={historyData?.fbrDocument}
                                width="80"
                                height="50"
                              />
                              {/* <Base64Image data={historyData?.applicantCNICBack} width='80' height='50' /> */}
                            </>
                          )
                        ) : (
                          <Base64Image data={pdfIcon} width="40" />
                        )}
                        {fbrDocumentVerifyPopUp && (
                          <OpenBase64ImageInPopup
                            docVerifyPopUp={fbrDocumentVerifyPopUp}
                            hideDocVerifyPopup={hideFbrDocumentVerifyAlert}
                            documentName="Fbr Document"
                            documentImage={historyData?.fbrDocument}
                            // backDocumentImage={historyData?.applicantCNICBack}
                            width={"100%"}
                            document={historyData?.fbrDocument}
                            documentFlag={historyData?.fbrDocumentFlag}
                            applicationProgressId={
                              historyData?.applicationProgressId
                            }
                            objectionStatus={historyData?.objectionStatus}
                            updateDocFlag={updateDocFlag}
                            titleToUpdateFlag="fbrDocument"
                            flag_document={flag_fbrDocument}
                          // flag_documentBack={flag_applicantCNICBack}
                          />
                        )}
                      </div>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      className="tittlegrid"
                      sx={{ textAlign: "center" }}
                    >
                      <p className="docTitle">Fbr Document</p>
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {dialogRowData.addDocAnyOther && (
                <Grid item lg={2}>
                  <Grid
                    container
                    sx={{
                      backgroundColor: dialogRowData.anyOtherDocumentFlag
                        ? getDocumentBackGroundColor(
                          dialogRowData.anyOtherDocumentFlag
                        )
                        : getDocumentBackGroundColor(
                          flag_addDocAnyOther
                        ),
                      borderRadius: "10px",
                      minHeight: "125px",
                      height: "auto",
                    }}
                  >
                    <Grid
                      item
                      lg={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        onClick={() => {
                          if (!addDocAnyOtherVerifyPopUp) {
                            setAddDocAnyOtherVerifyPopUp(true);
                          }
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {dialogRowData.addDocAnyOther.slice(0, 6) ===
                          "data:i" ? (
                          flag_addDocAnyOther === 1 ? (
                            <>
                              <Base64Image
                                data={dialogRowData.addDocAnyOther}
                                width="80"
                                height="110"
                              />
                              <img
                                src={tickicon}
                                width="25px"
                                height="25px"
                                alt="Tick Icon"
                                style={{
                                  position: "relative",
                                  zIndex: "2",
                                  marginRight: "-20px",
                                  marginTop: "60px",
                                }}
                              />
                            </>
                          ) : flag_addDocAnyOther === -1 ? (
                            <>
                              <Base64Image
                                data={dialogRowData.addDocAnyOther}
                                width="80"
                                height="110"
                              />
                              <img
                                src={crossIcon}
                                width="25px"
                                height="25px"
                                alt="Cross Icon"
                                style={{
                                  position: "relative",
                                  zIndex: "2",
                                  marginRight: "-20px",
                                  marginTop: "60px",
                                }}
                              />
                            </>
                          ) : (
                            <Base64Image
                              data={dialogRowData.addDocAnyOther}
                              width="80"
                              height="110"
                            />
                          )
                        ) : (
                          <Base64Image data={pdfIcon} width="40" />
                        )}
                        {addDocAnyOtherVerifyPopUp && (
                          <OpenBase64ImageInPopup
                            docVerifyPopUp={addDocAnyOtherVerifyPopUp}
                            hideDocVerifyPopup={
                              hideAddAnyOtherVerifyAlert
                            }
                            documentName="Any Other Document"
                            documentImage={
                              dialogRowData.addDocAnyOther
                            }
                            width={"100%"}
                            document={dialogRowData.addDocAnyOther}
                            documentFlag={
                              dialogRowData.anyOtherDocumentFlag
                            }
                            applicationProgressId={
                              dialogRowData.applicationProgressId
                            }
                            objectionStatus={
                              dialogRowData.objectionStatus
                            }
                            updateDocFlag={updateDocFlag}
                            documentRemarks={
                              addDocAnyOtherObjectionRemarks
                            }
                            titleToUpdateFlag="addDocAnyOther"
                            flag_document={flag_addDocAnyOther}
                          />
                        )}
                      </div>
                    </Grid>
                    <Grid item lg={12} className="tittlegrid">
                      <p className="docTitle">Any Other Document</p>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </DialogContent>
        ) : (
          historyData?.applicationProgressId == 2 &&
          historyData?.objectionStatus == 0 &&
          historyData.remarks === "Revert to Arrear Verification" && (
            <DialogContent className="dialog-content">
              <Typography style={{ color: "red" }}>
                Application Revert to Arrear Verification from DN Approval
              </Typography>
            </DialogContent>
          )
        )}

        <DialogActions className="dialog-action">
          <p className="description">
            Documents Verified by: {historyData?.lastModifiedBy} on:{" "}
            {convertDatewithTime(historyData?.lastModificationDate)}
          </p>
        </DialogActions>
      </Dialog>

      <Dialog
        open={arrearVerifiedSubPopUp}
        onClose={() => {
          setArrearVerifiedSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"sm"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">
            {historyData?.applicationProgressId == 3 &&
              historyData?.objectionStatus == 0
              ? "Arrear Verified"
              : "Arrear Objection"}
          </p>
          <CloseIcon
            id="clearPopup"
            className="closeIcon"
            onClick={() => {
              setArrearVerifiedSubPopUp(false);
            }}
          />
        </DialogTitle>
        {(historyData?.applicationProgressId == 3 ||
          (historyData?.applicationProgressId == 2 &&
            historyData?.objectionStatus == 1)) && (
            <DialogContent className="dialog-content">
              <DialogContentText component="div">
                <div style={{ textAlign: "center" }}>
                  {historyData?.applicationProgressId == 3 &&
                    historyData?.objectionStatus == 0 ? (
                    <div style={{ textAlign: "center" }}>
                      <p>
                        All dues were{" "}
                        <span style={{ fontWeight: "bold", color: "green" }}>
                          PAID
                        </span>{" "}
                        against the property.
                      </p>

                      <Grid
                        container
                        sx={{
                          borderRadius: "10px",
                          minHeight: "125px",
                          height: "auto",
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "10px",
                        }}
                      >
                        <Grid
                          item
                          lg={12}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingBottom: "5px",
                          }}
                        >
                          <div
                            onClick={() => setPaidBillPopUp(true)}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            {historyData?.paidBillImage?.slice(0, 6) ===
                              "data:i" ? (
                              <Base64Image
                                data={historyData?.paidBillImage}
                                width="100"
                                height="70"
                              />
                            ) : (
                              <Base64Image data={pdfIcon} width="40" />
                            )}
                          </div>
                        </Grid>

                        <Grid item lg={12} style={{ textAlign: "center" }}>
                          <p className="docTitle">Paid Bill</p>
                        </Grid>
                      </Grid>

                      {paidBillPopUp && (
                        <OpenBase64ImageInPopup
                          docVerifyPopUp={paidBillPopUp}
                          hideDocVerifyPopup={hidePaidBillAlert}
                          documentName="Paid Bill"
                          documentImage={historyData?.paidBillImage}
                          width={"100%"}
                        />
                      )}
                    </div>
                  ) : (
                    <p>
                      Dues of{" "}
                      <span style={{ fontWeight: "bold", color: "red" }}>
                        Rs. {numberFormatting(historyData?.arrearsAmount)}
                      </span>{" "}
                      are still{" "}
                      <span style={{ fontWeight: "bold", color: "red" }}>
                        PENDING
                      </span>{" "}
                      against the property.
                    </p>
                  )}
                </div>
              </DialogContentText>
            </DialogContent>
          )}
      </Dialog>

      {/* Cost Estimated Sub Pop Up */}
      <Dialog
        open={fieldSurveyedSubPopUp}
        onClose={() => {
          setFieldSurveyedSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          {historyData?.applicationProgressId == 3 &&
            historyData?.objectionStatus == 1 ? (
            <p className="title">Field Survey Objection</p>
          ) : historyData?.applicationProgressId == 3 &&
            historyData?.objectionStatus != 1 &&
            historyData?.remarks == "Field Survey Objection Removed." ? (
            <p className="title">Field Survey</p>
          ) : (
            historyData?.applicationProgressId == 3 &&
            historyData?.objectionStatus != 1 &&
            historyData?.remarks == "Revert to Field Survey." && (
              <p className="title">Objection</p>
            )
          )}
          {/* <p className="title">Cost Estimated</p> */}
          <CloseIcon
            id="clearPopup"
            onClick={() => {
              setFieldSurveyedSubPopUp(false);
            }}
            className="closeIcon"
          />
        </DialogTitle>
        {historyData?.applicationProgressId == 4 ? (
          <DialogContent className="dialog-content">
            <Grid container spacing={2} className="container">
              <Grid container item spacing={2} className="application-details">
                {historyData?.capitalCostAmount > 0 && (
                  <Grid item lg={3} md={6} xs={12} className="first-row-item">
                    <Typography className="prop-title">Capital Cost</Typography>
                    <Typography className="prop-detail">
                      {numberFormatting(historyData.capitalCostAmount)}
                    </Typography>
                  </Grid>
                )}

                {historyData?.securityDepositeAmount > 0 && (
                  <Grid item lg={3} md={6} xs={12} className="first-row-item">
                    <Typography className="prop-title">
                      Security to be Deposited
                    </Typography>
                    <Typography className="prop-detail">
                      {numberFormatting(historyData.securityDepositeAmount)}
                    </Typography>
                  </Grid>
                )}

                {historyData?.civilWorkCharges > 0 && (
                  <Grid item lg={3} md={6} xs={12} className="first-row-item">
                    <Typography className="prop-title">
                      Civil Work Charges
                    </Typography>
                    <Typography className="prop-detail">
                      {numberFormatting(historyData.civilWorkCharges)}
                    </Typography>
                  </Grid>
                )}

                {historyData?.fixedChargesOfMetering > 0 && (
                  <Grid item lg={3} md={6} xs={12} className="first-row-item">
                    <Typography className="prop-title">
                      Fixed Charges
                    </Typography>
                    <Typography className="prop-detail">
                      {numberFormatting(historyData.fixedChargesOfMetering)}
                    </Typography>
                  </Grid>
                )}

                {historyData?.miscellaneousCharges > 0 && (
                  <Grid item lg={3} md={6} xs={12} className="first-row-item">
                    <Typography className="prop-title">
                      Miscellaneous Charges
                    </Typography>
                    <Typography className="prop-detail">
                      {numberFormatting(historyData.miscellaneousCharges)}
                    </Typography>
                  </Grid>
                )}

                {historyData?.amountOfGridSharing > 0 && (
                  <Grid item lg={3} md={6} xs={12} className="first-row-item">
                    <Typography className="prop-title">Grid Sharing</Typography>
                    <Typography className="prop-detail">
                      {numberFormatting(historyData.amountOfGridSharing)}
                    </Typography>
                  </Grid>
                )}

                {historyData?.amountOfFeederRehab > 0 && (
                  <Grid item lg={3} md={6} xs={12} className="first-row-item">
                    <Typography className="prop-title">Feeder Rehab</Typography>
                    <Typography className="prop-detail">
                      {numberFormatting(historyData.amountOfFeederRehab)}
                    </Typography>
                  </Grid>
                )}

                {historyData?.lessTheCost > 0 && (
                  <Grid item lg={3} md={6} xs={12} className="first-row-item">
                    <Typography className="prop-title">
                      Less the Cost
                    </Typography>
                    <Typography className="prop-detail">
                      {numberFormatting(historyData.lessTheCost)}
                    </Typography>
                  </Grid>
                )}

                {/* --- Total --- */}
                <Grid
                  item
                  lg={3}
                  md={6}
                  xs={12}
                  className="first-row-item total-item"
                >
                  <Typography className="prop-title">
                    Total Cost Estimates Deposit
                  </Typography>
                  <Typography className="prop-detail total-value">
                    {(() => {
                      const capitalCostAmount =
                        Number(historyData?.capitalCostAmount) || 0;
                      const securityDepositeAmount =
                        Number(historyData?.securityDepositeAmount) || 0;
                      const civilWorkCharges =
                        Number(historyData?.civilWorkCharges) || 0;
                      const miscellaneousCharges =
                        Number(historyData?.miscellaneousCharges) || 0;
                      const fixedChargesOfMetering =
                        Number(historyData?.fixedChargesOfMetering) || 0;
                      const gridSharing =
                        Number(historyData?.amountOfGridSharing) || 0;
                      const feederRehab =
                        Number(historyData?.amountOfFeederRehab) || 0;
                      const lessCost = Number(historyData?.lessTheCost) || 0;

                      const total =
                        capitalCostAmount +
                        securityDepositeAmount +
                        civilWorkCharges +
                        miscellaneousCharges +
                        fixedChargesOfMetering +
                        gridSharing +
                        feederRehab -
                        lessCost;

                      return total > 0
                        ? `Rs. ${numberFormatting(parseInt(total))}`
                        : "-";
                    })()}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
        ) : historyData?.applicationProgressId == 3 &&
          historyData?.objectionStatus == 1 ? (
          <>
            <DialogContent className="dialog-content">
              <Grid item lg={6} md={6} xs={12} className="first-row-item">
                <Typography className="prop-title">
                  Site Observation Objection
                </Typography>
                <TextField
                  fullWidth
                  disabled
                  value={
                    historyData?.observationType == 6
                      ? historyData?.remarksDetail || "No Remarks Found"
                      : lookUpDataOfCON?.lookupFSObservation?.find(
                        (o) =>
                          o.observationType == historyData?.observationType
                      )?.observationDetails || "No Objection Details Found"
                  }
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
            </DialogContent>
          </>
        ) : historyData?.applicationProgressId == 3 &&
          historyData?.objectionStatus != 1 &&
          historyData?.remarks == "Field Survey Objection Removed." ? (
          <>
            <DialogContent className="dialog-content">
              <Grid item lg={6} md={6} xs={12} className="first-row-item">
                <Typography className="prop-title" style={{ color: "green" }}>
                  Site Observation Objection Removed
                </Typography>
              </Grid>
            </DialogContent>
          </>
        ) : (
          historyData?.applicationProgressId == 3 &&
          historyData?.objectionStatus != 1 &&
          historyData?.remarks == "Revert to Field Survey." && (
            <>
              <DialogContent className="dialog-content">
                <Grid item lg={6} md={6} xs={12} className="first-row-item">
                  <Typography className="prop-title" style={{ color: "red" }}>
                    Application Revert to Field Survey from DN Approval
                  </Typography>
                </Grid>
              </DialogContent>
            </>
          )
        )}
        <DialogActions className="dialog-action">
          <p className="description">
            Field Survey : {historyData?.lastModifiedBy} on:{" "}
            {convertDatewithTime(historyData?.lastModificationDate)}
          </p>
        </DialogActions>
      </Dialog>

      <Dialog
        open={fieldSurveyedObjectionSubPopUp}
        onClose={() => {
          setFieldSurveyedObjectionSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">Field Survey Objection</p>
          <CloseIcon
            id="clearPopup"
            onClick={() => {
              setFieldSurveyedObjectionSubPopUp(false);
            }}
            className="closeIcon"
          />
        </DialogTitle>
        {historyData?.applicationProgressId == 3 &&
          historyData?.objectionStatus == 1 && (
            <DialogContent className="dialog-content">
              <p style={{ fontSize: "16px", fontWeight: "600", color: "red" }}>
                {historyData?.observationType == 6
                  ? historyData?.remarksDetail || "No Remarks Found"
                  : lookUpDataOfCON?.lookupFSObservation?.find(
                    (o) => o.observationType == historyData?.observationType
                  )?.observationDetails || "No Objection Details Found"}
              </p>
            </DialogContent>
          )}
        <DialogActions className="dialog-action">
          <p className="description">
            Field Survey : {historyData?.lastModifiedBy} on:{" "}
            {convertDatewithTime(historyData?.lastModificationDate)}
          </p>
        </DialogActions>
      </Dialog>

      {/* Demand Note Approved Pop Up */}
      <Dialog
        open={dnApprovalSubPopUp}
        onClose={() => {
          setDnApprovalSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          {historyData?.applicationProgressId == 5 &&
            historyData?.objectionStatus == 1 ? (
            <p className="title">Demand Note Objection</p>
          ) : (
            <p className="title">Demand Note Approved</p>
          )}
          <div>
            <PrintIcon
              onClick={handleDialogDnDownload}
              className="printIcon"
            />
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setDnApprovalSubPopUp(false);
              }}
              className="closeIcon"
            />
          </div>
        </DialogTitle>
        {historyData?.applicationProgressId == 5 &&
          historyData?.objectionStatus !== 1 ? (
          <DialogContent className="dialog-content">
            <Grid container spacing={2} className="container">
              {/* --- First Row: Basic Info --- */}
              <Grid container item spacing={2} className="application-details">
                <Grid item lg={4} md={6} xs={12} className="first-row-item">
                  <Typography className="prop-title">Issue Date</Typography>
                  <Typography className="prop-detail">
                    {dnApproveStep?.issueDate
                      ? convertDate(dnApproveStep.issueDate)
                      : "-"}
                  </Typography>
                </Grid>

                <Grid item lg={4} md={6} xs={12} className="first-row-item">
                  <Typography className="prop-title">Due Date</Typography>
                  <Typography className="prop-detail">
                    {dnApproveStep?.dueDate
                      ? convertDate(dnApproveStep.dueDate)
                      : "-"}
                  </Typography>
                </Grid>

                <Grid item lg={4} md={6} xs={12} className="first-row-item">
                  <Typography className="prop-title">Bank Name</Typography>
                  <Typography className="prop-detail">
                    {bankName || "-"}
                  </Typography>
                </Grid>
              </Grid>

              {/* --- Second Row: Cost Breakdown --- */}
              <Grid container item spacing={2} className="application-details">
                {historyData?.capitalCostAmount > 0 && (
                  <Grid item lg={3} md={6} xs={12} className="first-row-item">
                    <Typography className="prop-title">Capital Cost</Typography>
                    <Typography className="prop-detail">
                      {numberFormatting(historyData.capitalCostAmount)}
                    </Typography>
                  </Grid>
                )}

                {historyData?.securityDepositeAmount > 0 && (
                  <Grid item lg={3} md={6} xs={12} className="first-row-item">
                    <Typography className="prop-title">
                      Security to be Deposited
                    </Typography>
                    <Typography className="prop-detail">
                      {numberFormatting(historyData.securityDepositeAmount)}
                    </Typography>
                  </Grid>
                )}

                {/* --- Total --- */}
                <Grid
                  item
                  lg={3}
                  md={6}
                  xs={12}
                  className="first-row-item total-item"
                >
                  <Typography className="prop-title">
                    Grand Total
                  </Typography>
                  <Typography className="prop-detail total-value">
                    {(() => {
                      const capitalCostAmount =
                        Number(historyData?.capitalCostAmount) || 0;
                      const securityDepositeAmount =
                        Number(historyData?.securityDepositeAmount) || 0;

                      const total =
                        capitalCostAmount +
                        securityDepositeAmount

                      return total > 0
                        ? `Rs. ${numberFormatting(parseInt(total))}`
                        : "-";
                    })()}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
        ) : (
          historyData?.applicationProgressId == 5 &&
          historyData?.objectionStatus == 1 && (
            <DialogContent className="dialog-content">
              <Typography style={{ color: "red" }}>
                Objection raised on DN Payment Verification
              </Typography>
            </DialogContent>
          )
        )}

        <DialogActions className="dialog-action">
          <p className="description">
            Demand Notice Approved by : {historyData?.lastModifiedBy} on:{" "}
            {convertDatewithTime(historyData?.lastModificationDate)}{" "}
          </p>
        </DialogActions>
      </Dialog>

      {/* DN Payment Submitted Pub Pop Up */}
      <Dialog
        open={dnPaymentSubmittedSubPopUp}
        onClose={() => {
          setDnPaymentSubmittedSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">DN Payment Submitted</p>
          <div>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setDnPaymentSubmittedSubPopUp(false);
              }}
              className="closeIcon"
            />
          </div>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid container spacing={2} className="container">
            {/* --- Row 1: Demand Notice Info --- */}
            <Grid container item spacing={2} className="application-details">
              <Grid item lg={3} md={6} xs={12} className="first-row-item">
                <Typography className="prop-title">Demand Notice No</Typography>
                <Typography className="prop-detail">
                  {dnApproveStep?.demandNoteNo || "-"}
                </Typography>
              </Grid>

              {historyData?.capitalCostAmount > 0 && (
                <Grid item lg={3} md={6} xs={12} className="first-row-item">
                  <Typography className="prop-title">Capital Cost</Typography>
                  <Typography className="prop-detail">
                    {numberFormatting(historyData.capitalCostAmount)}
                  </Typography>
                </Grid>
              )}

              {historyData?.securityDepositeAmount > 0 && (
                <Grid item lg={3} md={6} xs={12} className="first-row-item">
                  <Typography className="prop-title">
                    Security to be Deposited
                  </Typography>
                  <Typography className="prop-detail">
                    {numberFormatting(historyData.securityDepositeAmount)}
                  </Typography>
                </Grid>
              )}


              {/* --- Total --- */}
              <Grid
                item
                lg={3}
                md={6}
                xs={12}
                className="first-row-item total-item"
              >
                <Typography className="prop-title">
                  Grand Total
                </Typography>
                <Typography className="prop-detail total-value">
                  {(() => {
                    const capitalCostAmount =
                      Number(historyData?.capitalCostAmount) || 0;
                    const securityDepositeAmount =
                      Number(historyData?.securityDepositeAmount) || 0;

                    const total =
                      capitalCostAmount +
                      securityDepositeAmount

                    return total > 0
                      ? `Rs. ${numberFormatting(parseInt(total))}`
                      : "-";
                  })()}
                </Typography>
              </Grid>
            </Grid>

            <Grid container item spacing={2} className="application-details">
              <Grid item lg={3} md={6} xs={12} className="first-row-item">
                <Typography className="prop-title">Payment Date</Typography>
                <Typography className="prop-detail">
                  {historyData?.paymentDate
                    ? convertDate(historyData.paymentDate)
                    : "-"}
                </Typography>
              </Grid>

              <Grid item lg={3} className="paidDnDocument item">
                <Typography className="title">Paid Demand Notice</Typography>
                <Grid
                  container
                  sx={{
                    backgroundColor: getDocumentBackGroundColor(0),
                    borderRadius: "10px",
                    height: "250px",
                    width: "100%",
                    marginRight: "2%",
                  }}
                  className="docContainer"
                >
                  <Grid
                    item
                    lg={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingBottom: "5px",
                    }}
                  >
                    <div
                      onClick={() => {
                        if (!paidDNImagePopUp) {
                          setPaidDNImagePopUp(true);
                        }
                      }}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Base64Image data={dnImage} width={80} />
                    </div>
                    {paidDNImagePopUp && (
                      <OpenBase64ImageInPopup
                        docVerifyPopUp={paidDNImagePopUp}
                        hideDocVerifyPopup={hidePaidDnImagePopUp}
                        documentName="Paid DN Image"
                        documentImage={dnImage}
                        width={"100%"}
                        document={dnImage}
                        documentFlag={1}
                        applicationProgressId={
                          dialogRowData.applicationProgressId
                        }
                        objectionStatus={dialogRowData.objectionStatus}
                        updateDocFlag={updateDocFlag}
                        titleToUpdateFlag="copyOfApplicantCNIC"
                        flag_document={1}
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>

              <Grid item lg={3} md={6} xs={12}></Grid>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions className="dialog-action">
          <p className="description">
            Paid Demand Notice Image Uploaded by: {historyData?.lastModifiedBy}{" "}
            on: {convertDatewithTime(historyData?.lastModificationDate)}
          </p>
        </DialogActions>
      </Dialog>

      <Dialog
        open={dnPaymentVerifiedSubPopUp}
        onClose={() => {
          setDnPaymentVerifiedSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">DN Payment Verified</p>
          <div>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setDnPaymentVerifiedSubPopUp(false);
              }}
              className="closeIcon"
            />
          </div>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid container spacing={2} className="container">
            {/* --- Row 1: Demand Notice Info --- */}
            <Grid container item spacing={2} className="application-details">
              <Grid item lg={3} md={6} xs={12} className="first-row-item">
                <Typography className="prop-title">Demand Notice No</Typography>
                <Typography className="prop-detail">
                  {dnApproveStep?.demandNoteNo || "-"}
                </Typography>
              </Grid>

              {historyData?.capitalCostAmount > 0 && (
                <Grid item lg={3} md={6} xs={12} className="first-row-item">
                  <Typography className="prop-title">Capital Cost</Typography>
                  <Typography className="prop-detail">
                    {numberFormatting(historyData.capitalCostAmount)}
                  </Typography>
                </Grid>
              )}

              {historyData?.securityDepositeAmount > 0 && (
                <Grid item lg={3} md={6} xs={12} className="first-row-item">
                  <Typography className="prop-title">
                    Security to be Deposited
                  </Typography>
                  <Typography className="prop-detail">
                    {numberFormatting(historyData.securityDepositeAmount)}
                  </Typography>
                </Grid>
              )}

              {/* --- Total --- */}
              <Grid
                item
                lg={3}
                md={6}
                xs={12}
                className="first-row-item total-item"
              >
                <Typography className="prop-title">
                  Grand Total
                </Typography>
                <Typography className="prop-detail total-value">
                  {(() => {
                    const capitalCostAmount =
                      Number(historyData?.capitalCostAmount) || 0;
                    const securityDepositeAmount =
                      Number(historyData?.securityDepositeAmount) || 0;

                    const total =
                      capitalCostAmount +
                      securityDepositeAmount

                    return total > 0
                      ? `Rs. ${numberFormatting(parseInt(total))}`
                      : "-";
                  })()}
                </Typography>
              </Grid>
            </Grid>

            <Grid container item spacing={2} className="application-details">
              <Grid item lg={3} md={6} xs={12} className="first-row-item">
                <Typography className="prop-title">Payment Date</Typography>
                <Typography className="prop-detail">
                  {historyData?.paymentDate
                    ? convertDate(historyData.paymentDate)
                    : "-"}
                </Typography>
              </Grid>
              <Grid item lg={3} md={6} xs={12} className="first-row-item">
                <Typography className="prop-title">Verify By</Typography>
                <Typography className="prop-detail">
                  {historyData?.lastModifiedBy
                    ? historyData.lastModifiedBy
                    : "-"}
                </Typography>
              </Grid>
              <Grid item lg={3} md={6} xs={12} className="first-row-item">
                <Typography className="prop-title">
                  Verification Date
                </Typography>
                <Typography className="prop-detail">
                  {historyData?.lastModificationDate
                    ? convertDate(historyData.lastModificationDate)
                    : "-"}
                </Typography>
              </Grid>
              <Grid item lg={3} md={6} xs={12} className="first-row-item">
                <Typography className="prop-title">
                  Paid Demand Notice
                </Typography>
                <Grid
                  container
                  sx={{
                    backgroundColor: getDocumentBackGroundColor(0),
                    borderRadius: "10px",
                  }}
                  className="docContainer"
                >
                  <Grid
                    item
                    lg={12}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      onClick={() =>
                        !paidDNImagePopUp && setPaidDNImagePopUp(true)
                      }
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Base64Image
                        data={historyData?.paidDNImage}
                        width={100}
                      />
                    </div>
                    {paidDNImagePopUp && (
                      <OpenBase64ImageInPopup
                        docVerifyPopUp={paidDNImagePopUp}
                        hideDocVerifyPopup={hidePaidDnImagePopUp}
                        documentName="Paid DN Image"
                        documentImage={historyData?.paidDNImage}
                        width="100%"
                        document={historyData?.paidDNImage}
                        documentFlag={1}
                        applicationProgressId={
                          dialogRowData.applicationProgressId
                        }
                        objectionStatus={dialogRowData.objectionStatus}
                        updateDocFlag={updateDocFlag}
                        titleToUpdateFlag="copyOfApplicantCNIC"
                        flag_document={1}
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>

              <Grid item lg={3} md={6} xs={12}></Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <p className="description">
            Demand Notice Payment Verified by: {historyData?.lastModifiedBy} on:{" "}
            {convertDatewithTime(historyData?.lastModificationDate)}
          </p>
        </DialogActions>
      </Dialog>

      <Dialog
        open={serviceConnectionOrderedSubPopUp}
        onClose={() => {
          setServiceConnectionOrderedSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"lg"}
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">Sundary Job Order</p>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <PrintIcon
              onClick={() =>
                downloadSJOPDF(dialogRowData.applicationId, dnDets)
              }
              sx={{ color: "#006ad1", marginRight: "1%", cursor: "pointer" }}
            />
            <CloseIcon
              id="clearPopup"
              sx={{ cursor: "pointer" }}
              onClick={() => {
                setServiceConnectionOrderedSubPopUp(false);
              }}
              className="closeIcon"
            />
          </div>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Grid container className="container">
            <Grid item lg={12} mt={2}>
              <Table
                sx={{
                  borderCollapse: "collapse",
                  width: "100%",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  // borderRadius: '8px',
                  overflow: "hidden",
                }}
              >
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundImage:
                        "linear-gradient(180deg, #1e52a7, #a0bbe7)",
                    }}
                  >
                    <TableCell
                      sx={{
                        color: "white",
                        fontWeight: "bold",
                        border: "1px solid #1565c0",
                        padding: "6px 10px",
                      }}
                    ></TableCell>
                    <TableCell
                      sx={{
                        color: "white",
                        fontWeight: "bold",
                        border: "1px solid #1565c0",
                        padding: "6px 10px",
                      }}
                    >
                      {dnApproveStep.sjoCurrentDetails || "-"}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "white",
                        fontWeight: "bold",
                        border: "1px solid #1565c0",
                        padding: "6px 10px",
                      }}
                    >
                      {dnApproveStep.sjoNewDetails || "-"}
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {[
                    {
                      label: dnApproveStep.sjoName,
                      current: dnApproveStep.currentName,
                      newVal: dnApproveStep.newName,
                    },
                    {
                      label: dnApproveStep.sjoCNIC,
                      current: dnApproveStep.currentCNIC,
                      newVal: dnApproveStep.newCNIC,
                    },
                    {
                      label: dnApproveStep.sjoPhone,
                      current: dnApproveStep.currentPhone,
                      newVal: dnApproveStep.newPhone,
                    },
                    {
                      label: dnApproveStep.sjoFH,
                      current: dnApproveStep.currentFHName,
                      newVal: dnApproveStep.newFHName,
                    },
                    {
                      label: dnApproveStep.sjoEmail,
                      current: dnApproveStep.currentEmail,
                      newVal: dnApproveStep.newEmail,
                    },
                  ].map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        backgroundColor:
                          index % 2 === 0 ? "white" : "rgb(213, 229, 255)",
                        "&:hover": { backgroundColor: "#e3f2fd" },
                      }}
                    >
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          border: "1px solid #e0e0e0",
                          padding: "8px 16px",
                        }}
                      >
                        {row.label || "-"}
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid #e0e0e0",
                          padding: "8px 16px",
                        }}
                      >
                        {row.current || "-"}
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid #e0e0e0",
                          padding: "8px 16px",
                        }}
                      >
                        {row.newVal || "-"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <p className="description">
            Sundary Job Order Issued
            {/* by: {eFileData.find(item => item.remarks == "DN Payment Verified") ? eFileData.find(item => item.remarks == "DN Payment Verified").lastModifiedBy : ''} {eFileData.find(item => item.remarks == "DN Payment Verified") ? '(' + eFileData.find(item => item.remarks == "DN Payment Verified").roleName + ')' : ''} on: {eFileData.find(item => item.remarks == "DN Payment Verified") ? convertDatewithTime(eFileData.find(item => item.remarks == "DN Payment Verified").lastModificationDate) : ''} */}
          </p>
        </DialogActions>
      </Dialog>

      {/* SUCESS OR UNSUCESS MODAL */}
      <Dialog
        open={openResponseModal}
        onClose={() => {
          setOpenResponseModal(false);
          setResponseMessage("");
          setResponseMessageError("");
        }}
        fullWidth={true}
        maxWidth={"sm"}
        className="response-status-modal"
      >
        <DialogTitle sx={{ textAlign: "center", paddingBottom: 0 }}>
          {/* Icon */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
            <Box
              sx={{
                backgroundColor: responseMessageError ? "#fdecea" : "#e6f4ea", // light red or green bg
                border: `2px solid ${responseMessageError ? "#d32f2f" : "#2e7d32"
                  }`, // border color
                borderRadius: "50%",
                height: 70,
                width: 70,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {responseMessageError ? (
                <ErrorIcon sx={{ color: "#d32f2f", fontSize: "2.5rem" }} />
              ) : (
                <DoneIcon sx={{ color: "#2e7d32", fontSize: "2.5rem" }} />
              )}
            </Box>
            {/* {responseMessageError ? (
              <Box className="backgroundAttached" >
              <DoneIcon className="icon" />
            </Box>
          ) : (
            <Box className="backgroundAttached" >
              <ErrorIcon className="icon" />
            </Box>
          )} */}
          </Box>

          {/* Heading */}
          <Typography
            variant="h6"
            sx={{
              color: responseMessageError ? "red" : "green",
              fontWeight: "bold",
              fontSize: "1.7rem",
            }}
          >
            {responseMessageError ? "Error" : "Success"}
          </Typography>
        </DialogTitle>

        <DialogContent
          sx={{
            minHeight: "100px",
            display: "flex",
            flexDirection: "column", // stack vertically
            alignItems: "center",
            justifyContent: "center",
            gap: 2, // space between message and button
          }}
        >
          <DialogContentText
            component="div"
            sx={{
              color: responseMessageError ? "red" : "#444",
              textAlign: "center",
              fontSize: "1.5rem",
              padding: "0 12px",
            }}
          >
            {responseMessageError || responseMessage}
          </DialogContentText>

          {dialogRowData.applicationProgressId === 2 &&
            responseMessageError && (
              <Button
                onClick={() => {
                  downloadBill(dialogRowData.referenceNumber);
                }}
                variant="outlined"
                color="primary"
              >
                Open Your Bill
              </Button>
            )}
        </DialogContent>
      </Dialog>

      {/* DN Rejection Modal FOR REMARLS */}
      <Dialog
        open={dnRejectModalOpen}
        onClose={() => {
          setDnRejectModalOpen(false);
          dnRejectFormik.resetForm();
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "linear-gradient(to bottom, #2c5ab3, #87a4d6)",
            color: "white",
            fontWeight: "bold",
            textAlign: "center",
            fontSize: "1.25rem",
            py: 1.5,
            // borderTopLeftRadius: "10px",
            // borderTopRightRadius: "10px",
          }}
        >
          <Typography variant="h6" fontWeight="bold" sx={{ ml: 1 }}>
            Reject Demand Notice
          </Typography>

          <IconButton
            aria-label="close"
            onClick={() => {
              setDnRejectModalOpen(false);
              dnRejectFormik.resetForm();
            }}
            size="small"
            sx={{
              color: "white",
              mr: 1,
              "&:hover": { color: "#f5f5f5" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            dnRejectFormik.handleSubmit();
          }}
        >
          <DialogContent>
            <Box mt={1}>
              <Typography variant="body1" gutterBottom>
                Select Reason:
              </Typography>

              <TextField
                select
                id="reasonType"
                name="reasonType"
                fullWidth
                size="small"
                variant="outlined"
                value={dnRejectFormik.values.reasonType}
                onChange={dnRejectFormik.handleChange}
                onBlur={dnRejectFormik.handleBlur}
                error={
                  dnRejectFormik.touched.reasonType &&
                  Boolean(dnRejectFormik.errors.reasonType)
                }
                helperText={
                  dnRejectFormik.touched.reasonType &&
                  dnRejectFormik.errors.reasonType
                }
                sx={{
                  mb: 2,
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "black" },
                    "&:hover fieldset": { borderColor: "black" },
                    "&.Mui-focused fieldset": { borderColor: "black" },
                  },
                }}
              >
                <MenuItem value="">Select reason</MenuItem>
                <MenuItem value="3">Field Survey</MenuItem>
                <MenuItem value="2">Arrear Verification</MenuItem>
                <MenuItem value="1">Documents Verification</MenuItem>
              </TextField>

              <Typography variant="body1" gutterBottom>
                Please provide a reason for rejection:
              </Typography>

              <TextField
                id="remarks"
                name="remarks"
                multiline
                rows={4}
                fullWidth
                variant="outlined"
                placeholder="Enter your remarks here..."
                value={dnRejectFormik.values.remarks}
                onChange={dnRejectFormik.handleChange}
                onBlur={dnRejectFormik.handleBlur}
                error={
                  dnRejectFormik.touched.remarks &&
                  Boolean(dnRejectFormik.errors.remarks)
                }
                helperText={
                  dnRejectFormik.touched.remarks &&
                  dnRejectFormik.errors.remarks
                }
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "black" },
                    "&:hover fieldset": { borderColor: "black" },
                    "&.Mui-focused fieldset": { borderColor: "black" },
                  },
                }}
              />
            </Box>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={() => {
                setDnRejectModalOpen(false);
                dnRejectFormik.resetForm();
              }}
              variant="outlined"
              color="primary"
            >
              Cancel
            </Button>
            <Button type="submit" variant="contained" color="error">
              Reject
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Dialog
        open={showBoq}
        onClose={() => setShowBoq(false)}
        fullWidth
        maxWidth={false}
        className="rejection-removal"
        sx={{
          "& .MuiDialog-paper": {
            width: "80%",
            maxWidth: "1000px",
          },
        }}
      >
        <DialogTitle
          className="dialog-title"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Prepare Estimate
          <Box sx={{ marginRight: "2%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                arearBillDocumentFormik.resetForm();
                arearBillDocumentFormik.values.iv_arear_paid_bill_document = "";
                setShowBoq(false);
              }}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>

        <DialogContent sx={{ overflow: "visible", padding: 2 }}>
          {/* {fieldFormik.values.iv_distance == 0 && ( */}
          <Grid container direction="column" spacing={3}>
            {/* Show BOQ Item adding form only when Material Required */}
            {fieldFormik.values.iv_material_required === true && (
              <Grid item xs={12} display="flex" justifyContent="center">
                <TableContainer
                  component={Paper}
                  sx={{ p: 2, maxWidth: 900, width: "100%" }}
                >
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                      <Typography className="fieldLabel">Item</Typography>
                      <Autocomplete
                        options={allMaterialList}
                        getOptionLabel={(option) =>
                          option
                            ? option.item_Name
                              ? `${option.item_Code} - ${option.item_Name}`
                              : option.item_Code // agar name empty hai to sirf code dikhaye
                            : ""
                        }
                        value={
                          (allMaterialList || []).find(
                            (item) =>
                              item.item_Code ===
                              fieldItemFormik.values.iv_fieldItemId
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          fieldItemFormik.setFieldValue(
                            "iv_fieldItemId",
                            newValue ? newValue.item_Code : ""
                          );
                        }}
                        filterOptions={(options, state) =>
                          options.filter((option) => {
                            const input = state.inputValue.toLowerCase();
                            return (
                              String(option.item_Code)
                                .toLowerCase()
                                .includes(input) ||
                              (option.item_Name &&
                                String(option.item_Name)
                                  .toLowerCase()
                                  .includes(input))
                            );
                          })
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select Item"
                            size="small"
                            error={
                              fieldItemFormik.touched.iv_fieldItemId &&
                              Boolean(fieldItemFormik.errors.iv_fieldItemId)
                            }
                            helperText={
                              fieldItemFormik.touched.iv_fieldItemId &&
                              fieldItemFormik.errors.iv_fieldItemId
                            }
                            sx={{
                              "& .MuiInputBase-root": {
                                height: 35,
                                minHeight: 35,
                              },
                              "& .MuiInputBase-input": {
                                padding: "0 8px",
                              },
                            }}
                          />
                        )}
                        disableClearable
                        fullWidth
                        disabled={dnDetails && dnDetails.filledFlag === 1}
                      />
                    </Grid>

                    {/* Unit */}
                    <Grid item xs={2}>
                      <Typography className="fieldLabel">Unit</Typography>
                      <TextField
                        name="iv_fieldItemUnit"
                        value={fieldItemFormik.values.iv_fieldItemUnit}
                        fullWidth
                        disabled
                        InputProps={{
                          sx: {
                            height: 35, // 👈 yahan height control karein
                            textAlign: "right", // 👈 text right aligned
                            "& input": {
                              textAlign: "right", // 👈 ensure karein ke input ke andar text right me ho
                            },
                          },
                        }}
                      />
                    </Grid>

                    {/* Qty */}
                    <Grid item xs={2}>
                      <Typography className="fieldLabel">Qty</Typography>
                      <TextField
                        name="iv_fieldItemQty"
                        disabled={dnDetails && dnDetails.filledFlag === 1}
                        value={formatWholeNumberInput(fieldItemFormik.values.iv_fieldItemQty)}
                        fullWidth
                        onChange={(e) =>
                          fieldItemFormik.setFieldValue(
                            "iv_fieldItemQty",
                            sanitizeWholeNumberInput(e.target.value)
                          )
                        }
                        type="text"
                        inputProps={{ inputMode: "numeric" }}
                        size="small" // 👈 chhota input
                        InputProps={{
                          sx: {
                            height: 35, // 👈 yahan height control karein
                            textAlign: "right", // 👈 text right aligned
                            "& input": {
                              textAlign: "right", // 👈 ensure karein ke input ke andar text right me ho
                            },
                          },
                        }}
                      />
                    </Grid>

                    {/* Add Button */}
                    <Grid item xs={2}>
                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        fullWidth
                        sx={{ height: 50, marginTop: 2, height: 35 }} // 🔹 set height here
                        onClick={fieldItemFormik.handleSubmit}
                        disabled={dnDetails && dnDetails.filledFlag === 1}
                      >
                        Add
                      </Button>
                    </Grid>
                  </Grid>
                </TableContainer>
              </Grid>
            )}

            {/* ➤ Items Table */}
            {/* ➤ Items Table */}
            {fieldFormik.values.iv_material_required === true && itemsArray?.length > 0 && (
              <Grid item>
                <TableContainer
                  component={Paper}
                  sx={{
                    maxHeight: 250,
                    overflowY: "auto",
                  }}
                >
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>Sr.</TableCell>
                        <TableCell>Item Name</TableCell>
                        <TableCell align="right">Unit</TableCell>
                        <TableCell align="center" sx={{ minWidth: 130 }}>
                          Qty
                        </TableCell>
                        <TableCell align="right">Rate</TableCell>
                        <TableCell align="right">Amount</TableCell>
                        <TableCell align="center"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {itemsArray.map((row, index) => (
                        <TableRow key={row.Id}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{row.item_Name}</TableCell>
                          <TableCell align="right">{row.unit}</TableCell>
                          <TableCell align="center" sx={{ minWidth: 130 }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 1,
                                width: "100%",
                              }}
                            >
                              <IconButton
                                size="small"
                                onClick={() => updateItemQtyByDelta(row.Id, -1)}
                                disabled={dnDetails && dnDetails.filledFlag === 1}
                                sx={{ p: 0.5 }}
                              >
                                <RemoveIcon fontSize="small" />
                              </IconButton>
                              <Typography
                                component="span"
                                sx={{ minWidth: 28, textAlign: "center", fontWeight: 500 }}
                              >
                                {numberFormatting(row.qty)}
                              </Typography>
                              <IconButton
                                size="small"
                                onClick={() => updateItemQtyByDelta(row.Id, 1)}
                                disabled={dnDetails && dnDetails.filledFlag === 1}
                                sx={{ p: 0.5 }}
                              >
                                <AddIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </TableCell>
                          <TableCell align="right">
                            {numberFormatting(row.rate)}
                          </TableCell>
                          <TableCell align="right">
                            {numberFormatting(row.amount)}
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              onClick={() => deleteItem(row.Id)}
                              disabled={dnDetails && dnDetails.filledFlag === 1}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}

            {/* ➤ Charges Table */}
            <Grid item>
              <TableContainer component={Paper}>
                {/* <Typography variant="h6" sx={{ mb: 1, p: 1 }}>
                    Charges
                  </Typography> */}
                <Table sx={{ border: "1px solid #ccc" }}>
                  <TableBody>
                    {/* Row 1 */}
                    <TableRow>
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Items' Total Amount:
                          </Typography>
                          <Typography
                            className="value"
                            sx={{ flex: 1, textAlign: "right" }}
                          >
                            {itemsAmount ? numberFormatting(itemsAmount) : "-"}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {dialogRowData?.applicationId?.slice(3, 5) === "13" ? "Store Charges (0%):" : "Store Charges (12%):"}
                          </Typography>
                          <Typography
                            className="value"
                            sx={{ flex: 1, textAlign: "right" }}
                          >
                            {dialogRowData?.applicationId?.slice(3, 5) === "13" ? 0 : (storeCharges
                              ? numberFormatting(storeCharges)
                              : "-")}
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* Row 2 */}
                    <TableRow>
                      {/* Installation Charges (read-only value) */}
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Installation Charges (8%):
                          </Typography>
                          <Typography
                            className="value"
                            sx={{ flex: 1, textAlign: "right" }}
                          >
                            {installationCharges
                              ? numberFormatting(installationCharges)
                              : "-"}
                          </Typography>
                        </Box>
                      </TableCell>

                      {/* Grid Sharing Cost (input field) */}
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Grid Sharing Cost:
                          </Typography>
                          <TextField
                            name="iv_grid_sharing_cost"
                            value={formatWholeNumberInput(fieldFormik.values.iv_grid_sharing_cost)}
                            type="text"
                            inputProps={{ inputMode: "numeric" }}
                            size="small"
                            onChange={handleWholeNumberFieldChange(
                              "iv_grid_sharing_cost",
                              setGridSharingCost
                            )}
                            sx={{ flex: 1 }}
                            InputProps={{
                              sx: {
                                height: 25, // 👈 yahan height control karein
                                textAlign: "right", // 👈 text right aligned
                                "& input": {
                                  textAlign: "right", // 👈 ensure karein ke input ke andar text right me ho
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* Row 3 */}
                    {/* <TableRow>
                        <TableCell sx={{ border: "1px solid #ccc" }}>
                          <Typography className="title">Feeder Rehab Charges</Typography>
                          <TextField
                            name="iv_feeder_rehab_charges"
                            value={fieldFormik.values.iv_feeder_rehab_charges}
                            type="number"
                            fullWidth
                            size="small"
                            onChange={fieldFormik.handleChange}
                            onBlur={(e) =>
                              setFeederRehabilitationCharges(
                                e.target.value === "" ? 0 : parseInt(e.target.value)
                              )
                            }
                          />
                        </TableCell>
                        <TableCell sx={{ border: "1px solid #ccc" }}>
                          <Typography className="title">Civil Work Charges</Typography>
                          <TextField
                            name="iv_civil_work_charges"
                            value={fieldFormik.values.iv_civil_work_charges}
                            type="number"
                            fullWidth
                            size="small"
                            onChange={fieldFormik.handleChange}
                            onBlur={(e) =>
                              setCivilWorkCharges(e.target.value === "" ? 0 : parseInt(e.target.value))
                            }
                          />
                        </TableCell>
                      </TableRow> */}

                    <TableRow>
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Feeder Rehab Charges
                          </Typography>
                          <TextField
                            name="iv_feeder_rehab_charges"
                            value={formatWholeNumberInput(fieldFormik.values.iv_feeder_rehab_charges)}
                            type="text"
                            inputProps={{ inputMode: "numeric" }}
                            size="small"
                            onChange={handleWholeNumberFieldChange(
                              "iv_feeder_rehab_charges",
                              setFeederRehabilitationCharges
                            )}
                            sx={{ flex: 1 }} // 👈 baaki space yeh lega
                            InputProps={{
                              sx: {
                                height: 25, // 👈 yahan height control karein
                                textAlign: "right", // 👈 text right aligned
                                "& input": {
                                  textAlign: "right", // 👈 ensure karein ke input ke andar text right me ho
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>

                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Civil Work Charges
                          </Typography>
                          <TextField
                            name="iv_civil_work_charges"
                            value={formatWholeNumberInput(fieldFormik.values.iv_civil_work_charges)}
                            type="text"
                            inputProps={{ inputMode: "numeric" }}
                            size="small"
                            onChange={handleWholeNumberFieldChange(
                              "iv_civil_work_charges",
                              setCivilWorkCharges
                            )}
                            sx={{ flex: 1 }} // 👈 yahan bhi same
                            InputProps={{
                              sx: {
                                height: 25, // 👈 yahan height control karein
                                textAlign: "right", // 👈 text right aligned
                                "& input": {
                                  textAlign: "right", // 👈 ensure karein ke input ke andar text right me ho
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* Row 4 */}
                    <TableRow>
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Misc. Charges
                          </Typography>
                          <TextField
                            name="iv_miscellaneous_charges"
                            value={formatWholeNumberInput(fieldFormik.values.iv_miscellaneous_charges)}
                            type="text"
                            inputProps={{ inputMode: "numeric" }}
                            size="small"
                            onChange={handleWholeNumberFieldChange(
                              "iv_miscellaneous_charges",
                              setMiscellaneousCharges
                            )}
                            sx={{ flex: 1 }} // 👈 full remaining space
                            InputProps={{
                              sx: {
                                height: 25, // 👈 yahan height control karein
                                textAlign: "right", // 👈 text right aligned
                                "& input": {
                                  textAlign: "right", // 👈 ensure karein ke input ke andar text right me ho
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>

                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Fixed Charges
                          </Typography>
                          <TextField
                            name="iv_fixed_charges_of_metering"
                            value={formatWholeNumberInput(fieldFormik.values.iv_fixed_charges_of_metering)}
                            type="text"
                            inputProps={{ inputMode: "numeric" }}
                            size="small"
                            onChange={handleWholeNumberFieldChange(
                              "iv_fixed_charges_of_metering",
                              setFixedChargesOfMetering
                            )}
                            sx={{ flex: 1 }} // 👈 full remaining space
                            InputProps={{
                              sx: {
                                height: 25, // 👈 yahan height control karein
                                textAlign: "right", // 👈 text right aligned
                                "& input": {
                                  textAlign: "right", // 👈 ensure karein ke input ke andar text right me ho
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* Row 5 - M&T & Labour Charges */}
                    <TableRow>
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            M&T Charges
                          </Typography>
                          <TextField
                            name="iv_mnt_charges"
                            value={formatWholeNumberInput(fieldFormik.values.iv_mnt_charges)}
                            type="text"
                            inputProps={{ inputMode: "numeric" }}
                            size="small"
                            onChange={handleWholeNumberFieldChange(
                              "iv_mnt_charges",
                              setMntCharges
                            )}
                            sx={{ flex: 1 }}
                            InputProps={{
                              sx: {
                                height: 25,
                                textAlign: "right",
                                "& input": {
                                  textAlign: "right",
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>

                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Labour Charges
                          </Typography>
                          <TextField
                            name="iv_labour_charges"
                            value={formatWholeNumberInput(fieldFormik.values.iv_labour_charges)}
                            type="text"
                            inputProps={{ inputMode: "numeric" }}
                            size="small"
                            onChange={handleWholeNumberFieldChange(
                              "iv_labour_charges",
                              setLabourCharges
                            )}
                            sx={{ flex: 1 }}
                            InputProps={{
                              sx: {
                                height: 25,
                                textAlign: "right",
                                "& input": {
                                  textAlign: "right",
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* Row 6 - Design Vetting Fee & Consultancy Charges */}
                    <TableRow>
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Design Vetting Fee
                          </Typography>
                          <TextField
                            name="iv_design_vetting_fee"
                            value={formatWholeNumberInput(fieldFormik.values.iv_design_vetting_fee)}
                            type="text"
                            inputProps={{ inputMode: "numeric" }}
                            size="small"
                            onChange={handleWholeNumberFieldChange(
                              "iv_design_vetting_fee",
                              setDesignVettingFee
                            )}
                            sx={{ flex: 1 }}
                            InputProps={{
                              sx: {
                                height: 25,
                                textAlign: "right",
                                "& input": {
                                  textAlign: "right",
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>

                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Consultancy Charges
                          </Typography>
                          <TextField
                            name="iv_consultancy_charges"
                            value={formatWholeNumberInput(fieldFormik.values.iv_consultancy_charges)}
                            type="text"
                            inputProps={{ inputMode: "numeric" }}
                            size="small"
                            onChange={handleWholeNumberFieldChange(
                              "iv_consultancy_charges",
                              setConsultancyCharges
                            )}
                            sx={{ flex: 1 }}
                            InputProps={{
                              sx: {
                                height: 25,
                                textAlign: "right",
                                "& input": {
                                  textAlign: "right",
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* Row 7 - Variation & Dismantlement Charges */}
                    <TableRow>
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Variation Charges
                          </Typography>
                          <TextField
                            name="iv_variation_charges"
                            value={formatWholeNumberInput(fieldFormik.values.iv_variation_charges)}
                            type="text"
                            inputProps={{ inputMode: "numeric" }}
                            size="small"
                            onChange={handleWholeNumberFieldChange(
                              "iv_variation_charges",
                              setVariationCharges
                            )}
                            sx={{ flex: 1 }}
                            InputProps={{
                              sx: {
                                height: 25,
                                textAlign: "right",
                                "& input": {
                                  textAlign: "right",
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>

                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Dismantlement Charges
                          </Typography>
                          <TextField
                            name="iv_dismantlement_charges"
                            value={formatWholeNumberInput(fieldFormik.values.iv_dismantlement_charges)}
                            type="text"
                            inputProps={{ inputMode: "numeric" }}
                            size="small"
                            onChange={handleWholeNumberFieldChange(
                              "iv_dismantlement_charges",
                              setDismantlementCharges
                            )}
                            sx={{ flex: 1 }}
                            InputProps={{
                              sx: {
                                height: 25,
                                textAlign: "right",
                                "& input": {
                                  textAlign: "right",
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* Row 8 - Earthing Charges */}
                    <TableRow>
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Earthing Charges
                          </Typography>
                          <TextField
                            name="iv_earthing_charges"
                            value={formatWholeNumberInput(fieldFormik.values.iv_earthing_charges)}
                            type="text"
                            inputProps={{ inputMode: "numeric" }}
                            size="small"
                            onChange={handleWholeNumberFieldChange(
                              "iv_earthing_charges",
                              setEarthingCharges
                            )}
                            sx={{ flex: 1 }}
                            InputProps={{
                              sx: {
                                height: 25,
                                textAlign: "right",
                                "& input": {
                                  textAlign: "right",
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>
                      <TableCell sx={{ border: "1px solid #ccc" }}></TableCell>
                    </TableRow>

                    {/* ✅ Total Row */}
                    <TableRow>
                      <TableCell sx={{ border: "1px solid #ccc" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Typography
                            className="title"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            Less the Cost
                          </Typography>
                          <TextField
                            name="iv_less_the_cost"
                            value={formatWholeNumberInput(fieldFormik.values.iv_less_the_cost)}
                            type="text"
                            inputProps={{ inputMode: "numeric" }}
                            size="small"
                            onChange={handleWholeNumberFieldChange(
                              "iv_less_the_cost",
                              setLessTheCost
                            )}
                            sx={{ flex: 1 }} // 👈 TextField gets full remaining width
                            InputProps={{
                              sx: {
                                height: 25, // 👈 yahan height control karein
                                textAlign: "right", // 👈 text right aligned
                                "& input": {
                                  textAlign: "right", // 👈 ensure karein ke input ke andar text right me ho
                                },
                              },
                            }}
                          />
                        </Box>
                      </TableCell>

                      <TableCell
                        colSpan={2}
                        align="right"
                        sx={{
                          backgroundColor: "#0282ff",
                          border: "1px solid #ccc",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            color: "white",
                            fontSize: "20px",
                          }}
                        >
                          Total:{" "}
                          {grandTotalCharges
                            ? numberFormatting(grandTotalCharges)
                            : "-"}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
          {/* )} */}
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            className="confirmButton"
            sx={{ width: "30%", textTransform: "capitalize" }}
            onClick={onSaveCostEstimationConfirm}
          >
            Save Estimate
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showCostEstimation}
        onClose={handleCostEstimationClose}
        fullWidth={true}
        maxWidth={"sm"}
        className="rejection-removal"
      >
        <DialogTitle
          className="dialog-title"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Cost Estimation
          <Box sx={{ marginRight: "2%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                arearBillDocumentFormik.resetForm();
                arearBillDocumentFormik.values.iv_arear_paid_bill_document = "";
                handleCostEstimationClose();
              }}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>

        <DialogContent>
          {costEstimationForNC ? (
            <Box
              sx={{
                border: "1px solid #ddd",
                borderRadius: "12px",
                padding: "16px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                backgroundColor: "#fff",
                marginTop: "10px",
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong> Items' Total Amount:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {itemsAmount
                      ? Number(itemsAmount).toLocaleString()
                      : Number(
                        costEstimationForNC?.estimatedCapitalCost || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong> {dialogRowData?.applicationId?.slice(3, 5) === "13" ? "Store Charges (0%):" : "Store Charges (12%):"}</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {dialogRowData?.applicationId?.slice(3, 5) === "13" ? 0 : (storeCharges ? Number(storeCharges).toLocaleString() : 0)}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong> Installation Charges (8%):</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {installationCharges
                      ? Number(installationCharges).toLocaleString()
                      : 0}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Grid Sharing Cost:</strong>
                  </Typography>
                </Grid>

                <Grid item xs={6} textAlign="right">
                  {/* <Typography variant="body1">
                          Rs.{" "} */}
                  {/* {!boqItems || boqItems.length === 0
                            ? 0
                            : gridSharingCost !== null && gridSharingCost !== undefined && gridSharingCost !== ""
                              ? Number(gridSharingCost).toLocaleString()
                              : Number(costEstimationForNC?.amountOfGridSharing || 0).toLocaleString()} */}
                  {/* {Number(costEstimationForNC?.amountOfGridSharing || 0).toLocaleString()} */}
                  <Typography variant="body1">
                    Rs.{" "}
                    {gridSharingCost
                      ? Number(gridSharingCost).toLocaleString()
                      : Number(
                        costEstimationForNC?.amountOfGridSharing || 0
                      ).toLocaleString()}
                  </Typography>
                  {/* </Typography> */}
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Feeder Rehab Cost:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  {/* <Typography variant="body1">
                          Rs. {Number(costEstimationForNC?.amountOfFeederRehab || 0).toLocaleString()}
                        </Typography> */}
                  <Typography variant="body1">
                    Rs.{" "}
                    {feederRehabilitationCharges
                      ? Number(feederRehabilitationCharges).toLocaleString()
                      : Number(
                        costEstimationForNC?.amountOfFeederRehab || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Civil Work Charges:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {civilWorkCharges
                      ? Number(civilWorkCharges).toLocaleString()
                      : Number(
                        costEstimationForNC?.civilWorkCharges || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>M&T Charges:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {mntCharges
                      ? Number(mntCharges).toLocaleString()
                      : Number(
                        costEstimationForNC?.mntCharges || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Labour Charges:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {labourCharges
                      ? Number(labourCharges).toLocaleString()
                      : Number(
                        costEstimationForNC?.labourCharges || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Design Vetting Fee:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {designVettingFee
                      ? Number(designVettingFee).toLocaleString()
                      : Number(
                        costEstimationForNC?.designVettingFee || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Consultancy Charges:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {consultancyCharges
                      ? Number(consultancyCharges).toLocaleString()
                      : Number(
                        costEstimationForNC?.consultancyCharges || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Variation Charges:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {variationCharges
                      ? Number(variationCharges).toLocaleString()
                      : Number(
                        costEstimationForNC?.variationCharges || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Dismantlement Charges:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {dismantlementCharges
                      ? Number(dismantlementCharges).toLocaleString()
                      : Number(
                        costEstimationForNC?.dismantlementCharges || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Earthing Charges:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {earthingCharges
                      ? Number(earthingCharges).toLocaleString()
                      : Number(
                        costEstimationForNC?.earthingCharges || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Fixed Charges:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {fixedChargesOfMetering
                      ? Number(fixedChargesOfMetering).toLocaleString()
                      : Number(
                        costEstimationForNC?.fixedChargesOfMetering || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Miscellaneous Charges:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  {/* <Typography variant="body1">
                          Rs. {Number(costEstimationForNC?.miscellaneousCharges || 0).toLocaleString()}
                        </Typography> */}
                  <Typography variant="body1">
                    Rs.{" "}
                    {miscellaneousCharges
                      ? Number(miscellaneousCharges).toLocaleString()
                      : Number(
                        costEstimationForNC?.miscellaneousCharges || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Less the Cost:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  {/* <Typography variant="body1">
                          Rs. {Number(costEstimationForNC?.lessTheCost || 0).toLocaleString()}
                        </Typography> */}
                  <Typography variant="body1">
                    Rs.{" "}
                    {lessTheCost
                      ? Number(lessTheCost).toLocaleString()
                      : Number(
                        costEstimationForNC?.lessTheCost || 0
                      ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "green" }}
                  >
                    <strong>Capital Cost:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "green" }}
                  >
                    Rs.{" "}
                    {[
                      itemsAmount || 0,
                      gridSharingCost || 0,
                      dialogRowData?.applicationId?.slice(3, 5) === "13" ? 0 : (storeCharges || 0),
                      installationCharges || 0,
                      feederRehabilitationCharges || 0,
                      civilWorkCharges || 0,
                      mntCharges || 0,
                      labourCharges || 0,
                      designVettingFee || 0,
                      consultancyCharges || 0,
                      variationCharges || 0,
                      dismantlementCharges || 0,
                      earthingCharges || 0,
                      fixedChargesOfMetering || 0,
                      miscellaneousCharges || 0,
                      -(lessTheCost || 0),
                    ]
                      .map(Number)
                      .reduce((acc, val) => acc + val, 0)
                      .toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1" sx={{ color: "red" }}>
                    Current Security:
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1" sx={{ color: "red" }}>
                    Rs.{" "}
                    {Number(
                      costEstimationForNC?.currentSecurityAmount || 0
                    ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Estimated Security:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {Number(
                      costEstimationForNC?.estimatedSecurityAmount || 0
                    ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Diff. curr and Est. Security:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {Number(
                      (costEstimationForNC?.estimatedSecurityAmount || 0) -
                      (costEstimationForNC?.currentSecurityAmount || 0)
                    ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Security to be Deposited:</strong>
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography variant="body1">
                    Rs.{" "}
                    {Math.max(
                      (Number(costEstimationForNC?.estimatedSecurityAmount) ||
                        0) -
                      (Number(costEstimationForNC?.currentSecurityAmount) ||
                        0),
                      0
                    ).toLocaleString()}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "green" }}
                  >
                    <strong>Total Cost Estimation Deposit:</strong>
                  </Typography>
                </Grid>

                <Grid item xs={6} textAlign="right">
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "green" }}
                  >
                    Rs.{" "}
                    {(() => {
                      const values = [
                        itemsAmount,
                        gridSharingCost,
                        dialogRowData?.applicationId?.slice(3, 5) === "13" ? 0 : storeCharges,
                        installationCharges,
                        feederRehabilitationCharges,
                        civilWorkCharges,
                        mntCharges,
                        labourCharges,
                        designVettingFee,
                        consultancyCharges,
                        variationCharges,
                        dismantlementCharges,
                        earthingCharges,
                        fixedChargesOfMetering,
                        miscellaneousCharges,
                        -(Number(lessTheCost) || 0),
                        Math.max(
                          (Number(
                            costEstimationForNC?.estimatedSecurityAmount
                          ) || 0) -
                          (Number(
                            costEstimationForNC?.currentSecurityAmount
                          ) || 0),
                          0
                        ),
                      ];

                      // ✅ Ensure all are valid numbers
                      const total = values
                        .map((v) => Number(v) || 0)
                        .reduce((acc, val) => acc + val, 0);

                      return total.toLocaleString(); // e.g. "123,456"
                    })()}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          ) : (
            <Typography variant="body2">Loading cost details...</Typography>
          )}
        </DialogContent>
        {errormessageCostEstimation ? (
          <Typography
            style={{
              // border: "1px solid #ddd",
              // borderRadius: "12px",
              paddingLeft: "20px",
              paddingBottom: "20px",
              color: "red",
              // boxShadow: ,
              // backgroundColor: "red",
              // marginTop: "10px"
            }}
          >
            {errormessageCostEstimation}
          </Typography>
        ) : null}

        <DialogActions>
          <Button
            variant="contained"
            className="confirmButton"
            sx={{ width: "30%", textTransform: "capitalize" }}
            onClick={onPressCostEstimationConfirm}
          >
            Save Cost Estimation
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={rejectModalOpen}
        onClose={() => {
          setRejectModalOpen(false);
          setRemarks("");
          setRemarksError("");
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "linear-gradient(to bottom, #2c5ab3, #87a4d6)",
            color: "white",
            fontWeight: "bold",

            textAlign: "center",
            fontSize: "1.25rem",
            py: 1.5,
          }}
        >
          Reject Demand Note Payment
          <IconButton
            aria-label="close"
            onClick={() => {
              setRejectModalOpen(false);
              setRemarks("");
              setRemarksError("");
            }}
            size="small"
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "white",
              "&:hover": { color: "#f5f5f5" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <TextField
            label="Enter Remarks"
            fullWidth
            multiline
            rows={4}
            value={remarks}
            onChange={(e) => {
              setRemarks(e.target.value);
              if (e.target.value.trim().length >= 20) setRemarksError(""); // clear error on valid input
            }}
            placeholder="Enter your remarks..."
            sx={{ mt: 1 }}
            error={Boolean(remarksError)}
          />
          {remarksError && (
            <Box sx={{ color: "red", mt: 0.5, fontSize: 13 }}>
              {remarksError}
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setRejectModalOpen(false);
              setRemarks("");
              setRemarksError("");
            }}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (remarks.trim().length < 20) {
                setRemarksError("Remarks must be at least 20 characters.");
                return;
              }
              DNPaymentVerificationAPI(
                dialogRowData.applicationId,
                dialogRowData.applicationProgressId - 1,
                1,
                "Demand Note Payment Rejected",
                remarks
              );
              setRejectModalOpen(false);
              setRemarks("");
              setRemarksError("");
            }}
            variant="contained"
            color="error"
          >
            Reject
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={scoPopUp}
        onClose={scoHandleClose}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          style: { width: "100%", height: "45%", borderRadius: 20 },
        }}
      >
        <DialogTitle>
          <Box className="backgroundAttached">
            <DoneIcon className="icon" />
          </Box>
          {scoDetails.scoP2FillFlag &&
            CheckPermissions(
              permissions,
              "General Services",
              "Change of Attributes",
              "Workflow Permissions",
              "Meter Installation",
              "SCO P2 Creation"
            ) ? (
            <Typography variant="h6" className="groupTitle">
              SCO Generated
            </Typography>
          ) : (
            <Typography variant="h6" className="groupTitle">
              SCO Generated
            </Typography>
          )}
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            {scoDetails.scoP2FillFlag &&
              CheckPermissions(
                permissions,
                "General Services",
                "Change of Attributes",
                "Workflow Permissions",
                "Meter Installation",
                "SCO P2 Creation"
              ) ? (
              <p className="applicationSubmit">
                Your Service Connection has been generated successfully.
              </p>
            ) : (
              <p className="applicationSubmit">
                Your Service Connection has been generated successfully.
              </p>
            )}
            <p className="trackId"> {dialogRowData.applicationId}</p>
            <div
              style={{
                borderRadius: "5px",
                marginLeft: "27%",
                marginTop: "2%",
                cursor: "pointer",
              }}
            >
              {scoDetails.scoP2FillFlag &&
                CheckPermissions(
                  permissions,
                  "General Services",
                  "Change of Attributes",
                  "Workflow Permissions",
                  "Meter Installation",
                  "SCO P2 Creation"
                ) ? (
                <></>
              ) : (
                // <Button variant="outlined" onClick={() => downloadSCOPDF(dialogRowData)} sx={{ backgroundColor: 'white', cursor: 'pointer', border: '1px solid #006ad1', boxShadow: 'none', padding: '2%', width: '60%' }} ><PrintIcon sx={{ color: '#006ad1' }} />Print SCO </Button>
                // <Button variant="outlined" onClick={() => downloadSCOPDF(dialogRowData)} sx={{ backgroundColor: 'white', cursor: 'pointer', border: '1px solid #006ad1', boxShadow: 'none', padding: '2%', width: '60%' }} ><PrintIcon sx={{ color: '#006ad1' }} />Print SCO </Button>
                <></>
              )}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      <Dialog
        open={openRemarksDialog}
        onClose={handleCloseRemarks}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          className="subpopup-dialog1"
          sx={{
            background: "linear-gradient(to bottom, #2c5daa, #4a7dc1, #8eb5e2)", // gradient
            color: "white",
            fontWeight: 600,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
          }}
        >
          {/* Left: Title + SJO Button */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography
              variant="h6"
              className="title"
              sx={{ color: "white", fontWeight: "bold" }}
            >
              Enter Remark
            </Typography>
            {readyForBillingError !== "" ? (
              <Button
                variant="outlined"
                onClick={() =>
                  downloadSJOPDF(
                    dialogRowData.applicationId,
                    scoDetails,
                    dialogRowData,
                    dnDets
                  )
                }
                sx={{
                  backgroundColor: "white",
                  cursor: "pointer",
                  border: "1px solid #006ad1",
                  boxShadow: "none",
                  minWidth: "60px", // adjust width
                  height: "32px", // match button size
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <PrintIcon sx={{ color: "#006ad1" }} />
                SJO
              </Button>
            ) : null}
          </Box>

          {/* Right: Close Icon */}
          <CloseIcon
            id="clearPopup"
            className="closeIcon"
            sx={{
              cursor: "pointer",
              color: "white",
              "&:hover": { color: "#f0f0f0" },
            }}
            onClick={() => {
              setOpenRemarksDialog(false);
              setReadyForBillingError("");
              setOdRemarks("");
              setRemarksError("");
            }}
          />
        </DialogTitle>

        <DialogContent>
          <Typography sx={{ mb: 1 }}>
            Please provide remarks before proceeding for billing:
          </Typography>

          <TextField
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            placeholder="Type your remarks here..."
            value={odRemarks}
            onChange={(e) => {
              setOdRemarks(e.target.value);
              if (remarksError) setRemarksError("");
            }}
            error={Boolean(remarksError)}
            helperText={remarksError}
          />
        </DialogContent>

        <DialogActions
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            gap: 2, // space between error & buttons
          }}
        >
          {/* Error Row */}
          {readyForBillingError && (
            <Box sx={{ width: "100%" }}>
              <Error
                error={readyForBillingError}
                onClose={() => errorCloses()}
                backgroundColor="#FFC0CB"
                textColor="#bb0303"
                iconColor="#bb0303"
              />
            </Box>
          )}

          <Box
            sx={{
              display: "flex",
              gap: 1,
              width: "100%",
              justifyContent: "flex-end",
            }}
          >
            <Button
              onClick={handleCloseRemarks}
              color="error"
              variant="outlined"
            >
              Cancel
            </Button>

            <Button
              onClick={handleSubmitRemarks}
              color="primary"
              variant="contained"
            >
              Submit
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showDnExpiryPopup}
        onClose={() => {
          setShowDnExpiryPopup(false);
        }}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          style: { width: "100%", height: "45%", borderRadius: 20 },
        }}
      >
        <DialogTitle>
          <Box className="backgroundRedAttached">
            <EventBusyIcon className="icon" />
          </Box>
          <Typography variant="h6" className="groupTitle">
            Demand Note Expired
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <p className="applicationSubmit">
              Demand Note for below Application ID is expired.
            </p>
            <p className="trackId">{dnExpiryDialogData.applicationId}</p>
            <div
              style={{
                borderRadius: "5px",
                marginLeft: "27%",
                marginTop: "2%",
                cursor: "pointer",
              }}
            >
              <Button
                variant="outlined"
                onClick={async () => {
                  await callDemandNoteRenewalAPI(
                    dnExpiryDialogData.applicationId
                  );
                  setShowDnExpiryPopup(false);
                }}
                sx={{
                  backgroundColor: "white",
                  cursor: "pointer",
                  border: "1px solid #006ad1",
                  boxShadow: "none",
                  padding: "2%",
                  width: "60%",
                }}
              >
                Renew DN
              </Button>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      {/* Edit Popup */}
      <Dialog
        open={showEditPopup}
        onClose={() => {
          setEditSaveError("");
          setEditFbrDocument("");
          setEditFbrDocumentThumbnail("");
          setEditFbrDocumentError("");
          setEditFbrDocumentCleared(false);
          setEditNtnError("");
          setEditLoadChangeTypeError("");
          setEditNameErrors({
            newName: "",
            guardianName: "",
            newCNIC: "",
            newPhone: "",
          });
          setEditTariffError("");
          setShowEditPopup(false);
        }}
        fullWidth={true}
        maxWidth="lg"
        className="alert-popups"
      >
        <DialogTitle className="dialog-title">
          Edit Application
          <Box sx={{ marginTop: "1%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setEditSaveError("");
                setEditFbrDocument("");
                setEditFbrDocumentThumbnail("");
                setEditFbrDocumentError("");
                setEditFbrDocumentCleared(false);
                setEditNtnError("");
                setEditLoadChangeTypeError("");
                setEditNameErrors({
                  newName: "",
                  guardianName: "",
                  newCNIC: "",
                  newPhone: "",
                });
                setEditTariffError("");
                setShowEditPopup(false);
              }}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <DialogContentText component="div" className="dialog-content-text">
            <Typography variant="h6" className="group-title">
              <div className="redCell"></div>
              Application Details
            </Typography>
          </DialogContentText>

          {/* Common Fields Row */}
          <DialogContentText component="div" className="dialog-content-text">
            <div className="field-container">
              <Typography className="fieldLabel">Application ID</Typography>
              <TextField
                disabled
                type="text"
                value={dialogRowData.applicationId || ""}
                className="textfield"
              />
            </div>
            <div className="field-container">
              <Typography className="fieldLabel">Reference No.</Typography>
              <TextField
                type="text"
                value={editFormData.referenceNo}
                onChange={(e) => setEditFormData({ ...editFormData, referenceNo: e.target.value })}
                className="textfield"
                autoComplete="off"
                disabled
              />
            </div>
            <div className="field-container">
              <Typography className="fieldLabel">Address</Typography>
              <TextField
                type="text"
                value={editFormData.address}
                onChange={(e) => setEditFormData({ ...editFormData, address: e.target.value })}
                className="textfield"
                autoComplete="off"
                disabled
              />
            </div>
            <div className="field-container">
              <Typography className="fieldLabel">Tariff</Typography>
              <TextField
                type="text"
                value={editFormData.tariff}
                onChange={(e) => setEditFormData({ ...editFormData, tariff: e.target.value })}
                className="textfield"
                autoComplete="off"
                disabled
              />
            </div>
          </DialogContentText>

          {hasMultipleCoaSections(dialogRowData.changeOfAttributesType) && (
            <DialogContentText component="div" className="dialog-content-text" sx={{ width: "100%", mt: 1 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#003971", mb: 1 }}>
                Select section(s) to edit
              </Typography>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {coaIncludesName(dialogRowData.changeOfAttributesType) && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={editSections.name}
                        onChange={(e) =>
                          setEditSections((prev) => ({ ...prev, name: e.target.checked }))
                        }
                        sx={{ color: "#006ad1", "&.Mui-checked": { color: "#006ad1" } }}
                      />
                    }
                    label="Change of Name"
                  />
                )}
                {coaIncludesLoad(dialogRowData.changeOfAttributesType) && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={editSections.load}
                        onChange={(e) =>
                          setEditSections((prev) => ({ ...prev, load: e.target.checked }))
                        }
                        sx={{ color: "#006ad1", "&.Mui-checked": { color: "#006ad1" } }}
                      />
                    }
                    label="Change of Load"
                  />
                )}
                {coaIncludesTariff(dialogRowData.changeOfAttributesType) && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={editSections.tariff}
                        onChange={(e) =>
                          setEditSections((prev) => ({ ...prev, tariff: e.target.checked }))
                        }
                        sx={{ color: "#006ad1", "&.Mui-checked": { color: "#006ad1" } }}
                      />
                    }
                    label="Change of Tariff"
                  />
                )}
              </Box>
            </DialogContentText>
          )}

          {/* Change of Name Fields */}
          {coaIncludesName(dialogRowData.changeOfAttributesType) && editSections.name && (
            <>
              <DialogContentText component="div" className="dialog-content-text" sx={{ width: "100%", mt: 1 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#003971" }}>
                  Change of Name
                </Typography>
              </DialogContentText>
              <DialogContentText component="div" className="dialog-content-text">
                <div className="field-container">
                  <Typography className="fieldLabel">Current Name</Typography>
                  <TextField
                    type="text"
                    value={editFormData.currentName}
                    onChange={(e) => setEditFormData({ ...editFormData, currentName: e.target.value })}
                    className="textfield"
                    autoComplete="off"
                    disabled
                  />
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">New Name</Typography>
                  <TextField
                    type="text"
                    value={editFormData.newName}
                    onChange={(e) => {
                      setEditFormData({ ...editFormData, newName: e.target.value });
                      setEditNameErrors((prev) => ({ ...prev, newName: "" }));
                    }}
                    className="textfield"
                    autoComplete="off"
                    error={Boolean(editNameErrors.newName)}
                    helperText={editNameErrors.newName}
                  />
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">Relation</Typography>
                  <Select
                    value={editFormData.relation}
                    onChange={(e) => setEditFormData({ ...editFormData, relation: e.target.value })}
                    className="textfield"
                    displayEmpty
                  >
                    <MenuItem value={1}>S/O</MenuItem>
                    <MenuItem value={2}>D/O</MenuItem>
                    <MenuItem value={3}>W/O</MenuItem>
                    <MenuItem value={4}>C/O</MenuItem>
                  </Select>
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">Guardian Name</Typography>
                  <TextField
                    type="text"
                    value={editFormData.guardianName}
                    onChange={(e) => {
                      setEditFormData({ ...editFormData, guardianName: e.target.value });
                      setEditNameErrors((prev) => ({ ...prev, guardianName: "" }));
                    }}
                    className="textfield"
                    autoComplete="off"
                    error={Boolean(editNameErrors.guardianName)}
                    helperText={editNameErrors.guardianName}
                  />
                </div>
              </DialogContentText>
              <DialogContentText component="div" className="dialog-content-text">
                <div className="field-container">
                  <Typography className="fieldLabel">Current CNIC</Typography>
                  <TextField
                    type="text"
                    value={editFormData.currentCNIC}
                    onChange={(e) => setEditFormData({ ...editFormData, currentCNIC: e.target.value })}
                    className="textfield"
                    inputProps={{ maxLength: 13, autoComplete: "off" }}
                    disabled
                  />
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">New CNIC</Typography>
                  <TextField
                    type="text"
                    value={editFormData.newCNIC}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, "");
                      setEditFormData({ ...editFormData, newCNIC: val });
                      setEditNameErrors((prev) => ({ ...prev, newCNIC: "" }));
                    }}
                    className="textfield"
                    inputProps={{ maxLength: 13, autoComplete: "off" }}
                    error={Boolean(editNameErrors.newCNIC)}
                    helperText={editNameErrors.newCNIC}
                  />
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">Current Phone</Typography>
                  <TextField
                    type="text"
                    value={editFormData.currentPhone}
                    onChange={(e) => setEditFormData({ ...editFormData, currentPhone: e.target.value })}
                    className="textfield"
                    inputProps={{ maxLength: 11, autoComplete: "off" }}
                    disabled
                  />
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">New Phone</Typography>
                  <TextField
                    type="text"
                    value={editFormData.newPhone}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, "");
                      setEditFormData({ ...editFormData, newPhone: val });
                      setEditNameErrors((prev) => ({ ...prev, newPhone: "" }));
                    }}
                    className="textfield"
                    inputProps={{ maxLength: 11, autoComplete: "off" }}
                    error={Boolean(editNameErrors.newPhone)}
                    helperText={editNameErrors.newPhone}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" sx={{ mr: 0 }}>
                          <Select
                            value={editFormData.telcoCode}
                            onChange={(e) => setEditFormData({ ...editFormData, telcoCode: e.target.value })}
                            variant="standard"
                            disableUnderline
                            sx={{
                              minWidth: 70,
                              '& .MuiSelect-select': {
                                paddingRight: '20px !important',
                                paddingLeft: '0px'
                              }
                            }}
                          >
                            <MenuItem value={1}>Jazz</MenuItem>
                            <MenuItem value={2}>Zong</MenuItem>
                            <MenuItem value={3}>Telenor</MenuItem>
                            <MenuItem value={4}>Ufone</MenuItem>
                            <MenuItem value={5}>SCom</MenuItem>
                          </Select>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </DialogContentText>
            </>
          )}

          {/* Change of Load Fields */}
          {coaIncludesLoad(dialogRowData.changeOfAttributesType) && editSections.load && (
            <>
              <DialogContentText component="div" className="dialog-content-text" sx={{ width: "100%", mt: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#003971" }}>
                  Change of Load
                </Typography>
              </DialogContentText>
              <DialogContentText component="div" className="dialog-content-text">
                <div className="field-container">
                  <Typography className="fieldLabel">Load Change Type</Typography>
                  <Select
                    value={
                      editFormData.loadChangeType !== "" &&
                      editFormData.loadChangeType != null
                        ? String(editFormData.loadChangeType)
                        : ""
                    }
                    onChange={(e) => {
                      setEditFormData({
                        ...editFormData,
                        loadChangeType: e.target.value,
                      });
                      setEditLoadChangeTypeError("");
                      setEditLoadError("");
                    }}
                    className="textfield"
                    displayEmpty
                    error={Boolean(editLoadChangeTypeError)}
                  >
                    <MenuItem value="">
                      <em>Select Load Change Type</em>
                    </MenuItem>
                    {lookUpDataOfCON?.lookupLoadChangeType?.map((item) => (
                      <MenuItem key={item.typeId} value={String(item.typeId)}>
                        {item.typeName}
                      </MenuItem>
                    ))}
                  </Select>
                  {editLoadChangeTypeError ? (
                    <Typography variant="caption" color="error" sx={{ display: "block", mt: 0.5 }}>
                      {editLoadChangeTypeError}
                    </Typography>
                  ) : null}
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">Sanctioned Load (kW)</Typography>
                  <TextField
                    type="text"
                    value={editFormData.currentLoad}
                    className="textfield"
                    autoComplete="off"
                    disabled
                  />
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">New Load (KW)</Typography>
                  <TextField
                    type="text"
                    value={editFormData.newLoad}
                    onChange={(e) => {
                      const regex = /^[0-9]*\.?[0-9]*$/;
                      if (e.target.value === "" || regex.test(e.target.value)) {
                        setEditFormData({ ...editFormData, newLoad: e.target.value });
                        setEditLoadError("");
                      }
                    }}
                    onBlur={() => {
                      const loadErrors = validateEditLoad();
                      setEditLoadChangeTypeError(loadErrors.loadChangeType || "");
                      setEditLoadError(loadErrors.newLoad || "");
                    }}
                    className="textfield"
                    autoComplete="off"
                    error={Boolean(editLoadError)}
                    helperText={editLoadError}
                  />
                </div>
              </DialogContentText>
            </>
          )}

          {/* Change of Tariff Fields */}
          {coaIncludesTariff(dialogRowData.changeOfAttributesType) && editSections.tariff && (
            <>
              <DialogContentText component="div" className="dialog-content-text" sx={{ width: "100%", mt: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#003971" }}>
                  Change of Tariff
                </Typography>
              </DialogContentText>
              <DialogContentText component="div" className="dialog-content-text">
                <div className="field-container">
                  <Typography className="fieldLabel">Old Tariff</Typography>
                  <TextField
                    type="text"
                    value={editFormData.currentTariff}
                    className="textfield"
                    autoComplete="off"
                    disabled
                  />
                </div>
                <div className="field-container">
                  <Typography className="fieldLabel">New Tariff</Typography>
                  <FormControl fullWidth error={Boolean(editTariffError)}>
                  <Select
                    value={editFormData.newTariff || ""}
                    onChange={(e) => {
                      const newTariff = e.target.value;
                      setEditFormData({
                        ...editFormData,
                        newTariff,
                        ntnNo: requiresFbrDocument(newTariff)
                          ? editFormData.ntnNo
                          : "",
                      });
                      setEditTariffError(validateEditTariff(newTariff));
                      setEditSaveError("");
                      if (!requiresFbrDocument(newTariff)) {
                        setEditFbrDocument("");
                        setEditFbrDocumentThumbnail("");
                        setEditFbrDocumentError("");
                        setEditFbrDocumentCleared(false);
                        setEditNtnError("");
                      }
                    }}
                    className="textfield"
                    displayEmpty
                  >
                    <MenuItem value="">
                      <em>Select New Tariff</em>
                    </MenuItem>
                    {editFormData.newTariff &&
                      !allTariffList?.some(
                        (item) => item.tariffName === editFormData.newTariff
                      ) && (
                        <MenuItem value={editFormData.newTariff}>
                          {editFormData.newTariff}
                        </MenuItem>
                      )}
                    {allTariffList?.map((data, index) => (
                      <MenuItem key={index} value={data.tariffName}>
                        {data.tariffName}
                      </MenuItem>
                    ))}
                  </Select>
                  {editTariffError ? (
                    <FormHelperText>{editTariffError}</FormHelperText>
                  ) : null}
                  </FormControl>
                </div>
              </DialogContentText>
              {requiresFbrDocument(editFormData.newTariff) &&
                !hasExistingEditNtn(dialogRowData) && (
                <DialogContentText component="div" className="dialog-content-text">
                  <div className="field-container">
                    <Typography className="fieldLabel">
                      NTN No. <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      type="text"
                      value={editFormData.ntnNo}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, "");
                        if (val.length <= 13) {
                          setEditFormData({ ...editFormData, ntnNo: val });
                          setEditNtnError("");
                        }
                      }}
                      className="textfield"
                      autoComplete="off"
                      inputProps={{ maxLength: 13 }}
                      error={Boolean(editNtnError)}
                      helperText={editNtnError}
                    />
                  </div>
                </DialogContentText>
              )}
              {requiresFbrDocument(editFormData.newTariff) &&
                !hasExistingEditFbrDocument(dialogRowData) &&
                (() => {
                const activeEditFbrDocument = editFbrDocumentThumbnail || "";

                return (
                <DialogContentText component="div" className="dialog-content-text">
                  <div className="field-container" style={{ width: "100%" }}>
                    <Typography className="fieldLabel">
                      FBR Document <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Box
                      sx={{
                        mt: 1,
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 2,
                        flexWrap: "wrap",
                      }}
                    >
                      {activeEditFbrDocument ? (
                        <Box
                          onClick={() => openBase64Image(activeEditFbrDocument)}
                          sx={{
                            cursor: "pointer",
                            border: "1px solid #ddd",
                            borderRadius: 1,
                            p: 1,
                            backgroundColor: "#f8fafc",
                            minWidth: 120,
                            minHeight: 120,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {activeEditFbrDocument.slice(0, 6) === "data:i" ? (
                            <Base64Image
                              data={activeEditFbrDocument}
                              width="120"
                              height="160"
                            />
                          ) : isPdf(activeEditFbrDocument) ? (
                            <Base64Image data={pdfIcon} width="80" height="100" />
                          ) : (
                            <Base64Image
                              data={activeEditFbrDocument}
                              width="120"
                              height="160"
                            />
                          )}
                        </Box>
                      ) : null}
                      <Button
                        variant="outlined"
                        component="label"
                        startIcon={<FileUploadOutlinedIcon />}
                      >
                        {activeEditFbrDocument
                          ? "Re-upload FBR Document"
                          : "Upload FBR Document"}
                        <input
                          hidden
                          accept={documentExtensions}
                          type="file"
                          onChange={(e) => {
                            EditFbrDocument(e);
                            setEditFbrDocumentCleared(false);
                            setEditFbrDocumentError("");
                          }}
                        />
                      </Button>
                    </Box>
                    {editFbrDocumentError && (
                      <Typography variant="caption" color="error" sx={{ display: "block", mt: 0.5 }}>
                        {editFbrDocumentError}
                      </Typography>
                    )}
                  </div>
                </DialogContentText>
                );
              })()}
            </>
          )}
        </DialogContent>
        {editSaveError && (
          <Box sx={{ px: 3, pb: 1 }}>
            <Alert severity="error" onClose={() => setEditSaveError("")}>
              {editSaveError}
            </Alert>
          </Box>
        )}
        <DialogActions className="dialog-actions">
          <Button
            variant="outlined"
            onClick={() => {
              setEditSaveError("");
              setEditFbrDocument("");
              setEditFbrDocumentThumbnail("");
              setEditFbrDocumentError("");
              setEditFbrDocumentCleared(false);
              setEditNtnError("");
              setEditLoadChangeTypeError("");
              setEditNameErrors({
                newName: "",
                guardianName: "",
                newCNIC: "",
                newPhone: "",
              });
              setEditTariffError("");
              setShowEditPopup(false);
            }}
            sx={{
              backgroundColor: "white",
              border: "1px solid #006ad1",
              color: "#006ad1",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={async () => {
              setEditSaveError("");
              const coaType = Number(dialogRowData.changeOfAttributesType);
              const shouldEditName = coaIncludesName(coaType) && editSections.name;
              const shouldEditLoad = coaIncludesLoad(coaType) && editSections.load;
              const shouldEditTariff = coaIncludesTariff(coaType) && editSections.tariff;

              if (hasMultipleCoaSections(coaType) && !shouldEditName && !shouldEditLoad && !shouldEditTariff) {
                setEditSaveError("Please select at least one section to edit");
                return;
              }

              const nameErrors = shouldEditName
                ? validateEditName()
                : { newName: "", guardianName: "", newCNIC: "", newPhone: "" };
              const loadErrors = shouldEditLoad
                ? validateEditLoad()
                : { loadChangeType: "", newLoad: "" };
              const tariffError = shouldEditTariff
                ? validateEditTariff(editFormData.newTariff)
                : "";

              setEditNameErrors(nameErrors);
              setEditLoadChangeTypeError(loadErrors.loadChangeType || "");
              setEditLoadError(loadErrors.newLoad || "");
              setEditTariffError(tariffError);

              const firstValidationError = getFirstEditValidationError(
                nameErrors,
                loadErrors,
                tariffError
              );
              if (firstValidationError) {
                setEditSaveError(firstValidationError);
                return;
              }

              if (shouldEditTariff) {
                const newTariff = String(editFormData.newTariff || "").trim();
                if (requiresFbrDocument(newTariff)) {
                  if (!hasExistingEditNtn(dialogRowData)) {
                    const ntnError = validateEditNtn(editFormData.ntnNo, newTariff);
                    if (ntnError) {
                      setEditNtnError(ntnError);
                      setEditSaveError(ntnError);
                      return;
                    }
                  }
                  if (!hasExistingEditFbrDocument(dialogRowData) && !editFbrDocumentThumbnail) {
                    const fbrError = "FBR Document is required for this tariff.";
                    setEditFbrDocumentError(fbrError);
                    setEditSaveError(fbrError);
                    return;
                  }
                }
              }

              setViewBackdrop(true);
              try {
                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);
                myHeaders.append("Content-Type", "application/json");

                const resolvedNewTariff = shouldEditTariff
                  ? String(editFormData.newTariff || "").trim()
                  : String(dialogRowData.newTariff || "").trim();
                const payload = {
                  applicationId: dialogRowData.applicationId,
                  remarks: "Application updated.",
                  changeOfAttributesType: coaType,
                  telcoCode: Number(editFormData.telcoCode || dialogRowData.telcoCode) || 1,
                  ntnNo: shouldEditTariff && requiresFbrDocument(resolvedNewTariff)
                    ? String(
                        editFormData.ntnNo || dialogRowData.ntnNo || ""
                      ).trim()
                    : dialogRowData.ntnNo || "",
                };

                if (coaIncludesName(coaType)) {
                  payload.applicantName = shouldEditName
                    ? editFormData.newName || dialogRowData.applicantName
                    : dialogRowData.applicantName;
                  payload.applicantGuardianType = String(
                    shouldEditName
                      ? editFormData.relation || dialogRowData.applicantGuardianType
                      : dialogRowData.applicantGuardianType
                  );
                  payload.applicantGuardianName = shouldEditName
                    ? editFormData.guardianName || dialogRowData.applicantGuardianName
                    : dialogRowData.applicantGuardianName;
                  payload.applicantCNIC = shouldEditName
                    ? editFormData.newCNIC || dialogRowData.applicantCNIC
                    : dialogRowData.applicantCNIC;
                  payload.applicantPhoneNo = shouldEditName
                    ? editFormData.newPhone || dialogRowData.applicantPhoneNo
                    : dialogRowData.applicantPhoneNo;
                  payload.applicantEmail = shouldEditName
                    ? editFormData.newEmail || dialogRowData.applicantEmail || ""
                    : dialogRowData.applicantEmail || "";
                }

                if (coaIncludesLoad(coaType)) {
                  payload.changeOfLoadType = Number(
                    shouldEditLoad
                      ? editFormData.loadChangeType || dialogRowData.changeOfLoadType
                      : dialogRowData.changeOfLoadType
                  );
                  payload.currentSanctionLoad = parseFloat(
                    shouldEditLoad
                      ? editFormData.currentLoad || dialogRowData.currentSanctionLoad
                      : dialogRowData.currentSanctionLoad
                  );
                  payload.newSanctionLoad = parseFloat(
                    shouldEditLoad
                      ? editFormData.newLoad || dialogRowData.newSanctionLoad
                      : dialogRowData.newSanctionLoad
                  );
                }

                if (coaIncludesTariff(coaType)) {
                  payload.currentTariff = shouldEditTariff
                    ? editFormData.currentTariff || dialogRowData.currentTariff
                    : dialogRowData.currentTariff;
                  payload.newTariff = shouldEditTariff
                    ? resolvedNewTariff
                    : dialogRowData.newTariff;
                  payload.fbrDocument =
                    editFbrDocumentThumbnail ||
                    (!editFbrDocumentCleared && dialogRowData.fbrDocument) ||
                    "";
                }

                const requestOptions = {
                  method: "POST",
                  headers: myHeaders,
                  body: JSON.stringify(payload),
                  redirect: "follow",
                };

                const response = await fetch(
                  cfpBaseUrl + "changeOfAttributes/updateApplicationAttributes",
                  requestOptions
                );
                const result = await response.json();

                if (result.status == 200) {
                  mergeEditApiResponseIntoDialog(result.data, {
                    resolvedNewTariff,
                    shouldEditTariff,
                  });
                  const refreshedRow = await refreshDialogRowFromServer(
                    dialogRowData.applicationId
                  );
                  await callEfileAPI(
                    dialogRowData.applicationId,
                    refreshedRow || { ...dialogRowData, newTariff: resolvedNewTariff }
                  );
                  setEditSaveError("");
                  setShowEditPopup(false);
                  handleClose();
                } else {
                  setEditSaveError(result.message || "Failed to update application");
                }
              } catch (error) {
                console.error("Error updating application:", error);
                setEditSaveError("Error updating application. Please try again.");
              } finally {
                setViewBackdrop(false);
              }
            }}
            sx={{
              backgroundColor: "#006ad1",
              color: "white",
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Activity Log - Application Updated Details */}
      <Dialog
        open={coaApplicationUpdatedPopUp}
        onClose={() => {
          setCoaApplicationUpdatedPopUp(false);
          setCoaApplicationUpdatedHistoryData(null);
        }}
        fullWidth
        maxWidth="md"
        className="subpopup-dialog1"
      >
        <DialogTitle className="dialog-title">
          <p className="title">Application Updated</p>
          <CloseIcon
            className="closeIcon"
            onClick={() => {
              setCoaApplicationUpdatedPopUp(false);
              setCoaApplicationUpdatedHistoryData(null);
            }}
          />
        </DialogTitle>
        <DialogContent className="dialog-content">
          {coaApplicationUpdatedHistoryData ? (
            <>
              <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={6}>
                  <Typography className="fieldLabel">Application ID</Typography>
                  <Typography>
                    {coaApplicationUpdatedHistoryData.applicationId || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography className="fieldLabel">Application Type</Typography>
                  <Typography>
                    {applicationName(
                      coaApplicationUpdatedHistoryData.changeOfAttributesType
                    ) || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography className="fieldLabel">Step</Typography>
                  <Typography>
                    {coaApplicationUpdatedHistoryData.coaProgStatusName ||
                      progFunc(
                        getCoaApplicationUpdatedStepProgressId(
                          coaApplicationUpdatedHistoryData
                        )
                      ) ||
                      "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography className="fieldLabel">Processed By</Typography>
                  <Typography>
                    {coaApplicationUpdatedHistoryData.lastModifiedBy || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography className="fieldLabel">Date</Typography>
                  <Typography>
                    {coaApplicationUpdatedHistoryData.lastModificationDate
                      ? convertDatewithTime(
                          coaApplicationUpdatedHistoryData.lastModificationDate
                        )
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography className="fieldLabel">Remarks</Typography>
                  <Typography>
                    {coaApplicationUpdatedHistoryData.remarks || "-"}
                  </Typography>
                </Grid>
                {coaIncludesLoad(
                  coaApplicationUpdatedHistoryData.changeOfAttributesType
                ) && coaApplicationUpdatedHistoryData.changeOfLoadType ? (
                  <Grid item xs={12} sm={6}>
                    <Typography className="fieldLabel">Load Change Type</Typography>
                    <Typography>
                      {getLoadChangeTypeName(
                        coaApplicationUpdatedHistoryData.changeOfLoadType
                      ) || "-"}
                    </Typography>
                  </Grid>
                ) : null}
                {coaIncludesTariff(
                  coaApplicationUpdatedHistoryData.changeOfAttributesType
                ) && coaApplicationUpdatedHistoryData.ntnNo ? (
                  <Grid item xs={12} sm={6}>
                    <Typography className="fieldLabel">NTN No.</Typography>
                    <Typography>{coaApplicationUpdatedHistoryData.ntnNo}</Typography>
                  </Grid>
                ) : null}
              </Grid>

              <TableContainer component={Paper} sx={{ mb: 2 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#1e4e8c" }}>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Field
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Previous
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Updated
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getCoaApplicationUpdatedTableRows(
                      coaApplicationUpdatedHistoryData,
                      dialogRowData
                    ).map((row, index) => (
                      <TableRow
                        key={`${row.label}-${index}`}
                        sx={{
                          backgroundColor:
                            index % 2 === 0 ? "white" : "rgb(213, 229, 255)",
                        }}
                      >
                        <TableCell sx={{ fontWeight: "bold" }}>
                          {row.label || "-"}
                        </TableCell>
                        <TableCell>{row.current || "-"}</TableCell>
                        <TableCell>{row.newVal || "-"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {coaApplicationUpdatedHistoryData.fbrDocument?.length > 0 ? (
                <Box>
                  <Typography className="fieldLabel" sx={{ mb: 1 }}>
                    FBR Document
                  </Typography>
                  <Box
                    onClick={() =>
                      openBase64Image(coaApplicationUpdatedHistoryData.fbrDocument)
                    }
                    sx={{
                      cursor: "pointer",
                      display: "inline-block",
                      border: "1px solid #ddd",
                      borderRadius: 1,
                      p: 1,
                    }}
                  >
                    {coaApplicationUpdatedHistoryData.fbrDocument?.slice(
                      0,
                      6
                    ) === "data:i" ? (
                      <Base64Image
                        data={coaApplicationUpdatedHistoryData.fbrDocument}
                        width="120"
                        height="160"
                      />
                    ) : (
                      <Base64Image data={pdfIcon} width="80" height="100" />
                    )}
                  </Box>
                </Box>
              ) : null}
            </>
          ) : (
            <Typography>No update details found.</Typography>
          )}
        </DialogContent>
        <DialogActions className="dialog-actions">
          <Button
            variant="contained"
            onClick={() => {
              setCoaApplicationUpdatedPopUp(false);
              setCoaApplicationUpdatedHistoryData(null);
            }}
            sx={{ backgroundColor: "#006ad1" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
});

export default ChangeAttributesTable;
